"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Bakkt Business Portal Service APIs
 * Bakkt Business Portal Service APIs
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoleManagementControllerApi = exports.UserRoleManagementControllerApiFactory = exports.UserRoleManagementControllerApiFp = exports.UserRoleManagementControllerApiAxiosParamCreator = exports.TransactionControllerApi = exports.TransactionControllerApiFactory = exports.TransactionControllerApiFp = exports.TransactionControllerApiAxiosParamCreator = exports.TaxIdVerificationApi = exports.TaxIdVerificationApiFactory = exports.TaxIdVerificationApiFp = exports.TaxIdVerificationApiAxiosParamCreator = exports.SettlementApi = exports.SettlementApiFactory = exports.SettlementApiFp = exports.SettlementApiAxiosParamCreator = exports.PhotoIdVerificationApi = exports.PhotoIdVerificationApiFactory = exports.PhotoIdVerificationApiFp = exports.PhotoIdVerificationApiAxiosParamCreator = exports.PartySignUpApi = exports.PartySignUpApiFactory = exports.PartySignUpApiFp = exports.PartySignUpApiAxiosParamCreator = exports.PartyResetPasswordApi = exports.PartyResetPasswordApiFactory = exports.PartyResetPasswordApiFp = exports.PartyResetPasswordApiAxiosParamCreator = exports.PartyApi = exports.PartyApiFactory = exports.PartyApiFp = exports.PartyApiAxiosParamCreator = exports.PartnerPortalApisApi = exports.PartnerPortalApisApiFactory = exports.PartnerPortalApisApiFp = exports.PartnerPortalApisApiAxiosParamCreator = exports.PartnerAPIAdminApi = exports.PartnerAPIAdminApiFactory = exports.PartnerAPIAdminApiFp = exports.PartnerAPIAdminApiAxiosParamCreator = exports.OldMerchantPortalReportControllerApi = exports.OldMerchantPortalReportControllerApiFactory = exports.OldMerchantPortalReportControllerApiFp = exports.OldMerchantPortalReportControllerApiAxiosParamCreator = exports.OfficeOfForeignAssetsControlOFACApi = exports.OfficeOfForeignAssetsControlOFACApiFactory = exports.OfficeOfForeignAssetsControlOFACApiFp = exports.OfficeOfForeignAssetsControlOFACApiAxiosParamCreator = exports.NewPartySignUpFlowApi = exports.NewPartySignUpFlowApiFactory = exports.NewPartySignUpFlowApiFp = exports.NewPartySignUpFlowApiAxiosParamCreator = exports.MonitorApi = exports.MonitorApiFactory = exports.MonitorApiFp = exports.MonitorApiAxiosParamCreator = exports.EvilAchTransactionControllerApi = exports.EvilAchTransactionControllerApiFactory = exports.EvilAchTransactionControllerApiFp = exports.EvilAchTransactionControllerApiAxiosParamCreator = exports.EmbeddedPartnerAPIApi = exports.EmbeddedPartnerAPIApiFactory = exports.EmbeddedPartnerAPIApiFp = exports.EmbeddedPartnerAPIApiAxiosParamCreator = exports.ChecksStoresAliasApi = exports.ChecksStoresAliasApiFactory = exports.ChecksStoresAliasApiFp = exports.ChecksStoresAliasApiAxiosParamCreator = exports.BusinessPortalTicketControllerApi = exports.BusinessPortalTicketControllerApiFactory = exports.BusinessPortalTicketControllerApiFp = exports.BusinessPortalTicketControllerApiAxiosParamCreator = exports.BusinessPortalRiskControllerApi = exports.BusinessPortalRiskControllerApiFactory = exports.BusinessPortalRiskControllerApiFp = exports.BusinessPortalRiskControllerApiAxiosParamCreator = exports.BusinessPortalReportControllerApi = exports.BusinessPortalReportControllerApiFactory = exports.BusinessPortalReportControllerApiFp = exports.BusinessPortalReportControllerApiAxiosParamCreator = exports.BusinessPortalPartyControllerApi = exports.BusinessPortalPartyControllerApiFactory = exports.BusinessPortalPartyControllerApiFp = exports.BusinessPortalPartyControllerApiAxiosParamCreator = exports.BusinessPortalLoyaltyControllerApi = exports.BusinessPortalLoyaltyControllerApiFactory = exports.BusinessPortalLoyaltyControllerApiFp = exports.BusinessPortalLoyaltyControllerApiAxiosParamCreator = exports.BusinessPortalIncentiveControllerApi = exports.BusinessPortalIncentiveControllerApiFactory = exports.BusinessPortalIncentiveControllerApiFp = exports.BusinessPortalIncentiveControllerApiAxiosParamCreator = exports.BusinessPortalGiftCardControllerApi = exports.BusinessPortalGiftCardControllerApiFactory = exports.BusinessPortalGiftCardControllerApiFp = exports.BusinessPortalGiftCardControllerApiAxiosParamCreator = exports.BusinessPortalDisputeControllerApi = exports.BusinessPortalDisputeControllerApiFactory = exports.BusinessPortalDisputeControllerApiFp = exports.BusinessPortalDisputeControllerApiAxiosParamCreator = exports.BusinessPortalCardControllerApi = exports.BusinessPortalCardControllerApiFactory = exports.BusinessPortalCardControllerApiFp = exports.BusinessPortalCardControllerApiAxiosParamCreator = exports.BusinessPortalBankAccountControllerApi = exports.BusinessPortalBankAccountControllerApiFactory = exports.BusinessPortalBankAccountControllerApiFp = exports.BusinessPortalBankAccountControllerApiAxiosParamCreator = exports.BusinessPortalAchControllerApi = exports.BusinessPortalAchControllerApiFactory = exports.BusinessPortalAchControllerApiFp = exports.BusinessPortalAchControllerApiAxiosParamCreator = exports.BankAccountPatchesApi = exports.BankAccountPatchesApiFactory = exports.BankAccountPatchesApiFp = exports.BankAccountPatchesApiAxiosParamCreator = exports.BankAccountApi = exports.BankAccountApiFactory = exports.BankAccountApiFp = exports.BankAccountApiAxiosParamCreator = exports.BackwardsCompatibilityApi = exports.BackwardsCompatibilityApiFactory = exports.BackwardsCompatibilityApiFp = exports.BackwardsCompatibilityApiAxiosParamCreator = exports.AllowListManagementApi = exports.AllowListManagementApiFactory = exports.AllowListManagementApiFp = exports.AllowListManagementApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.AddIdentifierApi = exports.AddIdentifierApiFactory = exports.AddIdentifierApiFp = exports.AddIdentifierApiAxiosParamCreator = exports.ActivityAuditControllerApi = exports.ActivityAuditControllerApiFactory = exports.ActivityAuditControllerApiFp = exports.ActivityAuditControllerApiAxiosParamCreator = exports.AccountActivityControllerApi = exports.AccountActivityControllerApiFactory = exports.AccountActivityControllerApiFp = exports.AccountActivityControllerApiAxiosParamCreator = exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiAxiosParamCreator = exports.ThemeThemeNameEnum = exports.TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum = exports.SortBySortOrderEnum = exports.ServiceAmountCurrencyEnum = exports.ServiceAddressCountryEnum = exports.ReturnFileStatusEnum = exports.PortfolioByAssetAssetTypeEnum = exports.PartnerTransactionTransactionTypeEnum = exports.PartnerTransactionStatusEnum = exports.PartnerTransactionCryptoCurrencyTransactTypeEnum = exports.PartnerTransactionCryptoCurrencySourceEnum = exports.PartnerPartyLinkStatusEnum = exports.PartnerBatchErrorCodeEnum = exports.ModelFileStatusEnum = exports.IdentifierUserTypesEnum = exports.GetHistoricalCryptoCurrencyPriceResponseTargetCurrencyEnum = exports.GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum = exports.FilterSearchCriteriaEnum = exports.FiatAmountCurrencyEnum = exports.DurationPeriodEnum = exports.DebitFileStatusEnum = exports.CryptoOrFiatAmountCurrencyEnum = exports.CreditFileStatusEnum = exports.BasicPartyInfoStatusEnum = exports.BasicPartyInfoLevelEnum = exports.BasicPartnerInfoStatusEnum = exports.BasicPartnerInfoServiceTypesEnum = exports.BasicPartnerInfoMissingFieldsEnum = exports.AssetActivitySummarySearchRequestSystemEnum = exports.AssetActivitySummarySearchRequestCurrenciesEnum = exports.AssetActivitySummarySearchRequestAssetTypesEnum = exports.AssetActivitySummarySearchRequestAssetActivityTypesEnum = exports.AssetActivitySummarySearchRequestAssetActivityStatusEnum = exports.AssetActivitySearchRequestSystemEnum = exports.AssetActivitySearchRequestCurrencyEnum = exports.AssetActivitySearchRequestAssetTypesEnum = exports.AssetActivitySearchRequestAssetActivityTypesEnum = exports.AssetActivitySearchRequestAssetActivityStatusEnum = exports.ApiWhitelistPartyRequestReasonEnum = exports.ApiUpdateRoleRemovePermissionsEnum = exports.ApiUpdateRoleAddPermissionsEnum = exports.ApiUpdatePartnerRequestStatusEnum = exports.ApiUpdatePartnerRequestServiceTypesEnum = exports.ApiUpdatePartnerRequestPrimaryCurrencyEnum = exports.ApiUpdatePartnerRequestCryptoCurrenciesEnum = exports.ApiUpdateGiftCardProductStatusEnum = exports.ApiUnit21DownloadControlDataSinkTypeEnum = exports.ApiUnit21ControlDataSourceTypeEnum = exports.ApiUnit21BatchActivityDataSourceTypeEnum = exports.ApiTransactionTicketDetailsRegulationEFlagEnum = exports.ApiTransactionTicketDetailsDisputeStatusEnum = exports.ApiTransactionDetailsRequestAssetActivityTypeEnum = exports.ApiTransactionDetailsAssetTypeEnum = exports.ApiTransactionDetailsActivityTypeEnum = exports.ApiTransactionActivityDeclineReasonEnum = exports.ApiTransactionActivityActivityTypeEnum = exports.ApiTicketStatusEnum = exports.ApiTicketRecipientTypeEnum = exports.ApiTicketReasonCodeEnum = exports.ApiTicketCategoryEnum = exports.ApiThirdPartyVerificationLogVerificationTypeEnum = exports.ApiThirdPartyVerificationLogThirdPartyServiceEnum = exports.ApiSettlementSourceCurrencyEnum = exports.ApiSettlementAchTypeEnum = exports.ApiRewardsTransactionDetailsSupportedOperationsEnum = exports.ApiRewardsTransactionDetailsStatusEnum = exports.ApiRestrictionUnitEnum = exports.ApiRestrictionTypeEnum = exports.ApiRestrictionPeriodEnum = exports.ApiResponseMapStringThirdPartyResponseStatusPayloadEnum = exports.ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum = exports.ApiReportListRequestReportTypeEnum = exports.ApiRelatedTransactionTypeEnum = exports.ApiPrincipalActivityDetailFundingTypeEnum = exports.ApiPortalUserUserStatusEnum = exports.ApiPortalRolePermissionsEnum = exports.ApiPlaidEventPlaidEventSourceEnum = exports.ApiPlaidAccountStatusEnum = exports.ApiPlaidAccountLinkStatusEnum = exports.ApiPlaidAccountCurrencyEnum = exports.ApiPhotoIdVerificationRequestCountryEnum = exports.ApiPendingBankAccountVerificationTypeEnum = exports.ApiPendingBankAccountVerificationStatusEnum = exports.ApiPartyToPartyTransferTypeEnum = exports.ApiPartyToPartyTransferStatusEnum = exports.ApiPartyToPartyTransferRemindersSentEnum = exports.ApiPartyToPartyTransferAssetTypeEnum = exports.ApiPartyTaxIdDetailsTaxIdVerifiedEnum = exports.ApiPartyTaxIdDetailsResponseStatusEnum = exports.ApiPartyStatusUpdateRequestReasonEnum = exports.ApiPartySearchResponseOnBoardingStatusEnum = exports.ApiPartyRiskDetailsRiskLevelEnum = exports.ApiPartyPhotoIdDetailsIdVerifiedEnum = exports.ApiPartyOfacMatchMatchedRuleTypeEnum = exports.ApiPartyKycDetailsKycStatusEnum = exports.ApiPartyDashboardSearchSystemEnum = exports.ApiPartyBaseSearchResponseStatusEnum = exports.ApiPartyBaseSearchResponsePartyTypeEnum = exports.ApiPartyBaseSearchResponseLevelEnum = exports.ApiPartyTaxIdVerificationStatusEnum = exports.ApiPartyStatusEnum = exports.ApiPartyPhotoIdVerificationStatusEnum = exports.ApiPartyPartyTypeEnum = exports.ApiPartyLevelEnum = exports.ApiPartnerTransactionDetailsStatusEnum = exports.ApiPartnerTransactionDetailTransactionTypeEnum = exports.ApiPartnerTransactionDetailTargetCurrencyEnum = exports.ApiPartnerTransactionDetailStatusEnum = exports.ApiPartnerTransactionDetailSourceCurrencyEnum = exports.ApiPartnerTransactionDetailCryptoCurrencyTransactTypeEnum = exports.ApiPartnerTransactionDetailCryptoCurrencySourceEnum = exports.ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum = exports.ApiPartnerRiskConfigResponseProductEnum = exports.ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum = exports.ApiPartnerRiskConfigRequestProductEnum = exports.ApiPartnerPartyLinkStatusEnum = exports.ApiPartnerPartyEnrollmentValidationStatusValidationStatusEnum = exports.ApiPartnerPartyEnrollmentValidationStatusValidationReasonEnum = exports.ApiPartnerPartyEnrollmentLogPartyEnrollmentDataValidationStatusEnum = exports.ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum = exports.ApiPartnerPartyDetailStatusEnum = exports.ApiPartnerPartyDetailServiceTypesEnum = exports.ApiPartnerPartyDetailPartyLevelEnum = exports.ApiPartnerLedgerPostingTransactionTypeEnum = exports.ApiPartnerLedgerPostingTargetCurrencyEnum = exports.ApiPartnerLedgerPostingSourceCurrencyEnum = exports.ApiPartnerLedgerPostingCryptocurrencyTransactionTypeEnum = exports.ApiPartnerImmConfigUpdateRequestCommissionTypeEnum = exports.ApiPartnerDisputeDetailsStatusEnum = exports.ApiPartnerDisputeDetailsResolutionTypeEnum = exports.ApiPartnerDisputeDetailsReasonCodeEnum = exports.ApiPartnerDisputeDetailsDisputeTypeEnum = exports.ApiPartnerDisputeDetailsCurrencyEnum = exports.ApiPartnerConfigurationWalletTypeEnum = exports.ApiPartnerConfigurationSettlementTypeEnum = exports.ApiPartnerConfigurationCryptoCurrencySourceEnum = exports.ApiPartnerStatusEnum = exports.ApiPartnerServiceTypesEnum = exports.ApiPartnerPrimaryCurrencyEnum = exports.ApiPartnerMissingFieldsEnum = exports.ApiPartnerCryptoCurrenciesEnum = exports.ApiP2PTransactionDetailsStatusEnum = exports.ApiOfacRuleDefinitionRuleTypeEnum = exports.ApiMerchantTrasanctionDetailsTransactionStatusEnum = exports.ApiMerchantTrasanctionDetailsPreferredCurrencyEnum = exports.ApiMerchantTrasanctionDetailsCurrencyEnum = exports.ApiLoyaltyTransactionUnitPriceCurrencyEnum = exports.ApiLoyaltyTransactionTransactionCurrencyEnum = exports.ApiLoyaltyTransactionStatusEnum = exports.ApiLoyaltyTransactionLoyaltyTransactionTypeEnum = exports.ApiLoyaltyTransactionLoyaltyCurrencyEnum = exports.ApiLoyaltyAccountDetailStatusEnum = exports.ApiLoyaltyAccountDetailLoyaltyIntegrationTypeEnum = exports.ApiIncentiveTriggerDetailAssetTypeEnum = exports.ApiIncentiveTriggerDetailActionTypeEnum = exports.ApiIncentiveTriggerCriterionTypeEnum = exports.ApiIncentiveOfferSummaryAwardTypeEnum = exports.ApiIncentiveDetailResponsePartyAwardStatusEnum = exports.ApiIncentiveCriterionTypeEnum = exports.ApiIncentiveAwardDetailValueTypeEnum = exports.ApiIncentiveAwardDetailTypeEnum = exports.ApiIncentiveAwardDetailAwardExecutionCurrencyEnum = exports.ApiIdentityCheckResponseRiskLevelEnum = exports.ApiIdentityCheckResponseFlowEnum = exports.ApiGiftCardSummaryResponseStatusEnum = exports.ApiGiftCardProductStatusEnum = exports.ApiGiftCardFeedHistoryStatusEnum = exports.ApiGiftCardDetailResponseTransactionTypeEnum = exports.ApiGiftCardDetailResponseStatusEnum = exports.ApiFundingSourceDetailResponseTypeEnum = exports.ApiFundingSourceDetailCurrencyEnum = exports.ApiFundingSourceDetailAssetTypeEnum = exports.ApiFailureActivityTransactionTypeEnum = exports.ApiEnrichedAchRecordTypeEnum = exports.ApiEnrichedAchRecordStatusEnum = exports.ApiEmbeddedPartnerTransactionSummaryTransactionTypeEnum = exports.ApiEmbeddedPartnerTransactionTransactionTypeEnum = exports.ApiEmbeddedPartnerTransactionStatusEnum = exports.ApiEmbeddedPartnerTransactionCryptoCurrencyTransactTypeEnum = exports.ApiEmbeddedPartnerTransactionCryptoCurrencySourceEnum = exports.ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum = exports.ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum = exports.ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum = exports.ApiEmbeddedCryptoTransactionRequestTransactTypeEnum = exports.ApiEmbeddedCryptoExecutePriceResponseBuySellIndicatorEnum = exports.ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum = exports.ApiEmbeddedCryptoExecutePriceRequestBuySellIndicatorEnum = exports.ApiDisputeRegulationERequestRegulationEFlagEnum = exports.ApiDisputeCreateRequestReasonCodeEnum = exports.ApiDisputeCreateRequestDisputeTypeEnum = exports.ApiDisputeCreateRequestCurrencyEnum = exports.ApiDigitalCardActionRequestStatusEnum = exports.ApiDigitalCardStatusEnum = exports.ApiDigitalCardDeviceTypeEnum = exports.ApiDigitalCardDevicePlatformEnum = exports.ApiDeviceSessionResponseSourceEnum = exports.ApiDeviceSessionResponseFlowEnum = exports.ApiDeviceStatusEnum = exports.ApiDebitCardExpiryDateMonthEnum = exports.ApiDebitCardDetailsStatusEnum = exports.ApiDebitCardActivityStatusEnum = exports.ApiDebitCardActivityDeclineReasonEnum = exports.ApiDebitCardStatusEnum = exports.ApiDebitCardCardTypeEnum = exports.ApiDateRangeReportRequestReportTypeEnum = exports.ApiCryptoCurrencyTransactionTransactionCurrencyEnum = exports.ApiCryptoCurrencyTransactionStatusEnum = exports.ApiCryptoCurrencyTransactionQuantityUnitEnum = exports.ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum = exports.ApiCreditActionRequestAssetTypeEnum = exports.ApiCreateRolePermissionsEnum = exports.ApiCreatePartnerRequestServiceTypesEnum = exports.ApiCreatePartnerRequestPrimaryCurrencyEnum = exports.ApiCreatePartnerRequestMissingFieldsEnum = exports.ApiCreatePartnerRequestCryptoCurrenciesEnum = exports.ApiCreateBankAccountRequestVerificationStatusEnum = exports.ApiCommentOwnerEnum = exports.ApiCardIssuerPartyStatusEnum = exports.ApiCardIssuerPartyLastKycStatusEnum = exports.ApiCardActionRequestStatusEnum = exports.ApiCardStatusEnum = exports.ApiBlacklistedBankAccountOffenderReasonEnum = exports.ApiBlacklistAccountRequestReasonEnum = exports.ApiBlacklistAccountRemovalRequestReasonEnum = exports.ApiBitcoinTransactionDetailsFundingTypeEnum = exports.ApiBankAccountLinkStatusLinkStatusEnum = exports.ApiBankAccountVerificationTypeEnum = exports.ApiBankAccountStatusEnum = exports.ApiBankAccountLinkStatusEnum = exports.ApiBankAccountKycStatusEnum = exports.ApiBankAccountCurrencyEnum = exports.ApiBakktTransactionDetailsTransactionStatusEnum = exports.ApiBakktTransactionDetailsDisputeStatusEnum = exports.ApiBakktCardTransactionDetailsTransactionStatusEnum = exports.ApiBakktCardTransactionDetailsPreferredCurrencyEnum = exports.ApiAssetActivitySummaryTypeEnum = exports.ApiAssetActivitySummaryStatusEnum = exports.ApiAssetActivitySummarySourceCurrencyEnum = exports.ApiAssetActivitySummaryDestinationCurrencyEnum = exports.ApiAssetActivitySummaryDerivedTypeEnum = exports.ApiAssetActivitySummaryDeclineReasonEnum = exports.ApiAssetActivityDetailsTypeEnum = exports.ApiAssetActivityDetailsStatusEnum = exports.ApiAssetActivityDetailsSourceCurrencyEnum = exports.ApiAssetActivityDetailsDestinationCurrencyEnum = exports.ApiAssetActivityDetailsCostBasisCurrencyEnum = exports.ApiAssetActivityDetailsAssetTypeEnum = exports.ApiAssetActivityTypeEnum = exports.ApiAssetActivityStatusEnum = exports.ApiAssetActivitySourceCurrencyEnum = exports.ApiAssetActivitySourceAssetTypeEnum = exports.ApiAssetActivityGroupAssetTypeEnum = exports.ApiAssetActivityGroupActivityTypeEnum = exports.ApiAssetActivityFeeCurrencyEnum = exports.ApiAssetActivityDestinationCurrencyEnum = exports.ApiAssetActivityDestinationAssetTypeEnum = exports.ApiAssetActivityDeclineReasonEnum = exports.ApiAssetActivityCostBasisCurrencyEnum = exports.ApiAssetActivityAssetTypeEnum = exports.ApiAmountCurrencyEnum = exports.ApiAllowListItemCurrencyEnum = exports.ApiAllowListItemAllowListItemTypeEnum = exports.ApiAllowListItemAllowListItemSubtypeEnum = exports.ApiAddressCountryEnum = exports.ApiActivityAuditEntityTypeEnum = exports.ApiActivityAuditActivityTypeEnum = exports.ApiAchTransactionResponsePrefundingVerdictSummaryEnum = exports.ApiAchTransactionResponseCurrencyEnum = exports.ApiAchTransactionResponseAchTypeEnum = exports.ApiAchTransactionDetailsPrefundingVerdictEnum = exports.ApiAchTransactionDetailsCurrencyEnum = exports.ApiAchTransactionPrefundingVerdictEnum = exports.ApiAchTransactionCurrencyEnum = exports.ApiAchTransactionAchTypeEnum = exports.ApiAchSummaryViewTypeEnum = exports.ApiAchFileDetailTypeEnum = exports.ApiAchFileDetailStatusEnum = exports.ApiAccountActivityTypeEnum = exports.ApiAccountActivityReasonEnum = exports.ApiAccountCurrencyEnum = exports.ApiAccountAssetClassEnum = exports.AmountCurrencyEnum = exports.ActivityAuditSearchRequestEntityTypeEnum = exports.AchFileFileTypeEnum = exports.AccountActivitySearchRequestAccountActivityTypesEnum = exports.AccountActivitySearchRequestAccountActivityReasonsEnum = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var AccountActivitySearchRequestAccountActivityReasonsEnum;
(function (AccountActivitySearchRequestAccountActivityReasonsEnum) {
    AccountActivitySearchRequestAccountActivityReasonsEnum["ACCOUNT_CLOSURE_REQUESTED"] = "ACCOUNT_CLOSURE_REQUESTED";
    AccountActivitySearchRequestAccountActivityReasonsEnum["ACH_MAX_RETURNS"] = "ACH_MAX_RETURNS";
    AccountActivitySearchRequestAccountActivityReasonsEnum["ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED";
    AccountActivitySearchRequestAccountActivityReasonsEnum["ACH_RETURNS_COUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_EXCEEDED";
    AccountActivitySearchRequestAccountActivityReasonsEnum["ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED";
    AccountActivitySearchRequestAccountActivityReasonsEnum["ACH_RETURN_CODE"] = "ACH_RETURN_CODE";
    AccountActivitySearchRequestAccountActivityReasonsEnum["COMPLIANCE_INVESTIGATION"] = "COMPLIANCE_INVESTIGATION";
    AccountActivitySearchRequestAccountActivityReasonsEnum["COMPLIANCE_LOCKED"] = "COMPLIANCE_LOCKED";
    AccountActivitySearchRequestAccountActivityReasonsEnum["COMPLIANCE_VERIFICATION"] = "COMPLIANCE_VERIFICATION";
    AccountActivitySearchRequestAccountActivityReasonsEnum["CUSTOMER_GOOD_STANDING"] = "CUSTOMER_GOOD_STANDING";
    AccountActivitySearchRequestAccountActivityReasonsEnum["DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED";
    AccountActivitySearchRequestAccountActivityReasonsEnum["DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED";
    AccountActivitySearchRequestAccountActivityReasonsEnum["DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED";
    AccountActivitySearchRequestAccountActivityReasonsEnum["DEBIT_CARD_TRANSACTION_FRAUD_HOLD"] = "DEBIT_CARD_TRANSACTION_FRAUD_HOLD";
    AccountActivitySearchRequestAccountActivityReasonsEnum["LIQUIDATE_ACCOUNT"] = "LIQUIDATE_ACCOUNT";
    AccountActivitySearchRequestAccountActivityReasonsEnum["MARQETA_KYC_VERIFICATION"] = "MARQETA_KYC_VERIFICATION";
    AccountActivitySearchRequestAccountActivityReasonsEnum["NSF_BLOCKING"] = "NSF_BLOCKING";
    AccountActivitySearchRequestAccountActivityReasonsEnum["OLD_OFAC_CHECK"] = "OLD_OFAC_CHECK";
    AccountActivitySearchRequestAccountActivityReasonsEnum["OTHER"] = "OTHER";
    AccountActivitySearchRequestAccountActivityReasonsEnum["PLAID_IDENTITY_CHECK"] = "PLAID_IDENTITY_CHECK";
    AccountActivitySearchRequestAccountActivityReasonsEnum["PLAID_MISSING_NAMES"] = "PLAID_MISSING_NAMES";
    AccountActivitySearchRequestAccountActivityReasonsEnum["RELINK"] = "RELINK";
    AccountActivitySearchRequestAccountActivityReasonsEnum["RISK_DECISION"] = "RISK_DECISION";
    AccountActivitySearchRequestAccountActivityReasonsEnum["RISK_KYC"] = "RISK_KYC";
    AccountActivitySearchRequestAccountActivityReasonsEnum["RISK_SCREENING"] = "RISK_SCREENING";
    AccountActivitySearchRequestAccountActivityReasonsEnum["TAX_ID_MAX_RETRIES"] = "TAX_ID_MAX_RETRIES";
    AccountActivitySearchRequestAccountActivityReasonsEnum["CARD_TERMINATION_ERROR"] = "CARD_TERMINATION_ERROR";
    AccountActivitySearchRequestAccountActivityReasonsEnum["CLOSED"] = "CLOSED";
})(AccountActivitySearchRequestAccountActivityReasonsEnum = exports.AccountActivitySearchRequestAccountActivityReasonsEnum || (exports.AccountActivitySearchRequestAccountActivityReasonsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AccountActivitySearchRequestAccountActivityTypesEnum;
(function (AccountActivitySearchRequestAccountActivityTypesEnum) {
    AccountActivitySearchRequestAccountActivityTypesEnum["BANK_IDENTITY_CHECK"] = "BANK_IDENTITY_CHECK";
    AccountActivitySearchRequestAccountActivityTypesEnum["BAKKT_CARD_KYC_FAIL"] = "BAKKT_CARD_KYC_FAIL";
    AccountActivitySearchRequestAccountActivityTypesEnum["BAKKT_CARD_KYC_PENDING"] = "BAKKT_CARD_KYC_PENDING";
    AccountActivitySearchRequestAccountActivityTypesEnum["BAKKT_CARD_KYC_SUCCESS"] = "BAKKT_CARD_KYC_SUCCESS";
    AccountActivitySearchRequestAccountActivityTypesEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    AccountActivitySearchRequestAccountActivityTypesEnum["BANK_ACCOUNT_BLACKLIST"] = "BANK_ACCOUNT_BLACKLIST";
    AccountActivitySearchRequestAccountActivityTypesEnum["BANK_ACCOUNT_REMOVE_BLACKLIST"] = "BANK_ACCOUNT_REMOVE_BLACKLIST";
    AccountActivitySearchRequestAccountActivityTypesEnum["DEBIT_CARD_BLACKLIST"] = "DEBIT_CARD_BLACKLIST";
    AccountActivitySearchRequestAccountActivityTypesEnum["DEBIT_CARD_REMOVE_BLACKLIST"] = "DEBIT_CARD_REMOVE_BLACKLIST";
    AccountActivitySearchRequestAccountActivityTypesEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    AccountActivitySearchRequestAccountActivityTypesEnum["CREDIT"] = "CREDIT";
    AccountActivitySearchRequestAccountActivityTypesEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    AccountActivitySearchRequestAccountActivityTypesEnum["KYC_FAIL"] = "KYC_FAIL";
    AccountActivitySearchRequestAccountActivityTypesEnum["KYC_SUCCESS"] = "KYC_SUCCESS";
    AccountActivitySearchRequestAccountActivityTypesEnum["KYC_UPDATE"] = "KYC_UPDATE";
    AccountActivitySearchRequestAccountActivityTypesEnum["LIQUIDATE"] = "LIQUIDATE";
    AccountActivitySearchRequestAccountActivityTypesEnum["PARTY_REMOVE_WHITELIST"] = "PARTY_REMOVE_WHITELIST";
    AccountActivitySearchRequestAccountActivityTypesEnum["PARTY_WHITELIST"] = "PARTY_WHITELIST";
    AccountActivitySearchRequestAccountActivityTypesEnum["PREFUND_BLOCK"] = "PREFUND_BLOCK";
    AccountActivitySearchRequestAccountActivityTypesEnum["PREFUND_UNBLOCK"] = "PREFUND_UNBLOCK";
    AccountActivitySearchRequestAccountActivityTypesEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    AccountActivitySearchRequestAccountActivityTypesEnum["REPORT_REQUEST"] = "REPORT_REQUEST";
    AccountActivitySearchRequestAccountActivityTypesEnum["REPORT_SENT"] = "REPORT_SENT";
    AccountActivitySearchRequestAccountActivityTypesEnum["SUSPEND"] = "SUSPEND";
    AccountActivitySearchRequestAccountActivityTypesEnum["UNSUSPEND"] = "UNSUSPEND";
    AccountActivitySearchRequestAccountActivityTypesEnum["LIQUIDATE_REQUESTED"] = "LIQUIDATE_REQUESTED";
    AccountActivitySearchRequestAccountActivityTypesEnum["LIQUIDATE_REMOVE_REQUESTED"] = "LIQUIDATE_REMOVE_REQUESTED";
    AccountActivitySearchRequestAccountActivityTypesEnum["CLOSED"] = "CLOSED";
})(AccountActivitySearchRequestAccountActivityTypesEnum = exports.AccountActivitySearchRequestAccountActivityTypesEnum || (exports.AccountActivitySearchRequestAccountActivityTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AchFileFileTypeEnum;
(function (AchFileFileTypeEnum) {
    AchFileFileTypeEnum["OUTBOUND_CREDIT"] = "OUTBOUND_CREDIT";
    AchFileFileTypeEnum["OUTBOUND_DEBIT"] = "OUTBOUND_DEBIT";
    AchFileFileTypeEnum["OUTBOUND"] = "OUTBOUND";
    AchFileFileTypeEnum["RETURNS"] = "RETURNS";
})(AchFileFileTypeEnum = exports.AchFileFileTypeEnum || (exports.AchFileFileTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ActivityAuditSearchRequestEntityTypeEnum;
(function (ActivityAuditSearchRequestEntityTypeEnum) {
    ActivityAuditSearchRequestEntityTypeEnum["INCENTIVE"] = "INCENTIVE";
    ActivityAuditSearchRequestEntityTypeEnum["ACCOUNT"] = "ACCOUNT";
    ActivityAuditSearchRequestEntityTypeEnum["GIFTCARD_BRANDS"] = "GIFTCARD_BRANDS";
    ActivityAuditSearchRequestEntityTypeEnum["LOYALTY"] = "LOYALTY";
    ActivityAuditSearchRequestEntityTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    ActivityAuditSearchRequestEntityTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(ActivityAuditSearchRequestEntityTypeEnum = exports.ActivityAuditSearchRequestEntityTypeEnum || (exports.ActivityAuditSearchRequestEntityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AmountCurrencyEnum;
(function (AmountCurrencyEnum) {
    AmountCurrencyEnum["USD"] = "USD";
    AmountCurrencyEnum["AAVE"] = "AAVE";
    AmountCurrencyEnum["AVAX"] = "AVAX";
    AmountCurrencyEnum["AXS"] = "AXS";
    AmountCurrencyEnum["BAT"] = "BAT";
    AmountCurrencyEnum["BCH"] = "BCH";
    AmountCurrencyEnum["BTC"] = "BTC";
    AmountCurrencyEnum["DOGE"] = "DOGE";
    AmountCurrencyEnum["ETH"] = "ETH";
    AmountCurrencyEnum["LINK"] = "LINK";
    AmountCurrencyEnum["LTC"] = "LTC";
    AmountCurrencyEnum["MANA"] = "MANA";
    AmountCurrencyEnum["MATIC"] = "MATIC";
    AmountCurrencyEnum["SOL"] = "SOL";
    AmountCurrencyEnum["UNI"] = "UNI";
    AmountCurrencyEnum["USDC"] = "USDC";
    AmountCurrencyEnum["LXX"] = "LXX";
    AmountCurrencyEnum["LCP"] = "LCP";
    AmountCurrencyEnum["LWR"] = "LWR";
    AmountCurrencyEnum["LMO"] = "LMO";
    AmountCurrencyEnum["LKO"] = "LKO";
    AmountCurrencyEnum["LED"] = "LED";
})(AmountCurrencyEnum = exports.AmountCurrencyEnum || (exports.AmountCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAccountAssetClassEnum;
(function (ApiAccountAssetClassEnum) {
    ApiAccountAssetClassEnum["CASH"] = "CASH";
    ApiAccountAssetClassEnum["CRYPTO"] = "CRYPTO";
    ApiAccountAssetClassEnum["REWARDS"] = "REWARDS";
})(ApiAccountAssetClassEnum = exports.ApiAccountAssetClassEnum || (exports.ApiAccountAssetClassEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAccountCurrencyEnum;
(function (ApiAccountCurrencyEnum) {
    ApiAccountCurrencyEnum["USD"] = "USD";
    ApiAccountCurrencyEnum["AAVE"] = "AAVE";
    ApiAccountCurrencyEnum["AVAX"] = "AVAX";
    ApiAccountCurrencyEnum["AXS"] = "AXS";
    ApiAccountCurrencyEnum["BAT"] = "BAT";
    ApiAccountCurrencyEnum["BCH"] = "BCH";
    ApiAccountCurrencyEnum["BTC"] = "BTC";
    ApiAccountCurrencyEnum["DOGE"] = "DOGE";
    ApiAccountCurrencyEnum["ETH"] = "ETH";
    ApiAccountCurrencyEnum["LINK"] = "LINK";
    ApiAccountCurrencyEnum["LTC"] = "LTC";
    ApiAccountCurrencyEnum["MANA"] = "MANA";
    ApiAccountCurrencyEnum["MATIC"] = "MATIC";
    ApiAccountCurrencyEnum["SOL"] = "SOL";
    ApiAccountCurrencyEnum["UNI"] = "UNI";
    ApiAccountCurrencyEnum["USDC"] = "USDC";
    ApiAccountCurrencyEnum["LXX"] = "LXX";
    ApiAccountCurrencyEnum["LCP"] = "LCP";
    ApiAccountCurrencyEnum["LWR"] = "LWR";
    ApiAccountCurrencyEnum["LMO"] = "LMO";
    ApiAccountCurrencyEnum["LKO"] = "LKO";
    ApiAccountCurrencyEnum["LED"] = "LED";
})(ApiAccountCurrencyEnum = exports.ApiAccountCurrencyEnum || (exports.ApiAccountCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAccountActivityReasonEnum;
(function (ApiAccountActivityReasonEnum) {
    ApiAccountActivityReasonEnum["ACCOUNT_CLOSURE_REQUESTED"] = "ACCOUNT_CLOSURE_REQUESTED";
    ApiAccountActivityReasonEnum["ACH_MAX_RETURNS"] = "ACH_MAX_RETURNS";
    ApiAccountActivityReasonEnum["ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED";
    ApiAccountActivityReasonEnum["ACH_RETURNS_COUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_EXCEEDED";
    ApiAccountActivityReasonEnum["ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED";
    ApiAccountActivityReasonEnum["ACH_RETURN_CODE"] = "ACH_RETURN_CODE";
    ApiAccountActivityReasonEnum["COMPLIANCE_INVESTIGATION"] = "COMPLIANCE_INVESTIGATION";
    ApiAccountActivityReasonEnum["COMPLIANCE_LOCKED"] = "COMPLIANCE_LOCKED";
    ApiAccountActivityReasonEnum["COMPLIANCE_VERIFICATION"] = "COMPLIANCE_VERIFICATION";
    ApiAccountActivityReasonEnum["CUSTOMER_GOOD_STANDING"] = "CUSTOMER_GOOD_STANDING";
    ApiAccountActivityReasonEnum["DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED";
    ApiAccountActivityReasonEnum["DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED";
    ApiAccountActivityReasonEnum["DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED";
    ApiAccountActivityReasonEnum["DEBIT_CARD_TRANSACTION_FRAUD_HOLD"] = "DEBIT_CARD_TRANSACTION_FRAUD_HOLD";
    ApiAccountActivityReasonEnum["LIQUIDATE_ACCOUNT"] = "LIQUIDATE_ACCOUNT";
    ApiAccountActivityReasonEnum["MARQETA_KYC_VERIFICATION"] = "MARQETA_KYC_VERIFICATION";
    ApiAccountActivityReasonEnum["NSF_BLOCKING"] = "NSF_BLOCKING";
    ApiAccountActivityReasonEnum["OLD_OFAC_CHECK"] = "OLD_OFAC_CHECK";
    ApiAccountActivityReasonEnum["OTHER"] = "OTHER";
    ApiAccountActivityReasonEnum["PLAID_IDENTITY_CHECK"] = "PLAID_IDENTITY_CHECK";
    ApiAccountActivityReasonEnum["PLAID_MISSING_NAMES"] = "PLAID_MISSING_NAMES";
    ApiAccountActivityReasonEnum["RELINK"] = "RELINK";
    ApiAccountActivityReasonEnum["RISK_DECISION"] = "RISK_DECISION";
    ApiAccountActivityReasonEnum["RISK_KYC"] = "RISK_KYC";
    ApiAccountActivityReasonEnum["RISK_SCREENING"] = "RISK_SCREENING";
    ApiAccountActivityReasonEnum["TAX_ID_MAX_RETRIES"] = "TAX_ID_MAX_RETRIES";
    ApiAccountActivityReasonEnum["CARD_TERMINATION_ERROR"] = "CARD_TERMINATION_ERROR";
    ApiAccountActivityReasonEnum["CLOSED"] = "CLOSED";
})(ApiAccountActivityReasonEnum = exports.ApiAccountActivityReasonEnum || (exports.ApiAccountActivityReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAccountActivityTypeEnum;
(function (ApiAccountActivityTypeEnum) {
    ApiAccountActivityTypeEnum["BANK_IDENTITY_CHECK"] = "BANK_IDENTITY_CHECK";
    ApiAccountActivityTypeEnum["BAKKT_CARD_KYC_FAIL"] = "BAKKT_CARD_KYC_FAIL";
    ApiAccountActivityTypeEnum["BAKKT_CARD_KYC_PENDING"] = "BAKKT_CARD_KYC_PENDING";
    ApiAccountActivityTypeEnum["BAKKT_CARD_KYC_SUCCESS"] = "BAKKT_CARD_KYC_SUCCESS";
    ApiAccountActivityTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    ApiAccountActivityTypeEnum["BANK_ACCOUNT_BLACKLIST"] = "BANK_ACCOUNT_BLACKLIST";
    ApiAccountActivityTypeEnum["BANK_ACCOUNT_REMOVE_BLACKLIST"] = "BANK_ACCOUNT_REMOVE_BLACKLIST";
    ApiAccountActivityTypeEnum["DEBIT_CARD_BLACKLIST"] = "DEBIT_CARD_BLACKLIST";
    ApiAccountActivityTypeEnum["DEBIT_CARD_REMOVE_BLACKLIST"] = "DEBIT_CARD_REMOVE_BLACKLIST";
    ApiAccountActivityTypeEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiAccountActivityTypeEnum["CREDIT"] = "CREDIT";
    ApiAccountActivityTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiAccountActivityTypeEnum["KYC_FAIL"] = "KYC_FAIL";
    ApiAccountActivityTypeEnum["KYC_SUCCESS"] = "KYC_SUCCESS";
    ApiAccountActivityTypeEnum["KYC_UPDATE"] = "KYC_UPDATE";
    ApiAccountActivityTypeEnum["LIQUIDATE"] = "LIQUIDATE";
    ApiAccountActivityTypeEnum["PARTY_REMOVE_WHITELIST"] = "PARTY_REMOVE_WHITELIST";
    ApiAccountActivityTypeEnum["PARTY_WHITELIST"] = "PARTY_WHITELIST";
    ApiAccountActivityTypeEnum["PREFUND_BLOCK"] = "PREFUND_BLOCK";
    ApiAccountActivityTypeEnum["PREFUND_UNBLOCK"] = "PREFUND_UNBLOCK";
    ApiAccountActivityTypeEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiAccountActivityTypeEnum["REPORT_REQUEST"] = "REPORT_REQUEST";
    ApiAccountActivityTypeEnum["REPORT_SENT"] = "REPORT_SENT";
    ApiAccountActivityTypeEnum["SUSPEND"] = "SUSPEND";
    ApiAccountActivityTypeEnum["UNSUSPEND"] = "UNSUSPEND";
    ApiAccountActivityTypeEnum["LIQUIDATE_REQUESTED"] = "LIQUIDATE_REQUESTED";
    ApiAccountActivityTypeEnum["LIQUIDATE_REMOVE_REQUESTED"] = "LIQUIDATE_REMOVE_REQUESTED";
    ApiAccountActivityTypeEnum["CLOSED"] = "CLOSED";
})(ApiAccountActivityTypeEnum = exports.ApiAccountActivityTypeEnum || (exports.ApiAccountActivityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchFileDetailStatusEnum;
(function (ApiAchFileDetailStatusEnum) {
    ApiAchFileDetailStatusEnum["READY"] = "READY";
    ApiAchFileDetailStatusEnum["ERROR"] = "ERROR";
    ApiAchFileDetailStatusEnum["PROCESSED"] = "PROCESSED";
})(ApiAchFileDetailStatusEnum = exports.ApiAchFileDetailStatusEnum || (exports.ApiAchFileDetailStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchFileDetailTypeEnum;
(function (ApiAchFileDetailTypeEnum) {
    ApiAchFileDetailTypeEnum["UNSPECIFIED"] = "UNSPECIFIED";
    ApiAchFileDetailTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiAchFileDetailTypeEnum["WITHDRAWAL"] = "WITHDRAWAL";
    ApiAchFileDetailTypeEnum["RETURN_DEPOSIT"] = "RETURN_DEPOSIT";
    ApiAchFileDetailTypeEnum["RETURN_WITHDRAWAL"] = "RETURN_WITHDRAWAL";
})(ApiAchFileDetailTypeEnum = exports.ApiAchFileDetailTypeEnum || (exports.ApiAchFileDetailTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchSummaryViewTypeEnum;
(function (ApiAchSummaryViewTypeEnum) {
    ApiAchSummaryViewTypeEnum["OUTBOUND"] = "OUTBOUND";
    ApiAchSummaryViewTypeEnum["RETURNS"] = "RETURNS";
})(ApiAchSummaryViewTypeEnum = exports.ApiAchSummaryViewTypeEnum || (exports.ApiAchSummaryViewTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchTransactionAchTypeEnum;
(function (ApiAchTransactionAchTypeEnum) {
    ApiAchTransactionAchTypeEnum["WITHDRAWAL"] = "WITHDRAWAL";
    ApiAchTransactionAchTypeEnum["DEPOSIT"] = "DEPOSIT";
})(ApiAchTransactionAchTypeEnum = exports.ApiAchTransactionAchTypeEnum || (exports.ApiAchTransactionAchTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchTransactionCurrencyEnum;
(function (ApiAchTransactionCurrencyEnum) {
    ApiAchTransactionCurrencyEnum["USD"] = "USD";
    ApiAchTransactionCurrencyEnum["AAVE"] = "AAVE";
    ApiAchTransactionCurrencyEnum["AVAX"] = "AVAX";
    ApiAchTransactionCurrencyEnum["AXS"] = "AXS";
    ApiAchTransactionCurrencyEnum["BAT"] = "BAT";
    ApiAchTransactionCurrencyEnum["BCH"] = "BCH";
    ApiAchTransactionCurrencyEnum["BTC"] = "BTC";
    ApiAchTransactionCurrencyEnum["DOGE"] = "DOGE";
    ApiAchTransactionCurrencyEnum["ETH"] = "ETH";
    ApiAchTransactionCurrencyEnum["LINK"] = "LINK";
    ApiAchTransactionCurrencyEnum["LTC"] = "LTC";
    ApiAchTransactionCurrencyEnum["MANA"] = "MANA";
    ApiAchTransactionCurrencyEnum["MATIC"] = "MATIC";
    ApiAchTransactionCurrencyEnum["SOL"] = "SOL";
    ApiAchTransactionCurrencyEnum["UNI"] = "UNI";
    ApiAchTransactionCurrencyEnum["USDC"] = "USDC";
    ApiAchTransactionCurrencyEnum["LXX"] = "LXX";
    ApiAchTransactionCurrencyEnum["LCP"] = "LCP";
    ApiAchTransactionCurrencyEnum["LWR"] = "LWR";
    ApiAchTransactionCurrencyEnum["LMO"] = "LMO";
    ApiAchTransactionCurrencyEnum["LKO"] = "LKO";
    ApiAchTransactionCurrencyEnum["LED"] = "LED";
})(ApiAchTransactionCurrencyEnum = exports.ApiAchTransactionCurrencyEnum || (exports.ApiAchTransactionCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchTransactionPrefundingVerdictEnum;
(function (ApiAchTransactionPrefundingVerdictEnum) {
    ApiAchTransactionPrefundingVerdictEnum["ACCEPTED"] = "ACCEPTED";
    ApiAchTransactionPrefundingVerdictEnum["DECLINED_CAP_EXCEEDED"] = "DECLINED_CAP_EXCEEDED";
    ApiAchTransactionPrefundingVerdictEnum["DECLINED_NEGATIVE_BALANCE"] = "DECLINED_NEGATIVE_BALANCE";
    ApiAchTransactionPrefundingVerdictEnum["DECLINED_ALREADY_PREFUNDED"] = "DECLINED_ALREADY_PREFUNDED";
    ApiAchTransactionPrefundingVerdictEnum["DECLINED_RECENT_ACH_RETURNS"] = "DECLINED_RECENT_ACH_RETURNS";
    ApiAchTransactionPrefundingVerdictEnum["DECLINED_BANK_ACCOUNT_BALANCE_NOT_AVAILABLE"] = "DECLINED_BANK_ACCOUNT_BALANCE_NOT_AVAILABLE";
    ApiAchTransactionPrefundingVerdictEnum["DECLINED_PLAID_BALANCE_NOT_SUFFICIENT_FUNDS"] = "DECLINED_PLAID_BALANCE_NOT_SUFFICIENT_FUNDS";
    ApiAchTransactionPrefundingVerdictEnum["DISABLED"] = "DISABLED";
    ApiAchTransactionPrefundingVerdictEnum["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ApiAchTransactionPrefundingVerdictEnum["DECLINED_SAME_DAY_MICRODEPOSIT_ACCOUNT"] = "DECLINED_SAME_DAY_MICRODEPOSIT_ACCOUNT";
    ApiAchTransactionPrefundingVerdictEnum["DECLINED_INSTITUTION_DENIED"] = "DECLINED_INSTITUTION_DENIED";
})(ApiAchTransactionPrefundingVerdictEnum = exports.ApiAchTransactionPrefundingVerdictEnum || (exports.ApiAchTransactionPrefundingVerdictEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchTransactionDetailsCurrencyEnum;
(function (ApiAchTransactionDetailsCurrencyEnum) {
    ApiAchTransactionDetailsCurrencyEnum["USD"] = "USD";
    ApiAchTransactionDetailsCurrencyEnum["AAVE"] = "AAVE";
    ApiAchTransactionDetailsCurrencyEnum["AVAX"] = "AVAX";
    ApiAchTransactionDetailsCurrencyEnum["AXS"] = "AXS";
    ApiAchTransactionDetailsCurrencyEnum["BAT"] = "BAT";
    ApiAchTransactionDetailsCurrencyEnum["BCH"] = "BCH";
    ApiAchTransactionDetailsCurrencyEnum["BTC"] = "BTC";
    ApiAchTransactionDetailsCurrencyEnum["DOGE"] = "DOGE";
    ApiAchTransactionDetailsCurrencyEnum["ETH"] = "ETH";
    ApiAchTransactionDetailsCurrencyEnum["LINK"] = "LINK";
    ApiAchTransactionDetailsCurrencyEnum["LTC"] = "LTC";
    ApiAchTransactionDetailsCurrencyEnum["MANA"] = "MANA";
    ApiAchTransactionDetailsCurrencyEnum["MATIC"] = "MATIC";
    ApiAchTransactionDetailsCurrencyEnum["SOL"] = "SOL";
    ApiAchTransactionDetailsCurrencyEnum["UNI"] = "UNI";
    ApiAchTransactionDetailsCurrencyEnum["USDC"] = "USDC";
    ApiAchTransactionDetailsCurrencyEnum["LXX"] = "LXX";
    ApiAchTransactionDetailsCurrencyEnum["LCP"] = "LCP";
    ApiAchTransactionDetailsCurrencyEnum["LWR"] = "LWR";
    ApiAchTransactionDetailsCurrencyEnum["LMO"] = "LMO";
    ApiAchTransactionDetailsCurrencyEnum["LKO"] = "LKO";
    ApiAchTransactionDetailsCurrencyEnum["LED"] = "LED";
})(ApiAchTransactionDetailsCurrencyEnum = exports.ApiAchTransactionDetailsCurrencyEnum || (exports.ApiAchTransactionDetailsCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchTransactionDetailsPrefundingVerdictEnum;
(function (ApiAchTransactionDetailsPrefundingVerdictEnum) {
    ApiAchTransactionDetailsPrefundingVerdictEnum["ACCEPTED"] = "ACCEPTED";
    ApiAchTransactionDetailsPrefundingVerdictEnum["DECLINED_CAP_EXCEEDED"] = "DECLINED_CAP_EXCEEDED";
    ApiAchTransactionDetailsPrefundingVerdictEnum["DECLINED_NEGATIVE_BALANCE"] = "DECLINED_NEGATIVE_BALANCE";
    ApiAchTransactionDetailsPrefundingVerdictEnum["DECLINED_ALREADY_PREFUNDED"] = "DECLINED_ALREADY_PREFUNDED";
    ApiAchTransactionDetailsPrefundingVerdictEnum["DECLINED_RECENT_ACH_RETURNS"] = "DECLINED_RECENT_ACH_RETURNS";
    ApiAchTransactionDetailsPrefundingVerdictEnum["DECLINED_BANK_ACCOUNT_BALANCE_NOT_AVAILABLE"] = "DECLINED_BANK_ACCOUNT_BALANCE_NOT_AVAILABLE";
    ApiAchTransactionDetailsPrefundingVerdictEnum["DECLINED_PLAID_BALANCE_NOT_SUFFICIENT_FUNDS"] = "DECLINED_PLAID_BALANCE_NOT_SUFFICIENT_FUNDS";
    ApiAchTransactionDetailsPrefundingVerdictEnum["DISABLED"] = "DISABLED";
    ApiAchTransactionDetailsPrefundingVerdictEnum["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    ApiAchTransactionDetailsPrefundingVerdictEnum["DECLINED_SAME_DAY_MICRODEPOSIT_ACCOUNT"] = "DECLINED_SAME_DAY_MICRODEPOSIT_ACCOUNT";
    ApiAchTransactionDetailsPrefundingVerdictEnum["DECLINED_INSTITUTION_DENIED"] = "DECLINED_INSTITUTION_DENIED";
})(ApiAchTransactionDetailsPrefundingVerdictEnum = exports.ApiAchTransactionDetailsPrefundingVerdictEnum || (exports.ApiAchTransactionDetailsPrefundingVerdictEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchTransactionResponseAchTypeEnum;
(function (ApiAchTransactionResponseAchTypeEnum) {
    ApiAchTransactionResponseAchTypeEnum["WITHDRAWAL"] = "WITHDRAWAL";
    ApiAchTransactionResponseAchTypeEnum["DEPOSIT"] = "DEPOSIT";
})(ApiAchTransactionResponseAchTypeEnum = exports.ApiAchTransactionResponseAchTypeEnum || (exports.ApiAchTransactionResponseAchTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchTransactionResponseCurrencyEnum;
(function (ApiAchTransactionResponseCurrencyEnum) {
    ApiAchTransactionResponseCurrencyEnum["USD"] = "USD";
    ApiAchTransactionResponseCurrencyEnum["AAVE"] = "AAVE";
    ApiAchTransactionResponseCurrencyEnum["AVAX"] = "AVAX";
    ApiAchTransactionResponseCurrencyEnum["AXS"] = "AXS";
    ApiAchTransactionResponseCurrencyEnum["BAT"] = "BAT";
    ApiAchTransactionResponseCurrencyEnum["BCH"] = "BCH";
    ApiAchTransactionResponseCurrencyEnum["BTC"] = "BTC";
    ApiAchTransactionResponseCurrencyEnum["DOGE"] = "DOGE";
    ApiAchTransactionResponseCurrencyEnum["ETH"] = "ETH";
    ApiAchTransactionResponseCurrencyEnum["LINK"] = "LINK";
    ApiAchTransactionResponseCurrencyEnum["LTC"] = "LTC";
    ApiAchTransactionResponseCurrencyEnum["MANA"] = "MANA";
    ApiAchTransactionResponseCurrencyEnum["MATIC"] = "MATIC";
    ApiAchTransactionResponseCurrencyEnum["SOL"] = "SOL";
    ApiAchTransactionResponseCurrencyEnum["UNI"] = "UNI";
    ApiAchTransactionResponseCurrencyEnum["USDC"] = "USDC";
    ApiAchTransactionResponseCurrencyEnum["LXX"] = "LXX";
    ApiAchTransactionResponseCurrencyEnum["LCP"] = "LCP";
    ApiAchTransactionResponseCurrencyEnum["LWR"] = "LWR";
    ApiAchTransactionResponseCurrencyEnum["LMO"] = "LMO";
    ApiAchTransactionResponseCurrencyEnum["LKO"] = "LKO";
    ApiAchTransactionResponseCurrencyEnum["LED"] = "LED";
})(ApiAchTransactionResponseCurrencyEnum = exports.ApiAchTransactionResponseCurrencyEnum || (exports.ApiAchTransactionResponseCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAchTransactionResponsePrefundingVerdictSummaryEnum;
(function (ApiAchTransactionResponsePrefundingVerdictSummaryEnum) {
    ApiAchTransactionResponsePrefundingVerdictSummaryEnum["ACCEPTED"] = "ACCEPTED";
    ApiAchTransactionResponsePrefundingVerdictSummaryEnum["NOT_ACCEPTED"] = "NOT_ACCEPTED";
})(ApiAchTransactionResponsePrefundingVerdictSummaryEnum = exports.ApiAchTransactionResponsePrefundingVerdictSummaryEnum || (exports.ApiAchTransactionResponsePrefundingVerdictSummaryEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiActivityAuditActivityTypeEnum;
(function (ApiActivityAuditActivityTypeEnum) {
    ApiActivityAuditActivityTypeEnum["PUBLISHED"] = "PUBLISHED";
    ApiActivityAuditActivityTypeEnum["CONFIGURE"] = "CONFIGURE";
    ApiActivityAuditActivityTypeEnum["PREFUND_BLOCK"] = "PREFUND_BLOCK";
    ApiActivityAuditActivityTypeEnum["PREFUND_UNBLOCK"] = "PREFUND_UNBLOCK";
    ApiActivityAuditActivityTypeEnum["SUSPEND"] = "SUSPEND";
    ApiActivityAuditActivityTypeEnum["UNSUSPEND"] = "UNSUSPEND";
    ApiActivityAuditActivityTypeEnum["REPORT_REQUEST"] = "REPORT_REQUEST";
    ApiActivityAuditActivityTypeEnum["REPORT_SENT"] = "REPORT_SENT";
    ApiActivityAuditActivityTypeEnum["KYC_SUCCESS"] = "KYC_SUCCESS";
    ApiActivityAuditActivityTypeEnum["KYC_FAIL"] = "KYC_FAIL";
    ApiActivityAuditActivityTypeEnum["KYC_UPDATE"] = "KYC_UPDATE";
    ApiActivityAuditActivityTypeEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiActivityAuditActivityTypeEnum["CREDIT"] = "CREDIT";
    ApiActivityAuditActivityTypeEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiActivityAuditActivityTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiActivityAuditActivityTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    ApiActivityAuditActivityTypeEnum["BANK_ACCOUNT_BLACKLIST"] = "BANK_ACCOUNT_BLACKLIST";
    ApiActivityAuditActivityTypeEnum["BANK_ACCOUNT_REMOVE_BLACKLIST"] = "BANK_ACCOUNT_REMOVE_BLACKLIST";
    ApiActivityAuditActivityTypeEnum["BAKKT_CARD_KYC_SUCCESS"] = "BAKKT_CARD_KYC_SUCCESS";
    ApiActivityAuditActivityTypeEnum["BAKKT_CARD_KYC_PENDING"] = "BAKKT_CARD_KYC_PENDING";
    ApiActivityAuditActivityTypeEnum["BAKKT_CARD_KYC_FAIL"] = "BAKKT_CARD_KYC_FAIL";
    ApiActivityAuditActivityTypeEnum["LINK_LOYALTY_ACCOUNT"] = "LINK_LOYALTY_ACCOUNT";
    ApiActivityAuditActivityTypeEnum["UNLINK_LOYALTY_ACCOUNT"] = "UNLINK_LOYALTY_ACCOUNT";
})(ApiActivityAuditActivityTypeEnum = exports.ApiActivityAuditActivityTypeEnum || (exports.ApiActivityAuditActivityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiActivityAuditEntityTypeEnum;
(function (ApiActivityAuditEntityTypeEnum) {
    ApiActivityAuditEntityTypeEnum["INCENTIVE"] = "INCENTIVE";
    ApiActivityAuditEntityTypeEnum["ACCOUNT"] = "ACCOUNT";
    ApiActivityAuditEntityTypeEnum["GIFTCARD_BRANDS"] = "GIFTCARD_BRANDS";
    ApiActivityAuditEntityTypeEnum["LOYALTY"] = "LOYALTY";
    ApiActivityAuditEntityTypeEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    ApiActivityAuditEntityTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(ApiActivityAuditEntityTypeEnum = exports.ApiActivityAuditEntityTypeEnum || (exports.ApiActivityAuditEntityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAddressCountryEnum;
(function (ApiAddressCountryEnum) {
    ApiAddressCountryEnum["USA"] = "USA";
})(ApiAddressCountryEnum = exports.ApiAddressCountryEnum || (exports.ApiAddressCountryEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAllowListItemAllowListItemSubtypeEnum;
(function (ApiAllowListItemAllowListItemSubtypeEnum) {
    ApiAllowListItemAllowListItemSubtypeEnum["EMAIL"] = "EMAIL";
    ApiAllowListItemAllowListItemSubtypeEnum["PHONE"] = "PHONE";
    ApiAllowListItemAllowListItemSubtypeEnum["PARTY_ID"] = "PARTY_ID";
    ApiAllowListItemAllowListItemSubtypeEnum["REGION"] = "REGION";
})(ApiAllowListItemAllowListItemSubtypeEnum = exports.ApiAllowListItemAllowListItemSubtypeEnum || (exports.ApiAllowListItemAllowListItemSubtypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAllowListItemAllowListItemTypeEnum;
(function (ApiAllowListItemAllowListItemTypeEnum) {
    ApiAllowListItemAllowListItemTypeEnum["IDENTIFIER"] = "IDENTIFIER";
    ApiAllowListItemAllowListItemTypeEnum["ADDRESS"] = "ADDRESS";
    ApiAllowListItemAllowListItemTypeEnum["BATCH_P2P"] = "BATCH_P2P";
})(ApiAllowListItemAllowListItemTypeEnum = exports.ApiAllowListItemAllowListItemTypeEnum || (exports.ApiAllowListItemAllowListItemTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAllowListItemCurrencyEnum;
(function (ApiAllowListItemCurrencyEnum) {
    ApiAllowListItemCurrencyEnum["USD"] = "USD";
    ApiAllowListItemCurrencyEnum["AAVE"] = "AAVE";
    ApiAllowListItemCurrencyEnum["AVAX"] = "AVAX";
    ApiAllowListItemCurrencyEnum["AXS"] = "AXS";
    ApiAllowListItemCurrencyEnum["BAT"] = "BAT";
    ApiAllowListItemCurrencyEnum["BCH"] = "BCH";
    ApiAllowListItemCurrencyEnum["BTC"] = "BTC";
    ApiAllowListItemCurrencyEnum["DOGE"] = "DOGE";
    ApiAllowListItemCurrencyEnum["ETH"] = "ETH";
    ApiAllowListItemCurrencyEnum["LINK"] = "LINK";
    ApiAllowListItemCurrencyEnum["LTC"] = "LTC";
    ApiAllowListItemCurrencyEnum["MANA"] = "MANA";
    ApiAllowListItemCurrencyEnum["MATIC"] = "MATIC";
    ApiAllowListItemCurrencyEnum["SOL"] = "SOL";
    ApiAllowListItemCurrencyEnum["UNI"] = "UNI";
    ApiAllowListItemCurrencyEnum["USDC"] = "USDC";
    ApiAllowListItemCurrencyEnum["LXX"] = "LXX";
    ApiAllowListItemCurrencyEnum["LCP"] = "LCP";
    ApiAllowListItemCurrencyEnum["LWR"] = "LWR";
    ApiAllowListItemCurrencyEnum["LMO"] = "LMO";
    ApiAllowListItemCurrencyEnum["LKO"] = "LKO";
    ApiAllowListItemCurrencyEnum["LED"] = "LED";
})(ApiAllowListItemCurrencyEnum = exports.ApiAllowListItemCurrencyEnum || (exports.ApiAllowListItemCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAmountCurrencyEnum;
(function (ApiAmountCurrencyEnum) {
    ApiAmountCurrencyEnum["USD"] = "USD";
    ApiAmountCurrencyEnum["AAVE"] = "AAVE";
    ApiAmountCurrencyEnum["AVAX"] = "AVAX";
    ApiAmountCurrencyEnum["AXS"] = "AXS";
    ApiAmountCurrencyEnum["BAT"] = "BAT";
    ApiAmountCurrencyEnum["BCH"] = "BCH";
    ApiAmountCurrencyEnum["BTC"] = "BTC";
    ApiAmountCurrencyEnum["DOGE"] = "DOGE";
    ApiAmountCurrencyEnum["ETH"] = "ETH";
    ApiAmountCurrencyEnum["LINK"] = "LINK";
    ApiAmountCurrencyEnum["LTC"] = "LTC";
    ApiAmountCurrencyEnum["MANA"] = "MANA";
    ApiAmountCurrencyEnum["MATIC"] = "MATIC";
    ApiAmountCurrencyEnum["SOL"] = "SOL";
    ApiAmountCurrencyEnum["UNI"] = "UNI";
    ApiAmountCurrencyEnum["USDC"] = "USDC";
    ApiAmountCurrencyEnum["LXX"] = "LXX";
    ApiAmountCurrencyEnum["LCP"] = "LCP";
    ApiAmountCurrencyEnum["LWR"] = "LWR";
    ApiAmountCurrencyEnum["LMO"] = "LMO";
    ApiAmountCurrencyEnum["LKO"] = "LKO";
    ApiAmountCurrencyEnum["LED"] = "LED";
})(ApiAmountCurrencyEnum = exports.ApiAmountCurrencyEnum || (exports.ApiAmountCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityAssetTypeEnum;
(function (ApiAssetActivityAssetTypeEnum) {
    ApiAssetActivityAssetTypeEnum["CASH"] = "CASH";
    ApiAssetActivityAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiAssetActivityAssetTypeEnum["REWARDS"] = "REWARDS";
    ApiAssetActivityAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiAssetActivityAssetTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiAssetActivityAssetTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(ApiAssetActivityAssetTypeEnum = exports.ApiAssetActivityAssetTypeEnum || (exports.ApiAssetActivityAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityCostBasisCurrencyEnum;
(function (ApiAssetActivityCostBasisCurrencyEnum) {
    ApiAssetActivityCostBasisCurrencyEnum["USD"] = "USD";
    ApiAssetActivityCostBasisCurrencyEnum["AAVE"] = "AAVE";
    ApiAssetActivityCostBasisCurrencyEnum["AVAX"] = "AVAX";
    ApiAssetActivityCostBasisCurrencyEnum["AXS"] = "AXS";
    ApiAssetActivityCostBasisCurrencyEnum["BAT"] = "BAT";
    ApiAssetActivityCostBasisCurrencyEnum["BCH"] = "BCH";
    ApiAssetActivityCostBasisCurrencyEnum["BTC"] = "BTC";
    ApiAssetActivityCostBasisCurrencyEnum["DOGE"] = "DOGE";
    ApiAssetActivityCostBasisCurrencyEnum["ETH"] = "ETH";
    ApiAssetActivityCostBasisCurrencyEnum["LINK"] = "LINK";
    ApiAssetActivityCostBasisCurrencyEnum["LTC"] = "LTC";
    ApiAssetActivityCostBasisCurrencyEnum["MANA"] = "MANA";
    ApiAssetActivityCostBasisCurrencyEnum["MATIC"] = "MATIC";
    ApiAssetActivityCostBasisCurrencyEnum["SOL"] = "SOL";
    ApiAssetActivityCostBasisCurrencyEnum["UNI"] = "UNI";
    ApiAssetActivityCostBasisCurrencyEnum["USDC"] = "USDC";
    ApiAssetActivityCostBasisCurrencyEnum["LXX"] = "LXX";
    ApiAssetActivityCostBasisCurrencyEnum["LCP"] = "LCP";
    ApiAssetActivityCostBasisCurrencyEnum["LWR"] = "LWR";
    ApiAssetActivityCostBasisCurrencyEnum["LMO"] = "LMO";
    ApiAssetActivityCostBasisCurrencyEnum["LKO"] = "LKO";
    ApiAssetActivityCostBasisCurrencyEnum["LED"] = "LED";
})(ApiAssetActivityCostBasisCurrencyEnum = exports.ApiAssetActivityCostBasisCurrencyEnum || (exports.ApiAssetActivityCostBasisCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityDeclineReasonEnum;
(function (ApiAssetActivityDeclineReasonEnum) {
    ApiAssetActivityDeclineReasonEnum["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    ApiAssetActivityDeclineReasonEnum["FUNDING_PREFERENCE_NOT_FOUND"] = "FUNDING_PREFERENCE_NOT_FOUND";
    ApiAssetActivityDeclineReasonEnum["CARD_INVALID_STATUS"] = "CARD_INVALID_STATUS";
    ApiAssetActivityDeclineReasonEnum["CARD_NOT_FOUND"] = "CARD_NOT_FOUND";
    ApiAssetActivityDeclineReasonEnum["CARD_NOT_ACTIVATED"] = "CARD_NOT_ACTIVATED";
    ApiAssetActivityDeclineReasonEnum["DAILY_LIMIT_EXCEEDED"] = "DAILY_LIMIT_EXCEEDED";
    ApiAssetActivityDeclineReasonEnum["MONTHLY_LIMIT_EXCEEDED"] = "MONTHLY_LIMIT_EXCEEDED";
    ApiAssetActivityDeclineReasonEnum["OVER_LIMIT"] = "OVER_LIMIT";
    ApiAssetActivityDeclineReasonEnum["NOT_SUFFICIENT_FUNDS"] = "NOT_SUFFICIENT_FUNDS";
    ApiAssetActivityDeclineReasonEnum["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    ApiAssetActivityDeclineReasonEnum["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    ApiAssetActivityDeclineReasonEnum["CARD_ISSUER_PARTY_NOT_FOUND"] = "CARD_ISSUER_PARTY_NOT_FOUND";
    ApiAssetActivityDeclineReasonEnum["CARD_ISSUER_PARTY_INVALID_STATUS"] = "CARD_ISSUER_PARTY_INVALID_STATUS";
    ApiAssetActivityDeclineReasonEnum["PARTY_NOT_FOUND"] = "PARTY_NOT_FOUND";
    ApiAssetActivityDeclineReasonEnum["PARTY_INVALID_STATUS"] = "PARTY_INVALID_STATUS";
    ApiAssetActivityDeclineReasonEnum["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    ApiAssetActivityDeclineReasonEnum["DATA_MISMATCH"] = "DATA_MISMATCH";
    ApiAssetActivityDeclineReasonEnum["GENERIC_PAYMENT_PROCESSING_ERROR"] = "GENERIC_PAYMENT_PROCESSING_ERROR";
    ApiAssetActivityDeclineReasonEnum["PRECONDITION_NOT_MET"] = "PRECONDITION_NOT_MET";
    ApiAssetActivityDeclineReasonEnum["INSUFFICIENT_FUNDS_FOR_BAKKT_ACCOUNT_DEPOSIT"] = "INSUFFICIENT_FUNDS_FOR_BAKKT_ACCOUNT_DEPOSIT";
    ApiAssetActivityDeclineReasonEnum["BLACKLISTED_DEBIT_CARD"] = "BLACKLISTED_DEBIT_CARD";
    ApiAssetActivityDeclineReasonEnum["BLACKLISTED_MERCHANT_CATEGORY"] = "BLACKLISTED_MERCHANT_CATEGORY";
    ApiAssetActivityDeclineReasonEnum["BLACKLISTED_BANK_ACCOUNT"] = "BLACKLISTED_BANK_ACCOUNT";
    ApiAssetActivityDeclineReasonEnum["BANK_ACCOUNT_BLACKLISTED_LINKING_FAILED"] = "BANK_ACCOUNT_BLACKLISTED_LINKING_FAILED";
    ApiAssetActivityDeclineReasonEnum["TRANSACTION_FAILED"] = "TRANSACTION_FAILED";
    ApiAssetActivityDeclineReasonEnum["REAUTHENTICATION_REQUIRED"] = "REAUTHENTICATION_REQUIRED";
    ApiAssetActivityDeclineReasonEnum["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ApiAssetActivityDeclineReasonEnum["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ApiAssetActivityDeclineReasonEnum["PROCESSOR_DECLINED"] = "PROCESSOR_DECLINED";
    ApiAssetActivityDeclineReasonEnum["SETTLEMENT_DECLINED"] = "SETTLEMENT_DECLINED";
    ApiAssetActivityDeclineReasonEnum["GATEWAY_REJECTED"] = "GATEWAY_REJECTED";
    ApiAssetActivityDeclineReasonEnum["REWARDS_GATEWAY_REJECTED"] = "REWARDS_GATEWAY_REJECTED";
    ApiAssetActivityDeclineReasonEnum["AVS_ERROR"] = "AVS_ERROR";
    ApiAssetActivityDeclineReasonEnum["CVV_ERROR"] = "CVV_ERROR";
    ApiAssetActivityDeclineReasonEnum["AVS_GATEWAY_ERROR"] = "AVS_GATEWAY_ERROR";
    ApiAssetActivityDeclineReasonEnum["AVS_VERIFICATION_FAILED"] = "AVS_VERIFICATION_FAILED";
    ApiAssetActivityDeclineReasonEnum["CVV_VERIFICATION_FAILED"] = "CVV_VERIFICATION_FAILED";
    ApiAssetActivityDeclineReasonEnum["AMOUNT_VERIFICATION_FAILED"] = "AMOUNT_VERIFICATION_FAILED";
    ApiAssetActivityDeclineReasonEnum["DEBIT_CARD_NOT_FOUND"] = "DEBIT_CARD_NOT_FOUND";
    ApiAssetActivityDeclineReasonEnum["SDK_ERROR"] = "SDK_ERROR";
})(ApiAssetActivityDeclineReasonEnum = exports.ApiAssetActivityDeclineReasonEnum || (exports.ApiAssetActivityDeclineReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityDestinationAssetTypeEnum;
(function (ApiAssetActivityDestinationAssetTypeEnum) {
    ApiAssetActivityDestinationAssetTypeEnum["CASH"] = "CASH";
    ApiAssetActivityDestinationAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiAssetActivityDestinationAssetTypeEnum["REWARDS"] = "REWARDS";
    ApiAssetActivityDestinationAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiAssetActivityDestinationAssetTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiAssetActivityDestinationAssetTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(ApiAssetActivityDestinationAssetTypeEnum = exports.ApiAssetActivityDestinationAssetTypeEnum || (exports.ApiAssetActivityDestinationAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityDestinationCurrencyEnum;
(function (ApiAssetActivityDestinationCurrencyEnum) {
    ApiAssetActivityDestinationCurrencyEnum["USD"] = "USD";
    ApiAssetActivityDestinationCurrencyEnum["AAVE"] = "AAVE";
    ApiAssetActivityDestinationCurrencyEnum["AVAX"] = "AVAX";
    ApiAssetActivityDestinationCurrencyEnum["AXS"] = "AXS";
    ApiAssetActivityDestinationCurrencyEnum["BAT"] = "BAT";
    ApiAssetActivityDestinationCurrencyEnum["BCH"] = "BCH";
    ApiAssetActivityDestinationCurrencyEnum["BTC"] = "BTC";
    ApiAssetActivityDestinationCurrencyEnum["DOGE"] = "DOGE";
    ApiAssetActivityDestinationCurrencyEnum["ETH"] = "ETH";
    ApiAssetActivityDestinationCurrencyEnum["LINK"] = "LINK";
    ApiAssetActivityDestinationCurrencyEnum["LTC"] = "LTC";
    ApiAssetActivityDestinationCurrencyEnum["MANA"] = "MANA";
    ApiAssetActivityDestinationCurrencyEnum["MATIC"] = "MATIC";
    ApiAssetActivityDestinationCurrencyEnum["SOL"] = "SOL";
    ApiAssetActivityDestinationCurrencyEnum["UNI"] = "UNI";
    ApiAssetActivityDestinationCurrencyEnum["USDC"] = "USDC";
    ApiAssetActivityDestinationCurrencyEnum["LXX"] = "LXX";
    ApiAssetActivityDestinationCurrencyEnum["LCP"] = "LCP";
    ApiAssetActivityDestinationCurrencyEnum["LWR"] = "LWR";
    ApiAssetActivityDestinationCurrencyEnum["LMO"] = "LMO";
    ApiAssetActivityDestinationCurrencyEnum["LKO"] = "LKO";
    ApiAssetActivityDestinationCurrencyEnum["LED"] = "LED";
})(ApiAssetActivityDestinationCurrencyEnum = exports.ApiAssetActivityDestinationCurrencyEnum || (exports.ApiAssetActivityDestinationCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityFeeCurrencyEnum;
(function (ApiAssetActivityFeeCurrencyEnum) {
    ApiAssetActivityFeeCurrencyEnum["USD"] = "USD";
    ApiAssetActivityFeeCurrencyEnum["AAVE"] = "AAVE";
    ApiAssetActivityFeeCurrencyEnum["AVAX"] = "AVAX";
    ApiAssetActivityFeeCurrencyEnum["AXS"] = "AXS";
    ApiAssetActivityFeeCurrencyEnum["BAT"] = "BAT";
    ApiAssetActivityFeeCurrencyEnum["BCH"] = "BCH";
    ApiAssetActivityFeeCurrencyEnum["BTC"] = "BTC";
    ApiAssetActivityFeeCurrencyEnum["DOGE"] = "DOGE";
    ApiAssetActivityFeeCurrencyEnum["ETH"] = "ETH";
    ApiAssetActivityFeeCurrencyEnum["LINK"] = "LINK";
    ApiAssetActivityFeeCurrencyEnum["LTC"] = "LTC";
    ApiAssetActivityFeeCurrencyEnum["MANA"] = "MANA";
    ApiAssetActivityFeeCurrencyEnum["MATIC"] = "MATIC";
    ApiAssetActivityFeeCurrencyEnum["SOL"] = "SOL";
    ApiAssetActivityFeeCurrencyEnum["UNI"] = "UNI";
    ApiAssetActivityFeeCurrencyEnum["USDC"] = "USDC";
    ApiAssetActivityFeeCurrencyEnum["LXX"] = "LXX";
    ApiAssetActivityFeeCurrencyEnum["LCP"] = "LCP";
    ApiAssetActivityFeeCurrencyEnum["LWR"] = "LWR";
    ApiAssetActivityFeeCurrencyEnum["LMO"] = "LMO";
    ApiAssetActivityFeeCurrencyEnum["LKO"] = "LKO";
    ApiAssetActivityFeeCurrencyEnum["LED"] = "LED";
})(ApiAssetActivityFeeCurrencyEnum = exports.ApiAssetActivityFeeCurrencyEnum || (exports.ApiAssetActivityFeeCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityGroupActivityTypeEnum;
(function (ApiAssetActivityGroupActivityTypeEnum) {
    ApiAssetActivityGroupActivityTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiAssetActivityGroupActivityTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiAssetActivityGroupActivityTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiAssetActivityGroupActivityTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
})(ApiAssetActivityGroupActivityTypeEnum = exports.ApiAssetActivityGroupActivityTypeEnum || (exports.ApiAssetActivityGroupActivityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityGroupAssetTypeEnum;
(function (ApiAssetActivityGroupAssetTypeEnum) {
    ApiAssetActivityGroupAssetTypeEnum["CASH"] = "CASH";
    ApiAssetActivityGroupAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiAssetActivityGroupAssetTypeEnum["REWARDS"] = "REWARDS";
    ApiAssetActivityGroupAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiAssetActivityGroupAssetTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiAssetActivityGroupAssetTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(ApiAssetActivityGroupAssetTypeEnum = exports.ApiAssetActivityGroupAssetTypeEnum || (exports.ApiAssetActivityGroupAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivitySourceAssetTypeEnum;
(function (ApiAssetActivitySourceAssetTypeEnum) {
    ApiAssetActivitySourceAssetTypeEnum["CASH"] = "CASH";
    ApiAssetActivitySourceAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiAssetActivitySourceAssetTypeEnum["REWARDS"] = "REWARDS";
    ApiAssetActivitySourceAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiAssetActivitySourceAssetTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiAssetActivitySourceAssetTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(ApiAssetActivitySourceAssetTypeEnum = exports.ApiAssetActivitySourceAssetTypeEnum || (exports.ApiAssetActivitySourceAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivitySourceCurrencyEnum;
(function (ApiAssetActivitySourceCurrencyEnum) {
    ApiAssetActivitySourceCurrencyEnum["USD"] = "USD";
    ApiAssetActivitySourceCurrencyEnum["AAVE"] = "AAVE";
    ApiAssetActivitySourceCurrencyEnum["AVAX"] = "AVAX";
    ApiAssetActivitySourceCurrencyEnum["AXS"] = "AXS";
    ApiAssetActivitySourceCurrencyEnum["BAT"] = "BAT";
    ApiAssetActivitySourceCurrencyEnum["BCH"] = "BCH";
    ApiAssetActivitySourceCurrencyEnum["BTC"] = "BTC";
    ApiAssetActivitySourceCurrencyEnum["DOGE"] = "DOGE";
    ApiAssetActivitySourceCurrencyEnum["ETH"] = "ETH";
    ApiAssetActivitySourceCurrencyEnum["LINK"] = "LINK";
    ApiAssetActivitySourceCurrencyEnum["LTC"] = "LTC";
    ApiAssetActivitySourceCurrencyEnum["MANA"] = "MANA";
    ApiAssetActivitySourceCurrencyEnum["MATIC"] = "MATIC";
    ApiAssetActivitySourceCurrencyEnum["SOL"] = "SOL";
    ApiAssetActivitySourceCurrencyEnum["UNI"] = "UNI";
    ApiAssetActivitySourceCurrencyEnum["USDC"] = "USDC";
    ApiAssetActivitySourceCurrencyEnum["LXX"] = "LXX";
    ApiAssetActivitySourceCurrencyEnum["LCP"] = "LCP";
    ApiAssetActivitySourceCurrencyEnum["LWR"] = "LWR";
    ApiAssetActivitySourceCurrencyEnum["LMO"] = "LMO";
    ApiAssetActivitySourceCurrencyEnum["LKO"] = "LKO";
    ApiAssetActivitySourceCurrencyEnum["LED"] = "LED";
})(ApiAssetActivitySourceCurrencyEnum = exports.ApiAssetActivitySourceCurrencyEnum || (exports.ApiAssetActivitySourceCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityStatusEnum;
(function (ApiAssetActivityStatusEnum) {
    ApiAssetActivityStatusEnum["CANCELED"] = "CANCELED";
    ApiAssetActivityStatusEnum["COMPLETE"] = "COMPLETE";
    ApiAssetActivityStatusEnum["EXPIRED"] = "EXPIRED";
    ApiAssetActivityStatusEnum["PENDING"] = "PENDING";
    ApiAssetActivityStatusEnum["REJECTED"] = "REJECTED";
    ApiAssetActivityStatusEnum["REPLACED"] = "REPLACED";
    ApiAssetActivityStatusEnum["FAILED"] = "FAILED";
    ApiAssetActivityStatusEnum["PROVISIONAL"] = "PROVISIONAL";
})(ApiAssetActivityStatusEnum = exports.ApiAssetActivityStatusEnum || (exports.ApiAssetActivityStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityTypeEnum;
(function (ApiAssetActivityTypeEnum) {
    ApiAssetActivityTypeEnum["ADD"] = "ADD";
    ApiAssetActivityTypeEnum["BUY"] = "BUY";
    ApiAssetActivityTypeEnum["CARD_CHARGEBACK"] = "CARD_CHARGEBACK";
    ApiAssetActivityTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    ApiAssetActivityTypeEnum["CARD_REFUND"] = "CARD_REFUND";
    ApiAssetActivityTypeEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiAssetActivityTypeEnum["CREDIT"] = "CREDIT";
    ApiAssetActivityTypeEnum["CONVERT"] = "CONVERT";
    ApiAssetActivityTypeEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    ApiAssetActivityTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiAssetActivityTypeEnum["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
    ApiAssetActivityTypeEnum["DEPOSIT_RETURNED"] = "DEPOSIT_RETURNED";
    ApiAssetActivityTypeEnum["DEPOSIT_REVERSE"] = "DEPOSIT_REVERSE";
    ApiAssetActivityTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiAssetActivityTypeEnum["DISPUTE_CREDIT_REVERSE"] = "DISPUTE_CREDIT_REVERSE";
    ApiAssetActivityTypeEnum["FREEZE"] = "FREEZE";
    ApiAssetActivityTypeEnum["INCENTIVE"] = "INCENTIVE";
    ApiAssetActivityTypeEnum["INCENTIVE_CANCEL"] = "INCENTIVE_CANCEL";
    ApiAssetActivityTypeEnum["LOYALTY_BUY"] = "LOYALTY_BUY";
    ApiAssetActivityTypeEnum["LOYALTY_BUY_CANCEL"] = "LOYALTY_BUY_CANCEL";
    ApiAssetActivityTypeEnum["LOYALTY_CREDIT_CANCEL"] = "LOYALTY_CREDIT_CANCEL";
    ApiAssetActivityTypeEnum["LOYALTY_REDEEM"] = "LOYALTY_REDEEM";
    ApiAssetActivityTypeEnum["LOYALTY_CRYPTO_REDEEM_FAILED"] = "LOYALTY_CRYPTO_REDEEM_FAILED";
    ApiAssetActivityTypeEnum["LOYALTY_PAYMENT_REVERSAL"] = "LOYALTY_PAYMENT_REVERSAL";
    ApiAssetActivityTypeEnum["LINK"] = "LINK";
    ApiAssetActivityTypeEnum["MERCHANT_CREDIT"] = "MERCHANT_CREDIT";
    ApiAssetActivityTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiAssetActivityTypeEnum["MERCHANT_PAYMENT_AUTHORIZE"] = "MERCHANT_PAYMENT_AUTHORIZE";
    ApiAssetActivityTypeEnum["MERCHANT_PAYMENT_AUTHORIZE_DECLINED"] = "MERCHANT_PAYMENT_AUTHORIZE_DECLINED";
    ApiAssetActivityTypeEnum["MERCHANT_PAYMENT_CANCEL"] = "MERCHANT_PAYMENT_CANCEL";
    ApiAssetActivityTypeEnum["MERCHANT_PAYMENT_CAPTURE"] = "MERCHANT_PAYMENT_CAPTURE";
    ApiAssetActivityTypeEnum["MERCHANT_PAYMENT_CREDIT"] = "MERCHANT_PAYMENT_CREDIT";
    ApiAssetActivityTypeEnum["MERCHANT_PAYMENT_REFUND"] = "MERCHANT_PAYMENT_REFUND";
    ApiAssetActivityTypeEnum["MERCHANT_PAYMENT_DISPUTE"] = "MERCHANT_PAYMENT_DISPUTE";
    ApiAssetActivityTypeEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    ApiAssetActivityTypeEnum["PAYOUT"] = "PAYOUT";
    ApiAssetActivityTypeEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiAssetActivityTypeEnum["RECEIVE"] = "RECEIVE";
    ApiAssetActivityTypeEnum["REDEEM"] = "REDEEM";
    ApiAssetActivityTypeEnum["REMOVE"] = "REMOVE";
    ApiAssetActivityTypeEnum["RESTORE"] = "RESTORE";
    ApiAssetActivityTypeEnum["REVERSE"] = "REVERSE";
    ApiAssetActivityTypeEnum["SELL"] = "SELL";
    ApiAssetActivityTypeEnum["SEND"] = "SEND";
    ApiAssetActivityTypeEnum["TERMINATE"] = "TERMINATE";
    ApiAssetActivityTypeEnum["UNFREEZE"] = "UNFREEZE";
    ApiAssetActivityTypeEnum["UNLINK"] = "UNLINK";
    ApiAssetActivityTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiAssetActivityTypeEnum["WITHDRAW_REVERSE"] = "WITHDRAW_REVERSE";
    ApiAssetActivityTypeEnum["WITHDRAW_RETURN"] = "WITHDRAW_RETURN";
    ApiAssetActivityTypeEnum["WITHDRAW_RETURNED"] = "WITHDRAW_RETURNED";
    ApiAssetActivityTypeEnum["PARTNER_REWARD_CRYPTO"] = "PARTNER_REWARD_CRYPTO";
    ApiAssetActivityTypeEnum["PARTNER_REWARD_CASH"] = "PARTNER_REWARD_CASH";
})(ApiAssetActivityTypeEnum = exports.ApiAssetActivityTypeEnum || (exports.ApiAssetActivityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityDetailsAssetTypeEnum;
(function (ApiAssetActivityDetailsAssetTypeEnum) {
    ApiAssetActivityDetailsAssetTypeEnum["CASH"] = "CASH";
    ApiAssetActivityDetailsAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiAssetActivityDetailsAssetTypeEnum["REWARDS"] = "REWARDS";
    ApiAssetActivityDetailsAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiAssetActivityDetailsAssetTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiAssetActivityDetailsAssetTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(ApiAssetActivityDetailsAssetTypeEnum = exports.ApiAssetActivityDetailsAssetTypeEnum || (exports.ApiAssetActivityDetailsAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityDetailsCostBasisCurrencyEnum;
(function (ApiAssetActivityDetailsCostBasisCurrencyEnum) {
    ApiAssetActivityDetailsCostBasisCurrencyEnum["USD"] = "USD";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["AAVE"] = "AAVE";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["AVAX"] = "AVAX";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["AXS"] = "AXS";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["BAT"] = "BAT";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["BCH"] = "BCH";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["BTC"] = "BTC";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["DOGE"] = "DOGE";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["ETH"] = "ETH";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["LINK"] = "LINK";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["LTC"] = "LTC";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["MANA"] = "MANA";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["MATIC"] = "MATIC";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["SOL"] = "SOL";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["UNI"] = "UNI";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["USDC"] = "USDC";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["LXX"] = "LXX";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["LCP"] = "LCP";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["LWR"] = "LWR";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["LMO"] = "LMO";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["LKO"] = "LKO";
    ApiAssetActivityDetailsCostBasisCurrencyEnum["LED"] = "LED";
})(ApiAssetActivityDetailsCostBasisCurrencyEnum = exports.ApiAssetActivityDetailsCostBasisCurrencyEnum || (exports.ApiAssetActivityDetailsCostBasisCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityDetailsDestinationCurrencyEnum;
(function (ApiAssetActivityDetailsDestinationCurrencyEnum) {
    ApiAssetActivityDetailsDestinationCurrencyEnum["USD"] = "USD";
    ApiAssetActivityDetailsDestinationCurrencyEnum["AAVE"] = "AAVE";
    ApiAssetActivityDetailsDestinationCurrencyEnum["AVAX"] = "AVAX";
    ApiAssetActivityDetailsDestinationCurrencyEnum["AXS"] = "AXS";
    ApiAssetActivityDetailsDestinationCurrencyEnum["BAT"] = "BAT";
    ApiAssetActivityDetailsDestinationCurrencyEnum["BCH"] = "BCH";
    ApiAssetActivityDetailsDestinationCurrencyEnum["BTC"] = "BTC";
    ApiAssetActivityDetailsDestinationCurrencyEnum["DOGE"] = "DOGE";
    ApiAssetActivityDetailsDestinationCurrencyEnum["ETH"] = "ETH";
    ApiAssetActivityDetailsDestinationCurrencyEnum["LINK"] = "LINK";
    ApiAssetActivityDetailsDestinationCurrencyEnum["LTC"] = "LTC";
    ApiAssetActivityDetailsDestinationCurrencyEnum["MANA"] = "MANA";
    ApiAssetActivityDetailsDestinationCurrencyEnum["MATIC"] = "MATIC";
    ApiAssetActivityDetailsDestinationCurrencyEnum["SOL"] = "SOL";
    ApiAssetActivityDetailsDestinationCurrencyEnum["UNI"] = "UNI";
    ApiAssetActivityDetailsDestinationCurrencyEnum["USDC"] = "USDC";
    ApiAssetActivityDetailsDestinationCurrencyEnum["LXX"] = "LXX";
    ApiAssetActivityDetailsDestinationCurrencyEnum["LCP"] = "LCP";
    ApiAssetActivityDetailsDestinationCurrencyEnum["LWR"] = "LWR";
    ApiAssetActivityDetailsDestinationCurrencyEnum["LMO"] = "LMO";
    ApiAssetActivityDetailsDestinationCurrencyEnum["LKO"] = "LKO";
    ApiAssetActivityDetailsDestinationCurrencyEnum["LED"] = "LED";
})(ApiAssetActivityDetailsDestinationCurrencyEnum = exports.ApiAssetActivityDetailsDestinationCurrencyEnum || (exports.ApiAssetActivityDetailsDestinationCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityDetailsSourceCurrencyEnum;
(function (ApiAssetActivityDetailsSourceCurrencyEnum) {
    ApiAssetActivityDetailsSourceCurrencyEnum["USD"] = "USD";
    ApiAssetActivityDetailsSourceCurrencyEnum["AAVE"] = "AAVE";
    ApiAssetActivityDetailsSourceCurrencyEnum["AVAX"] = "AVAX";
    ApiAssetActivityDetailsSourceCurrencyEnum["AXS"] = "AXS";
    ApiAssetActivityDetailsSourceCurrencyEnum["BAT"] = "BAT";
    ApiAssetActivityDetailsSourceCurrencyEnum["BCH"] = "BCH";
    ApiAssetActivityDetailsSourceCurrencyEnum["BTC"] = "BTC";
    ApiAssetActivityDetailsSourceCurrencyEnum["DOGE"] = "DOGE";
    ApiAssetActivityDetailsSourceCurrencyEnum["ETH"] = "ETH";
    ApiAssetActivityDetailsSourceCurrencyEnum["LINK"] = "LINK";
    ApiAssetActivityDetailsSourceCurrencyEnum["LTC"] = "LTC";
    ApiAssetActivityDetailsSourceCurrencyEnum["MANA"] = "MANA";
    ApiAssetActivityDetailsSourceCurrencyEnum["MATIC"] = "MATIC";
    ApiAssetActivityDetailsSourceCurrencyEnum["SOL"] = "SOL";
    ApiAssetActivityDetailsSourceCurrencyEnum["UNI"] = "UNI";
    ApiAssetActivityDetailsSourceCurrencyEnum["USDC"] = "USDC";
    ApiAssetActivityDetailsSourceCurrencyEnum["LXX"] = "LXX";
    ApiAssetActivityDetailsSourceCurrencyEnum["LCP"] = "LCP";
    ApiAssetActivityDetailsSourceCurrencyEnum["LWR"] = "LWR";
    ApiAssetActivityDetailsSourceCurrencyEnum["LMO"] = "LMO";
    ApiAssetActivityDetailsSourceCurrencyEnum["LKO"] = "LKO";
    ApiAssetActivityDetailsSourceCurrencyEnum["LED"] = "LED";
})(ApiAssetActivityDetailsSourceCurrencyEnum = exports.ApiAssetActivityDetailsSourceCurrencyEnum || (exports.ApiAssetActivityDetailsSourceCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityDetailsStatusEnum;
(function (ApiAssetActivityDetailsStatusEnum) {
    ApiAssetActivityDetailsStatusEnum["CANCELED"] = "CANCELED";
    ApiAssetActivityDetailsStatusEnum["COMPLETE"] = "COMPLETE";
    ApiAssetActivityDetailsStatusEnum["EXPIRED"] = "EXPIRED";
    ApiAssetActivityDetailsStatusEnum["PENDING"] = "PENDING";
    ApiAssetActivityDetailsStatusEnum["REJECTED"] = "REJECTED";
    ApiAssetActivityDetailsStatusEnum["REPLACED"] = "REPLACED";
    ApiAssetActivityDetailsStatusEnum["FAILED"] = "FAILED";
    ApiAssetActivityDetailsStatusEnum["PROVISIONAL"] = "PROVISIONAL";
})(ApiAssetActivityDetailsStatusEnum = exports.ApiAssetActivityDetailsStatusEnum || (exports.ApiAssetActivityDetailsStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivityDetailsTypeEnum;
(function (ApiAssetActivityDetailsTypeEnum) {
    ApiAssetActivityDetailsTypeEnum["ADD"] = "ADD";
    ApiAssetActivityDetailsTypeEnum["BUY"] = "BUY";
    ApiAssetActivityDetailsTypeEnum["CARD_CHARGEBACK"] = "CARD_CHARGEBACK";
    ApiAssetActivityDetailsTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    ApiAssetActivityDetailsTypeEnum["CARD_REFUND"] = "CARD_REFUND";
    ApiAssetActivityDetailsTypeEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiAssetActivityDetailsTypeEnum["CREDIT"] = "CREDIT";
    ApiAssetActivityDetailsTypeEnum["CONVERT"] = "CONVERT";
    ApiAssetActivityDetailsTypeEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    ApiAssetActivityDetailsTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiAssetActivityDetailsTypeEnum["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
    ApiAssetActivityDetailsTypeEnum["DEPOSIT_RETURNED"] = "DEPOSIT_RETURNED";
    ApiAssetActivityDetailsTypeEnum["DEPOSIT_REVERSE"] = "DEPOSIT_REVERSE";
    ApiAssetActivityDetailsTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiAssetActivityDetailsTypeEnum["DISPUTE_CREDIT_REVERSE"] = "DISPUTE_CREDIT_REVERSE";
    ApiAssetActivityDetailsTypeEnum["FREEZE"] = "FREEZE";
    ApiAssetActivityDetailsTypeEnum["INCENTIVE"] = "INCENTIVE";
    ApiAssetActivityDetailsTypeEnum["INCENTIVE_CANCEL"] = "INCENTIVE_CANCEL";
    ApiAssetActivityDetailsTypeEnum["LOYALTY_BUY"] = "LOYALTY_BUY";
    ApiAssetActivityDetailsTypeEnum["LOYALTY_BUY_CANCEL"] = "LOYALTY_BUY_CANCEL";
    ApiAssetActivityDetailsTypeEnum["LOYALTY_CREDIT_CANCEL"] = "LOYALTY_CREDIT_CANCEL";
    ApiAssetActivityDetailsTypeEnum["LOYALTY_REDEEM"] = "LOYALTY_REDEEM";
    ApiAssetActivityDetailsTypeEnum["LOYALTY_CRYPTO_REDEEM_FAILED"] = "LOYALTY_CRYPTO_REDEEM_FAILED";
    ApiAssetActivityDetailsTypeEnum["LOYALTY_PAYMENT_REVERSAL"] = "LOYALTY_PAYMENT_REVERSAL";
    ApiAssetActivityDetailsTypeEnum["LINK"] = "LINK";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_CREDIT"] = "MERCHANT_CREDIT";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_PAYMENT_AUTHORIZE"] = "MERCHANT_PAYMENT_AUTHORIZE";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_PAYMENT_AUTHORIZE_DECLINED"] = "MERCHANT_PAYMENT_AUTHORIZE_DECLINED";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_PAYMENT_CANCEL"] = "MERCHANT_PAYMENT_CANCEL";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_PAYMENT_CAPTURE"] = "MERCHANT_PAYMENT_CAPTURE";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_PAYMENT_CREDIT"] = "MERCHANT_PAYMENT_CREDIT";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_PAYMENT_REFUND"] = "MERCHANT_PAYMENT_REFUND";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_PAYMENT_DISPUTE"] = "MERCHANT_PAYMENT_DISPUTE";
    ApiAssetActivityDetailsTypeEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    ApiAssetActivityDetailsTypeEnum["PAYOUT"] = "PAYOUT";
    ApiAssetActivityDetailsTypeEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiAssetActivityDetailsTypeEnum["RECEIVE"] = "RECEIVE";
    ApiAssetActivityDetailsTypeEnum["REDEEM"] = "REDEEM";
    ApiAssetActivityDetailsTypeEnum["REMOVE"] = "REMOVE";
    ApiAssetActivityDetailsTypeEnum["RESTORE"] = "RESTORE";
    ApiAssetActivityDetailsTypeEnum["REVERSE"] = "REVERSE";
    ApiAssetActivityDetailsTypeEnum["SELL"] = "SELL";
    ApiAssetActivityDetailsTypeEnum["SEND"] = "SEND";
    ApiAssetActivityDetailsTypeEnum["TERMINATE"] = "TERMINATE";
    ApiAssetActivityDetailsTypeEnum["UNFREEZE"] = "UNFREEZE";
    ApiAssetActivityDetailsTypeEnum["UNLINK"] = "UNLINK";
    ApiAssetActivityDetailsTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiAssetActivityDetailsTypeEnum["WITHDRAW_REVERSE"] = "WITHDRAW_REVERSE";
    ApiAssetActivityDetailsTypeEnum["WITHDRAW_RETURN"] = "WITHDRAW_RETURN";
    ApiAssetActivityDetailsTypeEnum["WITHDRAW_RETURNED"] = "WITHDRAW_RETURNED";
    ApiAssetActivityDetailsTypeEnum["PARTNER_REWARD_CRYPTO"] = "PARTNER_REWARD_CRYPTO";
    ApiAssetActivityDetailsTypeEnum["PARTNER_REWARD_CASH"] = "PARTNER_REWARD_CASH";
})(ApiAssetActivityDetailsTypeEnum = exports.ApiAssetActivityDetailsTypeEnum || (exports.ApiAssetActivityDetailsTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivitySummaryDeclineReasonEnum;
(function (ApiAssetActivitySummaryDeclineReasonEnum) {
    ApiAssetActivitySummaryDeclineReasonEnum["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    ApiAssetActivitySummaryDeclineReasonEnum["FUNDING_PREFERENCE_NOT_FOUND"] = "FUNDING_PREFERENCE_NOT_FOUND";
    ApiAssetActivitySummaryDeclineReasonEnum["CARD_INVALID_STATUS"] = "CARD_INVALID_STATUS";
    ApiAssetActivitySummaryDeclineReasonEnum["CARD_NOT_FOUND"] = "CARD_NOT_FOUND";
    ApiAssetActivitySummaryDeclineReasonEnum["CARD_NOT_ACTIVATED"] = "CARD_NOT_ACTIVATED";
    ApiAssetActivitySummaryDeclineReasonEnum["DAILY_LIMIT_EXCEEDED"] = "DAILY_LIMIT_EXCEEDED";
    ApiAssetActivitySummaryDeclineReasonEnum["MONTHLY_LIMIT_EXCEEDED"] = "MONTHLY_LIMIT_EXCEEDED";
    ApiAssetActivitySummaryDeclineReasonEnum["OVER_LIMIT"] = "OVER_LIMIT";
    ApiAssetActivitySummaryDeclineReasonEnum["NOT_SUFFICIENT_FUNDS"] = "NOT_SUFFICIENT_FUNDS";
    ApiAssetActivitySummaryDeclineReasonEnum["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    ApiAssetActivitySummaryDeclineReasonEnum["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    ApiAssetActivitySummaryDeclineReasonEnum["CARD_ISSUER_PARTY_NOT_FOUND"] = "CARD_ISSUER_PARTY_NOT_FOUND";
    ApiAssetActivitySummaryDeclineReasonEnum["CARD_ISSUER_PARTY_INVALID_STATUS"] = "CARD_ISSUER_PARTY_INVALID_STATUS";
    ApiAssetActivitySummaryDeclineReasonEnum["PARTY_NOT_FOUND"] = "PARTY_NOT_FOUND";
    ApiAssetActivitySummaryDeclineReasonEnum["PARTY_INVALID_STATUS"] = "PARTY_INVALID_STATUS";
    ApiAssetActivitySummaryDeclineReasonEnum["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    ApiAssetActivitySummaryDeclineReasonEnum["DATA_MISMATCH"] = "DATA_MISMATCH";
    ApiAssetActivitySummaryDeclineReasonEnum["GENERIC_PAYMENT_PROCESSING_ERROR"] = "GENERIC_PAYMENT_PROCESSING_ERROR";
    ApiAssetActivitySummaryDeclineReasonEnum["PRECONDITION_NOT_MET"] = "PRECONDITION_NOT_MET";
    ApiAssetActivitySummaryDeclineReasonEnum["INSUFFICIENT_FUNDS_FOR_BAKKT_ACCOUNT_DEPOSIT"] = "INSUFFICIENT_FUNDS_FOR_BAKKT_ACCOUNT_DEPOSIT";
    ApiAssetActivitySummaryDeclineReasonEnum["BLACKLISTED_DEBIT_CARD"] = "BLACKLISTED_DEBIT_CARD";
    ApiAssetActivitySummaryDeclineReasonEnum["BLACKLISTED_MERCHANT_CATEGORY"] = "BLACKLISTED_MERCHANT_CATEGORY";
    ApiAssetActivitySummaryDeclineReasonEnum["BLACKLISTED_BANK_ACCOUNT"] = "BLACKLISTED_BANK_ACCOUNT";
    ApiAssetActivitySummaryDeclineReasonEnum["BANK_ACCOUNT_BLACKLISTED_LINKING_FAILED"] = "BANK_ACCOUNT_BLACKLISTED_LINKING_FAILED";
    ApiAssetActivitySummaryDeclineReasonEnum["TRANSACTION_FAILED"] = "TRANSACTION_FAILED";
    ApiAssetActivitySummaryDeclineReasonEnum["REAUTHENTICATION_REQUIRED"] = "REAUTHENTICATION_REQUIRED";
    ApiAssetActivitySummaryDeclineReasonEnum["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ApiAssetActivitySummaryDeclineReasonEnum["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ApiAssetActivitySummaryDeclineReasonEnum["PROCESSOR_DECLINED"] = "PROCESSOR_DECLINED";
    ApiAssetActivitySummaryDeclineReasonEnum["SETTLEMENT_DECLINED"] = "SETTLEMENT_DECLINED";
    ApiAssetActivitySummaryDeclineReasonEnum["GATEWAY_REJECTED"] = "GATEWAY_REJECTED";
    ApiAssetActivitySummaryDeclineReasonEnum["REWARDS_GATEWAY_REJECTED"] = "REWARDS_GATEWAY_REJECTED";
    ApiAssetActivitySummaryDeclineReasonEnum["AVS_ERROR"] = "AVS_ERROR";
    ApiAssetActivitySummaryDeclineReasonEnum["CVV_ERROR"] = "CVV_ERROR";
    ApiAssetActivitySummaryDeclineReasonEnum["AVS_GATEWAY_ERROR"] = "AVS_GATEWAY_ERROR";
    ApiAssetActivitySummaryDeclineReasonEnum["AVS_VERIFICATION_FAILED"] = "AVS_VERIFICATION_FAILED";
    ApiAssetActivitySummaryDeclineReasonEnum["CVV_VERIFICATION_FAILED"] = "CVV_VERIFICATION_FAILED";
    ApiAssetActivitySummaryDeclineReasonEnum["AMOUNT_VERIFICATION_FAILED"] = "AMOUNT_VERIFICATION_FAILED";
    ApiAssetActivitySummaryDeclineReasonEnum["DEBIT_CARD_NOT_FOUND"] = "DEBIT_CARD_NOT_FOUND";
    ApiAssetActivitySummaryDeclineReasonEnum["SDK_ERROR"] = "SDK_ERROR";
})(ApiAssetActivitySummaryDeclineReasonEnum = exports.ApiAssetActivitySummaryDeclineReasonEnum || (exports.ApiAssetActivitySummaryDeclineReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivitySummaryDerivedTypeEnum;
(function (ApiAssetActivitySummaryDerivedTypeEnum) {
    ApiAssetActivitySummaryDerivedTypeEnum["ADD"] = "ADD";
    ApiAssetActivitySummaryDerivedTypeEnum["BUY"] = "BUY";
    ApiAssetActivitySummaryDerivedTypeEnum["CARD_CHARGEBACK"] = "CARD_CHARGEBACK";
    ApiAssetActivitySummaryDerivedTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    ApiAssetActivitySummaryDerivedTypeEnum["CARD_REFUND"] = "CARD_REFUND";
    ApiAssetActivitySummaryDerivedTypeEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiAssetActivitySummaryDerivedTypeEnum["CREDIT"] = "CREDIT";
    ApiAssetActivitySummaryDerivedTypeEnum["CONVERT"] = "CONVERT";
    ApiAssetActivitySummaryDerivedTypeEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    ApiAssetActivitySummaryDerivedTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiAssetActivitySummaryDerivedTypeEnum["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
    ApiAssetActivitySummaryDerivedTypeEnum["DEPOSIT_RETURNED"] = "DEPOSIT_RETURNED";
    ApiAssetActivitySummaryDerivedTypeEnum["DEPOSIT_REVERSE"] = "DEPOSIT_REVERSE";
    ApiAssetActivitySummaryDerivedTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiAssetActivitySummaryDerivedTypeEnum["DISPUTE_CREDIT_REVERSE"] = "DISPUTE_CREDIT_REVERSE";
    ApiAssetActivitySummaryDerivedTypeEnum["FREEZE"] = "FREEZE";
    ApiAssetActivitySummaryDerivedTypeEnum["INCENTIVE"] = "INCENTIVE";
    ApiAssetActivitySummaryDerivedTypeEnum["INCENTIVE_CANCEL"] = "INCENTIVE_CANCEL";
    ApiAssetActivitySummaryDerivedTypeEnum["LOYALTY_BUY"] = "LOYALTY_BUY";
    ApiAssetActivitySummaryDerivedTypeEnum["LOYALTY_BUY_CANCEL"] = "LOYALTY_BUY_CANCEL";
    ApiAssetActivitySummaryDerivedTypeEnum["LOYALTY_CREDIT_CANCEL"] = "LOYALTY_CREDIT_CANCEL";
    ApiAssetActivitySummaryDerivedTypeEnum["LOYALTY_REDEEM"] = "LOYALTY_REDEEM";
    ApiAssetActivitySummaryDerivedTypeEnum["LOYALTY_CRYPTO_REDEEM_FAILED"] = "LOYALTY_CRYPTO_REDEEM_FAILED";
    ApiAssetActivitySummaryDerivedTypeEnum["LOYALTY_PAYMENT_REVERSAL"] = "LOYALTY_PAYMENT_REVERSAL";
    ApiAssetActivitySummaryDerivedTypeEnum["LINK"] = "LINK";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_CREDIT"] = "MERCHANT_CREDIT";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_PAYMENT_AUTHORIZE"] = "MERCHANT_PAYMENT_AUTHORIZE";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_PAYMENT_AUTHORIZE_DECLINED"] = "MERCHANT_PAYMENT_AUTHORIZE_DECLINED";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_PAYMENT_CANCEL"] = "MERCHANT_PAYMENT_CANCEL";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_PAYMENT_CAPTURE"] = "MERCHANT_PAYMENT_CAPTURE";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_PAYMENT_CREDIT"] = "MERCHANT_PAYMENT_CREDIT";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_PAYMENT_REFUND"] = "MERCHANT_PAYMENT_REFUND";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_PAYMENT_DISPUTE"] = "MERCHANT_PAYMENT_DISPUTE";
    ApiAssetActivitySummaryDerivedTypeEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    ApiAssetActivitySummaryDerivedTypeEnum["PAYOUT"] = "PAYOUT";
    ApiAssetActivitySummaryDerivedTypeEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiAssetActivitySummaryDerivedTypeEnum["RECEIVE"] = "RECEIVE";
    ApiAssetActivitySummaryDerivedTypeEnum["REDEEM"] = "REDEEM";
    ApiAssetActivitySummaryDerivedTypeEnum["REMOVE"] = "REMOVE";
    ApiAssetActivitySummaryDerivedTypeEnum["RESTORE"] = "RESTORE";
    ApiAssetActivitySummaryDerivedTypeEnum["REVERSE"] = "REVERSE";
    ApiAssetActivitySummaryDerivedTypeEnum["SELL"] = "SELL";
    ApiAssetActivitySummaryDerivedTypeEnum["SEND"] = "SEND";
    ApiAssetActivitySummaryDerivedTypeEnum["TERMINATE"] = "TERMINATE";
    ApiAssetActivitySummaryDerivedTypeEnum["UNFREEZE"] = "UNFREEZE";
    ApiAssetActivitySummaryDerivedTypeEnum["UNLINK"] = "UNLINK";
    ApiAssetActivitySummaryDerivedTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiAssetActivitySummaryDerivedTypeEnum["WITHDRAW_REVERSE"] = "WITHDRAW_REVERSE";
    ApiAssetActivitySummaryDerivedTypeEnum["WITHDRAW_RETURN"] = "WITHDRAW_RETURN";
    ApiAssetActivitySummaryDerivedTypeEnum["WITHDRAW_RETURNED"] = "WITHDRAW_RETURNED";
    ApiAssetActivitySummaryDerivedTypeEnum["PARTNER_REWARD_CRYPTO"] = "PARTNER_REWARD_CRYPTO";
    ApiAssetActivitySummaryDerivedTypeEnum["PARTNER_REWARD_CASH"] = "PARTNER_REWARD_CASH";
})(ApiAssetActivitySummaryDerivedTypeEnum = exports.ApiAssetActivitySummaryDerivedTypeEnum || (exports.ApiAssetActivitySummaryDerivedTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivitySummaryDestinationCurrencyEnum;
(function (ApiAssetActivitySummaryDestinationCurrencyEnum) {
    ApiAssetActivitySummaryDestinationCurrencyEnum["USD"] = "USD";
    ApiAssetActivitySummaryDestinationCurrencyEnum["AAVE"] = "AAVE";
    ApiAssetActivitySummaryDestinationCurrencyEnum["AVAX"] = "AVAX";
    ApiAssetActivitySummaryDestinationCurrencyEnum["AXS"] = "AXS";
    ApiAssetActivitySummaryDestinationCurrencyEnum["BAT"] = "BAT";
    ApiAssetActivitySummaryDestinationCurrencyEnum["BCH"] = "BCH";
    ApiAssetActivitySummaryDestinationCurrencyEnum["BTC"] = "BTC";
    ApiAssetActivitySummaryDestinationCurrencyEnum["DOGE"] = "DOGE";
    ApiAssetActivitySummaryDestinationCurrencyEnum["ETH"] = "ETH";
    ApiAssetActivitySummaryDestinationCurrencyEnum["LINK"] = "LINK";
    ApiAssetActivitySummaryDestinationCurrencyEnum["LTC"] = "LTC";
    ApiAssetActivitySummaryDestinationCurrencyEnum["MANA"] = "MANA";
    ApiAssetActivitySummaryDestinationCurrencyEnum["MATIC"] = "MATIC";
    ApiAssetActivitySummaryDestinationCurrencyEnum["SOL"] = "SOL";
    ApiAssetActivitySummaryDestinationCurrencyEnum["UNI"] = "UNI";
    ApiAssetActivitySummaryDestinationCurrencyEnum["USDC"] = "USDC";
    ApiAssetActivitySummaryDestinationCurrencyEnum["LXX"] = "LXX";
    ApiAssetActivitySummaryDestinationCurrencyEnum["LCP"] = "LCP";
    ApiAssetActivitySummaryDestinationCurrencyEnum["LWR"] = "LWR";
    ApiAssetActivitySummaryDestinationCurrencyEnum["LMO"] = "LMO";
    ApiAssetActivitySummaryDestinationCurrencyEnum["LKO"] = "LKO";
    ApiAssetActivitySummaryDestinationCurrencyEnum["LED"] = "LED";
})(ApiAssetActivitySummaryDestinationCurrencyEnum = exports.ApiAssetActivitySummaryDestinationCurrencyEnum || (exports.ApiAssetActivitySummaryDestinationCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivitySummarySourceCurrencyEnum;
(function (ApiAssetActivitySummarySourceCurrencyEnum) {
    ApiAssetActivitySummarySourceCurrencyEnum["USD"] = "USD";
    ApiAssetActivitySummarySourceCurrencyEnum["AAVE"] = "AAVE";
    ApiAssetActivitySummarySourceCurrencyEnum["AVAX"] = "AVAX";
    ApiAssetActivitySummarySourceCurrencyEnum["AXS"] = "AXS";
    ApiAssetActivitySummarySourceCurrencyEnum["BAT"] = "BAT";
    ApiAssetActivitySummarySourceCurrencyEnum["BCH"] = "BCH";
    ApiAssetActivitySummarySourceCurrencyEnum["BTC"] = "BTC";
    ApiAssetActivitySummarySourceCurrencyEnum["DOGE"] = "DOGE";
    ApiAssetActivitySummarySourceCurrencyEnum["ETH"] = "ETH";
    ApiAssetActivitySummarySourceCurrencyEnum["LINK"] = "LINK";
    ApiAssetActivitySummarySourceCurrencyEnum["LTC"] = "LTC";
    ApiAssetActivitySummarySourceCurrencyEnum["MANA"] = "MANA";
    ApiAssetActivitySummarySourceCurrencyEnum["MATIC"] = "MATIC";
    ApiAssetActivitySummarySourceCurrencyEnum["SOL"] = "SOL";
    ApiAssetActivitySummarySourceCurrencyEnum["UNI"] = "UNI";
    ApiAssetActivitySummarySourceCurrencyEnum["USDC"] = "USDC";
    ApiAssetActivitySummarySourceCurrencyEnum["LXX"] = "LXX";
    ApiAssetActivitySummarySourceCurrencyEnum["LCP"] = "LCP";
    ApiAssetActivitySummarySourceCurrencyEnum["LWR"] = "LWR";
    ApiAssetActivitySummarySourceCurrencyEnum["LMO"] = "LMO";
    ApiAssetActivitySummarySourceCurrencyEnum["LKO"] = "LKO";
    ApiAssetActivitySummarySourceCurrencyEnum["LED"] = "LED";
})(ApiAssetActivitySummarySourceCurrencyEnum = exports.ApiAssetActivitySummarySourceCurrencyEnum || (exports.ApiAssetActivitySummarySourceCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivitySummaryStatusEnum;
(function (ApiAssetActivitySummaryStatusEnum) {
    ApiAssetActivitySummaryStatusEnum["CANCELED"] = "CANCELED";
    ApiAssetActivitySummaryStatusEnum["COMPLETE"] = "COMPLETE";
    ApiAssetActivitySummaryStatusEnum["EXPIRED"] = "EXPIRED";
    ApiAssetActivitySummaryStatusEnum["PENDING"] = "PENDING";
    ApiAssetActivitySummaryStatusEnum["REJECTED"] = "REJECTED";
    ApiAssetActivitySummaryStatusEnum["REPLACED"] = "REPLACED";
    ApiAssetActivitySummaryStatusEnum["REFUND"] = "REFUND";
    ApiAssetActivitySummaryStatusEnum["FAILED"] = "FAILED";
    ApiAssetActivitySummaryStatusEnum["PROVISIONAL"] = "PROVISIONAL";
    ApiAssetActivitySummaryStatusEnum["CAPTURED"] = "CAPTURED";
    ApiAssetActivitySummaryStatusEnum["PARTIAL_CAPTURED"] = "PARTIAL_CAPTURED";
    ApiAssetActivitySummaryStatusEnum["REFUNDED"] = "REFUNDED";
    ApiAssetActivitySummaryStatusEnum["REVERSED"] = "REVERSED";
    ApiAssetActivitySummaryStatusEnum["PARTIAL_REVERSED"] = "PARTIAL_REVERSED";
    ApiAssetActivitySummaryStatusEnum["AUTHORIZED"] = "AUTHORIZED";
    ApiAssetActivitySummaryStatusEnum["SETTLED"] = "SETTLED";
    ApiAssetActivitySummaryStatusEnum["DISPUTED"] = "DISPUTED";
    ApiAssetActivitySummaryStatusEnum["DISPUTE_CLOSED"] = "DISPUTE_CLOSED";
})(ApiAssetActivitySummaryStatusEnum = exports.ApiAssetActivitySummaryStatusEnum || (exports.ApiAssetActivitySummaryStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiAssetActivitySummaryTypeEnum;
(function (ApiAssetActivitySummaryTypeEnum) {
    ApiAssetActivitySummaryTypeEnum["ADD"] = "ADD";
    ApiAssetActivitySummaryTypeEnum["BUY"] = "BUY";
    ApiAssetActivitySummaryTypeEnum["CARD_CHARGEBACK"] = "CARD_CHARGEBACK";
    ApiAssetActivitySummaryTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    ApiAssetActivitySummaryTypeEnum["CARD_REFUND"] = "CARD_REFUND";
    ApiAssetActivitySummaryTypeEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiAssetActivitySummaryTypeEnum["CREDIT"] = "CREDIT";
    ApiAssetActivitySummaryTypeEnum["CONVERT"] = "CONVERT";
    ApiAssetActivitySummaryTypeEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    ApiAssetActivitySummaryTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiAssetActivitySummaryTypeEnum["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
    ApiAssetActivitySummaryTypeEnum["DEPOSIT_RETURNED"] = "DEPOSIT_RETURNED";
    ApiAssetActivitySummaryTypeEnum["DEPOSIT_REVERSE"] = "DEPOSIT_REVERSE";
    ApiAssetActivitySummaryTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiAssetActivitySummaryTypeEnum["DISPUTE_CREDIT_REVERSE"] = "DISPUTE_CREDIT_REVERSE";
    ApiAssetActivitySummaryTypeEnum["FREEZE"] = "FREEZE";
    ApiAssetActivitySummaryTypeEnum["INCENTIVE"] = "INCENTIVE";
    ApiAssetActivitySummaryTypeEnum["INCENTIVE_CANCEL"] = "INCENTIVE_CANCEL";
    ApiAssetActivitySummaryTypeEnum["LOYALTY_BUY"] = "LOYALTY_BUY";
    ApiAssetActivitySummaryTypeEnum["LOYALTY_BUY_CANCEL"] = "LOYALTY_BUY_CANCEL";
    ApiAssetActivitySummaryTypeEnum["LOYALTY_CREDIT_CANCEL"] = "LOYALTY_CREDIT_CANCEL";
    ApiAssetActivitySummaryTypeEnum["LOYALTY_REDEEM"] = "LOYALTY_REDEEM";
    ApiAssetActivitySummaryTypeEnum["LOYALTY_CRYPTO_REDEEM_FAILED"] = "LOYALTY_CRYPTO_REDEEM_FAILED";
    ApiAssetActivitySummaryTypeEnum["LOYALTY_PAYMENT_REVERSAL"] = "LOYALTY_PAYMENT_REVERSAL";
    ApiAssetActivitySummaryTypeEnum["LINK"] = "LINK";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_CREDIT"] = "MERCHANT_CREDIT";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_PAYMENT_AUTHORIZE"] = "MERCHANT_PAYMENT_AUTHORIZE";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_PAYMENT_AUTHORIZE_DECLINED"] = "MERCHANT_PAYMENT_AUTHORIZE_DECLINED";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_PAYMENT_CANCEL"] = "MERCHANT_PAYMENT_CANCEL";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_PAYMENT_CAPTURE"] = "MERCHANT_PAYMENT_CAPTURE";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_PAYMENT_CREDIT"] = "MERCHANT_PAYMENT_CREDIT";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_PAYMENT_REFUND"] = "MERCHANT_PAYMENT_REFUND";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_PAYMENT_DISPUTE"] = "MERCHANT_PAYMENT_DISPUTE";
    ApiAssetActivitySummaryTypeEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    ApiAssetActivitySummaryTypeEnum["PAYOUT"] = "PAYOUT";
    ApiAssetActivitySummaryTypeEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiAssetActivitySummaryTypeEnum["RECEIVE"] = "RECEIVE";
    ApiAssetActivitySummaryTypeEnum["REDEEM"] = "REDEEM";
    ApiAssetActivitySummaryTypeEnum["REMOVE"] = "REMOVE";
    ApiAssetActivitySummaryTypeEnum["RESTORE"] = "RESTORE";
    ApiAssetActivitySummaryTypeEnum["REVERSE"] = "REVERSE";
    ApiAssetActivitySummaryTypeEnum["SELL"] = "SELL";
    ApiAssetActivitySummaryTypeEnum["SEND"] = "SEND";
    ApiAssetActivitySummaryTypeEnum["TERMINATE"] = "TERMINATE";
    ApiAssetActivitySummaryTypeEnum["UNFREEZE"] = "UNFREEZE";
    ApiAssetActivitySummaryTypeEnum["UNLINK"] = "UNLINK";
    ApiAssetActivitySummaryTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiAssetActivitySummaryTypeEnum["WITHDRAW_REVERSE"] = "WITHDRAW_REVERSE";
    ApiAssetActivitySummaryTypeEnum["WITHDRAW_RETURN"] = "WITHDRAW_RETURN";
    ApiAssetActivitySummaryTypeEnum["WITHDRAW_RETURNED"] = "WITHDRAW_RETURNED";
    ApiAssetActivitySummaryTypeEnum["PARTNER_REWARD_CRYPTO"] = "PARTNER_REWARD_CRYPTO";
    ApiAssetActivitySummaryTypeEnum["PARTNER_REWARD_CASH"] = "PARTNER_REWARD_CASH";
})(ApiAssetActivitySummaryTypeEnum = exports.ApiAssetActivitySummaryTypeEnum || (exports.ApiAssetActivitySummaryTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBakktCardTransactionDetailsPreferredCurrencyEnum;
(function (ApiBakktCardTransactionDetailsPreferredCurrencyEnum) {
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["USD"] = "USD";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["AAVE"] = "AAVE";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["AVAX"] = "AVAX";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["AXS"] = "AXS";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["BAT"] = "BAT";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["BCH"] = "BCH";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["BTC"] = "BTC";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["DOGE"] = "DOGE";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["ETH"] = "ETH";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["LINK"] = "LINK";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["LTC"] = "LTC";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["MANA"] = "MANA";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["MATIC"] = "MATIC";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["SOL"] = "SOL";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["UNI"] = "UNI";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["USDC"] = "USDC";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["LXX"] = "LXX";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["LCP"] = "LCP";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["LWR"] = "LWR";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["LMO"] = "LMO";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["LKO"] = "LKO";
    ApiBakktCardTransactionDetailsPreferredCurrencyEnum["LED"] = "LED";
})(ApiBakktCardTransactionDetailsPreferredCurrencyEnum = exports.ApiBakktCardTransactionDetailsPreferredCurrencyEnum || (exports.ApiBakktCardTransactionDetailsPreferredCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBakktCardTransactionDetailsTransactionStatusEnum;
(function (ApiBakktCardTransactionDetailsTransactionStatusEnum) {
    ApiBakktCardTransactionDetailsTransactionStatusEnum["PENDING"] = "PENDING";
    ApiBakktCardTransactionDetailsTransactionStatusEnum["SETTLED"] = "SETTLED";
    ApiBakktCardTransactionDetailsTransactionStatusEnum["REVERSED"] = "REVERSED";
    ApiBakktCardTransactionDetailsTransactionStatusEnum["REFUNDED"] = "REFUNDED";
    ApiBakktCardTransactionDetailsTransactionStatusEnum["CHARGEBACK"] = "CHARGEBACK";
    ApiBakktCardTransactionDetailsTransactionStatusEnum["CHARGEBACK_REVERSED"] = "CHARGEBACK_REVERSED";
    ApiBakktCardTransactionDetailsTransactionStatusEnum["DECLINED"] = "DECLINED";
})(ApiBakktCardTransactionDetailsTransactionStatusEnum = exports.ApiBakktCardTransactionDetailsTransactionStatusEnum || (exports.ApiBakktCardTransactionDetailsTransactionStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBakktTransactionDetailsDisputeStatusEnum;
(function (ApiBakktTransactionDetailsDisputeStatusEnum) {
    ApiBakktTransactionDetailsDisputeStatusEnum["NEW"] = "NEW";
    ApiBakktTransactionDetailsDisputeStatusEnum["ESCALATED"] = "ESCALATED";
    ApiBakktTransactionDetailsDisputeStatusEnum["REJECTED"] = "REJECTED";
    ApiBakktTransactionDetailsDisputeStatusEnum["MERCHANT_REJECTED"] = "MERCHANT_REJECTED";
    ApiBakktTransactionDetailsDisputeStatusEnum["ACCEPTED"] = "ACCEPTED";
    ApiBakktTransactionDetailsDisputeStatusEnum["CANCELLED"] = "CANCELLED";
})(ApiBakktTransactionDetailsDisputeStatusEnum = exports.ApiBakktTransactionDetailsDisputeStatusEnum || (exports.ApiBakktTransactionDetailsDisputeStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBakktTransactionDetailsTransactionStatusEnum;
(function (ApiBakktTransactionDetailsTransactionStatusEnum) {
    ApiBakktTransactionDetailsTransactionStatusEnum["AUTHORIZED"] = "AUTHORIZED";
    ApiBakktTransactionDetailsTransactionStatusEnum["DECLINED"] = "DECLINED";
    ApiBakktTransactionDetailsTransactionStatusEnum["CAPTURED"] = "CAPTURED";
    ApiBakktTransactionDetailsTransactionStatusEnum["DISPUTE_OPEN"] = "DISPUTE_OPEN";
    ApiBakktTransactionDetailsTransactionStatusEnum["REVERSED"] = "REVERSED";
    ApiBakktTransactionDetailsTransactionStatusEnum["CANCELED"] = "CANCELED";
    ApiBakktTransactionDetailsTransactionStatusEnum["SETTLED"] = "SETTLED";
    ApiBakktTransactionDetailsTransactionStatusEnum["DISPUTE_CLOSED"] = "DISPUTE_CLOSED";
    ApiBakktTransactionDetailsTransactionStatusEnum["DISPUTED"] = "DISPUTED";
    ApiBakktTransactionDetailsTransactionStatusEnum["PARTIAL_CAPTURED"] = "PARTIAL_CAPTURED";
    ApiBakktTransactionDetailsTransactionStatusEnum["PARTIAL_REVERSED"] = "PARTIAL_REVERSED";
})(ApiBakktTransactionDetailsTransactionStatusEnum = exports.ApiBakktTransactionDetailsTransactionStatusEnum || (exports.ApiBakktTransactionDetailsTransactionStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBankAccountCurrencyEnum;
(function (ApiBankAccountCurrencyEnum) {
    ApiBankAccountCurrencyEnum["USD"] = "USD";
    ApiBankAccountCurrencyEnum["AAVE"] = "AAVE";
    ApiBankAccountCurrencyEnum["AVAX"] = "AVAX";
    ApiBankAccountCurrencyEnum["AXS"] = "AXS";
    ApiBankAccountCurrencyEnum["BAT"] = "BAT";
    ApiBankAccountCurrencyEnum["BCH"] = "BCH";
    ApiBankAccountCurrencyEnum["BTC"] = "BTC";
    ApiBankAccountCurrencyEnum["DOGE"] = "DOGE";
    ApiBankAccountCurrencyEnum["ETH"] = "ETH";
    ApiBankAccountCurrencyEnum["LINK"] = "LINK";
    ApiBankAccountCurrencyEnum["LTC"] = "LTC";
    ApiBankAccountCurrencyEnum["MANA"] = "MANA";
    ApiBankAccountCurrencyEnum["MATIC"] = "MATIC";
    ApiBankAccountCurrencyEnum["SOL"] = "SOL";
    ApiBankAccountCurrencyEnum["UNI"] = "UNI";
    ApiBankAccountCurrencyEnum["USDC"] = "USDC";
    ApiBankAccountCurrencyEnum["LXX"] = "LXX";
    ApiBankAccountCurrencyEnum["LCP"] = "LCP";
    ApiBankAccountCurrencyEnum["LWR"] = "LWR";
    ApiBankAccountCurrencyEnum["LMO"] = "LMO";
    ApiBankAccountCurrencyEnum["LKO"] = "LKO";
    ApiBankAccountCurrencyEnum["LED"] = "LED";
})(ApiBankAccountCurrencyEnum = exports.ApiBankAccountCurrencyEnum || (exports.ApiBankAccountCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBankAccountKycStatusEnum;
(function (ApiBankAccountKycStatusEnum) {
    ApiBankAccountKycStatusEnum["SUCCESS"] = "SUCCESS";
    ApiBankAccountKycStatusEnum["FAILED"] = "FAILED";
    ApiBankAccountKycStatusEnum["PENDING"] = "PENDING";
})(ApiBankAccountKycStatusEnum = exports.ApiBankAccountKycStatusEnum || (exports.ApiBankAccountKycStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBankAccountLinkStatusEnum;
(function (ApiBankAccountLinkStatusEnum) {
    ApiBankAccountLinkStatusEnum["CURRENT"] = "CURRENT";
    ApiBankAccountLinkStatusEnum["REFRESH_REQUIRED"] = "REFRESH_REQUIRED";
    ApiBankAccountLinkStatusEnum["PENDING_EXPIRATION"] = "PENDING_EXPIRATION";
})(ApiBankAccountLinkStatusEnum = exports.ApiBankAccountLinkStatusEnum || (exports.ApiBankAccountLinkStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBankAccountStatusEnum;
(function (ApiBankAccountStatusEnum) {
    ApiBankAccountStatusEnum["ACTIVE"] = "ACTIVE";
    ApiBankAccountStatusEnum["PENDING"] = "PENDING";
    ApiBankAccountStatusEnum["SUSPENDED"] = "SUSPENDED";
})(ApiBankAccountStatusEnum = exports.ApiBankAccountStatusEnum || (exports.ApiBankAccountStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBankAccountVerificationTypeEnum;
(function (ApiBankAccountVerificationTypeEnum) {
    ApiBankAccountVerificationTypeEnum["AUTOMATED_MICRODEPOSIT"] = "AUTOMATED_MICRODEPOSIT";
    ApiBankAccountVerificationTypeEnum["SAME_DAY_MICRODEPOSIT"] = "SAME_DAY_MICRODEPOSIT";
    ApiBankAccountVerificationTypeEnum["INSTANT"] = "INSTANT";
})(ApiBankAccountVerificationTypeEnum = exports.ApiBankAccountVerificationTypeEnum || (exports.ApiBankAccountVerificationTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBankAccountLinkStatusLinkStatusEnum;
(function (ApiBankAccountLinkStatusLinkStatusEnum) {
    ApiBankAccountLinkStatusLinkStatusEnum["CURRENT"] = "CURRENT";
    ApiBankAccountLinkStatusLinkStatusEnum["REFRESH_REQUIRED"] = "REFRESH_REQUIRED";
    ApiBankAccountLinkStatusLinkStatusEnum["PENDING_EXPIRATION"] = "PENDING_EXPIRATION";
})(ApiBankAccountLinkStatusLinkStatusEnum = exports.ApiBankAccountLinkStatusLinkStatusEnum || (exports.ApiBankAccountLinkStatusLinkStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBitcoinTransactionDetailsFundingTypeEnum;
(function (ApiBitcoinTransactionDetailsFundingTypeEnum) {
    ApiBitcoinTransactionDetailsFundingTypeEnum["PARTNER"] = "PARTNER";
    ApiBitcoinTransactionDetailsFundingTypeEnum["PARTY"] = "PARTY";
})(ApiBitcoinTransactionDetailsFundingTypeEnum = exports.ApiBitcoinTransactionDetailsFundingTypeEnum || (exports.ApiBitcoinTransactionDetailsFundingTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBlacklistAccountRemovalRequestReasonEnum;
(function (ApiBlacklistAccountRemovalRequestReasonEnum) {
    ApiBlacklistAccountRemovalRequestReasonEnum["ACCOUNT_CLOSURE_REQUESTED"] = "ACCOUNT_CLOSURE_REQUESTED";
    ApiBlacklistAccountRemovalRequestReasonEnum["ACH_MAX_RETURNS"] = "ACH_MAX_RETURNS";
    ApiBlacklistAccountRemovalRequestReasonEnum["ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED";
    ApiBlacklistAccountRemovalRequestReasonEnum["ACH_RETURNS_COUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_EXCEEDED";
    ApiBlacklistAccountRemovalRequestReasonEnum["ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED";
    ApiBlacklistAccountRemovalRequestReasonEnum["ACH_RETURN_CODE"] = "ACH_RETURN_CODE";
    ApiBlacklistAccountRemovalRequestReasonEnum["COMPLIANCE_INVESTIGATION"] = "COMPLIANCE_INVESTIGATION";
    ApiBlacklistAccountRemovalRequestReasonEnum["COMPLIANCE_LOCKED"] = "COMPLIANCE_LOCKED";
    ApiBlacklistAccountRemovalRequestReasonEnum["COMPLIANCE_VERIFICATION"] = "COMPLIANCE_VERIFICATION";
    ApiBlacklistAccountRemovalRequestReasonEnum["CUSTOMER_GOOD_STANDING"] = "CUSTOMER_GOOD_STANDING";
    ApiBlacklistAccountRemovalRequestReasonEnum["DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED";
    ApiBlacklistAccountRemovalRequestReasonEnum["DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED";
    ApiBlacklistAccountRemovalRequestReasonEnum["DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED";
    ApiBlacklistAccountRemovalRequestReasonEnum["DEBIT_CARD_TRANSACTION_FRAUD_HOLD"] = "DEBIT_CARD_TRANSACTION_FRAUD_HOLD";
    ApiBlacklistAccountRemovalRequestReasonEnum["LIQUIDATE_ACCOUNT"] = "LIQUIDATE_ACCOUNT";
    ApiBlacklistAccountRemovalRequestReasonEnum["MARQETA_KYC_VERIFICATION"] = "MARQETA_KYC_VERIFICATION";
    ApiBlacklistAccountRemovalRequestReasonEnum["NSF_BLOCKING"] = "NSF_BLOCKING";
    ApiBlacklistAccountRemovalRequestReasonEnum["OLD_OFAC_CHECK"] = "OLD_OFAC_CHECK";
    ApiBlacklistAccountRemovalRequestReasonEnum["OTHER"] = "OTHER";
    ApiBlacklistAccountRemovalRequestReasonEnum["PLAID_IDENTITY_CHECK"] = "PLAID_IDENTITY_CHECK";
    ApiBlacklistAccountRemovalRequestReasonEnum["PLAID_MISSING_NAMES"] = "PLAID_MISSING_NAMES";
    ApiBlacklistAccountRemovalRequestReasonEnum["RELINK"] = "RELINK";
    ApiBlacklistAccountRemovalRequestReasonEnum["RISK_DECISION"] = "RISK_DECISION";
    ApiBlacklistAccountRemovalRequestReasonEnum["RISK_KYC"] = "RISK_KYC";
    ApiBlacklistAccountRemovalRequestReasonEnum["RISK_SCREENING"] = "RISK_SCREENING";
    ApiBlacklistAccountRemovalRequestReasonEnum["TAX_ID_MAX_RETRIES"] = "TAX_ID_MAX_RETRIES";
    ApiBlacklistAccountRemovalRequestReasonEnum["CARD_TERMINATION_ERROR"] = "CARD_TERMINATION_ERROR";
    ApiBlacklistAccountRemovalRequestReasonEnum["CLOSED"] = "CLOSED";
})(ApiBlacklistAccountRemovalRequestReasonEnum = exports.ApiBlacklistAccountRemovalRequestReasonEnum || (exports.ApiBlacklistAccountRemovalRequestReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBlacklistAccountRequestReasonEnum;
(function (ApiBlacklistAccountRequestReasonEnum) {
    ApiBlacklistAccountRequestReasonEnum["ACCOUNT_CLOSURE_REQUESTED"] = "ACCOUNT_CLOSURE_REQUESTED";
    ApiBlacklistAccountRequestReasonEnum["ACH_MAX_RETURNS"] = "ACH_MAX_RETURNS";
    ApiBlacklistAccountRequestReasonEnum["ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED";
    ApiBlacklistAccountRequestReasonEnum["ACH_RETURNS_COUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_EXCEEDED";
    ApiBlacklistAccountRequestReasonEnum["ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED";
    ApiBlacklistAccountRequestReasonEnum["ACH_RETURN_CODE"] = "ACH_RETURN_CODE";
    ApiBlacklistAccountRequestReasonEnum["COMPLIANCE_INVESTIGATION"] = "COMPLIANCE_INVESTIGATION";
    ApiBlacklistAccountRequestReasonEnum["COMPLIANCE_LOCKED"] = "COMPLIANCE_LOCKED";
    ApiBlacklistAccountRequestReasonEnum["COMPLIANCE_VERIFICATION"] = "COMPLIANCE_VERIFICATION";
    ApiBlacklistAccountRequestReasonEnum["CUSTOMER_GOOD_STANDING"] = "CUSTOMER_GOOD_STANDING";
    ApiBlacklistAccountRequestReasonEnum["DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED";
    ApiBlacklistAccountRequestReasonEnum["DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED";
    ApiBlacklistAccountRequestReasonEnum["DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED";
    ApiBlacklistAccountRequestReasonEnum["DEBIT_CARD_TRANSACTION_FRAUD_HOLD"] = "DEBIT_CARD_TRANSACTION_FRAUD_HOLD";
    ApiBlacklistAccountRequestReasonEnum["LIQUIDATE_ACCOUNT"] = "LIQUIDATE_ACCOUNT";
    ApiBlacklistAccountRequestReasonEnum["MARQETA_KYC_VERIFICATION"] = "MARQETA_KYC_VERIFICATION";
    ApiBlacklistAccountRequestReasonEnum["NSF_BLOCKING"] = "NSF_BLOCKING";
    ApiBlacklistAccountRequestReasonEnum["OLD_OFAC_CHECK"] = "OLD_OFAC_CHECK";
    ApiBlacklistAccountRequestReasonEnum["OTHER"] = "OTHER";
    ApiBlacklistAccountRequestReasonEnum["PLAID_IDENTITY_CHECK"] = "PLAID_IDENTITY_CHECK";
    ApiBlacklistAccountRequestReasonEnum["PLAID_MISSING_NAMES"] = "PLAID_MISSING_NAMES";
    ApiBlacklistAccountRequestReasonEnum["RELINK"] = "RELINK";
    ApiBlacklistAccountRequestReasonEnum["RISK_DECISION"] = "RISK_DECISION";
    ApiBlacklistAccountRequestReasonEnum["RISK_KYC"] = "RISK_KYC";
    ApiBlacklistAccountRequestReasonEnum["RISK_SCREENING"] = "RISK_SCREENING";
    ApiBlacklistAccountRequestReasonEnum["TAX_ID_MAX_RETRIES"] = "TAX_ID_MAX_RETRIES";
    ApiBlacklistAccountRequestReasonEnum["CARD_TERMINATION_ERROR"] = "CARD_TERMINATION_ERROR";
    ApiBlacklistAccountRequestReasonEnum["CLOSED"] = "CLOSED";
})(ApiBlacklistAccountRequestReasonEnum = exports.ApiBlacklistAccountRequestReasonEnum || (exports.ApiBlacklistAccountRequestReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiBlacklistedBankAccountOffenderReasonEnum;
(function (ApiBlacklistedBankAccountOffenderReasonEnum) {
    ApiBlacklistedBankAccountOffenderReasonEnum["ACH_RETURN_CODE"] = "ACH_RETURN_CODE";
    ApiBlacklistedBankAccountOffenderReasonEnum["ACH_RETURNS_COUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_EXCEEDED";
    ApiBlacklistedBankAccountOffenderReasonEnum["ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED";
    ApiBlacklistedBankAccountOffenderReasonEnum["ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED";
    ApiBlacklistedBankAccountOffenderReasonEnum["CSR_BLACKLIST"] = "CSR_BLACKLIST";
})(ApiBlacklistedBankAccountOffenderReasonEnum = exports.ApiBlacklistedBankAccountOffenderReasonEnum || (exports.ApiBlacklistedBankAccountOffenderReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCardStatusEnum;
(function (ApiCardStatusEnum) {
    ApiCardStatusEnum["PENDING"] = "PENDING";
    ApiCardStatusEnum["ACTIVE"] = "ACTIVE";
    ApiCardStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiCardStatusEnum["TERMINATED"] = "TERMINATED";
    ApiCardStatusEnum["UNSUPPORTED"] = "UNSUPPORTED";
})(ApiCardStatusEnum = exports.ApiCardStatusEnum || (exports.ApiCardStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCardActionRequestStatusEnum;
(function (ApiCardActionRequestStatusEnum) {
    ApiCardActionRequestStatusEnum["PENDING"] = "PENDING";
    ApiCardActionRequestStatusEnum["ACTIVE"] = "ACTIVE";
    ApiCardActionRequestStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiCardActionRequestStatusEnum["TERMINATED"] = "TERMINATED";
    ApiCardActionRequestStatusEnum["UNSUPPORTED"] = "UNSUPPORTED";
})(ApiCardActionRequestStatusEnum = exports.ApiCardActionRequestStatusEnum || (exports.ApiCardActionRequestStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCardIssuerPartyLastKycStatusEnum;
(function (ApiCardIssuerPartyLastKycStatusEnum) {
    ApiCardIssuerPartyLastKycStatusEnum["SUCCESS"] = "SUCCESS";
    ApiCardIssuerPartyLastKycStatusEnum["PENDING"] = "PENDING";
    ApiCardIssuerPartyLastKycStatusEnum["FAILURE"] = "FAILURE";
})(ApiCardIssuerPartyLastKycStatusEnum = exports.ApiCardIssuerPartyLastKycStatusEnum || (exports.ApiCardIssuerPartyLastKycStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCardIssuerPartyStatusEnum;
(function (ApiCardIssuerPartyStatusEnum) {
    ApiCardIssuerPartyStatusEnum["PENDING"] = "PENDING";
    ApiCardIssuerPartyStatusEnum["ACTIVE"] = "ACTIVE";
    ApiCardIssuerPartyStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiCardIssuerPartyStatusEnum["CLOSED"] = "CLOSED";
})(ApiCardIssuerPartyStatusEnum = exports.ApiCardIssuerPartyStatusEnum || (exports.ApiCardIssuerPartyStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCommentOwnerEnum;
(function (ApiCommentOwnerEnum) {
    ApiCommentOwnerEnum["BAKKT"] = "BAKKT";
    ApiCommentOwnerEnum["MERCHANT"] = "MERCHANT";
})(ApiCommentOwnerEnum = exports.ApiCommentOwnerEnum || (exports.ApiCommentOwnerEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCreateBankAccountRequestVerificationStatusEnum;
(function (ApiCreateBankAccountRequestVerificationStatusEnum) {
    ApiCreateBankAccountRequestVerificationStatusEnum["PENDING_AUTOMATIC_VERIFICATION"] = "PENDING_AUTOMATIC_VERIFICATION";
    ApiCreateBankAccountRequestVerificationStatusEnum["PENDING_MANUAL_VERIFICATION"] = "PENDING_MANUAL_VERIFICATION";
    ApiCreateBankAccountRequestVerificationStatusEnum["AUTOMATICALLY_VERIFIED"] = "AUTOMATICALLY_VERIFIED";
    ApiCreateBankAccountRequestVerificationStatusEnum["MANUALLY_VERIFIED"] = "MANUALLY_VERIFIED";
    ApiCreateBankAccountRequestVerificationStatusEnum["VERIFICATION_EXPIRED"] = "VERIFICATION_EXPIRED";
    ApiCreateBankAccountRequestVerificationStatusEnum["VERIFICATION_FAILED"] = "VERIFICATION_FAILED";
})(ApiCreateBankAccountRequestVerificationStatusEnum = exports.ApiCreateBankAccountRequestVerificationStatusEnum || (exports.ApiCreateBankAccountRequestVerificationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCreatePartnerRequestCryptoCurrenciesEnum;
(function (ApiCreatePartnerRequestCryptoCurrenciesEnum) {
    ApiCreatePartnerRequestCryptoCurrenciesEnum["AAVE"] = "AAVE";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["AVAX"] = "AVAX";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["AXS"] = "AXS";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["BAT"] = "BAT";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["BTC"] = "BTC";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["DOGE"] = "DOGE";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["ETH"] = "ETH";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["LINK"] = "LINK";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["LTC"] = "LTC";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["MANA"] = "MANA";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["MATIC"] = "MATIC";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["SOL"] = "SOL";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["UNI"] = "UNI";
    ApiCreatePartnerRequestCryptoCurrenciesEnum["USDC"] = "USDC";
})(ApiCreatePartnerRequestCryptoCurrenciesEnum = exports.ApiCreatePartnerRequestCryptoCurrenciesEnum || (exports.ApiCreatePartnerRequestCryptoCurrenciesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCreatePartnerRequestMissingFieldsEnum;
(function (ApiCreatePartnerRequestMissingFieldsEnum) {
    ApiCreatePartnerRequestMissingFieldsEnum["TAX_ID_NUMBER"] = "TAX_ID_NUMBER";
    ApiCreatePartnerRequestMissingFieldsEnum["OCCUPATION"] = "OCCUPATION";
    ApiCreatePartnerRequestMissingFieldsEnum["FIRST_NAME"] = "FIRST_NAME";
    ApiCreatePartnerRequestMissingFieldsEnum["LAST_NAME"] = "LAST_NAME";
    ApiCreatePartnerRequestMissingFieldsEnum["ADDRESS"] = "ADDRESS";
    ApiCreatePartnerRequestMissingFieldsEnum["PHONE"] = "PHONE";
    ApiCreatePartnerRequestMissingFieldsEnum["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    ApiCreatePartnerRequestMissingFieldsEnum["EMAIL"] = "EMAIL";
})(ApiCreatePartnerRequestMissingFieldsEnum = exports.ApiCreatePartnerRequestMissingFieldsEnum || (exports.ApiCreatePartnerRequestMissingFieldsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCreatePartnerRequestPrimaryCurrencyEnum;
(function (ApiCreatePartnerRequestPrimaryCurrencyEnum) {
    ApiCreatePartnerRequestPrimaryCurrencyEnum["USD"] = "USD";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["AAVE"] = "AAVE";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["AVAX"] = "AVAX";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["AXS"] = "AXS";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["BAT"] = "BAT";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["BCH"] = "BCH";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["BTC"] = "BTC";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["DOGE"] = "DOGE";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["ETH"] = "ETH";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["LINK"] = "LINK";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["LTC"] = "LTC";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["MANA"] = "MANA";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["MATIC"] = "MATIC";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["SOL"] = "SOL";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["UNI"] = "UNI";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["USDC"] = "USDC";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["LXX"] = "LXX";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["LCP"] = "LCP";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["LWR"] = "LWR";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["LMO"] = "LMO";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["LKO"] = "LKO";
    ApiCreatePartnerRequestPrimaryCurrencyEnum["LED"] = "LED";
})(ApiCreatePartnerRequestPrimaryCurrencyEnum = exports.ApiCreatePartnerRequestPrimaryCurrencyEnum || (exports.ApiCreatePartnerRequestPrimaryCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCreatePartnerRequestServiceTypesEnum;
(function (ApiCreatePartnerRequestServiceTypesEnum) {
    ApiCreatePartnerRequestServiceTypesEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    ApiCreatePartnerRequestServiceTypesEnum["REWARD"] = "REWARD";
    ApiCreatePartnerRequestServiceTypesEnum["PARTY"] = "PARTY";
    ApiCreatePartnerRequestServiceTypesEnum["PAYOUT"] = "PAYOUT";
})(ApiCreatePartnerRequestServiceTypesEnum = exports.ApiCreatePartnerRequestServiceTypesEnum || (exports.ApiCreatePartnerRequestServiceTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCreateRolePermissionsEnum;
(function (ApiCreateRolePermissionsEnum) {
    ApiCreateRolePermissionsEnum["ALLOWLIST_CREATE"] = "ALLOWLIST_CREATE";
    ApiCreateRolePermissionsEnum["ALLOWLIST_DELETE"] = "ALLOWLIST_DELETE";
    ApiCreateRolePermissionsEnum["ALLOWLIST_UPDATE"] = "ALLOWLIST_UPDATE";
    ApiCreateRolePermissionsEnum["ALLOWLIST_VIEW"] = "ALLOWLIST_VIEW";
    ApiCreateRolePermissionsEnum["DISPUTE_DELETE_REASON"] = "DISPUTE_DELETE_REASON";
    ApiCreateRolePermissionsEnum["DISPUTE_EXPORT_CSV"] = "DISPUTE_EXPORT_CSV";
    ApiCreateRolePermissionsEnum["DISPUTE_UPDATE_ACCEPT"] = "DISPUTE_UPDATE_ACCEPT";
    ApiCreateRolePermissionsEnum["DISPUTE_UPDATE_AUTO_APPROVE"] = "DISPUTE_UPDATE_AUTO_APPROVE";
    ApiCreateRolePermissionsEnum["DISPUTE_UPDATE_CREDIT_REJECT"] = "DISPUTE_UPDATE_CREDIT_REJECT";
    ApiCreateRolePermissionsEnum["DISPUTE_UPDATE_PROVISIONAL"] = "DISPUTE_UPDATE_PROVISIONAL";
    ApiCreateRolePermissionsEnum["DISPUTE_CREATE"] = "DISPUTE_CREATE";
    ApiCreateRolePermissionsEnum["DISPUTE_VIEW"] = "DISPUTE_VIEW";
    ApiCreateRolePermissionsEnum["DEVICE_SESSION_VIEW"] = "DEVICE_SESSION_VIEW";
    ApiCreateRolePermissionsEnum["FINANCE_VIEW"] = "FINANCE_VIEW";
    ApiCreateRolePermissionsEnum["GIFTCARD_UPDATE_REACTIVATE"] = "GIFTCARD_UPDATE_REACTIVATE";
    ApiCreateRolePermissionsEnum["GIFTCARD_BRAND_UPDATE"] = "GIFTCARD_BRAND_UPDATE";
    ApiCreateRolePermissionsEnum["GIFTCARD_BRAND_VIEW_ACTIVITY"] = "GIFTCARD_BRAND_VIEW_ACTIVITY";
    ApiCreateRolePermissionsEnum["GIFTCARD_VIEW"] = "GIFTCARD_VIEW";
    ApiCreateRolePermissionsEnum["GIFTCARD_VIEW_BALANCE"] = "GIFTCARD_VIEW_BALANCE";
    ApiCreateRolePermissionsEnum["GIFTCARD_VIEW_ACTIVITY"] = "GIFTCARD_VIEW_ACTIVITY";
    ApiCreateRolePermissionsEnum["KYC_ACTIVITY_VIEW"] = "KYC_ACTIVITY_VIEW";
    ApiCreateRolePermissionsEnum["OFAC_CREATE"] = "OFAC_CREATE";
    ApiCreateRolePermissionsEnum["OFAC_DELETE"] = "OFAC_DELETE";
    ApiCreateRolePermissionsEnum["OFAC_UPDATE"] = "OFAC_UPDATE";
    ApiCreateRolePermissionsEnum["OFAC_VIEW"] = "OFAC_VIEW";
    ApiCreateRolePermissionsEnum["PARTY_VIEW"] = "PARTY_VIEW";
    ApiCreateRolePermissionsEnum["PORTAL_VIEW"] = "PORTAL_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_CREATE"] = "REPORT_CREATE";
    ApiCreateRolePermissionsEnum["TICKET_CREATE"] = "TICKET_CREATE";
    ApiCreateRolePermissionsEnum["TICKET_UPDATE_ASSIGN"] = "TICKET_UPDATE_ASSIGN";
    ApiCreateRolePermissionsEnum["TICKET_UPDATE_CANCEL"] = "TICKET_UPDATE_CANCEL";
    ApiCreateRolePermissionsEnum["TICKET_UPDATE_ESCALATE"] = "TICKET_UPDATE_ESCALATE";
    ApiCreateRolePermissionsEnum["TICKET_UPDATE_COMMENT"] = "TICKET_UPDATE_COMMENT";
    ApiCreateRolePermissionsEnum["TICKET_VIEW"] = "TICKET_VIEW";
    ApiCreateRolePermissionsEnum["TRANSACTIONS_VIEW"] = "TRANSACTIONS_VIEW";
    ApiCreateRolePermissionsEnum["USERS_CREATE"] = "USERS_CREATE";
    ApiCreateRolePermissionsEnum["USERS_UPDATE"] = "USERS_UPDATE";
    ApiCreateRolePermissionsEnum["USERS_UPDATE_SYNC"] = "USERS_UPDATE_SYNC";
    ApiCreateRolePermissionsEnum["USERS_VIEW"] = "USERS_VIEW";
    ApiCreateRolePermissionsEnum["USERS_VIEW_DETAIL"] = "USERS_VIEW_DETAIL";
    ApiCreateRolePermissionsEnum["ACCOUNT_PREFUND_BLOCK"] = "ACCOUNT_PREFUND_BLOCK";
    ApiCreateRolePermissionsEnum["PARTY_SUSPEND"] = "PARTY_SUSPEND";
    ApiCreateRolePermissionsEnum["PARTY_UNSUSPEND"] = "PARTY_UNSUSPEND";
    ApiCreateRolePermissionsEnum["ACCOUNT_PREFUND_UNBLOCK"] = "ACCOUNT_PREFUND_UNBLOCK";
    ApiCreateRolePermissionsEnum["ACCOUNT_ACTIVITY_VIEW"] = "ACCOUNT_ACTIVITY_VIEW";
    ApiCreateRolePermissionsEnum["BAKKT_CARD_VIEW"] = "BAKKT_CARD_VIEW";
    ApiCreateRolePermissionsEnum["BAKKT_CARD_UPDATE"] = "BAKKT_CARD_UPDATE";
    ApiCreateRolePermissionsEnum["PARTY_CREDIT_ADD"] = "PARTY_CREDIT_ADD";
    ApiCreateRolePermissionsEnum["PARTY_PII_VIEW"] = "PARTY_PII_VIEW";
    ApiCreateRolePermissionsEnum["KYC_UPDATE"] = "KYC_UPDATE";
    ApiCreateRolePermissionsEnum["CARD_ISSUER_KYC_UPDATE"] = "CARD_ISSUER_KYC_UPDATE";
    ApiCreateRolePermissionsEnum["BANKACCOUNT_BLACKLIST_VIEW"] = "BANKACCOUNT_BLACKLIST_VIEW";
    ApiCreateRolePermissionsEnum["BANKACCOUNT_BLACKLIST_UPDATE"] = "BANKACCOUNT_BLACKLIST_UPDATE";
    ApiCreateRolePermissionsEnum["PARTY_WHITELIST_UPDATE"] = "PARTY_WHITELIST_UPDATE";
    ApiCreateRolePermissionsEnum["INCENTIVE_OFFER_VIEW"] = "INCENTIVE_OFFER_VIEW";
    ApiCreateRolePermissionsEnum["LOYALTY_REDEEM_CANCEL"] = "LOYALTY_REDEEM_CANCEL";
    ApiCreateRolePermissionsEnum["LOYALTY_ACCOUNT_VIEW"] = "LOYALTY_ACCOUNT_VIEW";
    ApiCreateRolePermissionsEnum["LOYALTY_ACCOUNT_UPDATE"] = "LOYALTY_ACCOUNT_UPDATE";
    ApiCreateRolePermissionsEnum["INCENTIVE_OFFER_CREATE"] = "INCENTIVE_OFFER_CREATE";
    ApiCreateRolePermissionsEnum["ACTIVITY_AUDIT_VIEW"] = "ACTIVITY_AUDIT_VIEW";
    ApiCreateRolePermissionsEnum["DEBIT_CARD_VIEW"] = "DEBIT_CARD_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_ASSET_ACTIVTY_VIEW"] = "REPORT_ASSET_ACTIVTY_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_PREFUNDING_VIEW"] = "REPORT_PREFUNDING_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_VIRTUAL_CURRENCY_VIEW"] = "REPORT_VIRTUAL_CURRENCY_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_MTL_VIEW"] = "REPORT_MTL_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_SIFT_VIEW"] = "REPORT_SIFT_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_DISPUTE_CREDIT_VIEW"] = "REPORT_DISPUTE_CREDIT_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_GIFT_CARD_RECON_VIEW"] = "REPORT_GIFT_CARD_RECON_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_ACCOUNT_BALANCE_SUMMARY_VIEW"] = "REPORT_ACCOUNT_BALANCE_SUMMARY_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_ACH_PROCESSING_VIEW"] = "REPORT_ACH_PROCESSING_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_SUSPEND_ACCOUNT_VIEW"] = "REPORT_SUSPEND_ACCOUNT_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_P2P_TRANSFER_VIEW"] = "REPORT_P2P_TRANSFER_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_ASSET_ACTIVTY_CREATE"] = "REPORT_ASSET_ACTIVTY_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_PREFUNDING_CREATE"] = "REPORT_PREFUNDING_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_VIRTUAL_CURRENCY_CREATE"] = "REPORT_VIRTUAL_CURRENCY_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_MTL_CREATE"] = "REPORT_MTL_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_SIFT_CREATE"] = "REPORT_SIFT_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_DISPUTE_CREDIT_CREATE"] = "REPORT_DISPUTE_CREDIT_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_GIFT_CARD_RECON_CREATE"] = "REPORT_GIFT_CARD_RECON_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_ACCOUNT_BALANCE_SUMMARY_CREATE"] = "REPORT_ACCOUNT_BALANCE_SUMMARY_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_ACH_PROCESSING_CREATE"] = "REPORT_ACH_PROCESSING_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_SUSPEND_ACCOUNT_CREATE"] = "REPORT_SUSPEND_ACCOUNT_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_P2P_TRANSFERS_CREATE"] = "REPORT_P2P_TRANSFERS_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_QUIZNOS_VIEW"] = "REPORT_QUIZNOS_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_QUIZNOS_CREATE"] = "REPORT_QUIZNOS_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_CHOICE_VIEW"] = "REPORT_CHOICE_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_CHOICE_CREATE"] = "REPORT_CHOICE_CREATE";
    ApiCreateRolePermissionsEnum["RISK_AUDIT_VIEW"] = "RISK_AUDIT_VIEW";
    ApiCreateRolePermissionsEnum["RISK_AUDIT_VIEW_DETAIL"] = "RISK_AUDIT_VIEW_DETAIL";
    ApiCreateRolePermissionsEnum["REPORT_ACCOUNT_BALANCE_V2_VIEW"] = "REPORT_ACCOUNT_BALANCE_V2_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_ACCOUNT_BALANCE_V2_CREATE"] = "REPORT_ACCOUNT_BALANCE_V2_CREATE";
    ApiCreateRolePermissionsEnum["PLAID_ACCOUNT_DETAIL_VIEW"] = "PLAID_ACCOUNT_DETAIL_VIEW";
    ApiCreateRolePermissionsEnum["UNMASK_PLAID_ACCOUNT_NUMBERS"] = "UNMASK_PLAID_ACCOUNT_NUMBERS";
    ApiCreateRolePermissionsEnum["UNMASK_DEBIT_CARD_FIELDS"] = "UNMASK_DEBIT_CARD_FIELDS";
    ApiCreateRolePermissionsEnum["TRANSACTION_ACCOUNT_LINK_FAILURES_VIEW"] = "TRANSACTION_ACCOUNT_LINK_FAILURES_VIEW";
    ApiCreateRolePermissionsEnum["REPORT_BTC_TRANSACTION_REPORT_CREATE"] = "REPORT_BTC_TRANSACTION_REPORT_CREATE";
    ApiCreateRolePermissionsEnum["REPORT_CRYPTO_TRANSACTION_REPORT_CREATE"] = "REPORT_CRYPTO_TRANSACTION_REPORT_CREATE";
    ApiCreateRolePermissionsEnum["PARTNER_DETAIL_VIEW"] = "PARTNER_DETAIL_VIEW";
    ApiCreateRolePermissionsEnum["PARTNER_LINK_UNLINK"] = "PARTNER_LINK_UNLINK";
    ApiCreateRolePermissionsEnum["PARTY_NAME_UPDATE"] = "PARTY_NAME_UPDATE";
    ApiCreateRolePermissionsEnum["PARTY_LIQUIDATE"] = "PARTY_LIQUIDATE";
    ApiCreateRolePermissionsEnum["PARTY_STATUS_UPDATE"] = "PARTY_STATUS_UPDATE";
})(ApiCreateRolePermissionsEnum = exports.ApiCreateRolePermissionsEnum || (exports.ApiCreateRolePermissionsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCreditActionRequestAssetTypeEnum;
(function (ApiCreditActionRequestAssetTypeEnum) {
    ApiCreditActionRequestAssetTypeEnum["CASH"] = "CASH";
    ApiCreditActionRequestAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiCreditActionRequestAssetTypeEnum["REWARDS"] = "REWARDS";
    ApiCreditActionRequestAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiCreditActionRequestAssetTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiCreditActionRequestAssetTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(ApiCreditActionRequestAssetTypeEnum = exports.ApiCreditActionRequestAssetTypeEnum || (exports.ApiCreditActionRequestAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum;
(function (ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum) {
    ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum["BUY"] = "BUY";
    ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum["SELL"] = "SELL";
    ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum["RECEIVE"] = "RECEIVE";
    ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum["SEND"] = "SEND";
})(ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum = exports.ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum || (exports.ApiCryptoCurrencyTransactionCryptoCurrencyActionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCryptoCurrencyTransactionQuantityUnitEnum;
(function (ApiCryptoCurrencyTransactionQuantityUnitEnum) {
    ApiCryptoCurrencyTransactionQuantityUnitEnum["USD"] = "USD";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["AAVE"] = "AAVE";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["AVAX"] = "AVAX";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["AXS"] = "AXS";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["BAT"] = "BAT";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["BCH"] = "BCH";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["BTC"] = "BTC";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["DOGE"] = "DOGE";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["ETH"] = "ETH";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["LINK"] = "LINK";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["LTC"] = "LTC";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["MANA"] = "MANA";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["MATIC"] = "MATIC";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["SOL"] = "SOL";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["UNI"] = "UNI";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["USDC"] = "USDC";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["LXX"] = "LXX";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["LCP"] = "LCP";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["LWR"] = "LWR";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["LMO"] = "LMO";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["LKO"] = "LKO";
    ApiCryptoCurrencyTransactionQuantityUnitEnum["LED"] = "LED";
})(ApiCryptoCurrencyTransactionQuantityUnitEnum = exports.ApiCryptoCurrencyTransactionQuantityUnitEnum || (exports.ApiCryptoCurrencyTransactionQuantityUnitEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCryptoCurrencyTransactionStatusEnum;
(function (ApiCryptoCurrencyTransactionStatusEnum) {
    ApiCryptoCurrencyTransactionStatusEnum["CREATED"] = "CREATED";
    ApiCryptoCurrencyTransactionStatusEnum["COMPLETED"] = "COMPLETED";
    ApiCryptoCurrencyTransactionStatusEnum["CANCELED"] = "CANCELED";
})(ApiCryptoCurrencyTransactionStatusEnum = exports.ApiCryptoCurrencyTransactionStatusEnum || (exports.ApiCryptoCurrencyTransactionStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiCryptoCurrencyTransactionTransactionCurrencyEnum;
(function (ApiCryptoCurrencyTransactionTransactionCurrencyEnum) {
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["USD"] = "USD";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["AAVE"] = "AAVE";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["AVAX"] = "AVAX";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["AXS"] = "AXS";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["BAT"] = "BAT";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["BCH"] = "BCH";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["BTC"] = "BTC";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["DOGE"] = "DOGE";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["ETH"] = "ETH";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["LINK"] = "LINK";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["LTC"] = "LTC";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["MANA"] = "MANA";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["MATIC"] = "MATIC";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["SOL"] = "SOL";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["UNI"] = "UNI";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["USDC"] = "USDC";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["LXX"] = "LXX";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["LCP"] = "LCP";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["LWR"] = "LWR";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["LMO"] = "LMO";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["LKO"] = "LKO";
    ApiCryptoCurrencyTransactionTransactionCurrencyEnum["LED"] = "LED";
})(ApiCryptoCurrencyTransactionTransactionCurrencyEnum = exports.ApiCryptoCurrencyTransactionTransactionCurrencyEnum || (exports.ApiCryptoCurrencyTransactionTransactionCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDateRangeReportRequestReportTypeEnum;
(function (ApiDateRangeReportRequestReportTypeEnum) {
    ApiDateRangeReportRequestReportTypeEnum["ASSET_ACTIVTY"] = "ASSET_ACTIVTY";
    ApiDateRangeReportRequestReportTypeEnum["CHARGEBACK"] = "CHARGEBACK";
    ApiDateRangeReportRequestReportTypeEnum["PREFUNDING"] = "PREFUNDING";
    ApiDateRangeReportRequestReportTypeEnum["VIRTUAL_CURRENCY"] = "VIRTUAL_CURRENCY";
    ApiDateRangeReportRequestReportTypeEnum["SIFT"] = "SIFT";
    ApiDateRangeReportRequestReportTypeEnum["MERCHANT_RECONCILIATION_REPORT"] = "MERCHANT_RECONCILIATION_REPORT";
    ApiDateRangeReportRequestReportTypeEnum["PARTNER_SETTLEMENT_REPORT"] = "PARTNER_SETTLEMENT_REPORT";
    ApiDateRangeReportRequestReportTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiDateRangeReportRequestReportTypeEnum["ACCOUNT_BALANCE"] = "ACCOUNT_BALANCE";
    ApiDateRangeReportRequestReportTypeEnum["ACCOUNT_BALANCE_V2"] = "ACCOUNT_BALANCE_V2";
    ApiDateRangeReportRequestReportTypeEnum["ACCOUNT_BALANCE_SUMMARY"] = "ACCOUNT_BALANCE_SUMMARY";
    ApiDateRangeReportRequestReportTypeEnum["ALL_CURRENCY_MTL"] = "ALL_CURRENCY_MTL";
    ApiDateRangeReportRequestReportTypeEnum["MTL"] = "MTL";
    ApiDateRangeReportRequestReportTypeEnum["BTC_TRANSACTION_REPORT"] = "BTC_TRANSACTION_REPORT";
    ApiDateRangeReportRequestReportTypeEnum["CRYPTO_TRANSACTION_REPORT"] = "CRYPTO_TRANSACTION_REPORT";
    ApiDateRangeReportRequestReportTypeEnum["PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT"] = "PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT";
    ApiDateRangeReportRequestReportTypeEnum["SUSPEND_ACCOUNT"] = "SUSPEND_ACCOUNT";
    ApiDateRangeReportRequestReportTypeEnum["P2P_TRANSFER"] = "P2P_TRANSFER";
    ApiDateRangeReportRequestReportTypeEnum["GIFT_CARD_RECON"] = "GIFT_CARD_RECON";
    ApiDateRangeReportRequestReportTypeEnum["GIFT_CARD_REDEEM_RECON"] = "GIFT_CARD_REDEEM_RECON";
    ApiDateRangeReportRequestReportTypeEnum["GIFT_CARD_RECON_MONTH"] = "GIFT_CARD_RECON_MONTH";
    ApiDateRangeReportRequestReportTypeEnum["GIFT_CARD_REDEEM_RECON_MONTH"] = "GIFT_CARD_REDEEM_RECON_MONTH";
    ApiDateRangeReportRequestReportTypeEnum["ACH_FILE_RETURNS"] = "ACH_FILE_RETURNS";
    ApiDateRangeReportRequestReportTypeEnum["ACH_FILE_OUTBOUND"] = "ACH_FILE_OUTBOUND";
    ApiDateRangeReportRequestReportTypeEnum["PARTNER_RECONCILIATION_REPORT"] = "PARTNER_RECONCILIATION_REPORT";
    ApiDateRangeReportRequestReportTypeEnum["CHOICE"] = "CHOICE";
    ApiDateRangeReportRequestReportTypeEnum["QUIZNOS"] = "QUIZNOS";
    ApiDateRangeReportRequestReportTypeEnum["FISERV_PAYMENT_STATUS"] = "FISERV_PAYMENT_STATUS";
})(ApiDateRangeReportRequestReportTypeEnum = exports.ApiDateRangeReportRequestReportTypeEnum || (exports.ApiDateRangeReportRequestReportTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDebitCardCardTypeEnum;
(function (ApiDebitCardCardTypeEnum) {
    ApiDebitCardCardTypeEnum["MASTERCARD"] = "MASTERCARD";
    ApiDebitCardCardTypeEnum["VISA"] = "VISA";
    ApiDebitCardCardTypeEnum["UNSUPPORTED"] = "UNSUPPORTED";
})(ApiDebitCardCardTypeEnum = exports.ApiDebitCardCardTypeEnum || (exports.ApiDebitCardCardTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDebitCardStatusEnum;
(function (ApiDebitCardStatusEnum) {
    ApiDebitCardStatusEnum["ACTIVE"] = "ACTIVE";
    ApiDebitCardStatusEnum["INACTIVE"] = "INACTIVE";
    ApiDebitCardStatusEnum["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    ApiDebitCardStatusEnum["VERIFICATION_EXPIRED"] = "VERIFICATION_EXPIRED";
})(ApiDebitCardStatusEnum = exports.ApiDebitCardStatusEnum || (exports.ApiDebitCardStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDebitCardActivityDeclineReasonEnum;
(function (ApiDebitCardActivityDeclineReasonEnum) {
    ApiDebitCardActivityDeclineReasonEnum["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    ApiDebitCardActivityDeclineReasonEnum["FUNDING_PREFERENCE_NOT_FOUND"] = "FUNDING_PREFERENCE_NOT_FOUND";
    ApiDebitCardActivityDeclineReasonEnum["CARD_INVALID_STATUS"] = "CARD_INVALID_STATUS";
    ApiDebitCardActivityDeclineReasonEnum["CARD_NOT_FOUND"] = "CARD_NOT_FOUND";
    ApiDebitCardActivityDeclineReasonEnum["CARD_NOT_ACTIVATED"] = "CARD_NOT_ACTIVATED";
    ApiDebitCardActivityDeclineReasonEnum["DAILY_LIMIT_EXCEEDED"] = "DAILY_LIMIT_EXCEEDED";
    ApiDebitCardActivityDeclineReasonEnum["MONTHLY_LIMIT_EXCEEDED"] = "MONTHLY_LIMIT_EXCEEDED";
    ApiDebitCardActivityDeclineReasonEnum["OVER_LIMIT"] = "OVER_LIMIT";
    ApiDebitCardActivityDeclineReasonEnum["NOT_SUFFICIENT_FUNDS"] = "NOT_SUFFICIENT_FUNDS";
    ApiDebitCardActivityDeclineReasonEnum["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    ApiDebitCardActivityDeclineReasonEnum["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    ApiDebitCardActivityDeclineReasonEnum["CARD_ISSUER_PARTY_NOT_FOUND"] = "CARD_ISSUER_PARTY_NOT_FOUND";
    ApiDebitCardActivityDeclineReasonEnum["CARD_ISSUER_PARTY_INVALID_STATUS"] = "CARD_ISSUER_PARTY_INVALID_STATUS";
    ApiDebitCardActivityDeclineReasonEnum["PARTY_NOT_FOUND"] = "PARTY_NOT_FOUND";
    ApiDebitCardActivityDeclineReasonEnum["PARTY_INVALID_STATUS"] = "PARTY_INVALID_STATUS";
    ApiDebitCardActivityDeclineReasonEnum["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    ApiDebitCardActivityDeclineReasonEnum["DATA_MISMATCH"] = "DATA_MISMATCH";
    ApiDebitCardActivityDeclineReasonEnum["GENERIC_PAYMENT_PROCESSING_ERROR"] = "GENERIC_PAYMENT_PROCESSING_ERROR";
    ApiDebitCardActivityDeclineReasonEnum["PRECONDITION_NOT_MET"] = "PRECONDITION_NOT_MET";
    ApiDebitCardActivityDeclineReasonEnum["INSUFFICIENT_FUNDS_FOR_BAKKT_ACCOUNT_DEPOSIT"] = "INSUFFICIENT_FUNDS_FOR_BAKKT_ACCOUNT_DEPOSIT";
    ApiDebitCardActivityDeclineReasonEnum["BLACKLISTED_DEBIT_CARD"] = "BLACKLISTED_DEBIT_CARD";
    ApiDebitCardActivityDeclineReasonEnum["BLACKLISTED_MERCHANT_CATEGORY"] = "BLACKLISTED_MERCHANT_CATEGORY";
    ApiDebitCardActivityDeclineReasonEnum["BLACKLISTED_BANK_ACCOUNT"] = "BLACKLISTED_BANK_ACCOUNT";
    ApiDebitCardActivityDeclineReasonEnum["BANK_ACCOUNT_BLACKLISTED_LINKING_FAILED"] = "BANK_ACCOUNT_BLACKLISTED_LINKING_FAILED";
    ApiDebitCardActivityDeclineReasonEnum["TRANSACTION_FAILED"] = "TRANSACTION_FAILED";
    ApiDebitCardActivityDeclineReasonEnum["REAUTHENTICATION_REQUIRED"] = "REAUTHENTICATION_REQUIRED";
    ApiDebitCardActivityDeclineReasonEnum["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ApiDebitCardActivityDeclineReasonEnum["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ApiDebitCardActivityDeclineReasonEnum["PROCESSOR_DECLINED"] = "PROCESSOR_DECLINED";
    ApiDebitCardActivityDeclineReasonEnum["SETTLEMENT_DECLINED"] = "SETTLEMENT_DECLINED";
    ApiDebitCardActivityDeclineReasonEnum["GATEWAY_REJECTED"] = "GATEWAY_REJECTED";
    ApiDebitCardActivityDeclineReasonEnum["REWARDS_GATEWAY_REJECTED"] = "REWARDS_GATEWAY_REJECTED";
    ApiDebitCardActivityDeclineReasonEnum["AVS_ERROR"] = "AVS_ERROR";
    ApiDebitCardActivityDeclineReasonEnum["CVV_ERROR"] = "CVV_ERROR";
    ApiDebitCardActivityDeclineReasonEnum["AVS_GATEWAY_ERROR"] = "AVS_GATEWAY_ERROR";
    ApiDebitCardActivityDeclineReasonEnum["AVS_VERIFICATION_FAILED"] = "AVS_VERIFICATION_FAILED";
    ApiDebitCardActivityDeclineReasonEnum["CVV_VERIFICATION_FAILED"] = "CVV_VERIFICATION_FAILED";
    ApiDebitCardActivityDeclineReasonEnum["AMOUNT_VERIFICATION_FAILED"] = "AMOUNT_VERIFICATION_FAILED";
    ApiDebitCardActivityDeclineReasonEnum["DEBIT_CARD_NOT_FOUND"] = "DEBIT_CARD_NOT_FOUND";
    ApiDebitCardActivityDeclineReasonEnum["SDK_ERROR"] = "SDK_ERROR";
})(ApiDebitCardActivityDeclineReasonEnum = exports.ApiDebitCardActivityDeclineReasonEnum || (exports.ApiDebitCardActivityDeclineReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDebitCardActivityStatusEnum;
(function (ApiDebitCardActivityStatusEnum) {
    ApiDebitCardActivityStatusEnum["CANCELED"] = "CANCELED";
    ApiDebitCardActivityStatusEnum["COMPLETE"] = "COMPLETE";
    ApiDebitCardActivityStatusEnum["EXPIRED"] = "EXPIRED";
    ApiDebitCardActivityStatusEnum["PENDING"] = "PENDING";
    ApiDebitCardActivityStatusEnum["REJECTED"] = "REJECTED";
    ApiDebitCardActivityStatusEnum["REPLACED"] = "REPLACED";
    ApiDebitCardActivityStatusEnum["FAILED"] = "FAILED";
    ApiDebitCardActivityStatusEnum["PROVISIONAL"] = "PROVISIONAL";
})(ApiDebitCardActivityStatusEnum = exports.ApiDebitCardActivityStatusEnum || (exports.ApiDebitCardActivityStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDebitCardDetailsStatusEnum;
(function (ApiDebitCardDetailsStatusEnum) {
    ApiDebitCardDetailsStatusEnum["ACTIVE"] = "ACTIVE";
    ApiDebitCardDetailsStatusEnum["INACTIVE"] = "INACTIVE";
    ApiDebitCardDetailsStatusEnum["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
    ApiDebitCardDetailsStatusEnum["VERIFICATION_EXPIRED"] = "VERIFICATION_EXPIRED";
})(ApiDebitCardDetailsStatusEnum = exports.ApiDebitCardDetailsStatusEnum || (exports.ApiDebitCardDetailsStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDebitCardExpiryDateMonthEnum;
(function (ApiDebitCardExpiryDateMonthEnum) {
    ApiDebitCardExpiryDateMonthEnum["JANUARY"] = "JANUARY";
    ApiDebitCardExpiryDateMonthEnum["FEBRUARY"] = "FEBRUARY";
    ApiDebitCardExpiryDateMonthEnum["MARCH"] = "MARCH";
    ApiDebitCardExpiryDateMonthEnum["APRIL"] = "APRIL";
    ApiDebitCardExpiryDateMonthEnum["MAY"] = "MAY";
    ApiDebitCardExpiryDateMonthEnum["JUNE"] = "JUNE";
    ApiDebitCardExpiryDateMonthEnum["JULY"] = "JULY";
    ApiDebitCardExpiryDateMonthEnum["AUGUST"] = "AUGUST";
    ApiDebitCardExpiryDateMonthEnum["SEPTEMBER"] = "SEPTEMBER";
    ApiDebitCardExpiryDateMonthEnum["OCTOBER"] = "OCTOBER";
    ApiDebitCardExpiryDateMonthEnum["NOVEMBER"] = "NOVEMBER";
    ApiDebitCardExpiryDateMonthEnum["DECEMBER"] = "DECEMBER";
})(ApiDebitCardExpiryDateMonthEnum = exports.ApiDebitCardExpiryDateMonthEnum || (exports.ApiDebitCardExpiryDateMonthEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDeviceStatusEnum;
(function (ApiDeviceStatusEnum) {
    ApiDeviceStatusEnum["SUCCESS"] = "SUCCESS";
    ApiDeviceStatusEnum["FAILURE"] = "FAILURE";
})(ApiDeviceStatusEnum = exports.ApiDeviceStatusEnum || (exports.ApiDeviceStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDeviceSessionResponseFlowEnum;
(function (ApiDeviceSessionResponseFlowEnum) {
    ApiDeviceSessionResponseFlowEnum["L1_IDENTITY_CHECK_FINALIZE"] = "L1_IDENTITY_CHECK_FINALIZE";
    ApiDeviceSessionResponseFlowEnum["L2A_IDENTITY_CHECK_FINALIZE"] = "L2A_IDENTITY_CHECK_FINALIZE";
    ApiDeviceSessionResponseFlowEnum["L2A_IDENTITY_CHECK_ADMIN"] = "L2A_IDENTITY_CHECK_ADMIN";
    ApiDeviceSessionResponseFlowEnum["L2A_IDENTITY_CHECK_UPDATE_ADDRESS"] = "L2A_IDENTITY_CHECK_UPDATE_ADDRESS";
    ApiDeviceSessionResponseFlowEnum["L2B_IDENTITY_CHECK"] = "L2B_IDENTITY_CHECK";
    ApiDeviceSessionResponseFlowEnum["L2B_IDENTITY_CHECK_ADMIN"] = "L2B_IDENTITY_CHECK_ADMIN";
    ApiDeviceSessionResponseFlowEnum["L2C_IDENTITY_CHECK"] = "L2C_IDENTITY_CHECK";
    ApiDeviceSessionResponseFlowEnum["PROFILE_UPDATE_ADDRESS"] = "PROFILE_UPDATE_ADDRESS";
    ApiDeviceSessionResponseFlowEnum["PROFILE_UPDATE_IDENTIFIER"] = "PROFILE_UPDATE_IDENTIFIER";
    ApiDeviceSessionResponseFlowEnum["BATCH_UPLOAD"] = "BATCH_UPLOAD";
    ApiDeviceSessionResponseFlowEnum["LOGIN"] = "LOGIN";
    ApiDeviceSessionResponseFlowEnum["LOGOUT"] = "LOGOUT";
    ApiDeviceSessionResponseFlowEnum["REGISTRATION"] = "REGISTRATION";
    ApiDeviceSessionResponseFlowEnum["TRANSACTION"] = "TRANSACTION";
    ApiDeviceSessionResponseFlowEnum["BANK_VERIFICATION"] = "BANK_VERIFICATION";
    ApiDeviceSessionResponseFlowEnum["PARTNER_PARTY_ENROLLMENT"] = "PARTNER_PARTY_ENROLLMENT";
    ApiDeviceSessionResponseFlowEnum["ACH_DEPOSIT"] = "ACH_DEPOSIT";
    ApiDeviceSessionResponseFlowEnum["ACH_WITHDRAW"] = "ACH_WITHDRAW";
    ApiDeviceSessionResponseFlowEnum["BUY_CRYPTO"] = "BUY_CRYPTO";
    ApiDeviceSessionResponseFlowEnum["SELL_CRYPTO"] = "SELL_CRYPTO";
    ApiDeviceSessionResponseFlowEnum["SEND_CRYPTO"] = "SEND_CRYPTO";
    ApiDeviceSessionResponseFlowEnum["CONVERT_REWARD"] = "CONVERT_REWARD";
    ApiDeviceSessionResponseFlowEnum["SEND_CASH"] = "SEND_CASH";
    ApiDeviceSessionResponseFlowEnum["BUY_GIFT_CARD"] = "BUY_GIFT_CARD";
    ApiDeviceSessionResponseFlowEnum["LINKING_BANK"] = "LINKING_BANK";
    ApiDeviceSessionResponseFlowEnum["LINKING_DEBIT_CARD"] = "LINKING_DEBIT_CARD";
    ApiDeviceSessionResponseFlowEnum["DEBIT_CARD_DEPOSIT_TO_WALLET"] = "DEBIT_CARD_DEPOSIT_TO_WALLET";
    ApiDeviceSessionResponseFlowEnum["DEBIT_CARD_WITHDRAWAL_FROM_WALLET"] = "DEBIT_CARD_WITHDRAWAL_FROM_WALLET";
    ApiDeviceSessionResponseFlowEnum["PAYMENT"] = "PAYMENT";
    ApiDeviceSessionResponseFlowEnum["DEBITCARD_VERIFICATION"] = "DEBITCARD_VERIFICATION";
})(ApiDeviceSessionResponseFlowEnum = exports.ApiDeviceSessionResponseFlowEnum || (exports.ApiDeviceSessionResponseFlowEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDeviceSessionResponseSourceEnum;
(function (ApiDeviceSessionResponseSourceEnum) {
    ApiDeviceSessionResponseSourceEnum["ARKOSE"] = "ARKOSE";
    ApiDeviceSessionResponseSourceEnum["SARDINE"] = "SARDINE";
    ApiDeviceSessionResponseSourceEnum["SIFT"] = "SIFT";
})(ApiDeviceSessionResponseSourceEnum = exports.ApiDeviceSessionResponseSourceEnum || (exports.ApiDeviceSessionResponseSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDigitalCardDevicePlatformEnum;
(function (ApiDigitalCardDevicePlatformEnum) {
    ApiDigitalCardDevicePlatformEnum["ANDROID"] = "ANDROID";
    ApiDigitalCardDevicePlatformEnum["IOS"] = "IOS";
    ApiDigitalCardDevicePlatformEnum["WEB"] = "WEB";
})(ApiDigitalCardDevicePlatformEnum = exports.ApiDigitalCardDevicePlatformEnum || (exports.ApiDigitalCardDevicePlatformEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDigitalCardDeviceTypeEnum;
(function (ApiDigitalCardDeviceTypeEnum) {
    ApiDigitalCardDeviceTypeEnum["MOBILE_PHONE"] = "MOBILE_PHONE";
    ApiDigitalCardDeviceTypeEnum["WATCH"] = "WATCH";
    ApiDigitalCardDeviceTypeEnum["TABLET"] = "TABLET";
    ApiDigitalCardDeviceTypeEnum["MOBILE_PHONE_OR_TABLET"] = "MOBILE_PHONE_OR_TABLET";
    ApiDigitalCardDeviceTypeEnum["VEHICLE"] = "VEHICLE";
    ApiDigitalCardDeviceTypeEnum["APPLIANCE"] = "APPLIANCE";
    ApiDigitalCardDeviceTypeEnum["LAPTOP"] = "LAPTOP";
    ApiDigitalCardDeviceTypeEnum["GAMING_DEVICE"] = "GAMING_DEVICE";
    ApiDigitalCardDeviceTypeEnum["MERCHANT_CARD_ON_FILE"] = "MERCHANT_CARD_ON_FILE";
    ApiDigitalCardDeviceTypeEnum["UNKNOWN"] = "UNKNOWN";
})(ApiDigitalCardDeviceTypeEnum = exports.ApiDigitalCardDeviceTypeEnum || (exports.ApiDigitalCardDeviceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDigitalCardStatusEnum;
(function (ApiDigitalCardStatusEnum) {
    ApiDigitalCardStatusEnum["REQUESTED"] = "REQUESTED";
    ApiDigitalCardStatusEnum["PENDING"] = "PENDING";
    ApiDigitalCardStatusEnum["REQUEST_DECLINED"] = "REQUEST_DECLINED";
    ApiDigitalCardStatusEnum["ACTIVE"] = "ACTIVE";
    ApiDigitalCardStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiDigitalCardStatusEnum["TERMINATED"] = "TERMINATED";
})(ApiDigitalCardStatusEnum = exports.ApiDigitalCardStatusEnum || (exports.ApiDigitalCardStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDigitalCardActionRequestStatusEnum;
(function (ApiDigitalCardActionRequestStatusEnum) {
    ApiDigitalCardActionRequestStatusEnum["REQUESTED"] = "REQUESTED";
    ApiDigitalCardActionRequestStatusEnum["PENDING"] = "PENDING";
    ApiDigitalCardActionRequestStatusEnum["REQUEST_DECLINED"] = "REQUEST_DECLINED";
    ApiDigitalCardActionRequestStatusEnum["ACTIVE"] = "ACTIVE";
    ApiDigitalCardActionRequestStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiDigitalCardActionRequestStatusEnum["TERMINATED"] = "TERMINATED";
})(ApiDigitalCardActionRequestStatusEnum = exports.ApiDigitalCardActionRequestStatusEnum || (exports.ApiDigitalCardActionRequestStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDisputeCreateRequestCurrencyEnum;
(function (ApiDisputeCreateRequestCurrencyEnum) {
    ApiDisputeCreateRequestCurrencyEnum["USD"] = "USD";
    ApiDisputeCreateRequestCurrencyEnum["AAVE"] = "AAVE";
    ApiDisputeCreateRequestCurrencyEnum["AVAX"] = "AVAX";
    ApiDisputeCreateRequestCurrencyEnum["AXS"] = "AXS";
    ApiDisputeCreateRequestCurrencyEnum["BAT"] = "BAT";
    ApiDisputeCreateRequestCurrencyEnum["BCH"] = "BCH";
    ApiDisputeCreateRequestCurrencyEnum["BTC"] = "BTC";
    ApiDisputeCreateRequestCurrencyEnum["DOGE"] = "DOGE";
    ApiDisputeCreateRequestCurrencyEnum["ETH"] = "ETH";
    ApiDisputeCreateRequestCurrencyEnum["LINK"] = "LINK";
    ApiDisputeCreateRequestCurrencyEnum["LTC"] = "LTC";
    ApiDisputeCreateRequestCurrencyEnum["MANA"] = "MANA";
    ApiDisputeCreateRequestCurrencyEnum["MATIC"] = "MATIC";
    ApiDisputeCreateRequestCurrencyEnum["SOL"] = "SOL";
    ApiDisputeCreateRequestCurrencyEnum["UNI"] = "UNI";
    ApiDisputeCreateRequestCurrencyEnum["USDC"] = "USDC";
    ApiDisputeCreateRequestCurrencyEnum["LXX"] = "LXX";
    ApiDisputeCreateRequestCurrencyEnum["LCP"] = "LCP";
    ApiDisputeCreateRequestCurrencyEnum["LWR"] = "LWR";
    ApiDisputeCreateRequestCurrencyEnum["LMO"] = "LMO";
    ApiDisputeCreateRequestCurrencyEnum["LKO"] = "LKO";
    ApiDisputeCreateRequestCurrencyEnum["LED"] = "LED";
})(ApiDisputeCreateRequestCurrencyEnum = exports.ApiDisputeCreateRequestCurrencyEnum || (exports.ApiDisputeCreateRequestCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDisputeCreateRequestDisputeTypeEnum;
(function (ApiDisputeCreateRequestDisputeTypeEnum) {
    ApiDisputeCreateRequestDisputeTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiDisputeCreateRequestDisputeTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiDisputeCreateRequestDisputeTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiDisputeCreateRequestDisputeTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    ApiDisputeCreateRequestDisputeTypeEnum["MERCHANT_PAYMENT_V1"] = "MERCHANT_PAYMENT_V1";
    ApiDisputeCreateRequestDisputeTypeEnum["PARTNER_TRANSACTION"] = "PARTNER_TRANSACTION";
})(ApiDisputeCreateRequestDisputeTypeEnum = exports.ApiDisputeCreateRequestDisputeTypeEnum || (exports.ApiDisputeCreateRequestDisputeTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDisputeCreateRequestReasonCodeEnum;
(function (ApiDisputeCreateRequestReasonCodeEnum) {
    ApiDisputeCreateRequestReasonCodeEnum["DAC01"] = "DAC01";
    ApiDisputeCreateRequestReasonCodeEnum["DAC02"] = "DAC02";
    ApiDisputeCreateRequestReasonCodeEnum["DAC03"] = "DAC03";
    ApiDisputeCreateRequestReasonCodeEnum["DAC04"] = "DAC04";
    ApiDisputeCreateRequestReasonCodeEnum["DAC05"] = "DAC05";
    ApiDisputeCreateRequestReasonCodeEnum["DAC06"] = "DAC06";
    ApiDisputeCreateRequestReasonCodeEnum["DAC07"] = "DAC07";
    ApiDisputeCreateRequestReasonCodeEnum["DAC08"] = "DAC08";
    ApiDisputeCreateRequestReasonCodeEnum["DAC09"] = "DAC09";
    ApiDisputeCreateRequestReasonCodeEnum["DAC10"] = "DAC10";
})(ApiDisputeCreateRequestReasonCodeEnum = exports.ApiDisputeCreateRequestReasonCodeEnum || (exports.ApiDisputeCreateRequestReasonCodeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiDisputeRegulationERequestRegulationEFlagEnum;
(function (ApiDisputeRegulationERequestRegulationEFlagEnum) {
    ApiDisputeRegulationERequestRegulationEFlagEnum["YES"] = "YES";
    ApiDisputeRegulationERequestRegulationEFlagEnum["NO"] = "NO";
    ApiDisputeRegulationERequestRegulationEFlagEnum["NO_DISPOSITION"] = "NO_DISPOSITION";
})(ApiDisputeRegulationERequestRegulationEFlagEnum = exports.ApiDisputeRegulationERequestRegulationEFlagEnum || (exports.ApiDisputeRegulationERequestRegulationEFlagEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedCryptoExecutePriceRequestBuySellIndicatorEnum;
(function (ApiEmbeddedCryptoExecutePriceRequestBuySellIndicatorEnum) {
    ApiEmbeddedCryptoExecutePriceRequestBuySellIndicatorEnum["BUY"] = "BUY";
    ApiEmbeddedCryptoExecutePriceRequestBuySellIndicatorEnum["SELL"] = "SELL";
})(ApiEmbeddedCryptoExecutePriceRequestBuySellIndicatorEnum = exports.ApiEmbeddedCryptoExecutePriceRequestBuySellIndicatorEnum || (exports.ApiEmbeddedCryptoExecutePriceRequestBuySellIndicatorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum;
(function (ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum) {
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["USD"] = "USD";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["AAVE"] = "AAVE";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["AVAX"] = "AVAX";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["AXS"] = "AXS";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["BAT"] = "BAT";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["BCH"] = "BCH";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["BTC"] = "BTC";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["DOGE"] = "DOGE";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["ETH"] = "ETH";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["LINK"] = "LINK";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["LTC"] = "LTC";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["MANA"] = "MANA";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["MATIC"] = "MATIC";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["SOL"] = "SOL";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["UNI"] = "UNI";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["USDC"] = "USDC";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["LXX"] = "LXX";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["LCP"] = "LCP";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["LWR"] = "LWR";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["LMO"] = "LMO";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["LKO"] = "LKO";
    ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum["LED"] = "LED";
})(ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum = exports.ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum || (exports.ApiEmbeddedCryptoExecutePriceRequestDestinationCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedCryptoExecutePriceResponseBuySellIndicatorEnum;
(function (ApiEmbeddedCryptoExecutePriceResponseBuySellIndicatorEnum) {
    ApiEmbeddedCryptoExecutePriceResponseBuySellIndicatorEnum["BUY"] = "BUY";
    ApiEmbeddedCryptoExecutePriceResponseBuySellIndicatorEnum["SELL"] = "SELL";
})(ApiEmbeddedCryptoExecutePriceResponseBuySellIndicatorEnum = exports.ApiEmbeddedCryptoExecutePriceResponseBuySellIndicatorEnum || (exports.ApiEmbeddedCryptoExecutePriceResponseBuySellIndicatorEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedCryptoTransactionRequestTransactTypeEnum;
(function (ApiEmbeddedCryptoTransactionRequestTransactTypeEnum) {
    ApiEmbeddedCryptoTransactionRequestTransactTypeEnum["BUY"] = "BUY";
    ApiEmbeddedCryptoTransactionRequestTransactTypeEnum["SELL"] = "SELL";
})(ApiEmbeddedCryptoTransactionRequestTransactTypeEnum = exports.ApiEmbeddedCryptoTransactionRequestTransactTypeEnum || (exports.ApiEmbeddedCryptoTransactionRequestTransactTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum;
(function (ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum) {
    ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum["REWARD"] = "REWARD";
    ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum["LOYALTY"] = "LOYALTY";
    ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum["PAYOUT"] = "PAYOUT";
})(ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum = exports.ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum || (exports.ApiEmbeddedCryptoTransactionResponseTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum;
(function (ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum) {
    ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum["TAX_ID_NUMBER"] = "TAX_ID_NUMBER";
    ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum["OCCUPATION"] = "OCCUPATION";
    ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum["FIRST_NAME"] = "FIRST_NAME";
    ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum["LAST_NAME"] = "LAST_NAME";
    ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum["ADDRESS"] = "ADDRESS";
    ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum["PHONE"] = "PHONE";
    ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum["EMAIL"] = "EMAIL";
})(ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum = exports.ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum || (exports.ApiEmbeddedPartnerPartyProfileResponseFieldsAvailableFromPartnerEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum;
(function (ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum) {
    ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum["TAX_ID_NUMBER"] = "TAX_ID_NUMBER";
    ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum["OCCUPATION"] = "OCCUPATION";
    ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum["FIRST_NAME"] = "FIRST_NAME";
    ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum["LAST_NAME"] = "LAST_NAME";
    ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum["ADDRESS"] = "ADDRESS";
    ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum["PHONE"] = "PHONE";
    ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum["EMAIL"] = "EMAIL";
})(ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum = exports.ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum || (exports.ApiEmbeddedPartnerPartyProfileResponseMissingFieldsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedPartnerTransactionCryptoCurrencySourceEnum;
(function (ApiEmbeddedPartnerTransactionCryptoCurrencySourceEnum) {
    ApiEmbeddedPartnerTransactionCryptoCurrencySourceEnum["PARTNER"] = "PARTNER";
    ApiEmbeddedPartnerTransactionCryptoCurrencySourceEnum["PARTY"] = "PARTY";
})(ApiEmbeddedPartnerTransactionCryptoCurrencySourceEnum = exports.ApiEmbeddedPartnerTransactionCryptoCurrencySourceEnum || (exports.ApiEmbeddedPartnerTransactionCryptoCurrencySourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedPartnerTransactionCryptoCurrencyTransactTypeEnum;
(function (ApiEmbeddedPartnerTransactionCryptoCurrencyTransactTypeEnum) {
    ApiEmbeddedPartnerTransactionCryptoCurrencyTransactTypeEnum["BUY"] = "BUY";
    ApiEmbeddedPartnerTransactionCryptoCurrencyTransactTypeEnum["SELL"] = "SELL";
})(ApiEmbeddedPartnerTransactionCryptoCurrencyTransactTypeEnum = exports.ApiEmbeddedPartnerTransactionCryptoCurrencyTransactTypeEnum || (exports.ApiEmbeddedPartnerTransactionCryptoCurrencyTransactTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedPartnerTransactionStatusEnum;
(function (ApiEmbeddedPartnerTransactionStatusEnum) {
    ApiEmbeddedPartnerTransactionStatusEnum["CAPTURED"] = "CAPTURED";
    ApiEmbeddedPartnerTransactionStatusEnum["DECLINED"] = "DECLINED";
    ApiEmbeddedPartnerTransactionStatusEnum["DISPUTED"] = "DISPUTED";
    ApiEmbeddedPartnerTransactionStatusEnum["CANCELLED"] = "CANCELLED";
})(ApiEmbeddedPartnerTransactionStatusEnum = exports.ApiEmbeddedPartnerTransactionStatusEnum || (exports.ApiEmbeddedPartnerTransactionStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedPartnerTransactionTransactionTypeEnum;
(function (ApiEmbeddedPartnerTransactionTransactionTypeEnum) {
    ApiEmbeddedPartnerTransactionTransactionTypeEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    ApiEmbeddedPartnerTransactionTransactionTypeEnum["REWARD"] = "REWARD";
    ApiEmbeddedPartnerTransactionTransactionTypeEnum["LOYALTY"] = "LOYALTY";
    ApiEmbeddedPartnerTransactionTransactionTypeEnum["PAYOUT"] = "PAYOUT";
})(ApiEmbeddedPartnerTransactionTransactionTypeEnum = exports.ApiEmbeddedPartnerTransactionTransactionTypeEnum || (exports.ApiEmbeddedPartnerTransactionTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEmbeddedPartnerTransactionSummaryTransactionTypeEnum;
(function (ApiEmbeddedPartnerTransactionSummaryTransactionTypeEnum) {
    ApiEmbeddedPartnerTransactionSummaryTransactionTypeEnum["BUY"] = "BUY";
    ApiEmbeddedPartnerTransactionSummaryTransactionTypeEnum["SELL"] = "SELL";
})(ApiEmbeddedPartnerTransactionSummaryTransactionTypeEnum = exports.ApiEmbeddedPartnerTransactionSummaryTransactionTypeEnum || (exports.ApiEmbeddedPartnerTransactionSummaryTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEnrichedAchRecordStatusEnum;
(function (ApiEnrichedAchRecordStatusEnum) {
    ApiEnrichedAchRecordStatusEnum["READY"] = "READY";
    ApiEnrichedAchRecordStatusEnum["ERROR"] = "ERROR";
    ApiEnrichedAchRecordStatusEnum["PROCESSED"] = "PROCESSED";
})(ApiEnrichedAchRecordStatusEnum = exports.ApiEnrichedAchRecordStatusEnum || (exports.ApiEnrichedAchRecordStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiEnrichedAchRecordTypeEnum;
(function (ApiEnrichedAchRecordTypeEnum) {
    ApiEnrichedAchRecordTypeEnum["UNSPECIFIED"] = "UNSPECIFIED";
    ApiEnrichedAchRecordTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiEnrichedAchRecordTypeEnum["WITHDRAWAL"] = "WITHDRAWAL";
    ApiEnrichedAchRecordTypeEnum["RETURN_DEPOSIT"] = "RETURN_DEPOSIT";
    ApiEnrichedAchRecordTypeEnum["RETURN_WITHDRAWAL"] = "RETURN_WITHDRAWAL";
})(ApiEnrichedAchRecordTypeEnum = exports.ApiEnrichedAchRecordTypeEnum || (exports.ApiEnrichedAchRecordTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiFailureActivityTransactionTypeEnum;
(function (ApiFailureActivityTransactionTypeEnum) {
    ApiFailureActivityTransactionTypeEnum["SIFT_SCORE"] = "SIFT_SCORE";
    ApiFailureActivityTransactionTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiFailureActivityTransactionTypeEnum["DEBIT_CARD_LINK"] = "DEBIT_CARD_LINK";
    ApiFailureActivityTransactionTypeEnum["ACH_LINK"] = "ACH_LINK";
})(ApiFailureActivityTransactionTypeEnum = exports.ApiFailureActivityTransactionTypeEnum || (exports.ApiFailureActivityTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiFundingSourceDetailAssetTypeEnum;
(function (ApiFundingSourceDetailAssetTypeEnum) {
    ApiFundingSourceDetailAssetTypeEnum["CASH"] = "CASH";
    ApiFundingSourceDetailAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiFundingSourceDetailAssetTypeEnum["REWARDS"] = "REWARDS";
})(ApiFundingSourceDetailAssetTypeEnum = exports.ApiFundingSourceDetailAssetTypeEnum || (exports.ApiFundingSourceDetailAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiFundingSourceDetailCurrencyEnum;
(function (ApiFundingSourceDetailCurrencyEnum) {
    ApiFundingSourceDetailCurrencyEnum["USD"] = "USD";
    ApiFundingSourceDetailCurrencyEnum["AAVE"] = "AAVE";
    ApiFundingSourceDetailCurrencyEnum["AVAX"] = "AVAX";
    ApiFundingSourceDetailCurrencyEnum["AXS"] = "AXS";
    ApiFundingSourceDetailCurrencyEnum["BAT"] = "BAT";
    ApiFundingSourceDetailCurrencyEnum["BCH"] = "BCH";
    ApiFundingSourceDetailCurrencyEnum["BTC"] = "BTC";
    ApiFundingSourceDetailCurrencyEnum["DOGE"] = "DOGE";
    ApiFundingSourceDetailCurrencyEnum["ETH"] = "ETH";
    ApiFundingSourceDetailCurrencyEnum["LINK"] = "LINK";
    ApiFundingSourceDetailCurrencyEnum["LTC"] = "LTC";
    ApiFundingSourceDetailCurrencyEnum["MANA"] = "MANA";
    ApiFundingSourceDetailCurrencyEnum["MATIC"] = "MATIC";
    ApiFundingSourceDetailCurrencyEnum["SOL"] = "SOL";
    ApiFundingSourceDetailCurrencyEnum["UNI"] = "UNI";
    ApiFundingSourceDetailCurrencyEnum["USDC"] = "USDC";
    ApiFundingSourceDetailCurrencyEnum["LXX"] = "LXX";
    ApiFundingSourceDetailCurrencyEnum["LCP"] = "LCP";
    ApiFundingSourceDetailCurrencyEnum["LWR"] = "LWR";
    ApiFundingSourceDetailCurrencyEnum["LMO"] = "LMO";
    ApiFundingSourceDetailCurrencyEnum["LKO"] = "LKO";
    ApiFundingSourceDetailCurrencyEnum["LED"] = "LED";
})(ApiFundingSourceDetailCurrencyEnum = exports.ApiFundingSourceDetailCurrencyEnum || (exports.ApiFundingSourceDetailCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiFundingSourceDetailResponseTypeEnum;
(function (ApiFundingSourceDetailResponseTypeEnum) {
    ApiFundingSourceDetailResponseTypeEnum["BUY_GIFTCARD"] = "BUY_GIFTCARD";
    ApiFundingSourceDetailResponseTypeEnum["BUY_CRYPTO"] = "BUY_CRYPTO";
    ApiFundingSourceDetailResponseTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
})(ApiFundingSourceDetailResponseTypeEnum = exports.ApiFundingSourceDetailResponseTypeEnum || (exports.ApiFundingSourceDetailResponseTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiGiftCardDetailResponseStatusEnum;
(function (ApiGiftCardDetailResponseStatusEnum) {
    ApiGiftCardDetailResponseStatusEnum["ACTIVE"] = "ACTIVE";
    ApiGiftCardDetailResponseStatusEnum["INACTIVE"] = "INACTIVE";
})(ApiGiftCardDetailResponseStatusEnum = exports.ApiGiftCardDetailResponseStatusEnum || (exports.ApiGiftCardDetailResponseStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiGiftCardDetailResponseTransactionTypeEnum;
(function (ApiGiftCardDetailResponseTransactionTypeEnum) {
    ApiGiftCardDetailResponseTransactionTypeEnum["BUY"] = "BUY";
    ApiGiftCardDetailResponseTransactionTypeEnum["ADD"] = "ADD";
    ApiGiftCardDetailResponseTransactionTypeEnum["SEND"] = "SEND";
    ApiGiftCardDetailResponseTransactionTypeEnum["CREDIT"] = "CREDIT";
    ApiGiftCardDetailResponseTransactionTypeEnum["REDEEM"] = "REDEEM";
    ApiGiftCardDetailResponseTransactionTypeEnum["INCENTIVE"] = "INCENTIVE";
})(ApiGiftCardDetailResponseTransactionTypeEnum = exports.ApiGiftCardDetailResponseTransactionTypeEnum || (exports.ApiGiftCardDetailResponseTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiGiftCardFeedHistoryStatusEnum;
(function (ApiGiftCardFeedHistoryStatusEnum) {
    ApiGiftCardFeedHistoryStatusEnum["RUNNING"] = "RUNNING";
    ApiGiftCardFeedHistoryStatusEnum["SUCCESS"] = "SUCCESS";
    ApiGiftCardFeedHistoryStatusEnum["FAILURE"] = "FAILURE";
})(ApiGiftCardFeedHistoryStatusEnum = exports.ApiGiftCardFeedHistoryStatusEnum || (exports.ApiGiftCardFeedHistoryStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiGiftCardProductStatusEnum;
(function (ApiGiftCardProductStatusEnum) {
    ApiGiftCardProductStatusEnum["DRAFT"] = "DRAFT";
    ApiGiftCardProductStatusEnum["ACTIVATED"] = "ACTIVATED";
    ApiGiftCardProductStatusEnum["SUSPENDED"] = "SUSPENDED";
})(ApiGiftCardProductStatusEnum = exports.ApiGiftCardProductStatusEnum || (exports.ApiGiftCardProductStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiGiftCardSummaryResponseStatusEnum;
(function (ApiGiftCardSummaryResponseStatusEnum) {
    ApiGiftCardSummaryResponseStatusEnum["ACTIVE"] = "ACTIVE";
    ApiGiftCardSummaryResponseStatusEnum["INACTIVE"] = "INACTIVE";
})(ApiGiftCardSummaryResponseStatusEnum = exports.ApiGiftCardSummaryResponseStatusEnum || (exports.ApiGiftCardSummaryResponseStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIdentityCheckResponseFlowEnum;
(function (ApiIdentityCheckResponseFlowEnum) {
    ApiIdentityCheckResponseFlowEnum["L1_IDENTITY_CHECK_FINALIZE"] = "L1_IDENTITY_CHECK_FINALIZE";
    ApiIdentityCheckResponseFlowEnum["L2A_IDENTITY_CHECK_FINALIZE"] = "L2A_IDENTITY_CHECK_FINALIZE";
    ApiIdentityCheckResponseFlowEnum["L2A_IDENTITY_CHECK_ADMIN"] = "L2A_IDENTITY_CHECK_ADMIN";
    ApiIdentityCheckResponseFlowEnum["L2A_IDENTITY_CHECK_UPDATE_ADDRESS"] = "L2A_IDENTITY_CHECK_UPDATE_ADDRESS";
    ApiIdentityCheckResponseFlowEnum["L2B_IDENTITY_CHECK"] = "L2B_IDENTITY_CHECK";
    ApiIdentityCheckResponseFlowEnum["L2B_IDENTITY_CHECK_ADMIN"] = "L2B_IDENTITY_CHECK_ADMIN";
    ApiIdentityCheckResponseFlowEnum["L2C_IDENTITY_CHECK"] = "L2C_IDENTITY_CHECK";
    ApiIdentityCheckResponseFlowEnum["PROFILE_UPDATE_ADDRESS"] = "PROFILE_UPDATE_ADDRESS";
    ApiIdentityCheckResponseFlowEnum["PROFILE_UPDATE_IDENTIFIER"] = "PROFILE_UPDATE_IDENTIFIER";
    ApiIdentityCheckResponseFlowEnum["BATCH_UPLOAD"] = "BATCH_UPLOAD";
    ApiIdentityCheckResponseFlowEnum["LOGIN"] = "LOGIN";
    ApiIdentityCheckResponseFlowEnum["LOGOUT"] = "LOGOUT";
    ApiIdentityCheckResponseFlowEnum["REGISTRATION"] = "REGISTRATION";
    ApiIdentityCheckResponseFlowEnum["TRANSACTION"] = "TRANSACTION";
    ApiIdentityCheckResponseFlowEnum["BANK_VERIFICATION"] = "BANK_VERIFICATION";
    ApiIdentityCheckResponseFlowEnum["PARTNER_PARTY_ENROLLMENT"] = "PARTNER_PARTY_ENROLLMENT";
    ApiIdentityCheckResponseFlowEnum["ACH_DEPOSIT"] = "ACH_DEPOSIT";
    ApiIdentityCheckResponseFlowEnum["ACH_WITHDRAW"] = "ACH_WITHDRAW";
    ApiIdentityCheckResponseFlowEnum["BUY_CRYPTO"] = "BUY_CRYPTO";
    ApiIdentityCheckResponseFlowEnum["SELL_CRYPTO"] = "SELL_CRYPTO";
    ApiIdentityCheckResponseFlowEnum["SEND_CRYPTO"] = "SEND_CRYPTO";
    ApiIdentityCheckResponseFlowEnum["CONVERT_REWARD"] = "CONVERT_REWARD";
    ApiIdentityCheckResponseFlowEnum["SEND_CASH"] = "SEND_CASH";
    ApiIdentityCheckResponseFlowEnum["BUY_GIFT_CARD"] = "BUY_GIFT_CARD";
    ApiIdentityCheckResponseFlowEnum["LINKING_BANK"] = "LINKING_BANK";
    ApiIdentityCheckResponseFlowEnum["LINKING_DEBIT_CARD"] = "LINKING_DEBIT_CARD";
    ApiIdentityCheckResponseFlowEnum["DEBIT_CARD_DEPOSIT_TO_WALLET"] = "DEBIT_CARD_DEPOSIT_TO_WALLET";
    ApiIdentityCheckResponseFlowEnum["DEBIT_CARD_WITHDRAWAL_FROM_WALLET"] = "DEBIT_CARD_WITHDRAWAL_FROM_WALLET";
    ApiIdentityCheckResponseFlowEnum["PAYMENT"] = "PAYMENT";
    ApiIdentityCheckResponseFlowEnum["DEBITCARD_VERIFICATION"] = "DEBITCARD_VERIFICATION";
})(ApiIdentityCheckResponseFlowEnum = exports.ApiIdentityCheckResponseFlowEnum || (exports.ApiIdentityCheckResponseFlowEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIdentityCheckResponseRiskLevelEnum;
(function (ApiIdentityCheckResponseRiskLevelEnum) {
    ApiIdentityCheckResponseRiskLevelEnum["VERY_HIGH"] = "VERY_HIGH";
    ApiIdentityCheckResponseRiskLevelEnum["HIGH"] = "HIGH";
    ApiIdentityCheckResponseRiskLevelEnum["MEDIUM"] = "MEDIUM";
    ApiIdentityCheckResponseRiskLevelEnum["LOW"] = "LOW";
})(ApiIdentityCheckResponseRiskLevelEnum = exports.ApiIdentityCheckResponseRiskLevelEnum || (exports.ApiIdentityCheckResponseRiskLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIncentiveAwardDetailAwardExecutionCurrencyEnum;
(function (ApiIncentiveAwardDetailAwardExecutionCurrencyEnum) {
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["USD"] = "USD";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["AAVE"] = "AAVE";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["AVAX"] = "AVAX";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["AXS"] = "AXS";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["BAT"] = "BAT";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["BCH"] = "BCH";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["BTC"] = "BTC";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["DOGE"] = "DOGE";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["ETH"] = "ETH";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["LINK"] = "LINK";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["LTC"] = "LTC";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["MANA"] = "MANA";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["MATIC"] = "MATIC";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["SOL"] = "SOL";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["UNI"] = "UNI";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["USDC"] = "USDC";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["LXX"] = "LXX";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["LCP"] = "LCP";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["LWR"] = "LWR";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["LMO"] = "LMO";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["LKO"] = "LKO";
    ApiIncentiveAwardDetailAwardExecutionCurrencyEnum["LED"] = "LED";
})(ApiIncentiveAwardDetailAwardExecutionCurrencyEnum = exports.ApiIncentiveAwardDetailAwardExecutionCurrencyEnum || (exports.ApiIncentiveAwardDetailAwardExecutionCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIncentiveAwardDetailTypeEnum;
(function (ApiIncentiveAwardDetailTypeEnum) {
    ApiIncentiveAwardDetailTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiIncentiveAwardDetailTypeEnum["CRYPTO"] = "CRYPTO";
    ApiIncentiveAwardDetailTypeEnum["CASH"] = "CASH";
    ApiIncentiveAwardDetailTypeEnum["FEATURE_WHITELIST"] = "FEATURE_WHITELIST";
    ApiIncentiveAwardDetailTypeEnum["LOYALTY"] = "LOYALTY";
})(ApiIncentiveAwardDetailTypeEnum = exports.ApiIncentiveAwardDetailTypeEnum || (exports.ApiIncentiveAwardDetailTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIncentiveAwardDetailValueTypeEnum;
(function (ApiIncentiveAwardDetailValueTypeEnum) {
    ApiIncentiveAwardDetailValueTypeEnum["FIXED_AWARD"] = "FIXED_AWARD";
    ApiIncentiveAwardDetailValueTypeEnum["PERCENT_AWARD"] = "PERCENT_AWARD";
})(ApiIncentiveAwardDetailValueTypeEnum = exports.ApiIncentiveAwardDetailValueTypeEnum || (exports.ApiIncentiveAwardDetailValueTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIncentiveCriterionTypeEnum;
(function (ApiIncentiveCriterionTypeEnum) {
    ApiIncentiveCriterionTypeEnum["REGISTRATION_DATE"] = "REGISTRATION_DATE";
    ApiIncentiveCriterionTypeEnum["FIXED_IDENTIFIERS"] = "FIXED_IDENTIFIERS";
    ApiIncentiveCriterionTypeEnum["OPEN_TO_ALL"] = "OPEN_TO_ALL";
    ApiIncentiveCriterionTypeEnum["FIRST_OFFER"] = "FIRST_OFFER";
    ApiIncentiveCriterionTypeEnum["FIRST_OFFER_EXCLUDING_OTHER_OFFER"] = "FIRST_OFFER_EXCLUDING_OTHER_OFFER";
    ApiIncentiveCriterionTypeEnum["INELIGIBLE_IF_OTHER_OFFER"] = "INELIGIBLE_IF_OTHER_OFFER";
    ApiIncentiveCriterionTypeEnum["CAMPAIGN_NAME_MATCH"] = "CAMPAIGN_NAME_MATCH";
})(ApiIncentiveCriterionTypeEnum = exports.ApiIncentiveCriterionTypeEnum || (exports.ApiIncentiveCriterionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIncentiveDetailResponsePartyAwardStatusEnum;
(function (ApiIncentiveDetailResponsePartyAwardStatusEnum) {
    ApiIncentiveDetailResponsePartyAwardStatusEnum["COMPLETE"] = "COMPLETE";
    ApiIncentiveDetailResponsePartyAwardStatusEnum["PENDING"] = "PENDING";
    ApiIncentiveDetailResponsePartyAwardStatusEnum["EXPIRED"] = "EXPIRED";
    ApiIncentiveDetailResponsePartyAwardStatusEnum["FAILED"] = "FAILED";
})(ApiIncentiveDetailResponsePartyAwardStatusEnum = exports.ApiIncentiveDetailResponsePartyAwardStatusEnum || (exports.ApiIncentiveDetailResponsePartyAwardStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIncentiveOfferSummaryAwardTypeEnum;
(function (ApiIncentiveOfferSummaryAwardTypeEnum) {
    ApiIncentiveOfferSummaryAwardTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiIncentiveOfferSummaryAwardTypeEnum["CRYPTO"] = "CRYPTO";
    ApiIncentiveOfferSummaryAwardTypeEnum["CASH"] = "CASH";
    ApiIncentiveOfferSummaryAwardTypeEnum["FEATURE_WHITELIST"] = "FEATURE_WHITELIST";
    ApiIncentiveOfferSummaryAwardTypeEnum["LOYALTY"] = "LOYALTY";
})(ApiIncentiveOfferSummaryAwardTypeEnum = exports.ApiIncentiveOfferSummaryAwardTypeEnum || (exports.ApiIncentiveOfferSummaryAwardTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIncentiveTriggerCriterionTypeEnum;
(function (ApiIncentiveTriggerCriterionTypeEnum) {
    ApiIncentiveTriggerCriterionTypeEnum["LOYALTY_PARTNER_BY_NAME"] = "LOYALTY_PARTNER_BY_NAME";
    ApiIncentiveTriggerCriterionTypeEnum["BAKKT_CARD_PAYMENT"] = "BAKKT_CARD_PAYMENT";
    ApiIncentiveTriggerCriterionTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiIncentiveTriggerCriterionTypeEnum["LOYALTY_REDEMPTION"] = "LOYALTY_REDEMPTION";
    ApiIncentiveTriggerCriterionTypeEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    ApiIncentiveTriggerCriterionTypeEnum["PARTY_TO_PARTY_TRANSFER"] = "PARTY_TO_PARTY_TRANSFER";
})(ApiIncentiveTriggerCriterionTypeEnum = exports.ApiIncentiveTriggerCriterionTypeEnum || (exports.ApiIncentiveTriggerCriterionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIncentiveTriggerDetailActionTypeEnum;
(function (ApiIncentiveTriggerDetailActionTypeEnum) {
    ApiIncentiveTriggerDetailActionTypeEnum["BUY"] = "BUY";
    ApiIncentiveTriggerDetailActionTypeEnum["SEND"] = "SEND";
    ApiIncentiveTriggerDetailActionTypeEnum["LINK"] = "LINK";
    ApiIncentiveTriggerDetailActionTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiIncentiveTriggerDetailActionTypeEnum["PAYMENT"] = "PAYMENT";
    ApiIncentiveTriggerDetailActionTypeEnum["REDEEM"] = "REDEEM";
    ApiIncentiveTriggerDetailActionTypeEnum["USER_REGISTRATION"] = "USER_REGISTRATION";
    ApiIncentiveTriggerDetailActionTypeEnum["USER_REFEREE"] = "USER_REFEREE";
    ApiIncentiveTriggerDetailActionTypeEnum["USER_REFERRER"] = "USER_REFERRER";
})(ApiIncentiveTriggerDetailActionTypeEnum = exports.ApiIncentiveTriggerDetailActionTypeEnum || (exports.ApiIncentiveTriggerDetailActionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiIncentiveTriggerDetailAssetTypeEnum;
(function (ApiIncentiveTriggerDetailAssetTypeEnum) {
    ApiIncentiveTriggerDetailAssetTypeEnum["CASH"] = "CASH";
    ApiIncentiveTriggerDetailAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiIncentiveTriggerDetailAssetTypeEnum["REWARDS"] = "REWARDS";
    ApiIncentiveTriggerDetailAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiIncentiveTriggerDetailAssetTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiIncentiveTriggerDetailAssetTypeEnum["MERCHANT"] = "MERCHANT";
    ApiIncentiveTriggerDetailAssetTypeEnum["NONE"] = "NONE";
    ApiIncentiveTriggerDetailAssetTypeEnum["ANY"] = "ANY";
})(ApiIncentiveTriggerDetailAssetTypeEnum = exports.ApiIncentiveTriggerDetailAssetTypeEnum || (exports.ApiIncentiveTriggerDetailAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiLoyaltyAccountDetailLoyaltyIntegrationTypeEnum;
(function (ApiLoyaltyAccountDetailLoyaltyIntegrationTypeEnum) {
    ApiLoyaltyAccountDetailLoyaltyIntegrationTypeEnum["UNKNOWN"] = "UNKNOWN";
    ApiLoyaltyAccountDetailLoyaltyIntegrationTypeEnum["AWARD_WALLET"] = "AWARD_WALLET";
    ApiLoyaltyAccountDetailLoyaltyIntegrationTypeEnum["REWARDS_GATEWAY"] = "REWARDS_GATEWAY";
})(ApiLoyaltyAccountDetailLoyaltyIntegrationTypeEnum = exports.ApiLoyaltyAccountDetailLoyaltyIntegrationTypeEnum || (exports.ApiLoyaltyAccountDetailLoyaltyIntegrationTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiLoyaltyAccountDetailStatusEnum;
(function (ApiLoyaltyAccountDetailStatusEnum) {
    ApiLoyaltyAccountDetailStatusEnum["OPEN"] = "OPEN";
    ApiLoyaltyAccountDetailStatusEnum["PENDING"] = "PENDING";
    ApiLoyaltyAccountDetailStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiLoyaltyAccountDetailStatusEnum["UNLINKED"] = "UNLINKED";
    ApiLoyaltyAccountDetailStatusEnum["EXPIRED"] = "EXPIRED";
})(ApiLoyaltyAccountDetailStatusEnum = exports.ApiLoyaltyAccountDetailStatusEnum || (exports.ApiLoyaltyAccountDetailStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiLoyaltyTransactionLoyaltyCurrencyEnum;
(function (ApiLoyaltyTransactionLoyaltyCurrencyEnum) {
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["USD"] = "USD";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["AAVE"] = "AAVE";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["AVAX"] = "AVAX";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["AXS"] = "AXS";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["BAT"] = "BAT";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["BCH"] = "BCH";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["BTC"] = "BTC";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["DOGE"] = "DOGE";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["ETH"] = "ETH";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["LINK"] = "LINK";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["LTC"] = "LTC";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["MANA"] = "MANA";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["MATIC"] = "MATIC";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["SOL"] = "SOL";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["UNI"] = "UNI";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["USDC"] = "USDC";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["LXX"] = "LXX";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["LCP"] = "LCP";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["LWR"] = "LWR";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["LMO"] = "LMO";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["LKO"] = "LKO";
    ApiLoyaltyTransactionLoyaltyCurrencyEnum["LED"] = "LED";
})(ApiLoyaltyTransactionLoyaltyCurrencyEnum = exports.ApiLoyaltyTransactionLoyaltyCurrencyEnum || (exports.ApiLoyaltyTransactionLoyaltyCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiLoyaltyTransactionLoyaltyTransactionTypeEnum;
(function (ApiLoyaltyTransactionLoyaltyTransactionTypeEnum) {
    ApiLoyaltyTransactionLoyaltyTransactionTypeEnum["REDEMPTION_CANCEL"] = "REDEMPTION_CANCEL";
    ApiLoyaltyTransactionLoyaltyTransactionTypeEnum["REDEMPTION"] = "REDEMPTION";
    ApiLoyaltyTransactionLoyaltyTransactionTypeEnum["CREDIT"] = "CREDIT";
    ApiLoyaltyTransactionLoyaltyTransactionTypeEnum["CREDIT_CANCEL"] = "CREDIT_CANCEL";
    ApiLoyaltyTransactionLoyaltyTransactionTypeEnum["BUY"] = "BUY";
    ApiLoyaltyTransactionLoyaltyTransactionTypeEnum["BUY_CANCEL"] = "BUY_CANCEL";
    ApiLoyaltyTransactionLoyaltyTransactionTypeEnum["PAY_WITH_POINTS"] = "PAY_WITH_POINTS";
})(ApiLoyaltyTransactionLoyaltyTransactionTypeEnum = exports.ApiLoyaltyTransactionLoyaltyTransactionTypeEnum || (exports.ApiLoyaltyTransactionLoyaltyTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiLoyaltyTransactionStatusEnum;
(function (ApiLoyaltyTransactionStatusEnum) {
    ApiLoyaltyTransactionStatusEnum["COMPLETE"] = "COMPLETE";
    ApiLoyaltyTransactionStatusEnum["PENDING"] = "PENDING";
    ApiLoyaltyTransactionStatusEnum["TIMED_OUT"] = "TIMED_OUT";
    ApiLoyaltyTransactionStatusEnum["PERMANENT_FAILURE"] = "PERMANENT_FAILURE";
    ApiLoyaltyTransactionStatusEnum["REPLACED_NSF"] = "REPLACED_NSF";
    ApiLoyaltyTransactionStatusEnum["NO_AVAILABLE_BALANCE"] = "NO_AVAILABLE_BALANCE";
})(ApiLoyaltyTransactionStatusEnum = exports.ApiLoyaltyTransactionStatusEnum || (exports.ApiLoyaltyTransactionStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiLoyaltyTransactionTransactionCurrencyEnum;
(function (ApiLoyaltyTransactionTransactionCurrencyEnum) {
    ApiLoyaltyTransactionTransactionCurrencyEnum["USD"] = "USD";
    ApiLoyaltyTransactionTransactionCurrencyEnum["AAVE"] = "AAVE";
    ApiLoyaltyTransactionTransactionCurrencyEnum["AVAX"] = "AVAX";
    ApiLoyaltyTransactionTransactionCurrencyEnum["AXS"] = "AXS";
    ApiLoyaltyTransactionTransactionCurrencyEnum["BAT"] = "BAT";
    ApiLoyaltyTransactionTransactionCurrencyEnum["BCH"] = "BCH";
    ApiLoyaltyTransactionTransactionCurrencyEnum["BTC"] = "BTC";
    ApiLoyaltyTransactionTransactionCurrencyEnum["DOGE"] = "DOGE";
    ApiLoyaltyTransactionTransactionCurrencyEnum["ETH"] = "ETH";
    ApiLoyaltyTransactionTransactionCurrencyEnum["LINK"] = "LINK";
    ApiLoyaltyTransactionTransactionCurrencyEnum["LTC"] = "LTC";
    ApiLoyaltyTransactionTransactionCurrencyEnum["MANA"] = "MANA";
    ApiLoyaltyTransactionTransactionCurrencyEnum["MATIC"] = "MATIC";
    ApiLoyaltyTransactionTransactionCurrencyEnum["SOL"] = "SOL";
    ApiLoyaltyTransactionTransactionCurrencyEnum["UNI"] = "UNI";
    ApiLoyaltyTransactionTransactionCurrencyEnum["USDC"] = "USDC";
    ApiLoyaltyTransactionTransactionCurrencyEnum["LXX"] = "LXX";
    ApiLoyaltyTransactionTransactionCurrencyEnum["LCP"] = "LCP";
    ApiLoyaltyTransactionTransactionCurrencyEnum["LWR"] = "LWR";
    ApiLoyaltyTransactionTransactionCurrencyEnum["LMO"] = "LMO";
    ApiLoyaltyTransactionTransactionCurrencyEnum["LKO"] = "LKO";
    ApiLoyaltyTransactionTransactionCurrencyEnum["LED"] = "LED";
})(ApiLoyaltyTransactionTransactionCurrencyEnum = exports.ApiLoyaltyTransactionTransactionCurrencyEnum || (exports.ApiLoyaltyTransactionTransactionCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiLoyaltyTransactionUnitPriceCurrencyEnum;
(function (ApiLoyaltyTransactionUnitPriceCurrencyEnum) {
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["USD"] = "USD";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["AAVE"] = "AAVE";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["AVAX"] = "AVAX";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["AXS"] = "AXS";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["BAT"] = "BAT";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["BCH"] = "BCH";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["BTC"] = "BTC";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["DOGE"] = "DOGE";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["ETH"] = "ETH";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["LINK"] = "LINK";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["LTC"] = "LTC";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["MANA"] = "MANA";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["MATIC"] = "MATIC";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["SOL"] = "SOL";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["UNI"] = "UNI";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["USDC"] = "USDC";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["LXX"] = "LXX";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["LCP"] = "LCP";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["LWR"] = "LWR";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["LMO"] = "LMO";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["LKO"] = "LKO";
    ApiLoyaltyTransactionUnitPriceCurrencyEnum["LED"] = "LED";
})(ApiLoyaltyTransactionUnitPriceCurrencyEnum = exports.ApiLoyaltyTransactionUnitPriceCurrencyEnum || (exports.ApiLoyaltyTransactionUnitPriceCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiMerchantTrasanctionDetailsCurrencyEnum;
(function (ApiMerchantTrasanctionDetailsCurrencyEnum) {
    ApiMerchantTrasanctionDetailsCurrencyEnum["USD"] = "USD";
    ApiMerchantTrasanctionDetailsCurrencyEnum["AAVE"] = "AAVE";
    ApiMerchantTrasanctionDetailsCurrencyEnum["AVAX"] = "AVAX";
    ApiMerchantTrasanctionDetailsCurrencyEnum["AXS"] = "AXS";
    ApiMerchantTrasanctionDetailsCurrencyEnum["BAT"] = "BAT";
    ApiMerchantTrasanctionDetailsCurrencyEnum["BCH"] = "BCH";
    ApiMerchantTrasanctionDetailsCurrencyEnum["BTC"] = "BTC";
    ApiMerchantTrasanctionDetailsCurrencyEnum["DOGE"] = "DOGE";
    ApiMerchantTrasanctionDetailsCurrencyEnum["ETH"] = "ETH";
    ApiMerchantTrasanctionDetailsCurrencyEnum["LINK"] = "LINK";
    ApiMerchantTrasanctionDetailsCurrencyEnum["LTC"] = "LTC";
    ApiMerchantTrasanctionDetailsCurrencyEnum["MANA"] = "MANA";
    ApiMerchantTrasanctionDetailsCurrencyEnum["MATIC"] = "MATIC";
    ApiMerchantTrasanctionDetailsCurrencyEnum["SOL"] = "SOL";
    ApiMerchantTrasanctionDetailsCurrencyEnum["UNI"] = "UNI";
    ApiMerchantTrasanctionDetailsCurrencyEnum["USDC"] = "USDC";
    ApiMerchantTrasanctionDetailsCurrencyEnum["LXX"] = "LXX";
    ApiMerchantTrasanctionDetailsCurrencyEnum["LCP"] = "LCP";
    ApiMerchantTrasanctionDetailsCurrencyEnum["LWR"] = "LWR";
    ApiMerchantTrasanctionDetailsCurrencyEnum["LMO"] = "LMO";
    ApiMerchantTrasanctionDetailsCurrencyEnum["LKO"] = "LKO";
    ApiMerchantTrasanctionDetailsCurrencyEnum["LED"] = "LED";
})(ApiMerchantTrasanctionDetailsCurrencyEnum = exports.ApiMerchantTrasanctionDetailsCurrencyEnum || (exports.ApiMerchantTrasanctionDetailsCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiMerchantTrasanctionDetailsPreferredCurrencyEnum;
(function (ApiMerchantTrasanctionDetailsPreferredCurrencyEnum) {
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["USD"] = "USD";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["AAVE"] = "AAVE";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["AVAX"] = "AVAX";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["AXS"] = "AXS";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["BAT"] = "BAT";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["BCH"] = "BCH";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["BTC"] = "BTC";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["DOGE"] = "DOGE";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["ETH"] = "ETH";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["LINK"] = "LINK";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["LTC"] = "LTC";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["MANA"] = "MANA";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["MATIC"] = "MATIC";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["SOL"] = "SOL";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["UNI"] = "UNI";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["USDC"] = "USDC";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["LXX"] = "LXX";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["LCP"] = "LCP";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["LWR"] = "LWR";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["LMO"] = "LMO";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["LKO"] = "LKO";
    ApiMerchantTrasanctionDetailsPreferredCurrencyEnum["LED"] = "LED";
})(ApiMerchantTrasanctionDetailsPreferredCurrencyEnum = exports.ApiMerchantTrasanctionDetailsPreferredCurrencyEnum || (exports.ApiMerchantTrasanctionDetailsPreferredCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiMerchantTrasanctionDetailsTransactionStatusEnum;
(function (ApiMerchantTrasanctionDetailsTransactionStatusEnum) {
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["AUTHORIZED"] = "AUTHORIZED";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["DECLINED"] = "DECLINED";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["CAPTURED"] = "CAPTURED";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["DISPUTE_OPEN"] = "DISPUTE_OPEN";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["REVERSED"] = "REVERSED";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["CANCELED"] = "CANCELED";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["SETTLED"] = "SETTLED";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["DISPUTE_CLOSED"] = "DISPUTE_CLOSED";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["DISPUTED"] = "DISPUTED";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["PARTIAL_CAPTURED"] = "PARTIAL_CAPTURED";
    ApiMerchantTrasanctionDetailsTransactionStatusEnum["PARTIAL_REVERSED"] = "PARTIAL_REVERSED";
})(ApiMerchantTrasanctionDetailsTransactionStatusEnum = exports.ApiMerchantTrasanctionDetailsTransactionStatusEnum || (exports.ApiMerchantTrasanctionDetailsTransactionStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiOfacRuleDefinitionRuleTypeEnum;
(function (ApiOfacRuleDefinitionRuleTypeEnum) {
    ApiOfacRuleDefinitionRuleTypeEnum["HARD"] = "HARD";
    ApiOfacRuleDefinitionRuleTypeEnum["SOFT"] = "SOFT";
})(ApiOfacRuleDefinitionRuleTypeEnum = exports.ApiOfacRuleDefinitionRuleTypeEnum || (exports.ApiOfacRuleDefinitionRuleTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiP2PTransactionDetailsStatusEnum;
(function (ApiP2PTransactionDetailsStatusEnum) {
    ApiP2PTransactionDetailsStatusEnum["CREATED"] = "CREATED";
    ApiP2PTransactionDetailsStatusEnum["PROCESSING"] = "PROCESSING";
    ApiP2PTransactionDetailsStatusEnum["ACCEPTED_BY_FROM_PARTY"] = "ACCEPTED_BY_FROM_PARTY";
    ApiP2PTransactionDetailsStatusEnum["ACCEPTED_BY_SYSTEM"] = "ACCEPTED_BY_SYSTEM";
    ApiP2PTransactionDetailsStatusEnum["CANCELED_BY_FROM_PARTY"] = "CANCELED_BY_FROM_PARTY";
    ApiP2PTransactionDetailsStatusEnum["CANCELED_BY_TO_PARTY"] = "CANCELED_BY_TO_PARTY";
    ApiP2PTransactionDetailsStatusEnum["CANCELED_BY_SYSTEM"] = "CANCELED_BY_SYSTEM";
})(ApiP2PTransactionDetailsStatusEnum = exports.ApiP2PTransactionDetailsStatusEnum || (exports.ApiP2PTransactionDetailsStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerCryptoCurrenciesEnum;
(function (ApiPartnerCryptoCurrenciesEnum) {
    ApiPartnerCryptoCurrenciesEnum["AAVE"] = "AAVE";
    ApiPartnerCryptoCurrenciesEnum["AVAX"] = "AVAX";
    ApiPartnerCryptoCurrenciesEnum["AXS"] = "AXS";
    ApiPartnerCryptoCurrenciesEnum["BAT"] = "BAT";
    ApiPartnerCryptoCurrenciesEnum["BTC"] = "BTC";
    ApiPartnerCryptoCurrenciesEnum["DOGE"] = "DOGE";
    ApiPartnerCryptoCurrenciesEnum["ETH"] = "ETH";
    ApiPartnerCryptoCurrenciesEnum["LINK"] = "LINK";
    ApiPartnerCryptoCurrenciesEnum["LTC"] = "LTC";
    ApiPartnerCryptoCurrenciesEnum["MANA"] = "MANA";
    ApiPartnerCryptoCurrenciesEnum["MATIC"] = "MATIC";
    ApiPartnerCryptoCurrenciesEnum["SOL"] = "SOL";
    ApiPartnerCryptoCurrenciesEnum["UNI"] = "UNI";
    ApiPartnerCryptoCurrenciesEnum["USDC"] = "USDC";
})(ApiPartnerCryptoCurrenciesEnum = exports.ApiPartnerCryptoCurrenciesEnum || (exports.ApiPartnerCryptoCurrenciesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerMissingFieldsEnum;
(function (ApiPartnerMissingFieldsEnum) {
    ApiPartnerMissingFieldsEnum["TAX_ID_NUMBER"] = "TAX_ID_NUMBER";
    ApiPartnerMissingFieldsEnum["OCCUPATION"] = "OCCUPATION";
    ApiPartnerMissingFieldsEnum["FIRST_NAME"] = "FIRST_NAME";
    ApiPartnerMissingFieldsEnum["LAST_NAME"] = "LAST_NAME";
    ApiPartnerMissingFieldsEnum["ADDRESS"] = "ADDRESS";
    ApiPartnerMissingFieldsEnum["PHONE"] = "PHONE";
    ApiPartnerMissingFieldsEnum["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    ApiPartnerMissingFieldsEnum["EMAIL"] = "EMAIL";
})(ApiPartnerMissingFieldsEnum = exports.ApiPartnerMissingFieldsEnum || (exports.ApiPartnerMissingFieldsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerPrimaryCurrencyEnum;
(function (ApiPartnerPrimaryCurrencyEnum) {
    ApiPartnerPrimaryCurrencyEnum["USD"] = "USD";
    ApiPartnerPrimaryCurrencyEnum["AAVE"] = "AAVE";
    ApiPartnerPrimaryCurrencyEnum["AVAX"] = "AVAX";
    ApiPartnerPrimaryCurrencyEnum["AXS"] = "AXS";
    ApiPartnerPrimaryCurrencyEnum["BAT"] = "BAT";
    ApiPartnerPrimaryCurrencyEnum["BCH"] = "BCH";
    ApiPartnerPrimaryCurrencyEnum["BTC"] = "BTC";
    ApiPartnerPrimaryCurrencyEnum["DOGE"] = "DOGE";
    ApiPartnerPrimaryCurrencyEnum["ETH"] = "ETH";
    ApiPartnerPrimaryCurrencyEnum["LINK"] = "LINK";
    ApiPartnerPrimaryCurrencyEnum["LTC"] = "LTC";
    ApiPartnerPrimaryCurrencyEnum["MANA"] = "MANA";
    ApiPartnerPrimaryCurrencyEnum["MATIC"] = "MATIC";
    ApiPartnerPrimaryCurrencyEnum["SOL"] = "SOL";
    ApiPartnerPrimaryCurrencyEnum["UNI"] = "UNI";
    ApiPartnerPrimaryCurrencyEnum["USDC"] = "USDC";
    ApiPartnerPrimaryCurrencyEnum["LXX"] = "LXX";
    ApiPartnerPrimaryCurrencyEnum["LCP"] = "LCP";
    ApiPartnerPrimaryCurrencyEnum["LWR"] = "LWR";
    ApiPartnerPrimaryCurrencyEnum["LMO"] = "LMO";
    ApiPartnerPrimaryCurrencyEnum["LKO"] = "LKO";
    ApiPartnerPrimaryCurrencyEnum["LED"] = "LED";
})(ApiPartnerPrimaryCurrencyEnum = exports.ApiPartnerPrimaryCurrencyEnum || (exports.ApiPartnerPrimaryCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerServiceTypesEnum;
(function (ApiPartnerServiceTypesEnum) {
    ApiPartnerServiceTypesEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    ApiPartnerServiceTypesEnum["REWARD"] = "REWARD";
    ApiPartnerServiceTypesEnum["PARTY"] = "PARTY";
    ApiPartnerServiceTypesEnum["PAYOUT"] = "PAYOUT";
})(ApiPartnerServiceTypesEnum = exports.ApiPartnerServiceTypesEnum || (exports.ApiPartnerServiceTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerStatusEnum;
(function (ApiPartnerStatusEnum) {
    ApiPartnerStatusEnum["ACTIVE"] = "ACTIVE";
    ApiPartnerStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiPartnerStatusEnum["CLOSED"] = "CLOSED";
})(ApiPartnerStatusEnum = exports.ApiPartnerStatusEnum || (exports.ApiPartnerStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerConfigurationCryptoCurrencySourceEnum;
(function (ApiPartnerConfigurationCryptoCurrencySourceEnum) {
    ApiPartnerConfigurationCryptoCurrencySourceEnum["PARTNER"] = "PARTNER";
    ApiPartnerConfigurationCryptoCurrencySourceEnum["PARTY"] = "PARTY";
})(ApiPartnerConfigurationCryptoCurrencySourceEnum = exports.ApiPartnerConfigurationCryptoCurrencySourceEnum || (exports.ApiPartnerConfigurationCryptoCurrencySourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerConfigurationSettlementTypeEnum;
(function (ApiPartnerConfigurationSettlementTypeEnum) {
    ApiPartnerConfigurationSettlementTypeEnum["GROSS"] = "GROSS";
    ApiPartnerConfigurationSettlementTypeEnum["NET"] = "NET";
})(ApiPartnerConfigurationSettlementTypeEnum = exports.ApiPartnerConfigurationSettlementTypeEnum || (exports.ApiPartnerConfigurationSettlementTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerConfigurationWalletTypeEnum;
(function (ApiPartnerConfigurationWalletTypeEnum) {
    ApiPartnerConfigurationWalletTypeEnum["PARTNER"] = "PARTNER";
    ApiPartnerConfigurationWalletTypeEnum["SHARED"] = "SHARED";
})(ApiPartnerConfigurationWalletTypeEnum = exports.ApiPartnerConfigurationWalletTypeEnum || (exports.ApiPartnerConfigurationWalletTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerDisputeDetailsCurrencyEnum;
(function (ApiPartnerDisputeDetailsCurrencyEnum) {
    ApiPartnerDisputeDetailsCurrencyEnum["USD"] = "USD";
    ApiPartnerDisputeDetailsCurrencyEnum["AAVE"] = "AAVE";
    ApiPartnerDisputeDetailsCurrencyEnum["AVAX"] = "AVAX";
    ApiPartnerDisputeDetailsCurrencyEnum["AXS"] = "AXS";
    ApiPartnerDisputeDetailsCurrencyEnum["BAT"] = "BAT";
    ApiPartnerDisputeDetailsCurrencyEnum["BCH"] = "BCH";
    ApiPartnerDisputeDetailsCurrencyEnum["BTC"] = "BTC";
    ApiPartnerDisputeDetailsCurrencyEnum["DOGE"] = "DOGE";
    ApiPartnerDisputeDetailsCurrencyEnum["ETH"] = "ETH";
    ApiPartnerDisputeDetailsCurrencyEnum["LINK"] = "LINK";
    ApiPartnerDisputeDetailsCurrencyEnum["LTC"] = "LTC";
    ApiPartnerDisputeDetailsCurrencyEnum["MANA"] = "MANA";
    ApiPartnerDisputeDetailsCurrencyEnum["MATIC"] = "MATIC";
    ApiPartnerDisputeDetailsCurrencyEnum["SOL"] = "SOL";
    ApiPartnerDisputeDetailsCurrencyEnum["UNI"] = "UNI";
    ApiPartnerDisputeDetailsCurrencyEnum["USDC"] = "USDC";
    ApiPartnerDisputeDetailsCurrencyEnum["LXX"] = "LXX";
    ApiPartnerDisputeDetailsCurrencyEnum["LCP"] = "LCP";
    ApiPartnerDisputeDetailsCurrencyEnum["LWR"] = "LWR";
    ApiPartnerDisputeDetailsCurrencyEnum["LMO"] = "LMO";
    ApiPartnerDisputeDetailsCurrencyEnum["LKO"] = "LKO";
    ApiPartnerDisputeDetailsCurrencyEnum["LED"] = "LED";
})(ApiPartnerDisputeDetailsCurrencyEnum = exports.ApiPartnerDisputeDetailsCurrencyEnum || (exports.ApiPartnerDisputeDetailsCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerDisputeDetailsDisputeTypeEnum;
(function (ApiPartnerDisputeDetailsDisputeTypeEnum) {
    ApiPartnerDisputeDetailsDisputeTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiPartnerDisputeDetailsDisputeTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiPartnerDisputeDetailsDisputeTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiPartnerDisputeDetailsDisputeTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    ApiPartnerDisputeDetailsDisputeTypeEnum["MERCHANT_PAYMENT_V1"] = "MERCHANT_PAYMENT_V1";
    ApiPartnerDisputeDetailsDisputeTypeEnum["PARTNER_TRANSACTION"] = "PARTNER_TRANSACTION";
})(ApiPartnerDisputeDetailsDisputeTypeEnum = exports.ApiPartnerDisputeDetailsDisputeTypeEnum || (exports.ApiPartnerDisputeDetailsDisputeTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerDisputeDetailsReasonCodeEnum;
(function (ApiPartnerDisputeDetailsReasonCodeEnum) {
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC01"] = "DAC01";
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC02"] = "DAC02";
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC03"] = "DAC03";
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC04"] = "DAC04";
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC05"] = "DAC05";
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC06"] = "DAC06";
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC07"] = "DAC07";
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC08"] = "DAC08";
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC09"] = "DAC09";
    ApiPartnerDisputeDetailsReasonCodeEnum["DAC10"] = "DAC10";
})(ApiPartnerDisputeDetailsReasonCodeEnum = exports.ApiPartnerDisputeDetailsReasonCodeEnum || (exports.ApiPartnerDisputeDetailsReasonCodeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerDisputeDetailsResolutionTypeEnum;
(function (ApiPartnerDisputeDetailsResolutionTypeEnum) {
    ApiPartnerDisputeDetailsResolutionTypeEnum["CHARGEBACK"] = "CHARGEBACK";
    ApiPartnerDisputeDetailsResolutionTypeEnum["CHARGEBACK_BAKKT"] = "CHARGEBACK_BAKKT";
    ApiPartnerDisputeDetailsResolutionTypeEnum["CREDIT"] = "CREDIT";
    ApiPartnerDisputeDetailsResolutionTypeEnum["REFUND"] = "REFUND";
})(ApiPartnerDisputeDetailsResolutionTypeEnum = exports.ApiPartnerDisputeDetailsResolutionTypeEnum || (exports.ApiPartnerDisputeDetailsResolutionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerDisputeDetailsStatusEnum;
(function (ApiPartnerDisputeDetailsStatusEnum) {
    ApiPartnerDisputeDetailsStatusEnum["NEW"] = "NEW";
    ApiPartnerDisputeDetailsStatusEnum["ESCALATED"] = "ESCALATED";
    ApiPartnerDisputeDetailsStatusEnum["REJECTED"] = "REJECTED";
    ApiPartnerDisputeDetailsStatusEnum["MERCHANT_REJECTED"] = "MERCHANT_REJECTED";
    ApiPartnerDisputeDetailsStatusEnum["ACCEPTED"] = "ACCEPTED";
    ApiPartnerDisputeDetailsStatusEnum["CANCELLED"] = "CANCELLED";
})(ApiPartnerDisputeDetailsStatusEnum = exports.ApiPartnerDisputeDetailsStatusEnum || (exports.ApiPartnerDisputeDetailsStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerImmConfigUpdateRequestCommissionTypeEnum;
(function (ApiPartnerImmConfigUpdateRequestCommissionTypeEnum) {
    ApiPartnerImmConfigUpdateRequestCommissionTypeEnum["FLAT"] = "FLAT";
    ApiPartnerImmConfigUpdateRequestCommissionTypeEnum["VARIABLE"] = "VARIABLE";
})(ApiPartnerImmConfigUpdateRequestCommissionTypeEnum = exports.ApiPartnerImmConfigUpdateRequestCommissionTypeEnum || (exports.ApiPartnerImmConfigUpdateRequestCommissionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerLedgerPostingCryptocurrencyTransactionTypeEnum;
(function (ApiPartnerLedgerPostingCryptocurrencyTransactionTypeEnum) {
    ApiPartnerLedgerPostingCryptocurrencyTransactionTypeEnum["BUY"] = "BUY";
    ApiPartnerLedgerPostingCryptocurrencyTransactionTypeEnum["SELL"] = "SELL";
})(ApiPartnerLedgerPostingCryptocurrencyTransactionTypeEnum = exports.ApiPartnerLedgerPostingCryptocurrencyTransactionTypeEnum || (exports.ApiPartnerLedgerPostingCryptocurrencyTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerLedgerPostingSourceCurrencyEnum;
(function (ApiPartnerLedgerPostingSourceCurrencyEnum) {
    ApiPartnerLedgerPostingSourceCurrencyEnum["USD"] = "USD";
    ApiPartnerLedgerPostingSourceCurrencyEnum["AAVE"] = "AAVE";
    ApiPartnerLedgerPostingSourceCurrencyEnum["AVAX"] = "AVAX";
    ApiPartnerLedgerPostingSourceCurrencyEnum["AXS"] = "AXS";
    ApiPartnerLedgerPostingSourceCurrencyEnum["BAT"] = "BAT";
    ApiPartnerLedgerPostingSourceCurrencyEnum["BCH"] = "BCH";
    ApiPartnerLedgerPostingSourceCurrencyEnum["BTC"] = "BTC";
    ApiPartnerLedgerPostingSourceCurrencyEnum["DOGE"] = "DOGE";
    ApiPartnerLedgerPostingSourceCurrencyEnum["ETH"] = "ETH";
    ApiPartnerLedgerPostingSourceCurrencyEnum["LINK"] = "LINK";
    ApiPartnerLedgerPostingSourceCurrencyEnum["LTC"] = "LTC";
    ApiPartnerLedgerPostingSourceCurrencyEnum["MANA"] = "MANA";
    ApiPartnerLedgerPostingSourceCurrencyEnum["MATIC"] = "MATIC";
    ApiPartnerLedgerPostingSourceCurrencyEnum["SOL"] = "SOL";
    ApiPartnerLedgerPostingSourceCurrencyEnum["UNI"] = "UNI";
    ApiPartnerLedgerPostingSourceCurrencyEnum["USDC"] = "USDC";
    ApiPartnerLedgerPostingSourceCurrencyEnum["LXX"] = "LXX";
    ApiPartnerLedgerPostingSourceCurrencyEnum["LCP"] = "LCP";
    ApiPartnerLedgerPostingSourceCurrencyEnum["LWR"] = "LWR";
    ApiPartnerLedgerPostingSourceCurrencyEnum["LMO"] = "LMO";
    ApiPartnerLedgerPostingSourceCurrencyEnum["LKO"] = "LKO";
    ApiPartnerLedgerPostingSourceCurrencyEnum["LED"] = "LED";
})(ApiPartnerLedgerPostingSourceCurrencyEnum = exports.ApiPartnerLedgerPostingSourceCurrencyEnum || (exports.ApiPartnerLedgerPostingSourceCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerLedgerPostingTargetCurrencyEnum;
(function (ApiPartnerLedgerPostingTargetCurrencyEnum) {
    ApiPartnerLedgerPostingTargetCurrencyEnum["USD"] = "USD";
    ApiPartnerLedgerPostingTargetCurrencyEnum["AAVE"] = "AAVE";
    ApiPartnerLedgerPostingTargetCurrencyEnum["AVAX"] = "AVAX";
    ApiPartnerLedgerPostingTargetCurrencyEnum["AXS"] = "AXS";
    ApiPartnerLedgerPostingTargetCurrencyEnum["BAT"] = "BAT";
    ApiPartnerLedgerPostingTargetCurrencyEnum["BCH"] = "BCH";
    ApiPartnerLedgerPostingTargetCurrencyEnum["BTC"] = "BTC";
    ApiPartnerLedgerPostingTargetCurrencyEnum["DOGE"] = "DOGE";
    ApiPartnerLedgerPostingTargetCurrencyEnum["ETH"] = "ETH";
    ApiPartnerLedgerPostingTargetCurrencyEnum["LINK"] = "LINK";
    ApiPartnerLedgerPostingTargetCurrencyEnum["LTC"] = "LTC";
    ApiPartnerLedgerPostingTargetCurrencyEnum["MANA"] = "MANA";
    ApiPartnerLedgerPostingTargetCurrencyEnum["MATIC"] = "MATIC";
    ApiPartnerLedgerPostingTargetCurrencyEnum["SOL"] = "SOL";
    ApiPartnerLedgerPostingTargetCurrencyEnum["UNI"] = "UNI";
    ApiPartnerLedgerPostingTargetCurrencyEnum["USDC"] = "USDC";
    ApiPartnerLedgerPostingTargetCurrencyEnum["LXX"] = "LXX";
    ApiPartnerLedgerPostingTargetCurrencyEnum["LCP"] = "LCP";
    ApiPartnerLedgerPostingTargetCurrencyEnum["LWR"] = "LWR";
    ApiPartnerLedgerPostingTargetCurrencyEnum["LMO"] = "LMO";
    ApiPartnerLedgerPostingTargetCurrencyEnum["LKO"] = "LKO";
    ApiPartnerLedgerPostingTargetCurrencyEnum["LED"] = "LED";
})(ApiPartnerLedgerPostingTargetCurrencyEnum = exports.ApiPartnerLedgerPostingTargetCurrencyEnum || (exports.ApiPartnerLedgerPostingTargetCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerLedgerPostingTransactionTypeEnum;
(function (ApiPartnerLedgerPostingTransactionTypeEnum) {
    ApiPartnerLedgerPostingTransactionTypeEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    ApiPartnerLedgerPostingTransactionTypeEnum["REWARD"] = "REWARD";
    ApiPartnerLedgerPostingTransactionTypeEnum["LOYALTY"] = "LOYALTY";
    ApiPartnerLedgerPostingTransactionTypeEnum["PAYOUT"] = "PAYOUT";
})(ApiPartnerLedgerPostingTransactionTypeEnum = exports.ApiPartnerLedgerPostingTransactionTypeEnum || (exports.ApiPartnerLedgerPostingTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerPartyDetailPartyLevelEnum;
(function (ApiPartnerPartyDetailPartyLevelEnum) {
    ApiPartnerPartyDetailPartyLevelEnum["UNKNOWN"] = "UNKNOWN";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_1"] = "LEVEL_1";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_1_SUSPENDED"] = "LEVEL_1_SUSPENDED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_1_LIQUIDATED"] = "LEVEL_1_LIQUIDATED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_2"] = "LEVEL_2";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_2_SUSPENDED"] = "LEVEL_2_SUSPENDED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_2_LIQUIDATED"] = "LEVEL_2_LIQUIDATED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_3"] = "LEVEL_3";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_3_SUSPENDED"] = "LEVEL_3_SUSPENDED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_3_LIQUIDATED"] = "LEVEL_3_LIQUIDATED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_4"] = "LEVEL_4";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_4_SUSPENDED"] = "LEVEL_4_SUSPENDED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_4_LIQUIDATED"] = "LEVEL_4_LIQUIDATED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_5"] = "LEVEL_5";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_5_SUSPENDED"] = "LEVEL_5_SUSPENDED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_5_LIQUIDATED"] = "LEVEL_5_LIQUIDATED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_99"] = "LEVEL_99";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_99_SUSPENDED"] = "LEVEL_99_SUSPENDED";
    ApiPartnerPartyDetailPartyLevelEnum["LEVEL_99_LIQUIDATED"] = "LEVEL_99_LIQUIDATED";
    ApiPartnerPartyDetailPartyLevelEnum["CLOSED"] = "CLOSED";
})(ApiPartnerPartyDetailPartyLevelEnum = exports.ApiPartnerPartyDetailPartyLevelEnum || (exports.ApiPartnerPartyDetailPartyLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerPartyDetailServiceTypesEnum;
(function (ApiPartnerPartyDetailServiceTypesEnum) {
    ApiPartnerPartyDetailServiceTypesEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    ApiPartnerPartyDetailServiceTypesEnum["REWARD"] = "REWARD";
    ApiPartnerPartyDetailServiceTypesEnum["PARTY"] = "PARTY";
    ApiPartnerPartyDetailServiceTypesEnum["PAYOUT"] = "PAYOUT";
})(ApiPartnerPartyDetailServiceTypesEnum = exports.ApiPartnerPartyDetailServiceTypesEnum || (exports.ApiPartnerPartyDetailServiceTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerPartyDetailStatusEnum;
(function (ApiPartnerPartyDetailStatusEnum) {
    ApiPartnerPartyDetailStatusEnum["ACTIVE"] = "ACTIVE";
    ApiPartnerPartyDetailStatusEnum["OTP_REQUIRED"] = "OTP_REQUIRED";
    ApiPartnerPartyDetailStatusEnum["PENDING"] = "PENDING";
    ApiPartnerPartyDetailStatusEnum["UNDER_REVIEW"] = "UNDER_REVIEW";
    ApiPartnerPartyDetailStatusEnum["INACTIVE"] = "INACTIVE";
})(ApiPartnerPartyDetailStatusEnum = exports.ApiPartnerPartyDetailStatusEnum || (exports.ApiPartnerPartyDetailStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum;
(function (ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum) {
    ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum["ACTIVE"] = "ACTIVE";
    ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum["OTP_REQUIRED"] = "OTP_REQUIRED";
    ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum["PENDING"] = "PENDING";
    ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum["UNDER_REVIEW"] = "UNDER_REVIEW";
    ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum["INACTIVE"] = "INACTIVE";
})(ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum = exports.ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum || (exports.ApiPartnerPartyEnrollmentLogPartnerPartyLinkStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerPartyEnrollmentLogPartyEnrollmentDataValidationStatusEnum;
(function (ApiPartnerPartyEnrollmentLogPartyEnrollmentDataValidationStatusEnum) {
    ApiPartnerPartyEnrollmentLogPartyEnrollmentDataValidationStatusEnum["MATCHES"] = "DATA_MATCHES";
    ApiPartnerPartyEnrollmentLogPartyEnrollmentDataValidationStatusEnum["DOES_NOT_MATCH"] = "DATA_DOES_NOT_MATCH";
})(ApiPartnerPartyEnrollmentLogPartyEnrollmentDataValidationStatusEnum = exports.ApiPartnerPartyEnrollmentLogPartyEnrollmentDataValidationStatusEnum || (exports.ApiPartnerPartyEnrollmentLogPartyEnrollmentDataValidationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerPartyEnrollmentValidationStatusValidationReasonEnum;
(function (ApiPartnerPartyEnrollmentValidationStatusValidationReasonEnum) {
    ApiPartnerPartyEnrollmentValidationStatusValidationReasonEnum["PARTY_SUSPENDED"] = "PARTY_SUSPENDED";
    ApiPartnerPartyEnrollmentValidationStatusValidationReasonEnum["TRANSUNION_TAX_ID_VERIFICATION"] = "TRANSUNION_TAX_ID_VERIFICATION";
    ApiPartnerPartyEnrollmentValidationStatusValidationReasonEnum["RISK"] = "RISK";
})(ApiPartnerPartyEnrollmentValidationStatusValidationReasonEnum = exports.ApiPartnerPartyEnrollmentValidationStatusValidationReasonEnum || (exports.ApiPartnerPartyEnrollmentValidationStatusValidationReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerPartyEnrollmentValidationStatusValidationStatusEnum;
(function (ApiPartnerPartyEnrollmentValidationStatusValidationStatusEnum) {
    ApiPartnerPartyEnrollmentValidationStatusValidationStatusEnum["SUCCESS"] = "SUCCESS";
    ApiPartnerPartyEnrollmentValidationStatusValidationStatusEnum["FAILED"] = "FAILED";
})(ApiPartnerPartyEnrollmentValidationStatusValidationStatusEnum = exports.ApiPartnerPartyEnrollmentValidationStatusValidationStatusEnum || (exports.ApiPartnerPartyEnrollmentValidationStatusValidationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerPartyLinkStatusEnum;
(function (ApiPartnerPartyLinkStatusEnum) {
    ApiPartnerPartyLinkStatusEnum["ACTIVE"] = "ACTIVE";
    ApiPartnerPartyLinkStatusEnum["OTP_REQUIRED"] = "OTP_REQUIRED";
    ApiPartnerPartyLinkStatusEnum["PENDING"] = "PENDING";
    ApiPartnerPartyLinkStatusEnum["UNDER_REVIEW"] = "UNDER_REVIEW";
    ApiPartnerPartyLinkStatusEnum["INACTIVE"] = "INACTIVE";
})(ApiPartnerPartyLinkStatusEnum = exports.ApiPartnerPartyLinkStatusEnum || (exports.ApiPartnerPartyLinkStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerRiskConfigRequestProductEnum;
(function (ApiPartnerRiskConfigRequestProductEnum) {
    ApiPartnerRiskConfigRequestProductEnum["DEFAULT"] = "DEFAULT";
    ApiPartnerRiskConfigRequestProductEnum["BAKKT_APP"] = "BAKKT_APP";
    ApiPartnerRiskConfigRequestProductEnum["CRYPTO_AS_SERVICE"] = "CRYPTO_AS_SERVICE";
    ApiPartnerRiskConfigRequestProductEnum["EMBEDDED_CRYPTO_AS_SERVICE"] = "EMBEDDED_CRYPTO_AS_SERVICE";
    ApiPartnerRiskConfigRequestProductEnum["CRYPTO_CARD"] = "CRYPTO_CARD";
    ApiPartnerRiskConfigRequestProductEnum["CRYPTO_REWARDS"] = "CRYPTO_REWARDS";
    ApiPartnerRiskConfigRequestProductEnum["DISBURSEMENTS"] = "DISBURSEMENTS";
    ApiPartnerRiskConfigRequestProductEnum["PARTY"] = "PARTY";
    ApiPartnerRiskConfigRequestProductEnum["PAYOUTS"] = "PAYOUTS";
})(ApiPartnerRiskConfigRequestProductEnum = exports.ApiPartnerRiskConfigRequestProductEnum || (exports.ApiPartnerRiskConfigRequestProductEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum;
(function (ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum) {
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["UNKNOWN"] = "UNKNOWN";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_1"] = "LEVEL_1";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_1_SUSPENDED"] = "LEVEL_1_SUSPENDED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_1_LIQUIDATED"] = "LEVEL_1_LIQUIDATED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_2"] = "LEVEL_2";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_2_SUSPENDED"] = "LEVEL_2_SUSPENDED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_2_LIQUIDATED"] = "LEVEL_2_LIQUIDATED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_3"] = "LEVEL_3";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_3_SUSPENDED"] = "LEVEL_3_SUSPENDED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_3_LIQUIDATED"] = "LEVEL_3_LIQUIDATED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_4"] = "LEVEL_4";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_4_SUSPENDED"] = "LEVEL_4_SUSPENDED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_4_LIQUIDATED"] = "LEVEL_4_LIQUIDATED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_5"] = "LEVEL_5";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_5_SUSPENDED"] = "LEVEL_5_SUSPENDED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_5_LIQUIDATED"] = "LEVEL_5_LIQUIDATED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_99"] = "LEVEL_99";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_99_SUSPENDED"] = "LEVEL_99_SUSPENDED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["LEVEL_99_LIQUIDATED"] = "LEVEL_99_LIQUIDATED";
    ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum["CLOSED"] = "CLOSED";
})(ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum = exports.ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum || (exports.ApiPartnerRiskConfigRequestRequiredPartnerPartyLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerRiskConfigResponseProductEnum;
(function (ApiPartnerRiskConfigResponseProductEnum) {
    ApiPartnerRiskConfigResponseProductEnum["DEFAULT"] = "DEFAULT";
    ApiPartnerRiskConfigResponseProductEnum["BAKKT_APP"] = "BAKKT_APP";
    ApiPartnerRiskConfigResponseProductEnum["CRYPTO_AS_SERVICE"] = "CRYPTO_AS_SERVICE";
    ApiPartnerRiskConfigResponseProductEnum["EMBEDDED_CRYPTO_AS_SERVICE"] = "EMBEDDED_CRYPTO_AS_SERVICE";
    ApiPartnerRiskConfigResponseProductEnum["CRYPTO_CARD"] = "CRYPTO_CARD";
    ApiPartnerRiskConfigResponseProductEnum["CRYPTO_REWARDS"] = "CRYPTO_REWARDS";
    ApiPartnerRiskConfigResponseProductEnum["DISBURSEMENTS"] = "DISBURSEMENTS";
    ApiPartnerRiskConfigResponseProductEnum["PARTY"] = "PARTY";
    ApiPartnerRiskConfigResponseProductEnum["PAYOUTS"] = "PAYOUTS";
})(ApiPartnerRiskConfigResponseProductEnum = exports.ApiPartnerRiskConfigResponseProductEnum || (exports.ApiPartnerRiskConfigResponseProductEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum;
(function (ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum) {
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["UNKNOWN"] = "UNKNOWN";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_1"] = "LEVEL_1";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_1_SUSPENDED"] = "LEVEL_1_SUSPENDED";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_2"] = "LEVEL_2";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_2_SUSPENDED"] = "LEVEL_2_SUSPENDED";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_3"] = "LEVEL_3";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_3_SUSPENDED"] = "LEVEL_3_SUSPENDED";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_4"] = "LEVEL_4";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_4_SUSPENDED"] = "LEVEL_4_SUSPENDED";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_5"] = "LEVEL_5";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_5_SUSPENDED"] = "LEVEL_5_SUSPENDED";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_99"] = "LEVEL_99";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["LEVEL_99_SUSPENDED"] = "LEVEL_99_SUSPENDED";
    ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum["CLOSED"] = "CLOSED";
})(ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum = exports.ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum || (exports.ApiPartnerRiskConfigResponseRequiredPartnerPartyLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerTransactionDetailCryptoCurrencySourceEnum;
(function (ApiPartnerTransactionDetailCryptoCurrencySourceEnum) {
    ApiPartnerTransactionDetailCryptoCurrencySourceEnum["PARTNER"] = "PARTNER";
    ApiPartnerTransactionDetailCryptoCurrencySourceEnum["PARTY"] = "PARTY";
})(ApiPartnerTransactionDetailCryptoCurrencySourceEnum = exports.ApiPartnerTransactionDetailCryptoCurrencySourceEnum || (exports.ApiPartnerTransactionDetailCryptoCurrencySourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerTransactionDetailCryptoCurrencyTransactTypeEnum;
(function (ApiPartnerTransactionDetailCryptoCurrencyTransactTypeEnum) {
    ApiPartnerTransactionDetailCryptoCurrencyTransactTypeEnum["BUY"] = "BUY";
    ApiPartnerTransactionDetailCryptoCurrencyTransactTypeEnum["SELL"] = "SELL";
})(ApiPartnerTransactionDetailCryptoCurrencyTransactTypeEnum = exports.ApiPartnerTransactionDetailCryptoCurrencyTransactTypeEnum || (exports.ApiPartnerTransactionDetailCryptoCurrencyTransactTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerTransactionDetailSourceCurrencyEnum;
(function (ApiPartnerTransactionDetailSourceCurrencyEnum) {
    ApiPartnerTransactionDetailSourceCurrencyEnum["USD"] = "USD";
    ApiPartnerTransactionDetailSourceCurrencyEnum["AAVE"] = "AAVE";
    ApiPartnerTransactionDetailSourceCurrencyEnum["AVAX"] = "AVAX";
    ApiPartnerTransactionDetailSourceCurrencyEnum["AXS"] = "AXS";
    ApiPartnerTransactionDetailSourceCurrencyEnum["BAT"] = "BAT";
    ApiPartnerTransactionDetailSourceCurrencyEnum["BCH"] = "BCH";
    ApiPartnerTransactionDetailSourceCurrencyEnum["BTC"] = "BTC";
    ApiPartnerTransactionDetailSourceCurrencyEnum["DOGE"] = "DOGE";
    ApiPartnerTransactionDetailSourceCurrencyEnum["ETH"] = "ETH";
    ApiPartnerTransactionDetailSourceCurrencyEnum["LINK"] = "LINK";
    ApiPartnerTransactionDetailSourceCurrencyEnum["LTC"] = "LTC";
    ApiPartnerTransactionDetailSourceCurrencyEnum["MANA"] = "MANA";
    ApiPartnerTransactionDetailSourceCurrencyEnum["MATIC"] = "MATIC";
    ApiPartnerTransactionDetailSourceCurrencyEnum["SOL"] = "SOL";
    ApiPartnerTransactionDetailSourceCurrencyEnum["UNI"] = "UNI";
    ApiPartnerTransactionDetailSourceCurrencyEnum["USDC"] = "USDC";
    ApiPartnerTransactionDetailSourceCurrencyEnum["LXX"] = "LXX";
    ApiPartnerTransactionDetailSourceCurrencyEnum["LCP"] = "LCP";
    ApiPartnerTransactionDetailSourceCurrencyEnum["LWR"] = "LWR";
    ApiPartnerTransactionDetailSourceCurrencyEnum["LMO"] = "LMO";
    ApiPartnerTransactionDetailSourceCurrencyEnum["LKO"] = "LKO";
    ApiPartnerTransactionDetailSourceCurrencyEnum["LED"] = "LED";
})(ApiPartnerTransactionDetailSourceCurrencyEnum = exports.ApiPartnerTransactionDetailSourceCurrencyEnum || (exports.ApiPartnerTransactionDetailSourceCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerTransactionDetailStatusEnum;
(function (ApiPartnerTransactionDetailStatusEnum) {
    ApiPartnerTransactionDetailStatusEnum["CAPTURED"] = "CAPTURED";
    ApiPartnerTransactionDetailStatusEnum["DECLINED"] = "DECLINED";
    ApiPartnerTransactionDetailStatusEnum["DISPUTED"] = "DISPUTED";
    ApiPartnerTransactionDetailStatusEnum["CANCELLED"] = "CANCELLED";
})(ApiPartnerTransactionDetailStatusEnum = exports.ApiPartnerTransactionDetailStatusEnum || (exports.ApiPartnerTransactionDetailStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerTransactionDetailTargetCurrencyEnum;
(function (ApiPartnerTransactionDetailTargetCurrencyEnum) {
    ApiPartnerTransactionDetailTargetCurrencyEnum["USD"] = "USD";
    ApiPartnerTransactionDetailTargetCurrencyEnum["AAVE"] = "AAVE";
    ApiPartnerTransactionDetailTargetCurrencyEnum["AVAX"] = "AVAX";
    ApiPartnerTransactionDetailTargetCurrencyEnum["AXS"] = "AXS";
    ApiPartnerTransactionDetailTargetCurrencyEnum["BAT"] = "BAT";
    ApiPartnerTransactionDetailTargetCurrencyEnum["BCH"] = "BCH";
    ApiPartnerTransactionDetailTargetCurrencyEnum["BTC"] = "BTC";
    ApiPartnerTransactionDetailTargetCurrencyEnum["DOGE"] = "DOGE";
    ApiPartnerTransactionDetailTargetCurrencyEnum["ETH"] = "ETH";
    ApiPartnerTransactionDetailTargetCurrencyEnum["LINK"] = "LINK";
    ApiPartnerTransactionDetailTargetCurrencyEnum["LTC"] = "LTC";
    ApiPartnerTransactionDetailTargetCurrencyEnum["MANA"] = "MANA";
    ApiPartnerTransactionDetailTargetCurrencyEnum["MATIC"] = "MATIC";
    ApiPartnerTransactionDetailTargetCurrencyEnum["SOL"] = "SOL";
    ApiPartnerTransactionDetailTargetCurrencyEnum["UNI"] = "UNI";
    ApiPartnerTransactionDetailTargetCurrencyEnum["USDC"] = "USDC";
    ApiPartnerTransactionDetailTargetCurrencyEnum["LXX"] = "LXX";
    ApiPartnerTransactionDetailTargetCurrencyEnum["LCP"] = "LCP";
    ApiPartnerTransactionDetailTargetCurrencyEnum["LWR"] = "LWR";
    ApiPartnerTransactionDetailTargetCurrencyEnum["LMO"] = "LMO";
    ApiPartnerTransactionDetailTargetCurrencyEnum["LKO"] = "LKO";
    ApiPartnerTransactionDetailTargetCurrencyEnum["LED"] = "LED";
})(ApiPartnerTransactionDetailTargetCurrencyEnum = exports.ApiPartnerTransactionDetailTargetCurrencyEnum || (exports.ApiPartnerTransactionDetailTargetCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerTransactionDetailTransactionTypeEnum;
(function (ApiPartnerTransactionDetailTransactionTypeEnum) {
    ApiPartnerTransactionDetailTransactionTypeEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    ApiPartnerTransactionDetailTransactionTypeEnum["REWARD"] = "REWARD";
    ApiPartnerTransactionDetailTransactionTypeEnum["LOYALTY"] = "LOYALTY";
    ApiPartnerTransactionDetailTransactionTypeEnum["PAYOUT"] = "PAYOUT";
})(ApiPartnerTransactionDetailTransactionTypeEnum = exports.ApiPartnerTransactionDetailTransactionTypeEnum || (exports.ApiPartnerTransactionDetailTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartnerTransactionDetailsStatusEnum;
(function (ApiPartnerTransactionDetailsStatusEnum) {
    ApiPartnerTransactionDetailsStatusEnum["CAPTURED"] = "CAPTURED";
    ApiPartnerTransactionDetailsStatusEnum["DECLINED"] = "DECLINED";
    ApiPartnerTransactionDetailsStatusEnum["DISPUTED"] = "DISPUTED";
    ApiPartnerTransactionDetailsStatusEnum["CANCELLED"] = "CANCELLED";
})(ApiPartnerTransactionDetailsStatusEnum = exports.ApiPartnerTransactionDetailsStatusEnum || (exports.ApiPartnerTransactionDetailsStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyLevelEnum;
(function (ApiPartyLevelEnum) {
    ApiPartyLevelEnum["UNKNOWN"] = "UNKNOWN";
    ApiPartyLevelEnum["LEVEL_1"] = "LEVEL_1";
    ApiPartyLevelEnum["LEVEL_1_SUSPENDED"] = "LEVEL_1_SUSPENDED";
    ApiPartyLevelEnum["LEVEL_1_LIQUIDATED"] = "LEVEL_1_LIQUIDATED";
    ApiPartyLevelEnum["LEVEL_2"] = "LEVEL_2";
    ApiPartyLevelEnum["LEVEL_2_SUSPENDED"] = "LEVEL_2_SUSPENDED";
    ApiPartyLevelEnum["LEVEL_2_LIQUIDATED"] = "LEVEL_2_LIQUIDATED";
    ApiPartyLevelEnum["LEVEL_3"] = "LEVEL_3";
    ApiPartyLevelEnum["LEVEL_3_SUSPENDED"] = "LEVEL_3_SUSPENDED";
    ApiPartyLevelEnum["LEVEL_3_LIQUIDATED"] = "LEVEL_3_LIQUIDATED";
    ApiPartyLevelEnum["LEVEL_4"] = "LEVEL_4";
    ApiPartyLevelEnum["LEVEL_4_SUSPENDED"] = "LEVEL_4_SUSPENDED";
    ApiPartyLevelEnum["LEVEL_4_LIQUIDATED"] = "LEVEL_4_LIQUIDATED";
    ApiPartyLevelEnum["LEVEL_5"] = "LEVEL_5";
    ApiPartyLevelEnum["LEVEL_5_SUSPENDED"] = "LEVEL_5_SUSPENDED";
    ApiPartyLevelEnum["LEVEL_5_LIQUIDATED"] = "LEVEL_5_LIQUIDATED";
    ApiPartyLevelEnum["LEVEL_99"] = "LEVEL_99";
    ApiPartyLevelEnum["LEVEL_99_SUSPENDED"] = "LEVEL_99_SUSPENDED";
    ApiPartyLevelEnum["LEVEL_99_LIQUIDATED"] = "LEVEL_99_LIQUIDATED";
    ApiPartyLevelEnum["CLOSED"] = "CLOSED";
})(ApiPartyLevelEnum = exports.ApiPartyLevelEnum || (exports.ApiPartyLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyPartyTypeEnum;
(function (ApiPartyPartyTypeEnum) {
    ApiPartyPartyTypeEnum["SERVICE"] = "SERVICE";
    ApiPartyPartyTypeEnum["CONSUMER"] = "CONSUMER";
    ApiPartyPartyTypeEnum["MERCHANT"] = "MERCHANT";
})(ApiPartyPartyTypeEnum = exports.ApiPartyPartyTypeEnum || (exports.ApiPartyPartyTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyPhotoIdVerificationStatusEnum;
(function (ApiPartyPhotoIdVerificationStatusEnum) {
    ApiPartyPhotoIdVerificationStatusEnum["LOCKED"] = "LOCKED";
    ApiPartyPhotoIdVerificationStatusEnum["PENDING"] = "PENDING";
    ApiPartyPhotoIdVerificationStatusEnum["VERIFICATION_FAILED"] = "VERIFICATION_FAILED";
    ApiPartyPhotoIdVerificationStatusEnum["VERIFIED"] = "VERIFIED";
    ApiPartyPhotoIdVerificationStatusEnum["SKIPPED"] = "SKIPPED";
})(ApiPartyPhotoIdVerificationStatusEnum = exports.ApiPartyPhotoIdVerificationStatusEnum || (exports.ApiPartyPhotoIdVerificationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyStatusEnum;
(function (ApiPartyStatusEnum) {
    ApiPartyStatusEnum["OPEN"] = "OPEN";
    ApiPartyStatusEnum["CLOSED"] = "CLOSED";
    ApiPartyStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiPartyStatusEnum["LIQUIDATED"] = "LIQUIDATED";
})(ApiPartyStatusEnum = exports.ApiPartyStatusEnum || (exports.ApiPartyStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyTaxIdVerificationStatusEnum;
(function (ApiPartyTaxIdVerificationStatusEnum) {
    ApiPartyTaxIdVerificationStatusEnum["LOCKED"] = "LOCKED";
    ApiPartyTaxIdVerificationStatusEnum["PENDING"] = "PENDING";
    ApiPartyTaxIdVerificationStatusEnum["VERIFICATION_FAILED"] = "VERIFICATION_FAILED";
    ApiPartyTaxIdVerificationStatusEnum["VERIFIED"] = "VERIFIED";
    ApiPartyTaxIdVerificationStatusEnum["SKIPPED"] = "SKIPPED";
})(ApiPartyTaxIdVerificationStatusEnum = exports.ApiPartyTaxIdVerificationStatusEnum || (exports.ApiPartyTaxIdVerificationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyBaseSearchResponseLevelEnum;
(function (ApiPartyBaseSearchResponseLevelEnum) {
    ApiPartyBaseSearchResponseLevelEnum["UNKNOWN"] = "UNKNOWN";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_1"] = "LEVEL_1";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_1_SUSPENDED"] = "LEVEL_1_SUSPENDED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_1_LIQUIDATED"] = "LEVEL_1_LIQUIDATED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_2"] = "LEVEL_2";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_2_SUSPENDED"] = "LEVEL_2_SUSPENDED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_2_LIQUIDATED"] = "LEVEL_2_LIQUIDATED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_3"] = "LEVEL_3";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_3_SUSPENDED"] = "LEVEL_3_SUSPENDED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_3_LIQUIDATED"] = "LEVEL_3_LIQUIDATED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_4"] = "LEVEL_4";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_4_SUSPENDED"] = "LEVEL_4_SUSPENDED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_4_LIQUIDATED"] = "LEVEL_4_LIQUIDATED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_5"] = "LEVEL_5";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_5_SUSPENDED"] = "LEVEL_5_SUSPENDED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_5_LIQUIDATED"] = "LEVEL_5_LIQUIDATED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_99"] = "LEVEL_99";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_99_SUSPENDED"] = "LEVEL_99_SUSPENDED";
    ApiPartyBaseSearchResponseLevelEnum["LEVEL_99_LIQUIDATED"] = "LEVEL_99_LIQUIDATED";
    ApiPartyBaseSearchResponseLevelEnum["CLOSED"] = "CLOSED";
})(ApiPartyBaseSearchResponseLevelEnum = exports.ApiPartyBaseSearchResponseLevelEnum || (exports.ApiPartyBaseSearchResponseLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyBaseSearchResponsePartyTypeEnum;
(function (ApiPartyBaseSearchResponsePartyTypeEnum) {
    ApiPartyBaseSearchResponsePartyTypeEnum["SERVICE"] = "SERVICE";
    ApiPartyBaseSearchResponsePartyTypeEnum["CONSUMER"] = "CONSUMER";
    ApiPartyBaseSearchResponsePartyTypeEnum["MERCHANT"] = "MERCHANT";
})(ApiPartyBaseSearchResponsePartyTypeEnum = exports.ApiPartyBaseSearchResponsePartyTypeEnum || (exports.ApiPartyBaseSearchResponsePartyTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyBaseSearchResponseStatusEnum;
(function (ApiPartyBaseSearchResponseStatusEnum) {
    ApiPartyBaseSearchResponseStatusEnum["OPEN"] = "OPEN";
    ApiPartyBaseSearchResponseStatusEnum["CLOSED"] = "CLOSED";
    ApiPartyBaseSearchResponseStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiPartyBaseSearchResponseStatusEnum["LIQUIDATED"] = "LIQUIDATED";
})(ApiPartyBaseSearchResponseStatusEnum = exports.ApiPartyBaseSearchResponseStatusEnum || (exports.ApiPartyBaseSearchResponseStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyDashboardSearchSystemEnum;
(function (ApiPartyDashboardSearchSystemEnum) {
    ApiPartyDashboardSearchSystemEnum["TANGO"] = "TANGO";
    ApiPartyDashboardSearchSystemEnum["UNIT21"] = "UNIT21";
    ApiPartyDashboardSearchSystemEnum["SIFT"] = "SIFT";
    ApiPartyDashboardSearchSystemEnum["BRAZE"] = "BRAZE";
    ApiPartyDashboardSearchSystemEnum["SARDINE"] = "SARDINE";
    ApiPartyDashboardSearchSystemEnum["FUSIONAUTH"] = "FUSIONAUTH";
})(ApiPartyDashboardSearchSystemEnum = exports.ApiPartyDashboardSearchSystemEnum || (exports.ApiPartyDashboardSearchSystemEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyKycDetailsKycStatusEnum;
(function (ApiPartyKycDetailsKycStatusEnum) {
    ApiPartyKycDetailsKycStatusEnum["UNKNOWN"] = "UNKNOWN";
    ApiPartyKycDetailsKycStatusEnum["PASSED"] = "PASSED";
    ApiPartyKycDetailsKycStatusEnum["RELEASED"] = "RELEASED";
    ApiPartyKycDetailsKycStatusEnum["ON_HOLD"] = "ON_HOLD";
})(ApiPartyKycDetailsKycStatusEnum = exports.ApiPartyKycDetailsKycStatusEnum || (exports.ApiPartyKycDetailsKycStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyOfacMatchMatchedRuleTypeEnum;
(function (ApiPartyOfacMatchMatchedRuleTypeEnum) {
    ApiPartyOfacMatchMatchedRuleTypeEnum["HARD"] = "HARD";
    ApiPartyOfacMatchMatchedRuleTypeEnum["SOFT"] = "SOFT";
})(ApiPartyOfacMatchMatchedRuleTypeEnum = exports.ApiPartyOfacMatchMatchedRuleTypeEnum || (exports.ApiPartyOfacMatchMatchedRuleTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyPhotoIdDetailsIdVerifiedEnum;
(function (ApiPartyPhotoIdDetailsIdVerifiedEnum) {
    ApiPartyPhotoIdDetailsIdVerifiedEnum["LOCKED"] = "LOCKED";
    ApiPartyPhotoIdDetailsIdVerifiedEnum["PENDING"] = "PENDING";
    ApiPartyPhotoIdDetailsIdVerifiedEnum["VERIFICATION_FAILED"] = "VERIFICATION_FAILED";
    ApiPartyPhotoIdDetailsIdVerifiedEnum["VERIFIED"] = "VERIFIED";
    ApiPartyPhotoIdDetailsIdVerifiedEnum["SKIPPED"] = "SKIPPED";
})(ApiPartyPhotoIdDetailsIdVerifiedEnum = exports.ApiPartyPhotoIdDetailsIdVerifiedEnum || (exports.ApiPartyPhotoIdDetailsIdVerifiedEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyRiskDetailsRiskLevelEnum;
(function (ApiPartyRiskDetailsRiskLevelEnum) {
    ApiPartyRiskDetailsRiskLevelEnum["VERY_HIGH"] = "VERY_HIGH";
    ApiPartyRiskDetailsRiskLevelEnum["HIGH"] = "HIGH";
    ApiPartyRiskDetailsRiskLevelEnum["MEDIUM"] = "MEDIUM";
    ApiPartyRiskDetailsRiskLevelEnum["LOW"] = "LOW";
})(ApiPartyRiskDetailsRiskLevelEnum = exports.ApiPartyRiskDetailsRiskLevelEnum || (exports.ApiPartyRiskDetailsRiskLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartySearchResponseOnBoardingStatusEnum;
(function (ApiPartySearchResponseOnBoardingStatusEnum) {
    ApiPartySearchResponseOnBoardingStatusEnum["UNKNOWN"] = "UNKNOWN";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_1"] = "LEVEL_1";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_1_SUSPENDED"] = "LEVEL_1_SUSPENDED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_1_LIQUIDATED"] = "LEVEL_1_LIQUIDATED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_2"] = "LEVEL_2";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_2_SUSPENDED"] = "LEVEL_2_SUSPENDED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_2_LIQUIDATED"] = "LEVEL_2_LIQUIDATED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_3"] = "LEVEL_3";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_3_SUSPENDED"] = "LEVEL_3_SUSPENDED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_3_LIQUIDATED"] = "LEVEL_3_LIQUIDATED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_4"] = "LEVEL_4";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_4_SUSPENDED"] = "LEVEL_4_SUSPENDED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_4_LIQUIDATED"] = "LEVEL_4_LIQUIDATED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_5"] = "LEVEL_5";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_5_SUSPENDED"] = "LEVEL_5_SUSPENDED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_5_LIQUIDATED"] = "LEVEL_5_LIQUIDATED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_99"] = "LEVEL_99";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_99_SUSPENDED"] = "LEVEL_99_SUSPENDED";
    ApiPartySearchResponseOnBoardingStatusEnum["LEVEL_99_LIQUIDATED"] = "LEVEL_99_LIQUIDATED";
    ApiPartySearchResponseOnBoardingStatusEnum["CLOSED"] = "CLOSED";
})(ApiPartySearchResponseOnBoardingStatusEnum = exports.ApiPartySearchResponseOnBoardingStatusEnum || (exports.ApiPartySearchResponseOnBoardingStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyStatusUpdateRequestReasonEnum;
(function (ApiPartyStatusUpdateRequestReasonEnum) {
    ApiPartyStatusUpdateRequestReasonEnum["ACCOUNT_CLOSURE_REQUESTED"] = "ACCOUNT_CLOSURE_REQUESTED";
    ApiPartyStatusUpdateRequestReasonEnum["ACH_MAX_RETURNS"] = "ACH_MAX_RETURNS";
    ApiPartyStatusUpdateRequestReasonEnum["ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED";
    ApiPartyStatusUpdateRequestReasonEnum["ACH_RETURNS_COUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_EXCEEDED";
    ApiPartyStatusUpdateRequestReasonEnum["ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED";
    ApiPartyStatusUpdateRequestReasonEnum["ACH_RETURN_CODE"] = "ACH_RETURN_CODE";
    ApiPartyStatusUpdateRequestReasonEnum["COMPLIANCE_INVESTIGATION"] = "COMPLIANCE_INVESTIGATION";
    ApiPartyStatusUpdateRequestReasonEnum["COMPLIANCE_LOCKED"] = "COMPLIANCE_LOCKED";
    ApiPartyStatusUpdateRequestReasonEnum["COMPLIANCE_VERIFICATION"] = "COMPLIANCE_VERIFICATION";
    ApiPartyStatusUpdateRequestReasonEnum["CUSTOMER_GOOD_STANDING"] = "CUSTOMER_GOOD_STANDING";
    ApiPartyStatusUpdateRequestReasonEnum["DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED";
    ApiPartyStatusUpdateRequestReasonEnum["DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED";
    ApiPartyStatusUpdateRequestReasonEnum["DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED";
    ApiPartyStatusUpdateRequestReasonEnum["DEBIT_CARD_TRANSACTION_FRAUD_HOLD"] = "DEBIT_CARD_TRANSACTION_FRAUD_HOLD";
    ApiPartyStatusUpdateRequestReasonEnum["LIQUIDATE_ACCOUNT"] = "LIQUIDATE_ACCOUNT";
    ApiPartyStatusUpdateRequestReasonEnum["MARQETA_KYC_VERIFICATION"] = "MARQETA_KYC_VERIFICATION";
    ApiPartyStatusUpdateRequestReasonEnum["NSF_BLOCKING"] = "NSF_BLOCKING";
    ApiPartyStatusUpdateRequestReasonEnum["OLD_OFAC_CHECK"] = "OLD_OFAC_CHECK";
    ApiPartyStatusUpdateRequestReasonEnum["OTHER"] = "OTHER";
    ApiPartyStatusUpdateRequestReasonEnum["PLAID_IDENTITY_CHECK"] = "PLAID_IDENTITY_CHECK";
    ApiPartyStatusUpdateRequestReasonEnum["PLAID_MISSING_NAMES"] = "PLAID_MISSING_NAMES";
    ApiPartyStatusUpdateRequestReasonEnum["RELINK"] = "RELINK";
    ApiPartyStatusUpdateRequestReasonEnum["RISK_DECISION"] = "RISK_DECISION";
    ApiPartyStatusUpdateRequestReasonEnum["RISK_KYC"] = "RISK_KYC";
    ApiPartyStatusUpdateRequestReasonEnum["RISK_SCREENING"] = "RISK_SCREENING";
    ApiPartyStatusUpdateRequestReasonEnum["TAX_ID_MAX_RETRIES"] = "TAX_ID_MAX_RETRIES";
    ApiPartyStatusUpdateRequestReasonEnum["CARD_TERMINATION_ERROR"] = "CARD_TERMINATION_ERROR";
    ApiPartyStatusUpdateRequestReasonEnum["CLOSED"] = "CLOSED";
})(ApiPartyStatusUpdateRequestReasonEnum = exports.ApiPartyStatusUpdateRequestReasonEnum || (exports.ApiPartyStatusUpdateRequestReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyTaxIdDetailsResponseStatusEnum;
(function (ApiPartyTaxIdDetailsResponseStatusEnum) {
    ApiPartyTaxIdDetailsResponseStatusEnum["SUCCESS"] = "SUCCESS";
    ApiPartyTaxIdDetailsResponseStatusEnum["FAILURE"] = "FAILURE";
    ApiPartyTaxIdDetailsResponseStatusEnum["ACCESS_DENIED"] = "ACCESS_DENIED";
    ApiPartyTaxIdDetailsResponseStatusEnum["BAD_REQUEST"] = "BAD_REQUEST";
    ApiPartyTaxIdDetailsResponseStatusEnum["SERVICE_ERROR"] = "SERVICE_ERROR";
    ApiPartyTaxIdDetailsResponseStatusEnum["MULTIPLE_RECORDS"] = "MULTIPLE_RECORDS";
    ApiPartyTaxIdDetailsResponseStatusEnum["DOB_INVALID"] = "DOB_INVALID";
    ApiPartyTaxIdDetailsResponseStatusEnum["INVALID_TOKEN"] = "INVALID_TOKEN";
    ApiPartyTaxIdDetailsResponseStatusEnum["INVALID_MSG_CONTENT"] = "INVALID_MSG_CONTENT";
    ApiPartyTaxIdDetailsResponseStatusEnum["TIMEOUT"] = "TIMEOUT";
})(ApiPartyTaxIdDetailsResponseStatusEnum = exports.ApiPartyTaxIdDetailsResponseStatusEnum || (exports.ApiPartyTaxIdDetailsResponseStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyTaxIdDetailsTaxIdVerifiedEnum;
(function (ApiPartyTaxIdDetailsTaxIdVerifiedEnum) {
    ApiPartyTaxIdDetailsTaxIdVerifiedEnum["LOCKED"] = "LOCKED";
    ApiPartyTaxIdDetailsTaxIdVerifiedEnum["PENDING"] = "PENDING";
    ApiPartyTaxIdDetailsTaxIdVerifiedEnum["VERIFICATION_FAILED"] = "VERIFICATION_FAILED";
    ApiPartyTaxIdDetailsTaxIdVerifiedEnum["VERIFIED"] = "VERIFIED";
    ApiPartyTaxIdDetailsTaxIdVerifiedEnum["SKIPPED"] = "SKIPPED";
})(ApiPartyTaxIdDetailsTaxIdVerifiedEnum = exports.ApiPartyTaxIdDetailsTaxIdVerifiedEnum || (exports.ApiPartyTaxIdDetailsTaxIdVerifiedEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyToPartyTransferAssetTypeEnum;
(function (ApiPartyToPartyTransferAssetTypeEnum) {
    ApiPartyToPartyTransferAssetTypeEnum["CASH"] = "CASH";
    ApiPartyToPartyTransferAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiPartyToPartyTransferAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
})(ApiPartyToPartyTransferAssetTypeEnum = exports.ApiPartyToPartyTransferAssetTypeEnum || (exports.ApiPartyToPartyTransferAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyToPartyTransferRemindersSentEnum;
(function (ApiPartyToPartyTransferRemindersSentEnum) {
    ApiPartyToPartyTransferRemindersSentEnum[ApiPartyToPartyTransferRemindersSentEnum["NUMBER_null"] = null] = "NUMBER_null";
})(ApiPartyToPartyTransferRemindersSentEnum = exports.ApiPartyToPartyTransferRemindersSentEnum || (exports.ApiPartyToPartyTransferRemindersSentEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyToPartyTransferStatusEnum;
(function (ApiPartyToPartyTransferStatusEnum) {
    ApiPartyToPartyTransferStatusEnum["CREATED"] = "CREATED";
    ApiPartyToPartyTransferStatusEnum["PROCESSING"] = "PROCESSING";
    ApiPartyToPartyTransferStatusEnum["ACCEPTED_BY_FROM_PARTY"] = "ACCEPTED_BY_FROM_PARTY";
    ApiPartyToPartyTransferStatusEnum["ACCEPTED_BY_SYSTEM"] = "ACCEPTED_BY_SYSTEM";
    ApiPartyToPartyTransferStatusEnum["CANCELED_BY_FROM_PARTY"] = "CANCELED_BY_FROM_PARTY";
    ApiPartyToPartyTransferStatusEnum["CANCELED_BY_TO_PARTY"] = "CANCELED_BY_TO_PARTY";
    ApiPartyToPartyTransferStatusEnum["CANCELED_BY_SYSTEM"] = "CANCELED_BY_SYSTEM";
})(ApiPartyToPartyTransferStatusEnum = exports.ApiPartyToPartyTransferStatusEnum || (exports.ApiPartyToPartyTransferStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPartyToPartyTransferTypeEnum;
(function (ApiPartyToPartyTransferTypeEnum) {
    ApiPartyToPartyTransferTypeEnum["SEND"] = "SEND";
    ApiPartyToPartyTransferTypeEnum["REQUEST"] = "REQUEST";
})(ApiPartyToPartyTransferTypeEnum = exports.ApiPartyToPartyTransferTypeEnum || (exports.ApiPartyToPartyTransferTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPendingBankAccountVerificationStatusEnum;
(function (ApiPendingBankAccountVerificationStatusEnum) {
    ApiPendingBankAccountVerificationStatusEnum["COMPLETE"] = "COMPLETE";
    ApiPendingBankAccountVerificationStatusEnum["EXPIRED"] = "EXPIRED";
    ApiPendingBankAccountVerificationStatusEnum["PENDING"] = "PENDING";
})(ApiPendingBankAccountVerificationStatusEnum = exports.ApiPendingBankAccountVerificationStatusEnum || (exports.ApiPendingBankAccountVerificationStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPendingBankAccountVerificationTypeEnum;
(function (ApiPendingBankAccountVerificationTypeEnum) {
    ApiPendingBankAccountVerificationTypeEnum["AUTOMATED_MICRODEPOSIT"] = "AUTOMATED_MICRODEPOSIT";
    ApiPendingBankAccountVerificationTypeEnum["SAME_DAY_MICRODEPOSIT"] = "SAME_DAY_MICRODEPOSIT";
    ApiPendingBankAccountVerificationTypeEnum["INSTANT"] = "INSTANT";
})(ApiPendingBankAccountVerificationTypeEnum = exports.ApiPendingBankAccountVerificationTypeEnum || (exports.ApiPendingBankAccountVerificationTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPhotoIdVerificationRequestCountryEnum;
(function (ApiPhotoIdVerificationRequestCountryEnum) {
    ApiPhotoIdVerificationRequestCountryEnum["USA"] = "USA";
})(ApiPhotoIdVerificationRequestCountryEnum = exports.ApiPhotoIdVerificationRequestCountryEnum || (exports.ApiPhotoIdVerificationRequestCountryEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPlaidAccountCurrencyEnum;
(function (ApiPlaidAccountCurrencyEnum) {
    ApiPlaidAccountCurrencyEnum["USD"] = "USD";
    ApiPlaidAccountCurrencyEnum["AAVE"] = "AAVE";
    ApiPlaidAccountCurrencyEnum["AVAX"] = "AVAX";
    ApiPlaidAccountCurrencyEnum["AXS"] = "AXS";
    ApiPlaidAccountCurrencyEnum["BAT"] = "BAT";
    ApiPlaidAccountCurrencyEnum["BCH"] = "BCH";
    ApiPlaidAccountCurrencyEnum["BTC"] = "BTC";
    ApiPlaidAccountCurrencyEnum["DOGE"] = "DOGE";
    ApiPlaidAccountCurrencyEnum["ETH"] = "ETH";
    ApiPlaidAccountCurrencyEnum["LINK"] = "LINK";
    ApiPlaidAccountCurrencyEnum["LTC"] = "LTC";
    ApiPlaidAccountCurrencyEnum["MANA"] = "MANA";
    ApiPlaidAccountCurrencyEnum["MATIC"] = "MATIC";
    ApiPlaidAccountCurrencyEnum["SOL"] = "SOL";
    ApiPlaidAccountCurrencyEnum["UNI"] = "UNI";
    ApiPlaidAccountCurrencyEnum["USDC"] = "USDC";
    ApiPlaidAccountCurrencyEnum["LXX"] = "LXX";
    ApiPlaidAccountCurrencyEnum["LCP"] = "LCP";
    ApiPlaidAccountCurrencyEnum["LWR"] = "LWR";
    ApiPlaidAccountCurrencyEnum["LMO"] = "LMO";
    ApiPlaidAccountCurrencyEnum["LKO"] = "LKO";
    ApiPlaidAccountCurrencyEnum["LED"] = "LED";
})(ApiPlaidAccountCurrencyEnum = exports.ApiPlaidAccountCurrencyEnum || (exports.ApiPlaidAccountCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPlaidAccountLinkStatusEnum;
(function (ApiPlaidAccountLinkStatusEnum) {
    ApiPlaidAccountLinkStatusEnum["CURRENT"] = "CURRENT";
    ApiPlaidAccountLinkStatusEnum["REFRESH_REQUIRED"] = "REFRESH_REQUIRED";
    ApiPlaidAccountLinkStatusEnum["PENDING_EXPIRATION"] = "PENDING_EXPIRATION";
})(ApiPlaidAccountLinkStatusEnum = exports.ApiPlaidAccountLinkStatusEnum || (exports.ApiPlaidAccountLinkStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPlaidAccountStatusEnum;
(function (ApiPlaidAccountStatusEnum) {
    ApiPlaidAccountStatusEnum["ACTIVE"] = "ACTIVE";
    ApiPlaidAccountStatusEnum["PENDING"] = "PENDING";
    ApiPlaidAccountStatusEnum["SUSPENDED"] = "SUSPENDED";
})(ApiPlaidAccountStatusEnum = exports.ApiPlaidAccountStatusEnum || (exports.ApiPlaidAccountStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPlaidEventPlaidEventSourceEnum;
(function (ApiPlaidEventPlaidEventSourceEnum) {
    ApiPlaidEventPlaidEventSourceEnum["CLIENT"] = "CLIENT";
    ApiPlaidEventPlaidEventSourceEnum["SERVER"] = "SERVER";
})(ApiPlaidEventPlaidEventSourceEnum = exports.ApiPlaidEventPlaidEventSourceEnum || (exports.ApiPlaidEventPlaidEventSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPortalRolePermissionsEnum;
(function (ApiPortalRolePermissionsEnum) {
    ApiPortalRolePermissionsEnum["ALLOWLIST_CREATE"] = "ALLOWLIST_CREATE";
    ApiPortalRolePermissionsEnum["ALLOWLIST_DELETE"] = "ALLOWLIST_DELETE";
    ApiPortalRolePermissionsEnum["ALLOWLIST_UPDATE"] = "ALLOWLIST_UPDATE";
    ApiPortalRolePermissionsEnum["ALLOWLIST_VIEW"] = "ALLOWLIST_VIEW";
    ApiPortalRolePermissionsEnum["DISPUTE_DELETE_REASON"] = "DISPUTE_DELETE_REASON";
    ApiPortalRolePermissionsEnum["DISPUTE_EXPORT_CSV"] = "DISPUTE_EXPORT_CSV";
    ApiPortalRolePermissionsEnum["DISPUTE_UPDATE_ACCEPT"] = "DISPUTE_UPDATE_ACCEPT";
    ApiPortalRolePermissionsEnum["DISPUTE_UPDATE_AUTO_APPROVE"] = "DISPUTE_UPDATE_AUTO_APPROVE";
    ApiPortalRolePermissionsEnum["DISPUTE_UPDATE_CREDIT_REJECT"] = "DISPUTE_UPDATE_CREDIT_REJECT";
    ApiPortalRolePermissionsEnum["DISPUTE_UPDATE_PROVISIONAL"] = "DISPUTE_UPDATE_PROVISIONAL";
    ApiPortalRolePermissionsEnum["DISPUTE_CREATE"] = "DISPUTE_CREATE";
    ApiPortalRolePermissionsEnum["DISPUTE_VIEW"] = "DISPUTE_VIEW";
    ApiPortalRolePermissionsEnum["DEVICE_SESSION_VIEW"] = "DEVICE_SESSION_VIEW";
    ApiPortalRolePermissionsEnum["FINANCE_VIEW"] = "FINANCE_VIEW";
    ApiPortalRolePermissionsEnum["GIFTCARD_UPDATE_REACTIVATE"] = "GIFTCARD_UPDATE_REACTIVATE";
    ApiPortalRolePermissionsEnum["GIFTCARD_BRAND_UPDATE"] = "GIFTCARD_BRAND_UPDATE";
    ApiPortalRolePermissionsEnum["GIFTCARD_BRAND_VIEW_ACTIVITY"] = "GIFTCARD_BRAND_VIEW_ACTIVITY";
    ApiPortalRolePermissionsEnum["GIFTCARD_VIEW"] = "GIFTCARD_VIEW";
    ApiPortalRolePermissionsEnum["GIFTCARD_VIEW_BALANCE"] = "GIFTCARD_VIEW_BALANCE";
    ApiPortalRolePermissionsEnum["GIFTCARD_VIEW_ACTIVITY"] = "GIFTCARD_VIEW_ACTIVITY";
    ApiPortalRolePermissionsEnum["KYC_ACTIVITY_VIEW"] = "KYC_ACTIVITY_VIEW";
    ApiPortalRolePermissionsEnum["OFAC_CREATE"] = "OFAC_CREATE";
    ApiPortalRolePermissionsEnum["OFAC_DELETE"] = "OFAC_DELETE";
    ApiPortalRolePermissionsEnum["OFAC_UPDATE"] = "OFAC_UPDATE";
    ApiPortalRolePermissionsEnum["OFAC_VIEW"] = "OFAC_VIEW";
    ApiPortalRolePermissionsEnum["PARTY_VIEW"] = "PARTY_VIEW";
    ApiPortalRolePermissionsEnum["PORTAL_VIEW"] = "PORTAL_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_CREATE"] = "REPORT_CREATE";
    ApiPortalRolePermissionsEnum["TICKET_CREATE"] = "TICKET_CREATE";
    ApiPortalRolePermissionsEnum["TICKET_UPDATE_ASSIGN"] = "TICKET_UPDATE_ASSIGN";
    ApiPortalRolePermissionsEnum["TICKET_UPDATE_CANCEL"] = "TICKET_UPDATE_CANCEL";
    ApiPortalRolePermissionsEnum["TICKET_UPDATE_ESCALATE"] = "TICKET_UPDATE_ESCALATE";
    ApiPortalRolePermissionsEnum["TICKET_UPDATE_COMMENT"] = "TICKET_UPDATE_COMMENT";
    ApiPortalRolePermissionsEnum["TICKET_VIEW"] = "TICKET_VIEW";
    ApiPortalRolePermissionsEnum["TRANSACTIONS_VIEW"] = "TRANSACTIONS_VIEW";
    ApiPortalRolePermissionsEnum["USERS_CREATE"] = "USERS_CREATE";
    ApiPortalRolePermissionsEnum["USERS_UPDATE"] = "USERS_UPDATE";
    ApiPortalRolePermissionsEnum["USERS_UPDATE_SYNC"] = "USERS_UPDATE_SYNC";
    ApiPortalRolePermissionsEnum["USERS_VIEW"] = "USERS_VIEW";
    ApiPortalRolePermissionsEnum["USERS_VIEW_DETAIL"] = "USERS_VIEW_DETAIL";
    ApiPortalRolePermissionsEnum["ACCOUNT_PREFUND_BLOCK"] = "ACCOUNT_PREFUND_BLOCK";
    ApiPortalRolePermissionsEnum["PARTY_SUSPEND"] = "PARTY_SUSPEND";
    ApiPortalRolePermissionsEnum["PARTY_UNSUSPEND"] = "PARTY_UNSUSPEND";
    ApiPortalRolePermissionsEnum["ACCOUNT_PREFUND_UNBLOCK"] = "ACCOUNT_PREFUND_UNBLOCK";
    ApiPortalRolePermissionsEnum["ACCOUNT_ACTIVITY_VIEW"] = "ACCOUNT_ACTIVITY_VIEW";
    ApiPortalRolePermissionsEnum["BAKKT_CARD_VIEW"] = "BAKKT_CARD_VIEW";
    ApiPortalRolePermissionsEnum["BAKKT_CARD_UPDATE"] = "BAKKT_CARD_UPDATE";
    ApiPortalRolePermissionsEnum["PARTY_CREDIT_ADD"] = "PARTY_CREDIT_ADD";
    ApiPortalRolePermissionsEnum["PARTY_PII_VIEW"] = "PARTY_PII_VIEW";
    ApiPortalRolePermissionsEnum["KYC_UPDATE"] = "KYC_UPDATE";
    ApiPortalRolePermissionsEnum["CARD_ISSUER_KYC_UPDATE"] = "CARD_ISSUER_KYC_UPDATE";
    ApiPortalRolePermissionsEnum["BANKACCOUNT_BLACKLIST_VIEW"] = "BANKACCOUNT_BLACKLIST_VIEW";
    ApiPortalRolePermissionsEnum["BANKACCOUNT_BLACKLIST_UPDATE"] = "BANKACCOUNT_BLACKLIST_UPDATE";
    ApiPortalRolePermissionsEnum["PARTY_WHITELIST_UPDATE"] = "PARTY_WHITELIST_UPDATE";
    ApiPortalRolePermissionsEnum["INCENTIVE_OFFER_VIEW"] = "INCENTIVE_OFFER_VIEW";
    ApiPortalRolePermissionsEnum["LOYALTY_REDEEM_CANCEL"] = "LOYALTY_REDEEM_CANCEL";
    ApiPortalRolePermissionsEnum["LOYALTY_ACCOUNT_VIEW"] = "LOYALTY_ACCOUNT_VIEW";
    ApiPortalRolePermissionsEnum["LOYALTY_ACCOUNT_UPDATE"] = "LOYALTY_ACCOUNT_UPDATE";
    ApiPortalRolePermissionsEnum["INCENTIVE_OFFER_CREATE"] = "INCENTIVE_OFFER_CREATE";
    ApiPortalRolePermissionsEnum["ACTIVITY_AUDIT_VIEW"] = "ACTIVITY_AUDIT_VIEW";
    ApiPortalRolePermissionsEnum["DEBIT_CARD_VIEW"] = "DEBIT_CARD_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_ASSET_ACTIVTY_VIEW"] = "REPORT_ASSET_ACTIVTY_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_PREFUNDING_VIEW"] = "REPORT_PREFUNDING_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_VIRTUAL_CURRENCY_VIEW"] = "REPORT_VIRTUAL_CURRENCY_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_MTL_VIEW"] = "REPORT_MTL_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_SIFT_VIEW"] = "REPORT_SIFT_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_DISPUTE_CREDIT_VIEW"] = "REPORT_DISPUTE_CREDIT_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_GIFT_CARD_RECON_VIEW"] = "REPORT_GIFT_CARD_RECON_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_ACCOUNT_BALANCE_SUMMARY_VIEW"] = "REPORT_ACCOUNT_BALANCE_SUMMARY_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_ACH_PROCESSING_VIEW"] = "REPORT_ACH_PROCESSING_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_SUSPEND_ACCOUNT_VIEW"] = "REPORT_SUSPEND_ACCOUNT_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_P2P_TRANSFER_VIEW"] = "REPORT_P2P_TRANSFER_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_ASSET_ACTIVTY_CREATE"] = "REPORT_ASSET_ACTIVTY_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_PREFUNDING_CREATE"] = "REPORT_PREFUNDING_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_VIRTUAL_CURRENCY_CREATE"] = "REPORT_VIRTUAL_CURRENCY_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_MTL_CREATE"] = "REPORT_MTL_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_SIFT_CREATE"] = "REPORT_SIFT_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_DISPUTE_CREDIT_CREATE"] = "REPORT_DISPUTE_CREDIT_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_GIFT_CARD_RECON_CREATE"] = "REPORT_GIFT_CARD_RECON_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_ACCOUNT_BALANCE_SUMMARY_CREATE"] = "REPORT_ACCOUNT_BALANCE_SUMMARY_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_ACH_PROCESSING_CREATE"] = "REPORT_ACH_PROCESSING_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_SUSPEND_ACCOUNT_CREATE"] = "REPORT_SUSPEND_ACCOUNT_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_P2P_TRANSFERS_CREATE"] = "REPORT_P2P_TRANSFERS_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_QUIZNOS_VIEW"] = "REPORT_QUIZNOS_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_QUIZNOS_CREATE"] = "REPORT_QUIZNOS_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_CHOICE_VIEW"] = "REPORT_CHOICE_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_CHOICE_CREATE"] = "REPORT_CHOICE_CREATE";
    ApiPortalRolePermissionsEnum["RISK_AUDIT_VIEW"] = "RISK_AUDIT_VIEW";
    ApiPortalRolePermissionsEnum["RISK_AUDIT_VIEW_DETAIL"] = "RISK_AUDIT_VIEW_DETAIL";
    ApiPortalRolePermissionsEnum["REPORT_ACCOUNT_BALANCE_V2_VIEW"] = "REPORT_ACCOUNT_BALANCE_V2_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_ACCOUNT_BALANCE_V2_CREATE"] = "REPORT_ACCOUNT_BALANCE_V2_CREATE";
    ApiPortalRolePermissionsEnum["PLAID_ACCOUNT_DETAIL_VIEW"] = "PLAID_ACCOUNT_DETAIL_VIEW";
    ApiPortalRolePermissionsEnum["UNMASK_PLAID_ACCOUNT_NUMBERS"] = "UNMASK_PLAID_ACCOUNT_NUMBERS";
    ApiPortalRolePermissionsEnum["UNMASK_DEBIT_CARD_FIELDS"] = "UNMASK_DEBIT_CARD_FIELDS";
    ApiPortalRolePermissionsEnum["TRANSACTION_ACCOUNT_LINK_FAILURES_VIEW"] = "TRANSACTION_ACCOUNT_LINK_FAILURES_VIEW";
    ApiPortalRolePermissionsEnum["REPORT_BTC_TRANSACTION_REPORT_CREATE"] = "REPORT_BTC_TRANSACTION_REPORT_CREATE";
    ApiPortalRolePermissionsEnum["REPORT_CRYPTO_TRANSACTION_REPORT_CREATE"] = "REPORT_CRYPTO_TRANSACTION_REPORT_CREATE";
    ApiPortalRolePermissionsEnum["PARTNER_DETAIL_VIEW"] = "PARTNER_DETAIL_VIEW";
    ApiPortalRolePermissionsEnum["PARTNER_LINK_UNLINK"] = "PARTNER_LINK_UNLINK";
    ApiPortalRolePermissionsEnum["PARTY_NAME_UPDATE"] = "PARTY_NAME_UPDATE";
    ApiPortalRolePermissionsEnum["PARTY_LIQUIDATE"] = "PARTY_LIQUIDATE";
    ApiPortalRolePermissionsEnum["PARTY_STATUS_UPDATE"] = "PARTY_STATUS_UPDATE";
})(ApiPortalRolePermissionsEnum = exports.ApiPortalRolePermissionsEnum || (exports.ApiPortalRolePermissionsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPortalUserUserStatusEnum;
(function (ApiPortalUserUserStatusEnum) {
    ApiPortalUserUserStatusEnum["ACTIVE"] = "ACTIVE";
    ApiPortalUserUserStatusEnum["INACTIVE"] = "INACTIVE";
    ApiPortalUserUserStatusEnum["INVITED"] = "INVITED";
})(ApiPortalUserUserStatusEnum = exports.ApiPortalUserUserStatusEnum || (exports.ApiPortalUserUserStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiPrincipalActivityDetailFundingTypeEnum;
(function (ApiPrincipalActivityDetailFundingTypeEnum) {
    ApiPrincipalActivityDetailFundingTypeEnum["PARTNER"] = "PARTNER";
    ApiPrincipalActivityDetailFundingTypeEnum["PARTY"] = "PARTY";
})(ApiPrincipalActivityDetailFundingTypeEnum = exports.ApiPrincipalActivityDetailFundingTypeEnum || (exports.ApiPrincipalActivityDetailFundingTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiRelatedTransactionTypeEnum;
(function (ApiRelatedTransactionTypeEnum) {
    ApiRelatedTransactionTypeEnum["ADD"] = "ADD";
    ApiRelatedTransactionTypeEnum["BUY"] = "BUY";
    ApiRelatedTransactionTypeEnum["CARD_CHARGEBACK"] = "CARD_CHARGEBACK";
    ApiRelatedTransactionTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    ApiRelatedTransactionTypeEnum["CARD_REFUND"] = "CARD_REFUND";
    ApiRelatedTransactionTypeEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiRelatedTransactionTypeEnum["CREDIT"] = "CREDIT";
    ApiRelatedTransactionTypeEnum["CONVERT"] = "CONVERT";
    ApiRelatedTransactionTypeEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    ApiRelatedTransactionTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiRelatedTransactionTypeEnum["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
    ApiRelatedTransactionTypeEnum["DEPOSIT_RETURNED"] = "DEPOSIT_RETURNED";
    ApiRelatedTransactionTypeEnum["DEPOSIT_REVERSE"] = "DEPOSIT_REVERSE";
    ApiRelatedTransactionTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiRelatedTransactionTypeEnum["DISPUTE_CREDIT_REVERSE"] = "DISPUTE_CREDIT_REVERSE";
    ApiRelatedTransactionTypeEnum["FREEZE"] = "FREEZE";
    ApiRelatedTransactionTypeEnum["INCENTIVE"] = "INCENTIVE";
    ApiRelatedTransactionTypeEnum["INCENTIVE_CANCEL"] = "INCENTIVE_CANCEL";
    ApiRelatedTransactionTypeEnum["LOYALTY_BUY"] = "LOYALTY_BUY";
    ApiRelatedTransactionTypeEnum["LOYALTY_BUY_CANCEL"] = "LOYALTY_BUY_CANCEL";
    ApiRelatedTransactionTypeEnum["LOYALTY_CREDIT_CANCEL"] = "LOYALTY_CREDIT_CANCEL";
    ApiRelatedTransactionTypeEnum["LOYALTY_REDEEM"] = "LOYALTY_REDEEM";
    ApiRelatedTransactionTypeEnum["LOYALTY_CRYPTO_REDEEM_FAILED"] = "LOYALTY_CRYPTO_REDEEM_FAILED";
    ApiRelatedTransactionTypeEnum["LOYALTY_PAYMENT_REVERSAL"] = "LOYALTY_PAYMENT_REVERSAL";
    ApiRelatedTransactionTypeEnum["LINK"] = "LINK";
    ApiRelatedTransactionTypeEnum["MERCHANT_CREDIT"] = "MERCHANT_CREDIT";
    ApiRelatedTransactionTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiRelatedTransactionTypeEnum["MERCHANT_PAYMENT_AUTHORIZE"] = "MERCHANT_PAYMENT_AUTHORIZE";
    ApiRelatedTransactionTypeEnum["MERCHANT_PAYMENT_AUTHORIZE_DECLINED"] = "MERCHANT_PAYMENT_AUTHORIZE_DECLINED";
    ApiRelatedTransactionTypeEnum["MERCHANT_PAYMENT_CANCEL"] = "MERCHANT_PAYMENT_CANCEL";
    ApiRelatedTransactionTypeEnum["MERCHANT_PAYMENT_CAPTURE"] = "MERCHANT_PAYMENT_CAPTURE";
    ApiRelatedTransactionTypeEnum["MERCHANT_PAYMENT_CREDIT"] = "MERCHANT_PAYMENT_CREDIT";
    ApiRelatedTransactionTypeEnum["MERCHANT_PAYMENT_REFUND"] = "MERCHANT_PAYMENT_REFUND";
    ApiRelatedTransactionTypeEnum["MERCHANT_PAYMENT_DISPUTE"] = "MERCHANT_PAYMENT_DISPUTE";
    ApiRelatedTransactionTypeEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    ApiRelatedTransactionTypeEnum["PAYOUT"] = "PAYOUT";
    ApiRelatedTransactionTypeEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiRelatedTransactionTypeEnum["RECEIVE"] = "RECEIVE";
    ApiRelatedTransactionTypeEnum["REDEEM"] = "REDEEM";
    ApiRelatedTransactionTypeEnum["REMOVE"] = "REMOVE";
    ApiRelatedTransactionTypeEnum["RESTORE"] = "RESTORE";
    ApiRelatedTransactionTypeEnum["REVERSE"] = "REVERSE";
    ApiRelatedTransactionTypeEnum["SELL"] = "SELL";
    ApiRelatedTransactionTypeEnum["SEND"] = "SEND";
    ApiRelatedTransactionTypeEnum["TERMINATE"] = "TERMINATE";
    ApiRelatedTransactionTypeEnum["UNFREEZE"] = "UNFREEZE";
    ApiRelatedTransactionTypeEnum["UNLINK"] = "UNLINK";
    ApiRelatedTransactionTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiRelatedTransactionTypeEnum["WITHDRAW_REVERSE"] = "WITHDRAW_REVERSE";
    ApiRelatedTransactionTypeEnum["WITHDRAW_RETURN"] = "WITHDRAW_RETURN";
    ApiRelatedTransactionTypeEnum["WITHDRAW_RETURNED"] = "WITHDRAW_RETURNED";
    ApiRelatedTransactionTypeEnum["PARTNER_REWARD_CRYPTO"] = "PARTNER_REWARD_CRYPTO";
    ApiRelatedTransactionTypeEnum["PARTNER_REWARD_CASH"] = "PARTNER_REWARD_CASH";
})(ApiRelatedTransactionTypeEnum = exports.ApiRelatedTransactionTypeEnum || (exports.ApiRelatedTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiReportListRequestReportTypeEnum;
(function (ApiReportListRequestReportTypeEnum) {
    ApiReportListRequestReportTypeEnum["ASSET_ACTIVTY"] = "ASSET_ACTIVTY";
    ApiReportListRequestReportTypeEnum["CHARGEBACK"] = "CHARGEBACK";
    ApiReportListRequestReportTypeEnum["PREFUNDING"] = "PREFUNDING";
    ApiReportListRequestReportTypeEnum["VIRTUAL_CURRENCY"] = "VIRTUAL_CURRENCY";
    ApiReportListRequestReportTypeEnum["SIFT"] = "SIFT";
    ApiReportListRequestReportTypeEnum["MERCHANT_RECONCILIATION_REPORT"] = "MERCHANT_RECONCILIATION_REPORT";
    ApiReportListRequestReportTypeEnum["PARTNER_SETTLEMENT_REPORT"] = "PARTNER_SETTLEMENT_REPORT";
    ApiReportListRequestReportTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiReportListRequestReportTypeEnum["ACCOUNT_BALANCE"] = "ACCOUNT_BALANCE";
    ApiReportListRequestReportTypeEnum["ACCOUNT_BALANCE_V2"] = "ACCOUNT_BALANCE_V2";
    ApiReportListRequestReportTypeEnum["ACCOUNT_BALANCE_SUMMARY"] = "ACCOUNT_BALANCE_SUMMARY";
    ApiReportListRequestReportTypeEnum["ALL_CURRENCY_MTL"] = "ALL_CURRENCY_MTL";
    ApiReportListRequestReportTypeEnum["MTL"] = "MTL";
    ApiReportListRequestReportTypeEnum["BTC_TRANSACTION_REPORT"] = "BTC_TRANSACTION_REPORT";
    ApiReportListRequestReportTypeEnum["CRYPTO_TRANSACTION_REPORT"] = "CRYPTO_TRANSACTION_REPORT";
    ApiReportListRequestReportTypeEnum["PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT"] = "PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT";
    ApiReportListRequestReportTypeEnum["SUSPEND_ACCOUNT"] = "SUSPEND_ACCOUNT";
    ApiReportListRequestReportTypeEnum["P2P_TRANSFER"] = "P2P_TRANSFER";
    ApiReportListRequestReportTypeEnum["GIFT_CARD_RECON"] = "GIFT_CARD_RECON";
    ApiReportListRequestReportTypeEnum["GIFT_CARD_REDEEM_RECON"] = "GIFT_CARD_REDEEM_RECON";
    ApiReportListRequestReportTypeEnum["GIFT_CARD_RECON_MONTH"] = "GIFT_CARD_RECON_MONTH";
    ApiReportListRequestReportTypeEnum["GIFT_CARD_REDEEM_RECON_MONTH"] = "GIFT_CARD_REDEEM_RECON_MONTH";
    ApiReportListRequestReportTypeEnum["ACH_FILE_RETURNS"] = "ACH_FILE_RETURNS";
    ApiReportListRequestReportTypeEnum["ACH_FILE_OUTBOUND"] = "ACH_FILE_OUTBOUND";
    ApiReportListRequestReportTypeEnum["PARTNER_RECONCILIATION_REPORT"] = "PARTNER_RECONCILIATION_REPORT";
    ApiReportListRequestReportTypeEnum["CHOICE"] = "CHOICE";
    ApiReportListRequestReportTypeEnum["QUIZNOS"] = "QUIZNOS";
    ApiReportListRequestReportTypeEnum["FISERV_PAYMENT_STATUS"] = "FISERV_PAYMENT_STATUS";
})(ApiReportListRequestReportTypeEnum = exports.ApiReportListRequestReportTypeEnum || (exports.ApiReportListRequestReportTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum;
(function (ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum) {
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["BANK_IDENTITY_CHECK"] = "BANK_IDENTITY_CHECK";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["BAKKT_CARD_KYC_FAIL"] = "BAKKT_CARD_KYC_FAIL";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["BAKKT_CARD_KYC_PENDING"] = "BAKKT_CARD_KYC_PENDING";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["BAKKT_CARD_KYC_SUCCESS"] = "BAKKT_CARD_KYC_SUCCESS";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["BANK_ACCOUNT_BLACKLIST"] = "BANK_ACCOUNT_BLACKLIST";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["BANK_ACCOUNT_REMOVE_BLACKLIST"] = "BANK_ACCOUNT_REMOVE_BLACKLIST";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["DEBIT_CARD_BLACKLIST"] = "DEBIT_CARD_BLACKLIST";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["DEBIT_CARD_REMOVE_BLACKLIST"] = "DEBIT_CARD_REMOVE_BLACKLIST";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["CREDIT"] = "CREDIT";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["KYC_FAIL"] = "KYC_FAIL";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["KYC_SUCCESS"] = "KYC_SUCCESS";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["KYC_UPDATE"] = "KYC_UPDATE";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["LIQUIDATE"] = "LIQUIDATE";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["PARTY_REMOVE_WHITELIST"] = "PARTY_REMOVE_WHITELIST";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["PARTY_WHITELIST"] = "PARTY_WHITELIST";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["PREFUND_BLOCK"] = "PREFUND_BLOCK";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["PREFUND_UNBLOCK"] = "PREFUND_UNBLOCK";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["REPORT_REQUEST"] = "REPORT_REQUEST";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["REPORT_SENT"] = "REPORT_SENT";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["SUSPEND"] = "SUSPEND";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["UNSUSPEND"] = "UNSUSPEND";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["LIQUIDATE_REQUESTED"] = "LIQUIDATE_REQUESTED";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["LIQUIDATE_REMOVE_REQUESTED"] = "LIQUIDATE_REMOVE_REQUESTED";
    ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum["CLOSED"] = "CLOSED";
})(ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum = exports.ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum || (exports.ApiResponseMapAccountActivityReasonListAccountActivityTypePayloadEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiResponseMapStringThirdPartyResponseStatusPayloadEnum;
(function (ApiResponseMapStringThirdPartyResponseStatusPayloadEnum) {
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["SUCCESS"] = "SUCCESS";
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["FAILURE"] = "FAILURE";
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["ACCESS_DENIED"] = "ACCESS_DENIED";
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["BAD_REQUEST"] = "BAD_REQUEST";
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["SERVICE_ERROR"] = "SERVICE_ERROR";
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["MULTIPLE_RECORDS"] = "MULTIPLE_RECORDS";
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["DOB_INVALID"] = "DOB_INVALID";
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["INVALID_TOKEN"] = "INVALID_TOKEN";
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["INVALID_MSG_CONTENT"] = "INVALID_MSG_CONTENT";
    ApiResponseMapStringThirdPartyResponseStatusPayloadEnum["TIMEOUT"] = "TIMEOUT";
})(ApiResponseMapStringThirdPartyResponseStatusPayloadEnum = exports.ApiResponseMapStringThirdPartyResponseStatusPayloadEnum || (exports.ApiResponseMapStringThirdPartyResponseStatusPayloadEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiRestrictionPeriodEnum;
(function (ApiRestrictionPeriodEnum) {
    ApiRestrictionPeriodEnum["SINGLE"] = "SINGLE";
    ApiRestrictionPeriodEnum["ONE_DAY"] = "ONE_DAY";
    ApiRestrictionPeriodEnum["SEVEN_DAYS"] = "SEVEN_DAYS";
    ApiRestrictionPeriodEnum["THIRTY_DAYS"] = "THIRTY_DAYS";
    ApiRestrictionPeriodEnum["LIFETIME"] = "LIFETIME";
})(ApiRestrictionPeriodEnum = exports.ApiRestrictionPeriodEnum || (exports.ApiRestrictionPeriodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiRestrictionTypeEnum;
(function (ApiRestrictionTypeEnum) {
    ApiRestrictionTypeEnum["ACH_DEPOSIT"] = "ACH_DEPOSIT";
    ApiRestrictionTypeEnum["ACH_WITHDRAWAL"] = "ACH_WITHDRAWAL";
    ApiRestrictionTypeEnum["CASH_PAYMENT"] = "CASH_PAYMENT";
    ApiRestrictionTypeEnum["CASH_P2P"] = "CASH_P2P";
    ApiRestrictionTypeEnum["BITCOIN_ANY"] = "BITCOIN_ANY";
    ApiRestrictionTypeEnum["BITCOIN_BUY"] = "BITCOIN_BUY";
    ApiRestrictionTypeEnum["BITCOIN_P2P"] = "BITCOIN_P2P";
})(ApiRestrictionTypeEnum = exports.ApiRestrictionTypeEnum || (exports.ApiRestrictionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiRestrictionUnitEnum;
(function (ApiRestrictionUnitEnum) {
    ApiRestrictionUnitEnum["COUNT"] = "COUNT";
    ApiRestrictionUnitEnum["AMOUNT"] = "AMOUNT";
})(ApiRestrictionUnitEnum = exports.ApiRestrictionUnitEnum || (exports.ApiRestrictionUnitEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiRewardsTransactionDetailsStatusEnum;
(function (ApiRewardsTransactionDetailsStatusEnum) {
    ApiRewardsTransactionDetailsStatusEnum["COMPLETE"] = "COMPLETE";
    ApiRewardsTransactionDetailsStatusEnum["PENDING"] = "PENDING";
    ApiRewardsTransactionDetailsStatusEnum["CANCELED"] = "CANCELED";
})(ApiRewardsTransactionDetailsStatusEnum = exports.ApiRewardsTransactionDetailsStatusEnum || (exports.ApiRewardsTransactionDetailsStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiRewardsTransactionDetailsSupportedOperationsEnum;
(function (ApiRewardsTransactionDetailsSupportedOperationsEnum) {
    ApiRewardsTransactionDetailsSupportedOperationsEnum["BUY"] = "BUY";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["BUY_CANCEL"] = "BUY_CANCEL";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["CREDIT_CANCEL"] = "CREDIT_CANCEL";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["REDEEM_CANCEL"] = "REDEEM_CANCEL";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["CHECK_BALANCE"] = "CHECK_BALANCE";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["CREDIT"] = "CREDIT";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["ENROLL"] = "ENROLL";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["PAY_WITH_POINTS"] = "PAY_WITH_POINTS";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["QUOTE_BUY"] = "QUOTE_BUY";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["QUOTE_REDEEM"] = "QUOTE_REDEEM";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["REDEEM"] = "REDEEM";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["REDEEM_FOR_CRYPTO"] = "REDEEM_FOR_CRYPTO";
    ApiRewardsTransactionDetailsSupportedOperationsEnum["UNENROLL"] = "UNENROLL";
})(ApiRewardsTransactionDetailsSupportedOperationsEnum = exports.ApiRewardsTransactionDetailsSupportedOperationsEnum || (exports.ApiRewardsTransactionDetailsSupportedOperationsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiSettlementAchTypeEnum;
(function (ApiSettlementAchTypeEnum) {
    ApiSettlementAchTypeEnum["WITHDRAWAL"] = "WITHDRAWAL";
    ApiSettlementAchTypeEnum["DEPOSIT"] = "DEPOSIT";
})(ApiSettlementAchTypeEnum = exports.ApiSettlementAchTypeEnum || (exports.ApiSettlementAchTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiSettlementSourceCurrencyEnum;
(function (ApiSettlementSourceCurrencyEnum) {
    ApiSettlementSourceCurrencyEnum["USD"] = "USD";
    ApiSettlementSourceCurrencyEnum["AAVE"] = "AAVE";
    ApiSettlementSourceCurrencyEnum["AVAX"] = "AVAX";
    ApiSettlementSourceCurrencyEnum["AXS"] = "AXS";
    ApiSettlementSourceCurrencyEnum["BAT"] = "BAT";
    ApiSettlementSourceCurrencyEnum["BCH"] = "BCH";
    ApiSettlementSourceCurrencyEnum["BTC"] = "BTC";
    ApiSettlementSourceCurrencyEnum["DOGE"] = "DOGE";
    ApiSettlementSourceCurrencyEnum["ETH"] = "ETH";
    ApiSettlementSourceCurrencyEnum["LINK"] = "LINK";
    ApiSettlementSourceCurrencyEnum["LTC"] = "LTC";
    ApiSettlementSourceCurrencyEnum["MANA"] = "MANA";
    ApiSettlementSourceCurrencyEnum["MATIC"] = "MATIC";
    ApiSettlementSourceCurrencyEnum["SOL"] = "SOL";
    ApiSettlementSourceCurrencyEnum["UNI"] = "UNI";
    ApiSettlementSourceCurrencyEnum["USDC"] = "USDC";
    ApiSettlementSourceCurrencyEnum["LXX"] = "LXX";
    ApiSettlementSourceCurrencyEnum["LCP"] = "LCP";
    ApiSettlementSourceCurrencyEnum["LWR"] = "LWR";
    ApiSettlementSourceCurrencyEnum["LMO"] = "LMO";
    ApiSettlementSourceCurrencyEnum["LKO"] = "LKO";
    ApiSettlementSourceCurrencyEnum["LED"] = "LED";
})(ApiSettlementSourceCurrencyEnum = exports.ApiSettlementSourceCurrencyEnum || (exports.ApiSettlementSourceCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiThirdPartyVerificationLogThirdPartyServiceEnum;
(function (ApiThirdPartyVerificationLogThirdPartyServiceEnum) {
    ApiThirdPartyVerificationLogThirdPartyServiceEnum["MITEK"] = "MITEK";
    ApiThirdPartyVerificationLogThirdPartyServiceEnum["TRANSUNION"] = "TRANSUNION";
})(ApiThirdPartyVerificationLogThirdPartyServiceEnum = exports.ApiThirdPartyVerificationLogThirdPartyServiceEnum || (exports.ApiThirdPartyVerificationLogThirdPartyServiceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiThirdPartyVerificationLogVerificationTypeEnum;
(function (ApiThirdPartyVerificationLogVerificationTypeEnum) {
    ApiThirdPartyVerificationLogVerificationTypeEnum["TAX_ID"] = "TAX_ID";
    ApiThirdPartyVerificationLogVerificationTypeEnum["PHOTO_ID"] = "PHOTO_ID";
})(ApiThirdPartyVerificationLogVerificationTypeEnum = exports.ApiThirdPartyVerificationLogVerificationTypeEnum || (exports.ApiThirdPartyVerificationLogVerificationTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTicketCategoryEnum;
(function (ApiTicketCategoryEnum) {
    ApiTicketCategoryEnum["TRANSACTIONS"] = "TRANSACTIONS";
    ApiTicketCategoryEnum["BILLING"] = "BILLING";
    ApiTicketCategoryEnum["SETTLEMENT"] = "SETTLEMENT";
    ApiTicketCategoryEnum["OTHERS"] = "OTHERS";
    ApiTicketCategoryEnum["CHARGEBACKS"] = "CHARGEBACKS";
})(ApiTicketCategoryEnum = exports.ApiTicketCategoryEnum || (exports.ApiTicketCategoryEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTicketReasonCodeEnum;
(function (ApiTicketReasonCodeEnum) {
    ApiTicketReasonCodeEnum["DAC01"] = "DAC01";
    ApiTicketReasonCodeEnum["DAC02"] = "DAC02";
    ApiTicketReasonCodeEnum["DAC03"] = "DAC03";
    ApiTicketReasonCodeEnum["DAC04"] = "DAC04";
    ApiTicketReasonCodeEnum["DAC05"] = "DAC05";
    ApiTicketReasonCodeEnum["DAC06"] = "DAC06";
    ApiTicketReasonCodeEnum["DAC07"] = "DAC07";
    ApiTicketReasonCodeEnum["DAC08"] = "DAC08";
    ApiTicketReasonCodeEnum["DAC09"] = "DAC09";
    ApiTicketReasonCodeEnum["DAC10"] = "DAC10";
})(ApiTicketReasonCodeEnum = exports.ApiTicketReasonCodeEnum || (exports.ApiTicketReasonCodeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTicketRecipientTypeEnum;
(function (ApiTicketRecipientTypeEnum) {
    ApiTicketRecipientTypeEnum["CONSUMER"] = "CONSUMER";
    ApiTicketRecipientTypeEnum["MERCHANT"] = "MERCHANT";
    ApiTicketRecipientTypeEnum["INTERNAL"] = "INTERNAL";
})(ApiTicketRecipientTypeEnum = exports.ApiTicketRecipientTypeEnum || (exports.ApiTicketRecipientTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTicketStatusEnum;
(function (ApiTicketStatusEnum) {
    ApiTicketStatusEnum["NEW"] = "NEW";
    ApiTicketStatusEnum["OPEN"] = "OPEN";
    ApiTicketStatusEnum["PENDING"] = "PENDING";
    ApiTicketStatusEnum["SOLVED"] = "SOLVED";
    ApiTicketStatusEnum["CLOSED"] = "CLOSED";
})(ApiTicketStatusEnum = exports.ApiTicketStatusEnum || (exports.ApiTicketStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTransactionActivityActivityTypeEnum;
(function (ApiTransactionActivityActivityTypeEnum) {
    ApiTransactionActivityActivityTypeEnum["INITIATED"] = "INITIATED";
    ApiTransactionActivityActivityTypeEnum["EXECUTED"] = "EXECUTED";
    ApiTransactionActivityActivityTypeEnum["AUTHORIZED"] = "AUTHORIZED";
    ApiTransactionActivityActivityTypeEnum["REAUTHORIZED"] = "REAUTHORIZED";
    ApiTransactionActivityActivityTypeEnum["AUTH_DECLINED"] = "AUTH_DECLINED";
    ApiTransactionActivityActivityTypeEnum["CAPTURED"] = "CAPTURED";
    ApiTransactionActivityActivityTypeEnum["REVERSED"] = "REVERSED";
    ApiTransactionActivityActivityTypeEnum["SETTLED"] = "SETTLED";
    ApiTransactionActivityActivityTypeEnum["DISPUTED"] = "DISPUTED";
    ApiTransactionActivityActivityTypeEnum["ESCALATED"] = "ESCALATED";
    ApiTransactionActivityActivityTypeEnum["ACCEPTED"] = "ACCEPTED";
    ApiTransactionActivityActivityTypeEnum["REJECTED"] = "REJECTED";
    ApiTransactionActivityActivityTypeEnum["CHARGEBACK"] = "CHARGEBACK";
    ApiTransactionActivityActivityTypeEnum["FORCE_CHARGEBACK"] = "FORCE_CHARGEBACK";
    ApiTransactionActivityActivityTypeEnum["MERCHANT_REJECTED"] = "MERCHANT_REJECTED";
    ApiTransactionActivityActivityTypeEnum["MERCHANT_ACCEPTED"] = "MERCHANT_ACCEPTED";
    ApiTransactionActivityActivityTypeEnum["MERCHANT_RE_ESCALATED"] = "MERCHANT_RE_ESCALATED";
    ApiTransactionActivityActivityTypeEnum["CANCELLED"] = "CANCELLED";
    ApiTransactionActivityActivityTypeEnum["MERCHANT_ESCALATED"] = "MERCHANT_ESCALATED";
    ApiTransactionActivityActivityTypeEnum["DISPUTE_CANCELED"] = "DISPUTE_CANCELED";
    ApiTransactionActivityActivityTypeEnum["REGULATION_E"] = "REGULATION_E";
    ApiTransactionActivityActivityTypeEnum["PROVISIONAL_CREDIT"] = "PROVISIONAL_CREDIT";
    ApiTransactionActivityActivityTypeEnum["CANCELED"] = "CANCELED";
    ApiTransactionActivityActivityTypeEnum["COMPLETE"] = "COMPLETE";
    ApiTransactionActivityActivityTypeEnum["EXPIRED"] = "EXPIRED";
    ApiTransactionActivityActivityTypeEnum["REPLACED"] = "REPLACED";
    ApiTransactionActivityActivityTypeEnum["PENDING"] = "PENDING";
    ApiTransactionActivityActivityTypeEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    ApiTransactionActivityActivityTypeEnum["REFUNDED"] = "REFUNDED";
    ApiTransactionActivityActivityTypeEnum["CREDITED"] = "CREDITED";
})(ApiTransactionActivityActivityTypeEnum = exports.ApiTransactionActivityActivityTypeEnum || (exports.ApiTransactionActivityActivityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTransactionActivityDeclineReasonEnum;
(function (ApiTransactionActivityDeclineReasonEnum) {
    ApiTransactionActivityDeclineReasonEnum["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    ApiTransactionActivityDeclineReasonEnum["FUNDING_PREFERENCE_NOT_FOUND"] = "FUNDING_PREFERENCE_NOT_FOUND";
    ApiTransactionActivityDeclineReasonEnum["CARD_INVALID_STATUS"] = "CARD_INVALID_STATUS";
    ApiTransactionActivityDeclineReasonEnum["CARD_NOT_FOUND"] = "CARD_NOT_FOUND";
    ApiTransactionActivityDeclineReasonEnum["CARD_NOT_ACTIVATED"] = "CARD_NOT_ACTIVATED";
    ApiTransactionActivityDeclineReasonEnum["DAILY_LIMIT_EXCEEDED"] = "DAILY_LIMIT_EXCEEDED";
    ApiTransactionActivityDeclineReasonEnum["MONTHLY_LIMIT_EXCEEDED"] = "MONTHLY_LIMIT_EXCEEDED";
    ApiTransactionActivityDeclineReasonEnum["OVER_LIMIT"] = "OVER_LIMIT";
    ApiTransactionActivityDeclineReasonEnum["NOT_SUFFICIENT_FUNDS"] = "NOT_SUFFICIENT_FUNDS";
    ApiTransactionActivityDeclineReasonEnum["SUSPECTED_FRAUD"] = "SUSPECTED_FRAUD";
    ApiTransactionActivityDeclineReasonEnum["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    ApiTransactionActivityDeclineReasonEnum["CARD_ISSUER_PARTY_NOT_FOUND"] = "CARD_ISSUER_PARTY_NOT_FOUND";
    ApiTransactionActivityDeclineReasonEnum["CARD_ISSUER_PARTY_INVALID_STATUS"] = "CARD_ISSUER_PARTY_INVALID_STATUS";
    ApiTransactionActivityDeclineReasonEnum["PARTY_NOT_FOUND"] = "PARTY_NOT_FOUND";
    ApiTransactionActivityDeclineReasonEnum["PARTY_INVALID_STATUS"] = "PARTY_INVALID_STATUS";
    ApiTransactionActivityDeclineReasonEnum["CURRENCY_MISMATCH"] = "CURRENCY_MISMATCH";
    ApiTransactionActivityDeclineReasonEnum["DATA_MISMATCH"] = "DATA_MISMATCH";
    ApiTransactionActivityDeclineReasonEnum["GENERIC_PAYMENT_PROCESSING_ERROR"] = "GENERIC_PAYMENT_PROCESSING_ERROR";
    ApiTransactionActivityDeclineReasonEnum["PRECONDITION_NOT_MET"] = "PRECONDITION_NOT_MET";
    ApiTransactionActivityDeclineReasonEnum["INSUFFICIENT_FUNDS_FOR_BAKKT_ACCOUNT_DEPOSIT"] = "INSUFFICIENT_FUNDS_FOR_BAKKT_ACCOUNT_DEPOSIT";
    ApiTransactionActivityDeclineReasonEnum["BLACKLISTED_DEBIT_CARD"] = "BLACKLISTED_DEBIT_CARD";
    ApiTransactionActivityDeclineReasonEnum["BLACKLISTED_MERCHANT_CATEGORY"] = "BLACKLISTED_MERCHANT_CATEGORY";
    ApiTransactionActivityDeclineReasonEnum["BLACKLISTED_BANK_ACCOUNT"] = "BLACKLISTED_BANK_ACCOUNT";
    ApiTransactionActivityDeclineReasonEnum["BANK_ACCOUNT_BLACKLISTED_LINKING_FAILED"] = "BANK_ACCOUNT_BLACKLISTED_LINKING_FAILED";
    ApiTransactionActivityDeclineReasonEnum["TRANSACTION_FAILED"] = "TRANSACTION_FAILED";
    ApiTransactionActivityDeclineReasonEnum["REAUTHENTICATION_REQUIRED"] = "REAUTHENTICATION_REQUIRED";
    ApiTransactionActivityDeclineReasonEnum["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    ApiTransactionActivityDeclineReasonEnum["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    ApiTransactionActivityDeclineReasonEnum["PROCESSOR_DECLINED"] = "PROCESSOR_DECLINED";
    ApiTransactionActivityDeclineReasonEnum["SETTLEMENT_DECLINED"] = "SETTLEMENT_DECLINED";
    ApiTransactionActivityDeclineReasonEnum["GATEWAY_REJECTED"] = "GATEWAY_REJECTED";
    ApiTransactionActivityDeclineReasonEnum["REWARDS_GATEWAY_REJECTED"] = "REWARDS_GATEWAY_REJECTED";
    ApiTransactionActivityDeclineReasonEnum["AVS_ERROR"] = "AVS_ERROR";
    ApiTransactionActivityDeclineReasonEnum["CVV_ERROR"] = "CVV_ERROR";
    ApiTransactionActivityDeclineReasonEnum["AVS_GATEWAY_ERROR"] = "AVS_GATEWAY_ERROR";
    ApiTransactionActivityDeclineReasonEnum["AVS_VERIFICATION_FAILED"] = "AVS_VERIFICATION_FAILED";
    ApiTransactionActivityDeclineReasonEnum["CVV_VERIFICATION_FAILED"] = "CVV_VERIFICATION_FAILED";
    ApiTransactionActivityDeclineReasonEnum["AMOUNT_VERIFICATION_FAILED"] = "AMOUNT_VERIFICATION_FAILED";
    ApiTransactionActivityDeclineReasonEnum["DEBIT_CARD_NOT_FOUND"] = "DEBIT_CARD_NOT_FOUND";
    ApiTransactionActivityDeclineReasonEnum["SDK_ERROR"] = "SDK_ERROR";
})(ApiTransactionActivityDeclineReasonEnum = exports.ApiTransactionActivityDeclineReasonEnum || (exports.ApiTransactionActivityDeclineReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTransactionDetailsActivityTypeEnum;
(function (ApiTransactionDetailsActivityTypeEnum) {
    ApiTransactionDetailsActivityTypeEnum["ADD"] = "ADD";
    ApiTransactionDetailsActivityTypeEnum["BUY"] = "BUY";
    ApiTransactionDetailsActivityTypeEnum["CARD_CHARGEBACK"] = "CARD_CHARGEBACK";
    ApiTransactionDetailsActivityTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    ApiTransactionDetailsActivityTypeEnum["CARD_REFUND"] = "CARD_REFUND";
    ApiTransactionDetailsActivityTypeEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiTransactionDetailsActivityTypeEnum["CREDIT"] = "CREDIT";
    ApiTransactionDetailsActivityTypeEnum["CONVERT"] = "CONVERT";
    ApiTransactionDetailsActivityTypeEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    ApiTransactionDetailsActivityTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiTransactionDetailsActivityTypeEnum["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
    ApiTransactionDetailsActivityTypeEnum["DEPOSIT_RETURNED"] = "DEPOSIT_RETURNED";
    ApiTransactionDetailsActivityTypeEnum["DEPOSIT_REVERSE"] = "DEPOSIT_REVERSE";
    ApiTransactionDetailsActivityTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiTransactionDetailsActivityTypeEnum["DISPUTE_CREDIT_REVERSE"] = "DISPUTE_CREDIT_REVERSE";
    ApiTransactionDetailsActivityTypeEnum["FREEZE"] = "FREEZE";
    ApiTransactionDetailsActivityTypeEnum["INCENTIVE"] = "INCENTIVE";
    ApiTransactionDetailsActivityTypeEnum["INCENTIVE_CANCEL"] = "INCENTIVE_CANCEL";
    ApiTransactionDetailsActivityTypeEnum["LOYALTY_BUY"] = "LOYALTY_BUY";
    ApiTransactionDetailsActivityTypeEnum["LOYALTY_BUY_CANCEL"] = "LOYALTY_BUY_CANCEL";
    ApiTransactionDetailsActivityTypeEnum["LOYALTY_CREDIT_CANCEL"] = "LOYALTY_CREDIT_CANCEL";
    ApiTransactionDetailsActivityTypeEnum["LOYALTY_REDEEM"] = "LOYALTY_REDEEM";
    ApiTransactionDetailsActivityTypeEnum["LOYALTY_CRYPTO_REDEEM_FAILED"] = "LOYALTY_CRYPTO_REDEEM_FAILED";
    ApiTransactionDetailsActivityTypeEnum["LOYALTY_PAYMENT_REVERSAL"] = "LOYALTY_PAYMENT_REVERSAL";
    ApiTransactionDetailsActivityTypeEnum["LINK"] = "LINK";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_CREDIT"] = "MERCHANT_CREDIT";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_PAYMENT_AUTHORIZE"] = "MERCHANT_PAYMENT_AUTHORIZE";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_PAYMENT_AUTHORIZE_DECLINED"] = "MERCHANT_PAYMENT_AUTHORIZE_DECLINED";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_PAYMENT_CANCEL"] = "MERCHANT_PAYMENT_CANCEL";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_PAYMENT_CAPTURE"] = "MERCHANT_PAYMENT_CAPTURE";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_PAYMENT_CREDIT"] = "MERCHANT_PAYMENT_CREDIT";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_PAYMENT_REFUND"] = "MERCHANT_PAYMENT_REFUND";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_PAYMENT_DISPUTE"] = "MERCHANT_PAYMENT_DISPUTE";
    ApiTransactionDetailsActivityTypeEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    ApiTransactionDetailsActivityTypeEnum["PAYOUT"] = "PAYOUT";
    ApiTransactionDetailsActivityTypeEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiTransactionDetailsActivityTypeEnum["RECEIVE"] = "RECEIVE";
    ApiTransactionDetailsActivityTypeEnum["REDEEM"] = "REDEEM";
    ApiTransactionDetailsActivityTypeEnum["REMOVE"] = "REMOVE";
    ApiTransactionDetailsActivityTypeEnum["RESTORE"] = "RESTORE";
    ApiTransactionDetailsActivityTypeEnum["REVERSE"] = "REVERSE";
    ApiTransactionDetailsActivityTypeEnum["SELL"] = "SELL";
    ApiTransactionDetailsActivityTypeEnum["SEND"] = "SEND";
    ApiTransactionDetailsActivityTypeEnum["TERMINATE"] = "TERMINATE";
    ApiTransactionDetailsActivityTypeEnum["UNFREEZE"] = "UNFREEZE";
    ApiTransactionDetailsActivityTypeEnum["UNLINK"] = "UNLINK";
    ApiTransactionDetailsActivityTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiTransactionDetailsActivityTypeEnum["WITHDRAW_REVERSE"] = "WITHDRAW_REVERSE";
    ApiTransactionDetailsActivityTypeEnum["WITHDRAW_RETURN"] = "WITHDRAW_RETURN";
    ApiTransactionDetailsActivityTypeEnum["WITHDRAW_RETURNED"] = "WITHDRAW_RETURNED";
    ApiTransactionDetailsActivityTypeEnum["PARTNER_REWARD_CRYPTO"] = "PARTNER_REWARD_CRYPTO";
    ApiTransactionDetailsActivityTypeEnum["PARTNER_REWARD_CASH"] = "PARTNER_REWARD_CASH";
})(ApiTransactionDetailsActivityTypeEnum = exports.ApiTransactionDetailsActivityTypeEnum || (exports.ApiTransactionDetailsActivityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTransactionDetailsAssetTypeEnum;
(function (ApiTransactionDetailsAssetTypeEnum) {
    ApiTransactionDetailsAssetTypeEnum["CASH"] = "CASH";
    ApiTransactionDetailsAssetTypeEnum["CRYPTO"] = "CRYPTO";
    ApiTransactionDetailsAssetTypeEnum["REWARDS"] = "REWARDS";
    ApiTransactionDetailsAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    ApiTransactionDetailsAssetTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiTransactionDetailsAssetTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(ApiTransactionDetailsAssetTypeEnum = exports.ApiTransactionDetailsAssetTypeEnum || (exports.ApiTransactionDetailsAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTransactionDetailsRequestAssetActivityTypeEnum;
(function (ApiTransactionDetailsRequestAssetActivityTypeEnum) {
    ApiTransactionDetailsRequestAssetActivityTypeEnum["ADD"] = "ADD";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["BUY"] = "BUY";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["CARD_CHARGEBACK"] = "CARD_CHARGEBACK";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["CARD_REFUND"] = "CARD_REFUND";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["CREDIT"] = "CREDIT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["CONVERT"] = "CONVERT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["DEPOSIT"] = "DEPOSIT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["DEPOSIT_RETURNED"] = "DEPOSIT_RETURNED";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["DEPOSIT_REVERSE"] = "DEPOSIT_REVERSE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["DISPUTE_CREDIT_REVERSE"] = "DISPUTE_CREDIT_REVERSE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["FREEZE"] = "FREEZE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["INCENTIVE"] = "INCENTIVE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["INCENTIVE_CANCEL"] = "INCENTIVE_CANCEL";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["LOYALTY_BUY"] = "LOYALTY_BUY";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["LOYALTY_BUY_CANCEL"] = "LOYALTY_BUY_CANCEL";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["LOYALTY_CREDIT_CANCEL"] = "LOYALTY_CREDIT_CANCEL";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["LOYALTY_REDEEM"] = "LOYALTY_REDEEM";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["LOYALTY_CRYPTO_REDEEM_FAILED"] = "LOYALTY_CRYPTO_REDEEM_FAILED";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["LOYALTY_PAYMENT_REVERSAL"] = "LOYALTY_PAYMENT_REVERSAL";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["LINK"] = "LINK";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_CREDIT"] = "MERCHANT_CREDIT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_PAYMENT_AUTHORIZE"] = "MERCHANT_PAYMENT_AUTHORIZE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_PAYMENT_AUTHORIZE_DECLINED"] = "MERCHANT_PAYMENT_AUTHORIZE_DECLINED";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_PAYMENT_CANCEL"] = "MERCHANT_PAYMENT_CANCEL";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_PAYMENT_CAPTURE"] = "MERCHANT_PAYMENT_CAPTURE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_PAYMENT_CREDIT"] = "MERCHANT_PAYMENT_CREDIT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_PAYMENT_REFUND"] = "MERCHANT_PAYMENT_REFUND";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_PAYMENT_DISPUTE"] = "MERCHANT_PAYMENT_DISPUTE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["PAYOUT"] = "PAYOUT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["RECEIVE"] = "RECEIVE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["REDEEM"] = "REDEEM";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["REMOVE"] = "REMOVE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["RESTORE"] = "RESTORE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["REVERSE"] = "REVERSE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["SELL"] = "SELL";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["SEND"] = "SEND";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["TERMINATE"] = "TERMINATE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["UNFREEZE"] = "UNFREEZE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["UNLINK"] = "UNLINK";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["WITHDRAW"] = "WITHDRAW";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["WITHDRAW_REVERSE"] = "WITHDRAW_REVERSE";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["WITHDRAW_RETURN"] = "WITHDRAW_RETURN";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["WITHDRAW_RETURNED"] = "WITHDRAW_RETURNED";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["PARTNER_REWARD_CRYPTO"] = "PARTNER_REWARD_CRYPTO";
    ApiTransactionDetailsRequestAssetActivityTypeEnum["PARTNER_REWARD_CASH"] = "PARTNER_REWARD_CASH";
})(ApiTransactionDetailsRequestAssetActivityTypeEnum = exports.ApiTransactionDetailsRequestAssetActivityTypeEnum || (exports.ApiTransactionDetailsRequestAssetActivityTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTransactionTicketDetailsDisputeStatusEnum;
(function (ApiTransactionTicketDetailsDisputeStatusEnum) {
    ApiTransactionTicketDetailsDisputeStatusEnum["NEW"] = "NEW";
    ApiTransactionTicketDetailsDisputeStatusEnum["ESCALATED"] = "ESCALATED";
    ApiTransactionTicketDetailsDisputeStatusEnum["REJECTED"] = "REJECTED";
    ApiTransactionTicketDetailsDisputeStatusEnum["MERCHANT_REJECTED"] = "MERCHANT_REJECTED";
    ApiTransactionTicketDetailsDisputeStatusEnum["ACCEPTED"] = "ACCEPTED";
    ApiTransactionTicketDetailsDisputeStatusEnum["CANCELLED"] = "CANCELLED";
})(ApiTransactionTicketDetailsDisputeStatusEnum = exports.ApiTransactionTicketDetailsDisputeStatusEnum || (exports.ApiTransactionTicketDetailsDisputeStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiTransactionTicketDetailsRegulationEFlagEnum;
(function (ApiTransactionTicketDetailsRegulationEFlagEnum) {
    ApiTransactionTicketDetailsRegulationEFlagEnum["YES"] = "YES";
    ApiTransactionTicketDetailsRegulationEFlagEnum["NO"] = "NO";
    ApiTransactionTicketDetailsRegulationEFlagEnum["NO_DISPOSITION"] = "NO_DISPOSITION";
})(ApiTransactionTicketDetailsRegulationEFlagEnum = exports.ApiTransactionTicketDetailsRegulationEFlagEnum || (exports.ApiTransactionTicketDetailsRegulationEFlagEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUnit21BatchActivityDataSourceTypeEnum;
(function (ApiUnit21BatchActivityDataSourceTypeEnum) {
    ApiUnit21BatchActivityDataSourceTypeEnum["ACCOUNT"] = "ACCOUNT";
    ApiUnit21BatchActivityDataSourceTypeEnum["ACH_TRANSACTION"] = "ACH_TRANSACTION";
    ApiUnit21BatchActivityDataSourceTypeEnum["BAKKT_CASH_REDEEM"] = "BAKKT_CASH_REDEEM";
    ApiUnit21BatchActivityDataSourceTypeEnum["BTC_TRANSACTION"] = "BTC_TRANSACTION";
    ApiUnit21BatchActivityDataSourceTypeEnum["GC_PURCHASE"] = "GC_PURCHASE";
    ApiUnit21BatchActivityDataSourceTypeEnum["MERCHANT_TRANSACTION"] = "MERCHANT_TRANSACTION";
    ApiUnit21BatchActivityDataSourceTypeEnum["MERCHANT_PAYMENT_TRANSACTION"] = "MERCHANT_PAYMENT_TRANSACTION";
    ApiUnit21BatchActivityDataSourceTypeEnum["MERCHANT_PAYMENT_CHILD_TRANSACTION"] = "MERCHANT_PAYMENT_CHILD_TRANSACTION";
    ApiUnit21BatchActivityDataSourceTypeEnum["P2P_BTC"] = "P2P_BTC";
    ApiUnit21BatchActivityDataSourceTypeEnum["P2P_CASH"] = "P2P_CASH";
    ApiUnit21BatchActivityDataSourceTypeEnum["P2P_GIFT_CARD"] = "P2P_GIFT_CARD";
    ApiUnit21BatchActivityDataSourceTypeEnum["PARTY"] = "PARTY";
    ApiUnit21BatchActivityDataSourceTypeEnum["PLAID_ACCOUNT"] = "PLAID_ACCOUNT";
    ApiUnit21BatchActivityDataSourceTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiUnit21BatchActivityDataSourceTypeEnum["UNLINK_PLAID_ACCOUNT"] = "UNLINK_PLAID_ACCOUNT";
    ApiUnit21BatchActivityDataSourceTypeEnum["CARD_LINK"] = "CARD_LINK";
    ApiUnit21BatchActivityDataSourceTypeEnum["DEBIT_CARD_LINK"] = "DEBIT_CARD_LINK";
    ApiUnit21BatchActivityDataSourceTypeEnum["MERCHANT_PAYMENT_TOKEN_LINK"] = "MERCHANT_PAYMENT_TOKEN_LINK";
    ApiUnit21BatchActivityDataSourceTypeEnum["PARTNER_PARTY_LINK"] = "PARTNER_PARTY_LINK";
    ApiUnit21BatchActivityDataSourceTypeEnum["DEBIT_CARD_TRANSACTION"] = "DEBIT_CARD_TRANSACTION";
    ApiUnit21BatchActivityDataSourceTypeEnum["SEGMENT_IDENTITY_UPLOAD"] = "SEGMENT_IDENTITY_UPLOAD";
})(ApiUnit21BatchActivityDataSourceTypeEnum = exports.ApiUnit21BatchActivityDataSourceTypeEnum || (exports.ApiUnit21BatchActivityDataSourceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUnit21ControlDataSourceTypeEnum;
(function (ApiUnit21ControlDataSourceTypeEnum) {
    ApiUnit21ControlDataSourceTypeEnum["ACCOUNT"] = "ACCOUNT";
    ApiUnit21ControlDataSourceTypeEnum["ACH_TRANSACTION"] = "ACH_TRANSACTION";
    ApiUnit21ControlDataSourceTypeEnum["BAKKT_CASH_REDEEM"] = "BAKKT_CASH_REDEEM";
    ApiUnit21ControlDataSourceTypeEnum["BTC_TRANSACTION"] = "BTC_TRANSACTION";
    ApiUnit21ControlDataSourceTypeEnum["GC_PURCHASE"] = "GC_PURCHASE";
    ApiUnit21ControlDataSourceTypeEnum["MERCHANT_TRANSACTION"] = "MERCHANT_TRANSACTION";
    ApiUnit21ControlDataSourceTypeEnum["MERCHANT_PAYMENT_TRANSACTION"] = "MERCHANT_PAYMENT_TRANSACTION";
    ApiUnit21ControlDataSourceTypeEnum["MERCHANT_PAYMENT_CHILD_TRANSACTION"] = "MERCHANT_PAYMENT_CHILD_TRANSACTION";
    ApiUnit21ControlDataSourceTypeEnum["P2P_BTC"] = "P2P_BTC";
    ApiUnit21ControlDataSourceTypeEnum["P2P_CASH"] = "P2P_CASH";
    ApiUnit21ControlDataSourceTypeEnum["P2P_GIFT_CARD"] = "P2P_GIFT_CARD";
    ApiUnit21ControlDataSourceTypeEnum["PARTY"] = "PARTY";
    ApiUnit21ControlDataSourceTypeEnum["PLAID_ACCOUNT"] = "PLAID_ACCOUNT";
    ApiUnit21ControlDataSourceTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    ApiUnit21ControlDataSourceTypeEnum["UNLINK_PLAID_ACCOUNT"] = "UNLINK_PLAID_ACCOUNT";
    ApiUnit21ControlDataSourceTypeEnum["CARD_LINK"] = "CARD_LINK";
    ApiUnit21ControlDataSourceTypeEnum["DEBIT_CARD_LINK"] = "DEBIT_CARD_LINK";
    ApiUnit21ControlDataSourceTypeEnum["MERCHANT_PAYMENT_TOKEN_LINK"] = "MERCHANT_PAYMENT_TOKEN_LINK";
    ApiUnit21ControlDataSourceTypeEnum["PARTNER_PARTY_LINK"] = "PARTNER_PARTY_LINK";
    ApiUnit21ControlDataSourceTypeEnum["DEBIT_CARD_TRANSACTION"] = "DEBIT_CARD_TRANSACTION";
    ApiUnit21ControlDataSourceTypeEnum["SEGMENT_IDENTITY_UPLOAD"] = "SEGMENT_IDENTITY_UPLOAD";
})(ApiUnit21ControlDataSourceTypeEnum = exports.ApiUnit21ControlDataSourceTypeEnum || (exports.ApiUnit21ControlDataSourceTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUnit21DownloadControlDataSinkTypeEnum;
(function (ApiUnit21DownloadControlDataSinkTypeEnum) {
    ApiUnit21DownloadControlDataSinkTypeEnum["INSTRUMENT"] = "INSTRUMENT";
})(ApiUnit21DownloadControlDataSinkTypeEnum = exports.ApiUnit21DownloadControlDataSinkTypeEnum || (exports.ApiUnit21DownloadControlDataSinkTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUpdateGiftCardProductStatusEnum;
(function (ApiUpdateGiftCardProductStatusEnum) {
    ApiUpdateGiftCardProductStatusEnum["DRAFT"] = "DRAFT";
    ApiUpdateGiftCardProductStatusEnum["ACTIVATED"] = "ACTIVATED";
    ApiUpdateGiftCardProductStatusEnum["SUSPENDED"] = "SUSPENDED";
})(ApiUpdateGiftCardProductStatusEnum = exports.ApiUpdateGiftCardProductStatusEnum || (exports.ApiUpdateGiftCardProductStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUpdatePartnerRequestCryptoCurrenciesEnum;
(function (ApiUpdatePartnerRequestCryptoCurrenciesEnum) {
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["AAVE"] = "AAVE";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["AVAX"] = "AVAX";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["AXS"] = "AXS";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["BAT"] = "BAT";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["BTC"] = "BTC";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["DOGE"] = "DOGE";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["ETH"] = "ETH";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["LINK"] = "LINK";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["LTC"] = "LTC";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["MANA"] = "MANA";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["MATIC"] = "MATIC";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["SOL"] = "SOL";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["UNI"] = "UNI";
    ApiUpdatePartnerRequestCryptoCurrenciesEnum["USDC"] = "USDC";
})(ApiUpdatePartnerRequestCryptoCurrenciesEnum = exports.ApiUpdatePartnerRequestCryptoCurrenciesEnum || (exports.ApiUpdatePartnerRequestCryptoCurrenciesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUpdatePartnerRequestPrimaryCurrencyEnum;
(function (ApiUpdatePartnerRequestPrimaryCurrencyEnum) {
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["USD"] = "USD";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["AAVE"] = "AAVE";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["AVAX"] = "AVAX";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["AXS"] = "AXS";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["BAT"] = "BAT";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["BCH"] = "BCH";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["BTC"] = "BTC";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["DOGE"] = "DOGE";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["ETH"] = "ETH";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["LINK"] = "LINK";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["LTC"] = "LTC";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["MANA"] = "MANA";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["MATIC"] = "MATIC";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["SOL"] = "SOL";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["UNI"] = "UNI";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["USDC"] = "USDC";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["LXX"] = "LXX";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["LCP"] = "LCP";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["LWR"] = "LWR";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["LMO"] = "LMO";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["LKO"] = "LKO";
    ApiUpdatePartnerRequestPrimaryCurrencyEnum["LED"] = "LED";
})(ApiUpdatePartnerRequestPrimaryCurrencyEnum = exports.ApiUpdatePartnerRequestPrimaryCurrencyEnum || (exports.ApiUpdatePartnerRequestPrimaryCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUpdatePartnerRequestServiceTypesEnum;
(function (ApiUpdatePartnerRequestServiceTypesEnum) {
    ApiUpdatePartnerRequestServiceTypesEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    ApiUpdatePartnerRequestServiceTypesEnum["REWARD"] = "REWARD";
    ApiUpdatePartnerRequestServiceTypesEnum["PARTY"] = "PARTY";
    ApiUpdatePartnerRequestServiceTypesEnum["PAYOUT"] = "PAYOUT";
})(ApiUpdatePartnerRequestServiceTypesEnum = exports.ApiUpdatePartnerRequestServiceTypesEnum || (exports.ApiUpdatePartnerRequestServiceTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUpdatePartnerRequestStatusEnum;
(function (ApiUpdatePartnerRequestStatusEnum) {
    ApiUpdatePartnerRequestStatusEnum["ACTIVE"] = "ACTIVE";
    ApiUpdatePartnerRequestStatusEnum["SUSPENDED"] = "SUSPENDED";
    ApiUpdatePartnerRequestStatusEnum["CLOSED"] = "CLOSED";
})(ApiUpdatePartnerRequestStatusEnum = exports.ApiUpdatePartnerRequestStatusEnum || (exports.ApiUpdatePartnerRequestStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUpdateRoleAddPermissionsEnum;
(function (ApiUpdateRoleAddPermissionsEnum) {
    ApiUpdateRoleAddPermissionsEnum["ALLOWLIST_CREATE"] = "ALLOWLIST_CREATE";
    ApiUpdateRoleAddPermissionsEnum["ALLOWLIST_DELETE"] = "ALLOWLIST_DELETE";
    ApiUpdateRoleAddPermissionsEnum["ALLOWLIST_UPDATE"] = "ALLOWLIST_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["ALLOWLIST_VIEW"] = "ALLOWLIST_VIEW";
    ApiUpdateRoleAddPermissionsEnum["DISPUTE_DELETE_REASON"] = "DISPUTE_DELETE_REASON";
    ApiUpdateRoleAddPermissionsEnum["DISPUTE_EXPORT_CSV"] = "DISPUTE_EXPORT_CSV";
    ApiUpdateRoleAddPermissionsEnum["DISPUTE_UPDATE_ACCEPT"] = "DISPUTE_UPDATE_ACCEPT";
    ApiUpdateRoleAddPermissionsEnum["DISPUTE_UPDATE_AUTO_APPROVE"] = "DISPUTE_UPDATE_AUTO_APPROVE";
    ApiUpdateRoleAddPermissionsEnum["DISPUTE_UPDATE_CREDIT_REJECT"] = "DISPUTE_UPDATE_CREDIT_REJECT";
    ApiUpdateRoleAddPermissionsEnum["DISPUTE_UPDATE_PROVISIONAL"] = "DISPUTE_UPDATE_PROVISIONAL";
    ApiUpdateRoleAddPermissionsEnum["DISPUTE_CREATE"] = "DISPUTE_CREATE";
    ApiUpdateRoleAddPermissionsEnum["DISPUTE_VIEW"] = "DISPUTE_VIEW";
    ApiUpdateRoleAddPermissionsEnum["DEVICE_SESSION_VIEW"] = "DEVICE_SESSION_VIEW";
    ApiUpdateRoleAddPermissionsEnum["FINANCE_VIEW"] = "FINANCE_VIEW";
    ApiUpdateRoleAddPermissionsEnum["GIFTCARD_UPDATE_REACTIVATE"] = "GIFTCARD_UPDATE_REACTIVATE";
    ApiUpdateRoleAddPermissionsEnum["GIFTCARD_BRAND_UPDATE"] = "GIFTCARD_BRAND_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["GIFTCARD_BRAND_VIEW_ACTIVITY"] = "GIFTCARD_BRAND_VIEW_ACTIVITY";
    ApiUpdateRoleAddPermissionsEnum["GIFTCARD_VIEW"] = "GIFTCARD_VIEW";
    ApiUpdateRoleAddPermissionsEnum["GIFTCARD_VIEW_BALANCE"] = "GIFTCARD_VIEW_BALANCE";
    ApiUpdateRoleAddPermissionsEnum["GIFTCARD_VIEW_ACTIVITY"] = "GIFTCARD_VIEW_ACTIVITY";
    ApiUpdateRoleAddPermissionsEnum["KYC_ACTIVITY_VIEW"] = "KYC_ACTIVITY_VIEW";
    ApiUpdateRoleAddPermissionsEnum["OFAC_CREATE"] = "OFAC_CREATE";
    ApiUpdateRoleAddPermissionsEnum["OFAC_DELETE"] = "OFAC_DELETE";
    ApiUpdateRoleAddPermissionsEnum["OFAC_UPDATE"] = "OFAC_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["OFAC_VIEW"] = "OFAC_VIEW";
    ApiUpdateRoleAddPermissionsEnum["PARTY_VIEW"] = "PARTY_VIEW";
    ApiUpdateRoleAddPermissionsEnum["PORTAL_VIEW"] = "PORTAL_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_CREATE"] = "REPORT_CREATE";
    ApiUpdateRoleAddPermissionsEnum["TICKET_CREATE"] = "TICKET_CREATE";
    ApiUpdateRoleAddPermissionsEnum["TICKET_UPDATE_ASSIGN"] = "TICKET_UPDATE_ASSIGN";
    ApiUpdateRoleAddPermissionsEnum["TICKET_UPDATE_CANCEL"] = "TICKET_UPDATE_CANCEL";
    ApiUpdateRoleAddPermissionsEnum["TICKET_UPDATE_ESCALATE"] = "TICKET_UPDATE_ESCALATE";
    ApiUpdateRoleAddPermissionsEnum["TICKET_UPDATE_COMMENT"] = "TICKET_UPDATE_COMMENT";
    ApiUpdateRoleAddPermissionsEnum["TICKET_VIEW"] = "TICKET_VIEW";
    ApiUpdateRoleAddPermissionsEnum["TRANSACTIONS_VIEW"] = "TRANSACTIONS_VIEW";
    ApiUpdateRoleAddPermissionsEnum["USERS_CREATE"] = "USERS_CREATE";
    ApiUpdateRoleAddPermissionsEnum["USERS_UPDATE"] = "USERS_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["USERS_UPDATE_SYNC"] = "USERS_UPDATE_SYNC";
    ApiUpdateRoleAddPermissionsEnum["USERS_VIEW"] = "USERS_VIEW";
    ApiUpdateRoleAddPermissionsEnum["USERS_VIEW_DETAIL"] = "USERS_VIEW_DETAIL";
    ApiUpdateRoleAddPermissionsEnum["ACCOUNT_PREFUND_BLOCK"] = "ACCOUNT_PREFUND_BLOCK";
    ApiUpdateRoleAddPermissionsEnum["PARTY_SUSPEND"] = "PARTY_SUSPEND";
    ApiUpdateRoleAddPermissionsEnum["PARTY_UNSUSPEND"] = "PARTY_UNSUSPEND";
    ApiUpdateRoleAddPermissionsEnum["ACCOUNT_PREFUND_UNBLOCK"] = "ACCOUNT_PREFUND_UNBLOCK";
    ApiUpdateRoleAddPermissionsEnum["ACCOUNT_ACTIVITY_VIEW"] = "ACCOUNT_ACTIVITY_VIEW";
    ApiUpdateRoleAddPermissionsEnum["BAKKT_CARD_VIEW"] = "BAKKT_CARD_VIEW";
    ApiUpdateRoleAddPermissionsEnum["BAKKT_CARD_UPDATE"] = "BAKKT_CARD_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["PARTY_CREDIT_ADD"] = "PARTY_CREDIT_ADD";
    ApiUpdateRoleAddPermissionsEnum["PARTY_PII_VIEW"] = "PARTY_PII_VIEW";
    ApiUpdateRoleAddPermissionsEnum["KYC_UPDATE"] = "KYC_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["CARD_ISSUER_KYC_UPDATE"] = "CARD_ISSUER_KYC_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["BANKACCOUNT_BLACKLIST_VIEW"] = "BANKACCOUNT_BLACKLIST_VIEW";
    ApiUpdateRoleAddPermissionsEnum["BANKACCOUNT_BLACKLIST_UPDATE"] = "BANKACCOUNT_BLACKLIST_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["PARTY_WHITELIST_UPDATE"] = "PARTY_WHITELIST_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["INCENTIVE_OFFER_VIEW"] = "INCENTIVE_OFFER_VIEW";
    ApiUpdateRoleAddPermissionsEnum["LOYALTY_REDEEM_CANCEL"] = "LOYALTY_REDEEM_CANCEL";
    ApiUpdateRoleAddPermissionsEnum["LOYALTY_ACCOUNT_VIEW"] = "LOYALTY_ACCOUNT_VIEW";
    ApiUpdateRoleAddPermissionsEnum["LOYALTY_ACCOUNT_UPDATE"] = "LOYALTY_ACCOUNT_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["INCENTIVE_OFFER_CREATE"] = "INCENTIVE_OFFER_CREATE";
    ApiUpdateRoleAddPermissionsEnum["ACTIVITY_AUDIT_VIEW"] = "ACTIVITY_AUDIT_VIEW";
    ApiUpdateRoleAddPermissionsEnum["DEBIT_CARD_VIEW"] = "DEBIT_CARD_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_ASSET_ACTIVTY_VIEW"] = "REPORT_ASSET_ACTIVTY_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_PREFUNDING_VIEW"] = "REPORT_PREFUNDING_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_VIRTUAL_CURRENCY_VIEW"] = "REPORT_VIRTUAL_CURRENCY_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_MTL_VIEW"] = "REPORT_MTL_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_SIFT_VIEW"] = "REPORT_SIFT_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_DISPUTE_CREDIT_VIEW"] = "REPORT_DISPUTE_CREDIT_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_GIFT_CARD_RECON_VIEW"] = "REPORT_GIFT_CARD_RECON_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_ACCOUNT_BALANCE_SUMMARY_VIEW"] = "REPORT_ACCOUNT_BALANCE_SUMMARY_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_ACH_PROCESSING_VIEW"] = "REPORT_ACH_PROCESSING_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_SUSPEND_ACCOUNT_VIEW"] = "REPORT_SUSPEND_ACCOUNT_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_P2P_TRANSFER_VIEW"] = "REPORT_P2P_TRANSFER_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_ASSET_ACTIVTY_CREATE"] = "REPORT_ASSET_ACTIVTY_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_PREFUNDING_CREATE"] = "REPORT_PREFUNDING_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_VIRTUAL_CURRENCY_CREATE"] = "REPORT_VIRTUAL_CURRENCY_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_MTL_CREATE"] = "REPORT_MTL_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_SIFT_CREATE"] = "REPORT_SIFT_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_DISPUTE_CREDIT_CREATE"] = "REPORT_DISPUTE_CREDIT_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_GIFT_CARD_RECON_CREATE"] = "REPORT_GIFT_CARD_RECON_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_ACCOUNT_BALANCE_SUMMARY_CREATE"] = "REPORT_ACCOUNT_BALANCE_SUMMARY_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_ACH_PROCESSING_CREATE"] = "REPORT_ACH_PROCESSING_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_SUSPEND_ACCOUNT_CREATE"] = "REPORT_SUSPEND_ACCOUNT_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_P2P_TRANSFERS_CREATE"] = "REPORT_P2P_TRANSFERS_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_QUIZNOS_VIEW"] = "REPORT_QUIZNOS_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_QUIZNOS_CREATE"] = "REPORT_QUIZNOS_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_CHOICE_VIEW"] = "REPORT_CHOICE_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_CHOICE_CREATE"] = "REPORT_CHOICE_CREATE";
    ApiUpdateRoleAddPermissionsEnum["RISK_AUDIT_VIEW"] = "RISK_AUDIT_VIEW";
    ApiUpdateRoleAddPermissionsEnum["RISK_AUDIT_VIEW_DETAIL"] = "RISK_AUDIT_VIEW_DETAIL";
    ApiUpdateRoleAddPermissionsEnum["REPORT_ACCOUNT_BALANCE_V2_VIEW"] = "REPORT_ACCOUNT_BALANCE_V2_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_ACCOUNT_BALANCE_V2_CREATE"] = "REPORT_ACCOUNT_BALANCE_V2_CREATE";
    ApiUpdateRoleAddPermissionsEnum["PLAID_ACCOUNT_DETAIL_VIEW"] = "PLAID_ACCOUNT_DETAIL_VIEW";
    ApiUpdateRoleAddPermissionsEnum["UNMASK_PLAID_ACCOUNT_NUMBERS"] = "UNMASK_PLAID_ACCOUNT_NUMBERS";
    ApiUpdateRoleAddPermissionsEnum["UNMASK_DEBIT_CARD_FIELDS"] = "UNMASK_DEBIT_CARD_FIELDS";
    ApiUpdateRoleAddPermissionsEnum["TRANSACTION_ACCOUNT_LINK_FAILURES_VIEW"] = "TRANSACTION_ACCOUNT_LINK_FAILURES_VIEW";
    ApiUpdateRoleAddPermissionsEnum["REPORT_BTC_TRANSACTION_REPORT_CREATE"] = "REPORT_BTC_TRANSACTION_REPORT_CREATE";
    ApiUpdateRoleAddPermissionsEnum["REPORT_CRYPTO_TRANSACTION_REPORT_CREATE"] = "REPORT_CRYPTO_TRANSACTION_REPORT_CREATE";
    ApiUpdateRoleAddPermissionsEnum["PARTNER_DETAIL_VIEW"] = "PARTNER_DETAIL_VIEW";
    ApiUpdateRoleAddPermissionsEnum["PARTNER_LINK_UNLINK"] = "PARTNER_LINK_UNLINK";
    ApiUpdateRoleAddPermissionsEnum["PARTY_NAME_UPDATE"] = "PARTY_NAME_UPDATE";
    ApiUpdateRoleAddPermissionsEnum["PARTY_LIQUIDATE"] = "PARTY_LIQUIDATE";
    ApiUpdateRoleAddPermissionsEnum["PARTY_STATUS_UPDATE"] = "PARTY_STATUS_UPDATE";
})(ApiUpdateRoleAddPermissionsEnum = exports.ApiUpdateRoleAddPermissionsEnum || (exports.ApiUpdateRoleAddPermissionsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiUpdateRoleRemovePermissionsEnum;
(function (ApiUpdateRoleRemovePermissionsEnum) {
    ApiUpdateRoleRemovePermissionsEnum["ALLOWLIST_CREATE"] = "ALLOWLIST_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["ALLOWLIST_DELETE"] = "ALLOWLIST_DELETE";
    ApiUpdateRoleRemovePermissionsEnum["ALLOWLIST_UPDATE"] = "ALLOWLIST_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["ALLOWLIST_VIEW"] = "ALLOWLIST_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["DISPUTE_DELETE_REASON"] = "DISPUTE_DELETE_REASON";
    ApiUpdateRoleRemovePermissionsEnum["DISPUTE_EXPORT_CSV"] = "DISPUTE_EXPORT_CSV";
    ApiUpdateRoleRemovePermissionsEnum["DISPUTE_UPDATE_ACCEPT"] = "DISPUTE_UPDATE_ACCEPT";
    ApiUpdateRoleRemovePermissionsEnum["DISPUTE_UPDATE_AUTO_APPROVE"] = "DISPUTE_UPDATE_AUTO_APPROVE";
    ApiUpdateRoleRemovePermissionsEnum["DISPUTE_UPDATE_CREDIT_REJECT"] = "DISPUTE_UPDATE_CREDIT_REJECT";
    ApiUpdateRoleRemovePermissionsEnum["DISPUTE_UPDATE_PROVISIONAL"] = "DISPUTE_UPDATE_PROVISIONAL";
    ApiUpdateRoleRemovePermissionsEnum["DISPUTE_CREATE"] = "DISPUTE_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["DISPUTE_VIEW"] = "DISPUTE_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["DEVICE_SESSION_VIEW"] = "DEVICE_SESSION_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["FINANCE_VIEW"] = "FINANCE_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["GIFTCARD_UPDATE_REACTIVATE"] = "GIFTCARD_UPDATE_REACTIVATE";
    ApiUpdateRoleRemovePermissionsEnum["GIFTCARD_BRAND_UPDATE"] = "GIFTCARD_BRAND_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["GIFTCARD_BRAND_VIEW_ACTIVITY"] = "GIFTCARD_BRAND_VIEW_ACTIVITY";
    ApiUpdateRoleRemovePermissionsEnum["GIFTCARD_VIEW"] = "GIFTCARD_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["GIFTCARD_VIEW_BALANCE"] = "GIFTCARD_VIEW_BALANCE";
    ApiUpdateRoleRemovePermissionsEnum["GIFTCARD_VIEW_ACTIVITY"] = "GIFTCARD_VIEW_ACTIVITY";
    ApiUpdateRoleRemovePermissionsEnum["KYC_ACTIVITY_VIEW"] = "KYC_ACTIVITY_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["OFAC_CREATE"] = "OFAC_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["OFAC_DELETE"] = "OFAC_DELETE";
    ApiUpdateRoleRemovePermissionsEnum["OFAC_UPDATE"] = "OFAC_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["OFAC_VIEW"] = "OFAC_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["PARTY_VIEW"] = "PARTY_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["PORTAL_VIEW"] = "PORTAL_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_CREATE"] = "REPORT_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["TICKET_CREATE"] = "TICKET_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["TICKET_UPDATE_ASSIGN"] = "TICKET_UPDATE_ASSIGN";
    ApiUpdateRoleRemovePermissionsEnum["TICKET_UPDATE_CANCEL"] = "TICKET_UPDATE_CANCEL";
    ApiUpdateRoleRemovePermissionsEnum["TICKET_UPDATE_ESCALATE"] = "TICKET_UPDATE_ESCALATE";
    ApiUpdateRoleRemovePermissionsEnum["TICKET_UPDATE_COMMENT"] = "TICKET_UPDATE_COMMENT";
    ApiUpdateRoleRemovePermissionsEnum["TICKET_VIEW"] = "TICKET_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["TRANSACTIONS_VIEW"] = "TRANSACTIONS_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["USERS_CREATE"] = "USERS_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["USERS_UPDATE"] = "USERS_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["USERS_UPDATE_SYNC"] = "USERS_UPDATE_SYNC";
    ApiUpdateRoleRemovePermissionsEnum["USERS_VIEW"] = "USERS_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["USERS_VIEW_DETAIL"] = "USERS_VIEW_DETAIL";
    ApiUpdateRoleRemovePermissionsEnum["ACCOUNT_PREFUND_BLOCK"] = "ACCOUNT_PREFUND_BLOCK";
    ApiUpdateRoleRemovePermissionsEnum["PARTY_SUSPEND"] = "PARTY_SUSPEND";
    ApiUpdateRoleRemovePermissionsEnum["PARTY_UNSUSPEND"] = "PARTY_UNSUSPEND";
    ApiUpdateRoleRemovePermissionsEnum["ACCOUNT_PREFUND_UNBLOCK"] = "ACCOUNT_PREFUND_UNBLOCK";
    ApiUpdateRoleRemovePermissionsEnum["ACCOUNT_ACTIVITY_VIEW"] = "ACCOUNT_ACTIVITY_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["BAKKT_CARD_VIEW"] = "BAKKT_CARD_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["BAKKT_CARD_UPDATE"] = "BAKKT_CARD_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["PARTY_CREDIT_ADD"] = "PARTY_CREDIT_ADD";
    ApiUpdateRoleRemovePermissionsEnum["PARTY_PII_VIEW"] = "PARTY_PII_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["KYC_UPDATE"] = "KYC_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["CARD_ISSUER_KYC_UPDATE"] = "CARD_ISSUER_KYC_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["BANKACCOUNT_BLACKLIST_VIEW"] = "BANKACCOUNT_BLACKLIST_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["BANKACCOUNT_BLACKLIST_UPDATE"] = "BANKACCOUNT_BLACKLIST_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["PARTY_WHITELIST_UPDATE"] = "PARTY_WHITELIST_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["INCENTIVE_OFFER_VIEW"] = "INCENTIVE_OFFER_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["LOYALTY_REDEEM_CANCEL"] = "LOYALTY_REDEEM_CANCEL";
    ApiUpdateRoleRemovePermissionsEnum["LOYALTY_ACCOUNT_VIEW"] = "LOYALTY_ACCOUNT_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["LOYALTY_ACCOUNT_UPDATE"] = "LOYALTY_ACCOUNT_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["INCENTIVE_OFFER_CREATE"] = "INCENTIVE_OFFER_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["ACTIVITY_AUDIT_VIEW"] = "ACTIVITY_AUDIT_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["DEBIT_CARD_VIEW"] = "DEBIT_CARD_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_ASSET_ACTIVTY_VIEW"] = "REPORT_ASSET_ACTIVTY_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_PREFUNDING_VIEW"] = "REPORT_PREFUNDING_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_VIRTUAL_CURRENCY_VIEW"] = "REPORT_VIRTUAL_CURRENCY_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_MTL_VIEW"] = "REPORT_MTL_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_SIFT_VIEW"] = "REPORT_SIFT_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_DISPUTE_CREDIT_VIEW"] = "REPORT_DISPUTE_CREDIT_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_GIFT_CARD_RECON_VIEW"] = "REPORT_GIFT_CARD_RECON_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_ACCOUNT_BALANCE_SUMMARY_VIEW"] = "REPORT_ACCOUNT_BALANCE_SUMMARY_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_ACH_PROCESSING_VIEW"] = "REPORT_ACH_PROCESSING_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_SUSPEND_ACCOUNT_VIEW"] = "REPORT_SUSPEND_ACCOUNT_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_P2P_TRANSFER_VIEW"] = "REPORT_P2P_TRANSFER_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_ASSET_ACTIVTY_CREATE"] = "REPORT_ASSET_ACTIVTY_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_PREFUNDING_CREATE"] = "REPORT_PREFUNDING_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_VIRTUAL_CURRENCY_CREATE"] = "REPORT_VIRTUAL_CURRENCY_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_MTL_CREATE"] = "REPORT_MTL_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_SIFT_CREATE"] = "REPORT_SIFT_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_DISPUTE_CREDIT_CREATE"] = "REPORT_DISPUTE_CREDIT_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_GIFT_CARD_RECON_CREATE"] = "REPORT_GIFT_CARD_RECON_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_ACCOUNT_BALANCE_SUMMARY_CREATE"] = "REPORT_ACCOUNT_BALANCE_SUMMARY_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_ACH_PROCESSING_CREATE"] = "REPORT_ACH_PROCESSING_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_SUSPEND_ACCOUNT_CREATE"] = "REPORT_SUSPEND_ACCOUNT_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_P2P_TRANSFERS_CREATE"] = "REPORT_P2P_TRANSFERS_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_QUIZNOS_VIEW"] = "REPORT_QUIZNOS_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_QUIZNOS_CREATE"] = "REPORT_QUIZNOS_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_CHOICE_VIEW"] = "REPORT_CHOICE_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_CHOICE_CREATE"] = "REPORT_CHOICE_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["RISK_AUDIT_VIEW"] = "RISK_AUDIT_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["RISK_AUDIT_VIEW_DETAIL"] = "RISK_AUDIT_VIEW_DETAIL";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_ACCOUNT_BALANCE_V2_VIEW"] = "REPORT_ACCOUNT_BALANCE_V2_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_ACCOUNT_BALANCE_V2_CREATE"] = "REPORT_ACCOUNT_BALANCE_V2_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["PLAID_ACCOUNT_DETAIL_VIEW"] = "PLAID_ACCOUNT_DETAIL_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["UNMASK_PLAID_ACCOUNT_NUMBERS"] = "UNMASK_PLAID_ACCOUNT_NUMBERS";
    ApiUpdateRoleRemovePermissionsEnum["UNMASK_DEBIT_CARD_FIELDS"] = "UNMASK_DEBIT_CARD_FIELDS";
    ApiUpdateRoleRemovePermissionsEnum["TRANSACTION_ACCOUNT_LINK_FAILURES_VIEW"] = "TRANSACTION_ACCOUNT_LINK_FAILURES_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_BTC_TRANSACTION_REPORT_CREATE"] = "REPORT_BTC_TRANSACTION_REPORT_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["REPORT_CRYPTO_TRANSACTION_REPORT_CREATE"] = "REPORT_CRYPTO_TRANSACTION_REPORT_CREATE";
    ApiUpdateRoleRemovePermissionsEnum["PARTNER_DETAIL_VIEW"] = "PARTNER_DETAIL_VIEW";
    ApiUpdateRoleRemovePermissionsEnum["PARTNER_LINK_UNLINK"] = "PARTNER_LINK_UNLINK";
    ApiUpdateRoleRemovePermissionsEnum["PARTY_NAME_UPDATE"] = "PARTY_NAME_UPDATE";
    ApiUpdateRoleRemovePermissionsEnum["PARTY_LIQUIDATE"] = "PARTY_LIQUIDATE";
    ApiUpdateRoleRemovePermissionsEnum["PARTY_STATUS_UPDATE"] = "PARTY_STATUS_UPDATE";
})(ApiUpdateRoleRemovePermissionsEnum = exports.ApiUpdateRoleRemovePermissionsEnum || (exports.ApiUpdateRoleRemovePermissionsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ApiWhitelistPartyRequestReasonEnum;
(function (ApiWhitelistPartyRequestReasonEnum) {
    ApiWhitelistPartyRequestReasonEnum["ACCOUNT_CLOSURE_REQUESTED"] = "ACCOUNT_CLOSURE_REQUESTED";
    ApiWhitelistPartyRequestReasonEnum["ACH_MAX_RETURNS"] = "ACH_MAX_RETURNS";
    ApiWhitelistPartyRequestReasonEnum["ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_AND_TOTAL_AMOUNT_EXCEEDED";
    ApiWhitelistPartyRequestReasonEnum["ACH_RETURNS_COUNT_EXCEEDED"] = "ACH_RETURNS_COUNT_EXCEEDED";
    ApiWhitelistPartyRequestReasonEnum["ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED"] = "ACH_RETURNS_TOTAL_AMOUNT_EXCEEDED";
    ApiWhitelistPartyRequestReasonEnum["ACH_RETURN_CODE"] = "ACH_RETURN_CODE";
    ApiWhitelistPartyRequestReasonEnum["COMPLIANCE_INVESTIGATION"] = "COMPLIANCE_INVESTIGATION";
    ApiWhitelistPartyRequestReasonEnum["COMPLIANCE_LOCKED"] = "COMPLIANCE_LOCKED";
    ApiWhitelistPartyRequestReasonEnum["COMPLIANCE_VERIFICATION"] = "COMPLIANCE_VERIFICATION";
    ApiWhitelistPartyRequestReasonEnum["CUSTOMER_GOOD_STANDING"] = "CUSTOMER_GOOD_STANDING";
    ApiWhitelistPartyRequestReasonEnum["DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AMOUNT_VERIFICATION_COUNT_EXCEEDED";
    ApiWhitelistPartyRequestReasonEnum["DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_AVS_VERIFICATION_COUNT_EXCEEDED";
    ApiWhitelistPartyRequestReasonEnum["DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED"] = "DEBIT_CARD_CVV_VERIFICATION_COUNT_EXCEEDED";
    ApiWhitelistPartyRequestReasonEnum["DEBIT_CARD_TRANSACTION_FRAUD_HOLD"] = "DEBIT_CARD_TRANSACTION_FRAUD_HOLD";
    ApiWhitelistPartyRequestReasonEnum["LIQUIDATE_ACCOUNT"] = "LIQUIDATE_ACCOUNT";
    ApiWhitelistPartyRequestReasonEnum["MARQETA_KYC_VERIFICATION"] = "MARQETA_KYC_VERIFICATION";
    ApiWhitelistPartyRequestReasonEnum["NSF_BLOCKING"] = "NSF_BLOCKING";
    ApiWhitelistPartyRequestReasonEnum["OLD_OFAC_CHECK"] = "OLD_OFAC_CHECK";
    ApiWhitelistPartyRequestReasonEnum["OTHER"] = "OTHER";
    ApiWhitelistPartyRequestReasonEnum["PLAID_IDENTITY_CHECK"] = "PLAID_IDENTITY_CHECK";
    ApiWhitelistPartyRequestReasonEnum["PLAID_MISSING_NAMES"] = "PLAID_MISSING_NAMES";
    ApiWhitelistPartyRequestReasonEnum["RELINK"] = "RELINK";
    ApiWhitelistPartyRequestReasonEnum["RISK_DECISION"] = "RISK_DECISION";
    ApiWhitelistPartyRequestReasonEnum["RISK_KYC"] = "RISK_KYC";
    ApiWhitelistPartyRequestReasonEnum["RISK_SCREENING"] = "RISK_SCREENING";
    ApiWhitelistPartyRequestReasonEnum["TAX_ID_MAX_RETRIES"] = "TAX_ID_MAX_RETRIES";
    ApiWhitelistPartyRequestReasonEnum["CARD_TERMINATION_ERROR"] = "CARD_TERMINATION_ERROR";
    ApiWhitelistPartyRequestReasonEnum["CLOSED"] = "CLOSED";
})(ApiWhitelistPartyRequestReasonEnum = exports.ApiWhitelistPartyRequestReasonEnum || (exports.ApiWhitelistPartyRequestReasonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySearchRequestAssetActivityStatusEnum;
(function (AssetActivitySearchRequestAssetActivityStatusEnum) {
    AssetActivitySearchRequestAssetActivityStatusEnum["CANCELED"] = "CANCELED";
    AssetActivitySearchRequestAssetActivityStatusEnum["COMPLETE"] = "COMPLETE";
    AssetActivitySearchRequestAssetActivityStatusEnum["EXPIRED"] = "EXPIRED";
    AssetActivitySearchRequestAssetActivityStatusEnum["PENDING"] = "PENDING";
    AssetActivitySearchRequestAssetActivityStatusEnum["REJECTED"] = "REJECTED";
    AssetActivitySearchRequestAssetActivityStatusEnum["REPLACED"] = "REPLACED";
    AssetActivitySearchRequestAssetActivityStatusEnum["FAILED"] = "FAILED";
    AssetActivitySearchRequestAssetActivityStatusEnum["PROVISIONAL"] = "PROVISIONAL";
})(AssetActivitySearchRequestAssetActivityStatusEnum = exports.AssetActivitySearchRequestAssetActivityStatusEnum || (exports.AssetActivitySearchRequestAssetActivityStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySearchRequestAssetActivityTypesEnum;
(function (AssetActivitySearchRequestAssetActivityTypesEnum) {
    AssetActivitySearchRequestAssetActivityTypesEnum["ADD"] = "ADD";
    AssetActivitySearchRequestAssetActivityTypesEnum["BUY"] = "BUY";
    AssetActivitySearchRequestAssetActivityTypesEnum["CARD_CHARGEBACK"] = "CARD_CHARGEBACK";
    AssetActivitySearchRequestAssetActivityTypesEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    AssetActivitySearchRequestAssetActivityTypesEnum["CARD_REFUND"] = "CARD_REFUND";
    AssetActivitySearchRequestAssetActivityTypesEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    AssetActivitySearchRequestAssetActivityTypesEnum["CREDIT"] = "CREDIT";
    AssetActivitySearchRequestAssetActivityTypesEnum["CONVERT"] = "CONVERT";
    AssetActivitySearchRequestAssetActivityTypesEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    AssetActivitySearchRequestAssetActivityTypesEnum["DEPOSIT"] = "DEPOSIT";
    AssetActivitySearchRequestAssetActivityTypesEnum["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
    AssetActivitySearchRequestAssetActivityTypesEnum["DEPOSIT_RETURNED"] = "DEPOSIT_RETURNED";
    AssetActivitySearchRequestAssetActivityTypesEnum["DEPOSIT_REVERSE"] = "DEPOSIT_REVERSE";
    AssetActivitySearchRequestAssetActivityTypesEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    AssetActivitySearchRequestAssetActivityTypesEnum["DISPUTE_CREDIT_REVERSE"] = "DISPUTE_CREDIT_REVERSE";
    AssetActivitySearchRequestAssetActivityTypesEnum["FREEZE"] = "FREEZE";
    AssetActivitySearchRequestAssetActivityTypesEnum["INCENTIVE"] = "INCENTIVE";
    AssetActivitySearchRequestAssetActivityTypesEnum["INCENTIVE_CANCEL"] = "INCENTIVE_CANCEL";
    AssetActivitySearchRequestAssetActivityTypesEnum["LOYALTY_BUY"] = "LOYALTY_BUY";
    AssetActivitySearchRequestAssetActivityTypesEnum["LOYALTY_BUY_CANCEL"] = "LOYALTY_BUY_CANCEL";
    AssetActivitySearchRequestAssetActivityTypesEnum["LOYALTY_CREDIT_CANCEL"] = "LOYALTY_CREDIT_CANCEL";
    AssetActivitySearchRequestAssetActivityTypesEnum["LOYALTY_REDEEM"] = "LOYALTY_REDEEM";
    AssetActivitySearchRequestAssetActivityTypesEnum["LOYALTY_CRYPTO_REDEEM_FAILED"] = "LOYALTY_CRYPTO_REDEEM_FAILED";
    AssetActivitySearchRequestAssetActivityTypesEnum["LOYALTY_PAYMENT_REVERSAL"] = "LOYALTY_PAYMENT_REVERSAL";
    AssetActivitySearchRequestAssetActivityTypesEnum["LINK"] = "LINK";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_CREDIT"] = "MERCHANT_CREDIT";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_AUTHORIZE"] = "MERCHANT_PAYMENT_AUTHORIZE";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_AUTHORIZE_DECLINED"] = "MERCHANT_PAYMENT_AUTHORIZE_DECLINED";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_CANCEL"] = "MERCHANT_PAYMENT_CANCEL";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_CAPTURE"] = "MERCHANT_PAYMENT_CAPTURE";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_CREDIT"] = "MERCHANT_PAYMENT_CREDIT";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_REFUND"] = "MERCHANT_PAYMENT_REFUND";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_DISPUTE"] = "MERCHANT_PAYMENT_DISPUTE";
    AssetActivitySearchRequestAssetActivityTypesEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    AssetActivitySearchRequestAssetActivityTypesEnum["PAYOUT"] = "PAYOUT";
    AssetActivitySearchRequestAssetActivityTypesEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    AssetActivitySearchRequestAssetActivityTypesEnum["RECEIVE"] = "RECEIVE";
    AssetActivitySearchRequestAssetActivityTypesEnum["REDEEM"] = "REDEEM";
    AssetActivitySearchRequestAssetActivityTypesEnum["REMOVE"] = "REMOVE";
    AssetActivitySearchRequestAssetActivityTypesEnum["RESTORE"] = "RESTORE";
    AssetActivitySearchRequestAssetActivityTypesEnum["REVERSE"] = "REVERSE";
    AssetActivitySearchRequestAssetActivityTypesEnum["SELL"] = "SELL";
    AssetActivitySearchRequestAssetActivityTypesEnum["SEND"] = "SEND";
    AssetActivitySearchRequestAssetActivityTypesEnum["TERMINATE"] = "TERMINATE";
    AssetActivitySearchRequestAssetActivityTypesEnum["UNFREEZE"] = "UNFREEZE";
    AssetActivitySearchRequestAssetActivityTypesEnum["UNLINK"] = "UNLINK";
    AssetActivitySearchRequestAssetActivityTypesEnum["WITHDRAW"] = "WITHDRAW";
    AssetActivitySearchRequestAssetActivityTypesEnum["WITHDRAW_REVERSE"] = "WITHDRAW_REVERSE";
    AssetActivitySearchRequestAssetActivityTypesEnum["WITHDRAW_RETURN"] = "WITHDRAW_RETURN";
    AssetActivitySearchRequestAssetActivityTypesEnum["WITHDRAW_RETURNED"] = "WITHDRAW_RETURNED";
    AssetActivitySearchRequestAssetActivityTypesEnum["PARTNER_REWARD_CRYPTO"] = "PARTNER_REWARD_CRYPTO";
    AssetActivitySearchRequestAssetActivityTypesEnum["PARTNER_REWARD_CASH"] = "PARTNER_REWARD_CASH";
})(AssetActivitySearchRequestAssetActivityTypesEnum = exports.AssetActivitySearchRequestAssetActivityTypesEnum || (exports.AssetActivitySearchRequestAssetActivityTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySearchRequestAssetTypesEnum;
(function (AssetActivitySearchRequestAssetTypesEnum) {
    AssetActivitySearchRequestAssetTypesEnum["CASH"] = "CASH";
    AssetActivitySearchRequestAssetTypesEnum["CRYPTO"] = "CRYPTO";
    AssetActivitySearchRequestAssetTypesEnum["REWARDS"] = "REWARDS";
    AssetActivitySearchRequestAssetTypesEnum["GIFT_CARD"] = "GIFT_CARD";
    AssetActivitySearchRequestAssetTypesEnum["BAKKT_CARD"] = "BAKKT_CARD";
    AssetActivitySearchRequestAssetTypesEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(AssetActivitySearchRequestAssetTypesEnum = exports.AssetActivitySearchRequestAssetTypesEnum || (exports.AssetActivitySearchRequestAssetTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySearchRequestCurrencyEnum;
(function (AssetActivitySearchRequestCurrencyEnum) {
    AssetActivitySearchRequestCurrencyEnum["USD"] = "USD";
    AssetActivitySearchRequestCurrencyEnum["AAVE"] = "AAVE";
    AssetActivitySearchRequestCurrencyEnum["AVAX"] = "AVAX";
    AssetActivitySearchRequestCurrencyEnum["AXS"] = "AXS";
    AssetActivitySearchRequestCurrencyEnum["BAT"] = "BAT";
    AssetActivitySearchRequestCurrencyEnum["BCH"] = "BCH";
    AssetActivitySearchRequestCurrencyEnum["BTC"] = "BTC";
    AssetActivitySearchRequestCurrencyEnum["DOGE"] = "DOGE";
    AssetActivitySearchRequestCurrencyEnum["ETH"] = "ETH";
    AssetActivitySearchRequestCurrencyEnum["LINK"] = "LINK";
    AssetActivitySearchRequestCurrencyEnum["LTC"] = "LTC";
    AssetActivitySearchRequestCurrencyEnum["MANA"] = "MANA";
    AssetActivitySearchRequestCurrencyEnum["MATIC"] = "MATIC";
    AssetActivitySearchRequestCurrencyEnum["SOL"] = "SOL";
    AssetActivitySearchRequestCurrencyEnum["UNI"] = "UNI";
    AssetActivitySearchRequestCurrencyEnum["USDC"] = "USDC";
    AssetActivitySearchRequestCurrencyEnum["LXX"] = "LXX";
    AssetActivitySearchRequestCurrencyEnum["LCP"] = "LCP";
    AssetActivitySearchRequestCurrencyEnum["LWR"] = "LWR";
    AssetActivitySearchRequestCurrencyEnum["LMO"] = "LMO";
    AssetActivitySearchRequestCurrencyEnum["LKO"] = "LKO";
    AssetActivitySearchRequestCurrencyEnum["LED"] = "LED";
})(AssetActivitySearchRequestCurrencyEnum = exports.AssetActivitySearchRequestCurrencyEnum || (exports.AssetActivitySearchRequestCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySearchRequestSystemEnum;
(function (AssetActivitySearchRequestSystemEnum) {
    AssetActivitySearchRequestSystemEnum["TANGO"] = "TANGO";
    AssetActivitySearchRequestSystemEnum["UNIT21"] = "UNIT21";
    AssetActivitySearchRequestSystemEnum["SIFT"] = "SIFT";
    AssetActivitySearchRequestSystemEnum["BRAZE"] = "BRAZE";
    AssetActivitySearchRequestSystemEnum["SARDINE"] = "SARDINE";
    AssetActivitySearchRequestSystemEnum["FUSIONAUTH"] = "FUSIONAUTH";
})(AssetActivitySearchRequestSystemEnum = exports.AssetActivitySearchRequestSystemEnum || (exports.AssetActivitySearchRequestSystemEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySummarySearchRequestAssetActivityStatusEnum;
(function (AssetActivitySummarySearchRequestAssetActivityStatusEnum) {
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["CANCELED"] = "CANCELED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["COMPLETE"] = "COMPLETE";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["EXPIRED"] = "EXPIRED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["PENDING"] = "PENDING";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["REJECTED"] = "REJECTED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["REPLACED"] = "REPLACED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["REFUND"] = "REFUND";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["FAILED"] = "FAILED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["PROVISIONAL"] = "PROVISIONAL";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["CAPTURED"] = "CAPTURED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["PARTIAL_CAPTURED"] = "PARTIAL_CAPTURED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["REFUNDED"] = "REFUNDED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["REVERSED"] = "REVERSED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["PARTIAL_REVERSED"] = "PARTIAL_REVERSED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["AUTHORIZED"] = "AUTHORIZED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["SETTLED"] = "SETTLED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["DISPUTED"] = "DISPUTED";
    AssetActivitySummarySearchRequestAssetActivityStatusEnum["DISPUTE_CLOSED"] = "DISPUTE_CLOSED";
})(AssetActivitySummarySearchRequestAssetActivityStatusEnum = exports.AssetActivitySummarySearchRequestAssetActivityStatusEnum || (exports.AssetActivitySummarySearchRequestAssetActivityStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySummarySearchRequestAssetActivityTypesEnum;
(function (AssetActivitySummarySearchRequestAssetActivityTypesEnum) {
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["ADD"] = "ADD";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["BUY"] = "BUY";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["CARD_CHARGEBACK"] = "CARD_CHARGEBACK";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["CARD_PAYMENT"] = "CARD_PAYMENT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["CARD_REFUND"] = "CARD_REFUND";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["CONVENIENCE_CREDIT"] = "CONVENIENCE_CREDIT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["CREDIT"] = "CREDIT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["CONVERT"] = "CONVERT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["CONVERT_CANCEL"] = "CONVERT_CANCEL";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["DEPOSIT"] = "DEPOSIT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["DEPOSIT_RETURN"] = "DEPOSIT_RETURN";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["DEPOSIT_RETURNED"] = "DEPOSIT_RETURNED";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["DEPOSIT_REVERSE"] = "DEPOSIT_REVERSE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["DISPUTE_CREDIT"] = "DISPUTE_CREDIT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["DISPUTE_CREDIT_REVERSE"] = "DISPUTE_CREDIT_REVERSE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["FREEZE"] = "FREEZE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["INCENTIVE"] = "INCENTIVE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["INCENTIVE_CANCEL"] = "INCENTIVE_CANCEL";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["LOYALTY_BUY"] = "LOYALTY_BUY";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["LOYALTY_BUY_CANCEL"] = "LOYALTY_BUY_CANCEL";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["LOYALTY_CREDIT_CANCEL"] = "LOYALTY_CREDIT_CANCEL";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["LOYALTY_REDEEM"] = "LOYALTY_REDEEM";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["LOYALTY_CRYPTO_REDEEM_FAILED"] = "LOYALTY_CRYPTO_REDEEM_FAILED";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["LOYALTY_PAYMENT_REVERSAL"] = "LOYALTY_PAYMENT_REVERSAL";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["LINK"] = "LINK";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_CREDIT"] = "MERCHANT_CREDIT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT"] = "MERCHANT_PAYMENT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_AUTHORIZE"] = "MERCHANT_PAYMENT_AUTHORIZE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_AUTHORIZE_DECLINED"] = "MERCHANT_PAYMENT_AUTHORIZE_DECLINED";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_CANCEL"] = "MERCHANT_PAYMENT_CANCEL";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_CAPTURE"] = "MERCHANT_PAYMENT_CAPTURE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_CREDIT"] = "MERCHANT_PAYMENT_CREDIT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_REFUND"] = "MERCHANT_PAYMENT_REFUND";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_PAYMENT_DISPUTE"] = "MERCHANT_PAYMENT_DISPUTE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["PAYOUT"] = "PAYOUT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["PROMOTIONAL_CREDIT"] = "PROMOTIONAL_CREDIT";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["RECEIVE"] = "RECEIVE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["REDEEM"] = "REDEEM";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["REMOVE"] = "REMOVE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["RESTORE"] = "RESTORE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["REVERSE"] = "REVERSE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["SELL"] = "SELL";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["SEND"] = "SEND";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["TERMINATE"] = "TERMINATE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["UNFREEZE"] = "UNFREEZE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["UNLINK"] = "UNLINK";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["WITHDRAW"] = "WITHDRAW";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["WITHDRAW_REVERSE"] = "WITHDRAW_REVERSE";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["WITHDRAW_RETURN"] = "WITHDRAW_RETURN";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["WITHDRAW_RETURNED"] = "WITHDRAW_RETURNED";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["PARTNER_REWARD_CRYPTO"] = "PARTNER_REWARD_CRYPTO";
    AssetActivitySummarySearchRequestAssetActivityTypesEnum["PARTNER_REWARD_CASH"] = "PARTNER_REWARD_CASH";
})(AssetActivitySummarySearchRequestAssetActivityTypesEnum = exports.AssetActivitySummarySearchRequestAssetActivityTypesEnum || (exports.AssetActivitySummarySearchRequestAssetActivityTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySummarySearchRequestAssetTypesEnum;
(function (AssetActivitySummarySearchRequestAssetTypesEnum) {
    AssetActivitySummarySearchRequestAssetTypesEnum["CASH"] = "CASH";
    AssetActivitySummarySearchRequestAssetTypesEnum["CRYPTO"] = "CRYPTO";
    AssetActivitySummarySearchRequestAssetTypesEnum["REWARDS"] = "REWARDS";
    AssetActivitySummarySearchRequestAssetTypesEnum["GIFT_CARD"] = "GIFT_CARD";
    AssetActivitySummarySearchRequestAssetTypesEnum["BAKKT_CARD"] = "BAKKT_CARD";
    AssetActivitySummarySearchRequestAssetTypesEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(AssetActivitySummarySearchRequestAssetTypesEnum = exports.AssetActivitySummarySearchRequestAssetTypesEnum || (exports.AssetActivitySummarySearchRequestAssetTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySummarySearchRequestCurrenciesEnum;
(function (AssetActivitySummarySearchRequestCurrenciesEnum) {
    AssetActivitySummarySearchRequestCurrenciesEnum["USD"] = "USD";
    AssetActivitySummarySearchRequestCurrenciesEnum["AAVE"] = "AAVE";
    AssetActivitySummarySearchRequestCurrenciesEnum["AVAX"] = "AVAX";
    AssetActivitySummarySearchRequestCurrenciesEnum["AXS"] = "AXS";
    AssetActivitySummarySearchRequestCurrenciesEnum["BAT"] = "BAT";
    AssetActivitySummarySearchRequestCurrenciesEnum["BCH"] = "BCH";
    AssetActivitySummarySearchRequestCurrenciesEnum["BTC"] = "BTC";
    AssetActivitySummarySearchRequestCurrenciesEnum["DOGE"] = "DOGE";
    AssetActivitySummarySearchRequestCurrenciesEnum["ETH"] = "ETH";
    AssetActivitySummarySearchRequestCurrenciesEnum["LINK"] = "LINK";
    AssetActivitySummarySearchRequestCurrenciesEnum["LTC"] = "LTC";
    AssetActivitySummarySearchRequestCurrenciesEnum["MANA"] = "MANA";
    AssetActivitySummarySearchRequestCurrenciesEnum["MATIC"] = "MATIC";
    AssetActivitySummarySearchRequestCurrenciesEnum["SOL"] = "SOL";
    AssetActivitySummarySearchRequestCurrenciesEnum["UNI"] = "UNI";
    AssetActivitySummarySearchRequestCurrenciesEnum["USDC"] = "USDC";
    AssetActivitySummarySearchRequestCurrenciesEnum["LXX"] = "LXX";
    AssetActivitySummarySearchRequestCurrenciesEnum["LCP"] = "LCP";
    AssetActivitySummarySearchRequestCurrenciesEnum["LWR"] = "LWR";
    AssetActivitySummarySearchRequestCurrenciesEnum["LMO"] = "LMO";
    AssetActivitySummarySearchRequestCurrenciesEnum["LKO"] = "LKO";
    AssetActivitySummarySearchRequestCurrenciesEnum["LED"] = "LED";
})(AssetActivitySummarySearchRequestCurrenciesEnum = exports.AssetActivitySummarySearchRequestCurrenciesEnum || (exports.AssetActivitySummarySearchRequestCurrenciesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AssetActivitySummarySearchRequestSystemEnum;
(function (AssetActivitySummarySearchRequestSystemEnum) {
    AssetActivitySummarySearchRequestSystemEnum["TANGO"] = "TANGO";
    AssetActivitySummarySearchRequestSystemEnum["UNIT21"] = "UNIT21";
    AssetActivitySummarySearchRequestSystemEnum["SIFT"] = "SIFT";
    AssetActivitySummarySearchRequestSystemEnum["BRAZE"] = "BRAZE";
    AssetActivitySummarySearchRequestSystemEnum["SARDINE"] = "SARDINE";
    AssetActivitySummarySearchRequestSystemEnum["FUSIONAUTH"] = "FUSIONAUTH";
})(AssetActivitySummarySearchRequestSystemEnum = exports.AssetActivitySummarySearchRequestSystemEnum || (exports.AssetActivitySummarySearchRequestSystemEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BasicPartnerInfoMissingFieldsEnum;
(function (BasicPartnerInfoMissingFieldsEnum) {
    BasicPartnerInfoMissingFieldsEnum["TAX_ID_NUMBER"] = "TAX_ID_NUMBER";
    BasicPartnerInfoMissingFieldsEnum["OCCUPATION"] = "OCCUPATION";
    BasicPartnerInfoMissingFieldsEnum["FIRST_NAME"] = "FIRST_NAME";
    BasicPartnerInfoMissingFieldsEnum["LAST_NAME"] = "LAST_NAME";
    BasicPartnerInfoMissingFieldsEnum["ADDRESS"] = "ADDRESS";
    BasicPartnerInfoMissingFieldsEnum["PHONE"] = "PHONE";
    BasicPartnerInfoMissingFieldsEnum["DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    BasicPartnerInfoMissingFieldsEnum["EMAIL"] = "EMAIL";
})(BasicPartnerInfoMissingFieldsEnum = exports.BasicPartnerInfoMissingFieldsEnum || (exports.BasicPartnerInfoMissingFieldsEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BasicPartnerInfoServiceTypesEnum;
(function (BasicPartnerInfoServiceTypesEnum) {
    BasicPartnerInfoServiceTypesEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    BasicPartnerInfoServiceTypesEnum["REWARD"] = "REWARD";
    BasicPartnerInfoServiceTypesEnum["PARTY"] = "PARTY";
    BasicPartnerInfoServiceTypesEnum["PAYOUT"] = "PAYOUT";
})(BasicPartnerInfoServiceTypesEnum = exports.BasicPartnerInfoServiceTypesEnum || (exports.BasicPartnerInfoServiceTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BasicPartnerInfoStatusEnum;
(function (BasicPartnerInfoStatusEnum) {
    BasicPartnerInfoStatusEnum["ACTIVE"] = "ACTIVE";
    BasicPartnerInfoStatusEnum["SUSPENDED"] = "SUSPENDED";
    BasicPartnerInfoStatusEnum["CLOSED"] = "CLOSED";
})(BasicPartnerInfoStatusEnum = exports.BasicPartnerInfoStatusEnum || (exports.BasicPartnerInfoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BasicPartyInfoLevelEnum;
(function (BasicPartyInfoLevelEnum) {
    BasicPartyInfoLevelEnum["UNKNOWN"] = "UNKNOWN";
    BasicPartyInfoLevelEnum["LEVEL_1"] = "LEVEL_1";
    BasicPartyInfoLevelEnum["LEVEL_1_SUSPENDED"] = "LEVEL_1_SUSPENDED";
    BasicPartyInfoLevelEnum["LEVEL_1_LIQUIDATED"] = "LEVEL_1_LIQUIDATED";
    BasicPartyInfoLevelEnum["LEVEL_2"] = "LEVEL_2";
    BasicPartyInfoLevelEnum["LEVEL_2_SUSPENDED"] = "LEVEL_2_SUSPENDED";
    BasicPartyInfoLevelEnum["LEVEL_2_LIQUIDATED"] = "LEVEL_2_LIQUIDATED";
    BasicPartyInfoLevelEnum["LEVEL_3"] = "LEVEL_3";
    BasicPartyInfoLevelEnum["LEVEL_3_SUSPENDED"] = "LEVEL_3_SUSPENDED";
    BasicPartyInfoLevelEnum["LEVEL_3_LIQUIDATED"] = "LEVEL_3_LIQUIDATED";
    BasicPartyInfoLevelEnum["LEVEL_4"] = "LEVEL_4";
    BasicPartyInfoLevelEnum["LEVEL_4_SUSPENDED"] = "LEVEL_4_SUSPENDED";
    BasicPartyInfoLevelEnum["LEVEL_4_LIQUIDATED"] = "LEVEL_4_LIQUIDATED";
    BasicPartyInfoLevelEnum["LEVEL_5"] = "LEVEL_5";
    BasicPartyInfoLevelEnum["LEVEL_5_SUSPENDED"] = "LEVEL_5_SUSPENDED";
    BasicPartyInfoLevelEnum["LEVEL_5_LIQUIDATED"] = "LEVEL_5_LIQUIDATED";
    BasicPartyInfoLevelEnum["LEVEL_99"] = "LEVEL_99";
    BasicPartyInfoLevelEnum["LEVEL_99_SUSPENDED"] = "LEVEL_99_SUSPENDED";
    BasicPartyInfoLevelEnum["LEVEL_99_LIQUIDATED"] = "LEVEL_99_LIQUIDATED";
    BasicPartyInfoLevelEnum["CLOSED"] = "CLOSED";
})(BasicPartyInfoLevelEnum = exports.BasicPartyInfoLevelEnum || (exports.BasicPartyInfoLevelEnum = {}));
/**
    * @export
    * @enum {string}
    */
var BasicPartyInfoStatusEnum;
(function (BasicPartyInfoStatusEnum) {
    BasicPartyInfoStatusEnum["OPEN"] = "OPEN";
    BasicPartyInfoStatusEnum["CLOSED"] = "CLOSED";
    BasicPartyInfoStatusEnum["SUSPENDED"] = "SUSPENDED";
    BasicPartyInfoStatusEnum["LIQUIDATED"] = "LIQUIDATED";
})(BasicPartyInfoStatusEnum = exports.BasicPartyInfoStatusEnum || (exports.BasicPartyInfoStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CreditFileStatusEnum;
(function (CreditFileStatusEnum) {
    CreditFileStatusEnum["UNDEFINED"] = "UNDEFINED";
    CreditFileStatusEnum["CREATING"] = "CREATING";
    CreditFileStatusEnum["ERROR"] = "ERROR";
    CreditFileStatusEnum["CREATED_CONSUMER_BATCH"] = "CREATED_CONSUMER_BATCH";
    CreditFileStatusEnum["CREATED_MERCHANT_BATCH"] = "CREATED_MERCHANT_BATCH";
    CreditFileStatusEnum["CREATED_MERCHANT_V1_BATCH"] = "CREATED_MERCHANT_V1_BATCH";
    CreditFileStatusEnum["CREATED_PARTNER_BATCH"] = "CREATED_PARTNER_BATCH";
    CreditFileStatusEnum["UPLOADED"] = "UPLOADED";
    CreditFileStatusEnum["PARTIALLY_UPLOADED"] = "PARTIALLY_UPLOADED";
})(CreditFileStatusEnum = exports.CreditFileStatusEnum || (exports.CreditFileStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var CryptoOrFiatAmountCurrencyEnum;
(function (CryptoOrFiatAmountCurrencyEnum) {
    CryptoOrFiatAmountCurrencyEnum["AAVE"] = "AAVE";
    CryptoOrFiatAmountCurrencyEnum["AVAX"] = "AVAX";
    CryptoOrFiatAmountCurrencyEnum["AXS"] = "AXS";
    CryptoOrFiatAmountCurrencyEnum["BAT"] = "BAT";
    CryptoOrFiatAmountCurrencyEnum["BTC"] = "BTC";
    CryptoOrFiatAmountCurrencyEnum["DOGE"] = "DOGE";
    CryptoOrFiatAmountCurrencyEnum["ETH"] = "ETH";
    CryptoOrFiatAmountCurrencyEnum["LINK"] = "LINK";
    CryptoOrFiatAmountCurrencyEnum["LTC"] = "LTC";
    CryptoOrFiatAmountCurrencyEnum["MANA"] = "MANA";
    CryptoOrFiatAmountCurrencyEnum["MATIC"] = "MATIC";
    CryptoOrFiatAmountCurrencyEnum["SOL"] = "SOL";
    CryptoOrFiatAmountCurrencyEnum["UNI"] = "UNI";
    CryptoOrFiatAmountCurrencyEnum["USDC"] = "USDC";
    CryptoOrFiatAmountCurrencyEnum["USD"] = "USD";
    CryptoOrFiatAmountCurrencyEnum["LCP"] = "LCP";
    CryptoOrFiatAmountCurrencyEnum["LKO"] = "LKO";
    CryptoOrFiatAmountCurrencyEnum["LMO"] = "LMO";
    CryptoOrFiatAmountCurrencyEnum["LWR"] = "LWR";
    CryptoOrFiatAmountCurrencyEnum["LXX"] = "LXX";
    CryptoOrFiatAmountCurrencyEnum["LED"] = "LED";
})(CryptoOrFiatAmountCurrencyEnum = exports.CryptoOrFiatAmountCurrencyEnum || (exports.CryptoOrFiatAmountCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DebitFileStatusEnum;
(function (DebitFileStatusEnum) {
    DebitFileStatusEnum["UNDEFINED"] = "UNDEFINED";
    DebitFileStatusEnum["CREATING"] = "CREATING";
    DebitFileStatusEnum["ERROR"] = "ERROR";
    DebitFileStatusEnum["CREATED_CONSUMER_BATCH"] = "CREATED_CONSUMER_BATCH";
    DebitFileStatusEnum["CREATED_MERCHANT_BATCH"] = "CREATED_MERCHANT_BATCH";
    DebitFileStatusEnum["CREATED_MERCHANT_V1_BATCH"] = "CREATED_MERCHANT_V1_BATCH";
    DebitFileStatusEnum["CREATED_PARTNER_BATCH"] = "CREATED_PARTNER_BATCH";
    DebitFileStatusEnum["UPLOADED"] = "UPLOADED";
    DebitFileStatusEnum["PARTIALLY_UPLOADED"] = "PARTIALLY_UPLOADED";
})(DebitFileStatusEnum = exports.DebitFileStatusEnum || (exports.DebitFileStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var DurationPeriodEnum;
(function (DurationPeriodEnum) {
    DurationPeriodEnum["DAILY"] = "DAILY";
    DurationPeriodEnum["MONTHLY"] = "MONTHLY";
})(DurationPeriodEnum = exports.DurationPeriodEnum || (exports.DurationPeriodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FiatAmountCurrencyEnum;
(function (FiatAmountCurrencyEnum) {
    FiatAmountCurrencyEnum["USD"] = "USD";
})(FiatAmountCurrencyEnum = exports.FiatAmountCurrencyEnum || (exports.FiatAmountCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FilterSearchCriteriaEnum;
(function (FilterSearchCriteriaEnum) {
    FilterSearchCriteriaEnum["STARTS_WITH"] = "STARTS_WITH";
    FilterSearchCriteriaEnum["ENDS_WITH"] = "ENDS_WITH";
    FilterSearchCriteriaEnum["CONTAINS"] = "CONTAINS";
    FilterSearchCriteriaEnum["NOT_CONTAINS"] = "NOT_CONTAINS";
    FilterSearchCriteriaEnum["EQUALS"] = "EQUALS";
    FilterSearchCriteriaEnum["NOT_EQUALS"] = "NOT_EQUALS";
    FilterSearchCriteriaEnum["IN"] = "IN";
    FilterSearchCriteriaEnum["BEFORE"] = "BEFORE";
    FilterSearchCriteriaEnum["BEFORE_OR_NULL"] = "BEFORE_OR_NULL";
    FilterSearchCriteriaEnum["AFTER"] = "AFTER";
    FilterSearchCriteriaEnum["AFTER_OR_NULL"] = "AFTER_OR_NULL";
    FilterSearchCriteriaEnum["BETWEEN"] = "BETWEEN";
    FilterSearchCriteriaEnum["RELATIVE_TIME"] = "RELATIVE_TIME";
    FilterSearchCriteriaEnum["LESS_THAN"] = "LESS_THAN";
    FilterSearchCriteriaEnum["LESS_THAN_OR_EQUAL"] = "LESS_THAN_OR_EQUAL";
    FilterSearchCriteriaEnum["LESS_THAN_OR_EQUAL_OR_NULL"] = "LESS_THAN_OR_EQUAL_OR_NULL";
    FilterSearchCriteriaEnum["GREATER_THAN"] = "GREATER_THAN";
    FilterSearchCriteriaEnum["GREATER_THAN_OR_EQUAL"] = "GREATER_THAN_OR_EQUAL";
    FilterSearchCriteriaEnum["GREATER_THAN_OR_EQUAL_OR_NULL"] = "GREATER_THAN_OR_EQUAL_OR_NULL";
    FilterSearchCriteriaEnum["IN_RANGE"] = "IN_RANGE";
    FilterSearchCriteriaEnum["NOT_NULL"] = "NOT_NULL";
    FilterSearchCriteriaEnum["NOT_IN"] = "NOT_IN";
})(FilterSearchCriteriaEnum = exports.FilterSearchCriteriaEnum || (exports.FilterSearchCriteriaEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum;
(function (GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum) {
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["AAVE"] = "AAVE";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["AVAX"] = "AVAX";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["AXS"] = "AXS";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["BAT"] = "BAT";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["BTC"] = "BTC";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["DOGE"] = "DOGE";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["ETH"] = "ETH";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["LINK"] = "LINK";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["LTC"] = "LTC";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["MANA"] = "MANA";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["MATIC"] = "MATIC";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["SOL"] = "SOL";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["UNI"] = "UNI";
    GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum["USDC"] = "USDC";
})(GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum = exports.GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum || (exports.GetHistoricalCryptoCurrencyPriceResponseSourceCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetHistoricalCryptoCurrencyPriceResponseTargetCurrencyEnum;
(function (GetHistoricalCryptoCurrencyPriceResponseTargetCurrencyEnum) {
    GetHistoricalCryptoCurrencyPriceResponseTargetCurrencyEnum["USD"] = "USD";
})(GetHistoricalCryptoCurrencyPriceResponseTargetCurrencyEnum = exports.GetHistoricalCryptoCurrencyPriceResponseTargetCurrencyEnum || (exports.GetHistoricalCryptoCurrencyPriceResponseTargetCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var IdentifierUserTypesEnum;
(function (IdentifierUserTypesEnum) {
    IdentifierUserTypesEnum["APP_USER"] = "APP_USER";
    IdentifierUserTypesEnum["PARTNER_ENROLLED_USER"] = "PARTNER_ENROLLED_USER";
})(IdentifierUserTypesEnum = exports.IdentifierUserTypesEnum || (exports.IdentifierUserTypesEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ModelFileStatusEnum;
(function (ModelFileStatusEnum) {
    ModelFileStatusEnum["UNDEFINED"] = "UNDEFINED";
    ModelFileStatusEnum["CREATING"] = "CREATING";
    ModelFileStatusEnum["ERROR"] = "ERROR";
    ModelFileStatusEnum["CREATED_CONSUMER_BATCH"] = "CREATED_CONSUMER_BATCH";
    ModelFileStatusEnum["CREATED_MERCHANT_BATCH"] = "CREATED_MERCHANT_BATCH";
    ModelFileStatusEnum["CREATED_MERCHANT_V1_BATCH"] = "CREATED_MERCHANT_V1_BATCH";
    ModelFileStatusEnum["CREATED_PARTNER_BATCH"] = "CREATED_PARTNER_BATCH";
    ModelFileStatusEnum["UPLOADED"] = "UPLOADED";
    ModelFileStatusEnum["PARTIALLY_UPLOADED"] = "PARTIALLY_UPLOADED";
})(ModelFileStatusEnum = exports.ModelFileStatusEnum || (exports.ModelFileStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PartnerBatchErrorCodeEnum;
(function (PartnerBatchErrorCodeEnum) {
    PartnerBatchErrorCodeEnum["GENERATE_REPORT_ERROR"] = "GENERATE_REPORT_ERROR";
})(PartnerBatchErrorCodeEnum = exports.PartnerBatchErrorCodeEnum || (exports.PartnerBatchErrorCodeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PartnerPartyLinkStatusEnum;
(function (PartnerPartyLinkStatusEnum) {
    PartnerPartyLinkStatusEnum["ACTIVE"] = "ACTIVE";
    PartnerPartyLinkStatusEnum["OTP_REQUIRED"] = "OTP_REQUIRED";
    PartnerPartyLinkStatusEnum["PENDING"] = "PENDING";
    PartnerPartyLinkStatusEnum["UNDER_REVIEW"] = "UNDER_REVIEW";
    PartnerPartyLinkStatusEnum["INACTIVE"] = "INACTIVE";
})(PartnerPartyLinkStatusEnum = exports.PartnerPartyLinkStatusEnum || (exports.PartnerPartyLinkStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PartnerTransactionCryptoCurrencySourceEnum;
(function (PartnerTransactionCryptoCurrencySourceEnum) {
    PartnerTransactionCryptoCurrencySourceEnum["PARTNER"] = "PARTNER";
    PartnerTransactionCryptoCurrencySourceEnum["PARTY"] = "PARTY";
})(PartnerTransactionCryptoCurrencySourceEnum = exports.PartnerTransactionCryptoCurrencySourceEnum || (exports.PartnerTransactionCryptoCurrencySourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PartnerTransactionCryptoCurrencyTransactTypeEnum;
(function (PartnerTransactionCryptoCurrencyTransactTypeEnum) {
    PartnerTransactionCryptoCurrencyTransactTypeEnum["BUY"] = "BUY";
    PartnerTransactionCryptoCurrencyTransactTypeEnum["SELL"] = "SELL";
})(PartnerTransactionCryptoCurrencyTransactTypeEnum = exports.PartnerTransactionCryptoCurrencyTransactTypeEnum || (exports.PartnerTransactionCryptoCurrencyTransactTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PartnerTransactionStatusEnum;
(function (PartnerTransactionStatusEnum) {
    PartnerTransactionStatusEnum["CAPTURED"] = "CAPTURED";
    PartnerTransactionStatusEnum["DECLINED"] = "DECLINED";
    PartnerTransactionStatusEnum["DISPUTED"] = "DISPUTED";
    PartnerTransactionStatusEnum["CANCELLED"] = "CANCELLED";
})(PartnerTransactionStatusEnum = exports.PartnerTransactionStatusEnum || (exports.PartnerTransactionStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PartnerTransactionTransactionTypeEnum;
(function (PartnerTransactionTransactionTypeEnum) {
    PartnerTransactionTransactionTypeEnum["CRYPTO_CURRENCY"] = "CRYPTO_CURRENCY";
    PartnerTransactionTransactionTypeEnum["REWARD"] = "REWARD";
    PartnerTransactionTransactionTypeEnum["LOYALTY"] = "LOYALTY";
    PartnerTransactionTransactionTypeEnum["PAYOUT"] = "PAYOUT";
})(PartnerTransactionTransactionTypeEnum = exports.PartnerTransactionTransactionTypeEnum || (exports.PartnerTransactionTransactionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var PortfolioByAssetAssetTypeEnum;
(function (PortfolioByAssetAssetTypeEnum) {
    PortfolioByAssetAssetTypeEnum["CASH"] = "CASH";
    PortfolioByAssetAssetTypeEnum["CRYPTO"] = "CRYPTO";
    PortfolioByAssetAssetTypeEnum["REWARDS"] = "REWARDS";
    PortfolioByAssetAssetTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    PortfolioByAssetAssetTypeEnum["BAKKT_CARD"] = "BAKKT_CARD";
    PortfolioByAssetAssetTypeEnum["DEBIT_CARD"] = "DEBIT_CARD";
})(PortfolioByAssetAssetTypeEnum = exports.PortfolioByAssetAssetTypeEnum || (exports.PortfolioByAssetAssetTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ReturnFileStatusEnum;
(function (ReturnFileStatusEnum) {
    ReturnFileStatusEnum["UNDEFINED"] = "UNDEFINED";
    ReturnFileStatusEnum["LOADING"] = "LOADING";
    ReturnFileStatusEnum["ERROR"] = "ERROR";
    ReturnFileStatusEnum["LOADED"] = "LOADED";
    ReturnFileStatusEnum["PROCESSED"] = "PROCESSED";
    ReturnFileStatusEnum["PROCESSED_ERROR"] = "PROCESSED_ERROR";
})(ReturnFileStatusEnum = exports.ReturnFileStatusEnum || (exports.ReturnFileStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ServiceAddressCountryEnum;
(function (ServiceAddressCountryEnum) {
    ServiceAddressCountryEnum["USA"] = "USA";
})(ServiceAddressCountryEnum = exports.ServiceAddressCountryEnum || (exports.ServiceAddressCountryEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ServiceAmountCurrencyEnum;
(function (ServiceAmountCurrencyEnum) {
    ServiceAmountCurrencyEnum["USD"] = "USD";
    ServiceAmountCurrencyEnum["AAVE"] = "AAVE";
    ServiceAmountCurrencyEnum["AVAX"] = "AVAX";
    ServiceAmountCurrencyEnum["AXS"] = "AXS";
    ServiceAmountCurrencyEnum["BAT"] = "BAT";
    ServiceAmountCurrencyEnum["BCH"] = "BCH";
    ServiceAmountCurrencyEnum["BTC"] = "BTC";
    ServiceAmountCurrencyEnum["DOGE"] = "DOGE";
    ServiceAmountCurrencyEnum["ETH"] = "ETH";
    ServiceAmountCurrencyEnum["LINK"] = "LINK";
    ServiceAmountCurrencyEnum["LTC"] = "LTC";
    ServiceAmountCurrencyEnum["MANA"] = "MANA";
    ServiceAmountCurrencyEnum["MATIC"] = "MATIC";
    ServiceAmountCurrencyEnum["SOL"] = "SOL";
    ServiceAmountCurrencyEnum["UNI"] = "UNI";
    ServiceAmountCurrencyEnum["USDC"] = "USDC";
    ServiceAmountCurrencyEnum["LXX"] = "LXX";
    ServiceAmountCurrencyEnum["LCP"] = "LCP";
    ServiceAmountCurrencyEnum["LWR"] = "LWR";
    ServiceAmountCurrencyEnum["LMO"] = "LMO";
    ServiceAmountCurrencyEnum["LKO"] = "LKO";
    ServiceAmountCurrencyEnum["LED"] = "LED";
})(ServiceAmountCurrencyEnum = exports.ServiceAmountCurrencyEnum || (exports.ServiceAmountCurrencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var SortBySortOrderEnum;
(function (SortBySortOrderEnum) {
    SortBySortOrderEnum["ASC"] = "ASC";
    SortBySortOrderEnum["DESC"] = "DESC";
})(SortBySortOrderEnum = exports.SortBySortOrderEnum || (exports.SortBySortOrderEnum = {}));
/**
    * @export
    * @enum {string}
    */
var TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum;
(function (TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum) {
    TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum["ACTIVE"] = "ACTIVE";
    TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum["OTP_REQUIRED"] = "OTP_REQUIRED";
    TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum["PENDING"] = "PENDING";
    TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum["UNDER_REVIEW"] = "UNDER_REVIEW";
    TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum["INACTIVE"] = "INACTIVE";
})(TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum = exports.TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum || (exports.TestAdminPartnerPartyLinkStatusRequestPartnerPartyLinkStatusEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ThemeThemeNameEnum;
(function (ThemeThemeNameEnum) {
    ThemeThemeNameEnum["LIGHT"] = "LIGHT";
    ThemeThemeNameEnum["DARK"] = "DARK";
})(ThemeThemeNameEnum = exports.ThemeThemeNameEnum || (exports.ThemeThemeNameEnum = {}));
/**
 * AccountApi - axios parameter creator
 * @export
 */
exports.AccountApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} currency
         * @param {'ACH' | 'ACH_RETURN' | 'BAKKT_CASH_CARD_REDEMPTION' | 'BTC_BUY_SELL' | 'CARD_PAYMENT' | 'CONVENIENCE' | 'CRYPTO_REWARD' | 'DEBIT_CARD_DEPOSIT_TO_WALLET' | 'DEBIT_CARD_WITHDRAWAL_FROM_WALLET' | 'DEPOSIT_DISPUTE_ACCEPT' | 'DEPOSIT_DISPUTE_PROVISIONAL_ACCEPT' | 'DEPOSIT_DISPUTE_PROVISIONAL_REJECT' | 'DISPUTE_CREDIT' | 'INCENTIVE' | 'LOYALTY_BUY' | 'LOYALTY_CONVERSION' | 'LOYALTY_PAYMENTS_REDEEM' | 'LOYALTY_REDEEM' | 'MERCHANT_PAYMENT' | 'PARTNER_REWARDS_REDEEM' | 'PARTNER_PAYOUT' | 'PERSON_TO_PERSON_PAYMENT' | 'PROMOTIONAL' | 'VENDOR_PAYMENT' | 'WITHDRAW_DISPUTE_ACCEPT' | 'WITHDRAW_DISPUTE_PROVISIONAL_ACCEPT' | 'WITHDRAW_DISPUTE_PROVISIONAL_REJECT'} adjustmentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkLimitBalance: (currency, adjustmentType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'currency' is not null or undefined
            common_1.assertParamExists('checkLimitBalance', 'currency', currency);
            // verify required parameter 'adjustmentType' is not null or undefined
            common_1.assertParamExists('checkLimitBalance', 'adjustmentType', adjustmentType);
            const localVarPath = `/aof/party/account/limit-balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            if (adjustmentType !== undefined) {
                localVarQueryParameter['adjustmentType'] = adjustmentType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves all the accounts owned by a given party (retrieved from JWT).
         * @summary Retrieve Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccounts1: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/party/account/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccountApi - functional programming interface
 * @export
 */
exports.AccountApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} currency
         * @param {'ACH' | 'ACH_RETURN' | 'BAKKT_CASH_CARD_REDEMPTION' | 'BTC_BUY_SELL' | 'CARD_PAYMENT' | 'CONVENIENCE' | 'CRYPTO_REWARD' | 'DEBIT_CARD_DEPOSIT_TO_WALLET' | 'DEBIT_CARD_WITHDRAWAL_FROM_WALLET' | 'DEPOSIT_DISPUTE_ACCEPT' | 'DEPOSIT_DISPUTE_PROVISIONAL_ACCEPT' | 'DEPOSIT_DISPUTE_PROVISIONAL_REJECT' | 'DISPUTE_CREDIT' | 'INCENTIVE' | 'LOYALTY_BUY' | 'LOYALTY_CONVERSION' | 'LOYALTY_PAYMENTS_REDEEM' | 'LOYALTY_REDEEM' | 'MERCHANT_PAYMENT' | 'PARTNER_REWARDS_REDEEM' | 'PARTNER_PAYOUT' | 'PERSON_TO_PERSON_PAYMENT' | 'PROMOTIONAL' | 'VENDOR_PAYMENT' | 'WITHDRAW_DISPUTE_ACCEPT' | 'WITHDRAW_DISPUTE_PROVISIONAL_ACCEPT' | 'WITHDRAW_DISPUTE_PROVISIONAL_REJECT'} adjustmentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkLimitBalance(currency, adjustmentType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkLimitBalance(currency, adjustmentType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieves all the accounts owned by a given party (retrieved from JWT).
         * @summary Retrieve Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccounts1(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveAccounts1(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AccountApi - factory interface
 * @export
 */
exports.AccountApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountApiFp(configuration);
    return {
        /**
         *
         * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} currency
         * @param {'ACH' | 'ACH_RETURN' | 'BAKKT_CASH_CARD_REDEMPTION' | 'BTC_BUY_SELL' | 'CARD_PAYMENT' | 'CONVENIENCE' | 'CRYPTO_REWARD' | 'DEBIT_CARD_DEPOSIT_TO_WALLET' | 'DEBIT_CARD_WITHDRAWAL_FROM_WALLET' | 'DEPOSIT_DISPUTE_ACCEPT' | 'DEPOSIT_DISPUTE_PROVISIONAL_ACCEPT' | 'DEPOSIT_DISPUTE_PROVISIONAL_REJECT' | 'DISPUTE_CREDIT' | 'INCENTIVE' | 'LOYALTY_BUY' | 'LOYALTY_CONVERSION' | 'LOYALTY_PAYMENTS_REDEEM' | 'LOYALTY_REDEEM' | 'MERCHANT_PAYMENT' | 'PARTNER_REWARDS_REDEEM' | 'PARTNER_PAYOUT' | 'PERSON_TO_PERSON_PAYMENT' | 'PROMOTIONAL' | 'VENDOR_PAYMENT' | 'WITHDRAW_DISPUTE_ACCEPT' | 'WITHDRAW_DISPUTE_PROVISIONAL_ACCEPT' | 'WITHDRAW_DISPUTE_PROVISIONAL_REJECT'} adjustmentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkLimitBalance(currency, adjustmentType, options) {
            return localVarFp.checkLimitBalance(currency, adjustmentType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all the accounts owned by a given party (retrieved from JWT).
         * @summary Retrieve Accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccounts1(options) {
            return localVarFp.retrieveAccounts1(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
class AccountApi extends base_1.BaseAPI {
    /**
     *
     * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} currency
     * @param {'ACH' | 'ACH_RETURN' | 'BAKKT_CASH_CARD_REDEMPTION' | 'BTC_BUY_SELL' | 'CARD_PAYMENT' | 'CONVENIENCE' | 'CRYPTO_REWARD' | 'DEBIT_CARD_DEPOSIT_TO_WALLET' | 'DEBIT_CARD_WITHDRAWAL_FROM_WALLET' | 'DEPOSIT_DISPUTE_ACCEPT' | 'DEPOSIT_DISPUTE_PROVISIONAL_ACCEPT' | 'DEPOSIT_DISPUTE_PROVISIONAL_REJECT' | 'DISPUTE_CREDIT' | 'INCENTIVE' | 'LOYALTY_BUY' | 'LOYALTY_CONVERSION' | 'LOYALTY_PAYMENTS_REDEEM' | 'LOYALTY_REDEEM' | 'MERCHANT_PAYMENT' | 'PARTNER_REWARDS_REDEEM' | 'PARTNER_PAYOUT' | 'PERSON_TO_PERSON_PAYMENT' | 'PROMOTIONAL' | 'VENDOR_PAYMENT' | 'WITHDRAW_DISPUTE_ACCEPT' | 'WITHDRAW_DISPUTE_PROVISIONAL_ACCEPT' | 'WITHDRAW_DISPUTE_PROVISIONAL_REJECT'} adjustmentType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    checkLimitBalance(currency, adjustmentType, options) {
        return exports.AccountApiFp(this.configuration).checkLimitBalance(currency, adjustmentType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves all the accounts owned by a given party (retrieved from JWT).
     * @summary Retrieve Accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    retrieveAccounts1(options) {
        return exports.AccountApiFp(this.configuration).retrieveAccounts1(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountApi = AccountApi;
/**
 * AccountActivityControllerApi - axios parameter creator
 * @export
 */
exports.AccountActivityControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AccountActivitySearchRequest} accountActivitySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountActivities: (accountActivitySearchRequest, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountActivitySearchRequest' is not null or undefined
            common_1.assertParamExists('getAccountActivities', 'accountActivitySearchRequest', accountActivitySearchRequest);
            const localVarPath = `/business-portal/account/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(accountActivitySearchRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccountActivityControllerApi - functional programming interface
 * @export
 */
exports.AccountActivityControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AccountActivityControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AccountActivitySearchRequest} accountActivitySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountActivities(accountActivitySearchRequest, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountActivities(accountActivitySearchRequest, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AccountActivityControllerApi - factory interface
 * @export
 */
exports.AccountActivityControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AccountActivityControllerApiFp(configuration);
    return {
        /**
         *
         * @param {AccountActivitySearchRequest} accountActivitySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountActivities(accountActivitySearchRequest, page, size, sort, options) {
            return localVarFp.getAccountActivities(accountActivitySearchRequest, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountActivityControllerApi - object-oriented interface
 * @export
 * @class AccountActivityControllerApi
 * @extends {BaseAPI}
 */
class AccountActivityControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {AccountActivitySearchRequest} accountActivitySearchRequest
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountActivityControllerApi
     */
    getAccountActivities(accountActivitySearchRequest, page, size, sort, options) {
        return exports.AccountActivityControllerApiFp(this.configuration).getAccountActivities(accountActivitySearchRequest, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountActivityControllerApi = AccountActivityControllerApi;
/**
 * ActivityAuditControllerApi - axios parameter creator
 * @export
 */
exports.ActivityAuditControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ActivityAuditSearchRequest} activityAuditSearchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityAudit: (activityAuditSearchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'activityAuditSearchRequest' is not null or undefined
            common_1.assertParamExists('getActivityAudit', 'activityAuditSearchRequest', activityAuditSearchRequest);
            const localVarPath = `/business-portal/activityaudit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(activityAuditSearchRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityAuditByEntityId: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getActivityAuditByEntityId', 'id', id);
            const localVarPath = `/business-portal/activityaudit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ActivityAuditControllerApi - functional programming interface
 * @export
 */
exports.ActivityAuditControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ActivityAuditControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ActivityAuditSearchRequest} activityAuditSearchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityAudit(activityAuditSearchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActivityAudit(activityAuditSearchRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityAuditByEntityId(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActivityAuditByEntityId(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ActivityAuditControllerApi - factory interface
 * @export
 */
exports.ActivityAuditControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ActivityAuditControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ActivityAuditSearchRequest} activityAuditSearchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityAudit(activityAuditSearchRequest, options) {
            return localVarFp.getActivityAudit(activityAuditSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityAuditByEntityId(id, options) {
            return localVarFp.getActivityAuditByEntityId(id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ActivityAuditControllerApi - object-oriented interface
 * @export
 * @class ActivityAuditControllerApi
 * @extends {BaseAPI}
 */
class ActivityAuditControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {ActivityAuditSearchRequest} activityAuditSearchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityAuditControllerApi
     */
    getActivityAudit(activityAuditSearchRequest, options) {
        return exports.ActivityAuditControllerApiFp(this.configuration).getActivityAudit(activityAuditSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityAuditControllerApi
     */
    getActivityAuditByEntityId(id, options) {
        return exports.ActivityAuditControllerApiFp(this.configuration).getActivityAuditByEntityId(id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ActivityAuditControllerApi = ActivityAuditControllerApi;
/**
 * AddIdentifierApi - axios parameter creator
 * @export
 */
exports.AddIdentifierApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Designed for users without account created yet.
         * @summary Add Identifier to non-Account
         * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifier1: (apiAddIdentifierRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiAddIdentifierRequest' is not null or undefined
            common_1.assertParamExists('addIdentifier1', 'apiAddIdentifierRequest', apiAddIdentifierRequest);
            const localVarPath = `/aof/party/add-identifier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiAddIdentifierRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AddIdentifierApi - functional programming interface
 * @export
 */
exports.AddIdentifierApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AddIdentifierApiAxiosParamCreator(configuration);
    return {
        /**
         * Designed for users without account created yet.
         * @summary Add Identifier to non-Account
         * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifier1(apiAddIdentifierRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addIdentifier1(apiAddIdentifierRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AddIdentifierApi - factory interface
 * @export
 */
exports.AddIdentifierApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AddIdentifierApiFp(configuration);
    return {
        /**
         * Designed for users without account created yet.
         * @summary Add Identifier to non-Account
         * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifier1(apiAddIdentifierRequest, options) {
            return localVarFp.addIdentifier1(apiAddIdentifierRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AddIdentifierApi - object-oriented interface
 * @export
 * @class AddIdentifierApi
 * @extends {BaseAPI}
 */
class AddIdentifierApi extends base_1.BaseAPI {
    /**
     * Designed for users without account created yet.
     * @summary Add Identifier to non-Account
     * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddIdentifierApi
     */
    addIdentifier1(apiAddIdentifierRequest, options) {
        return exports.AddIdentifierApiFp(this.configuration).addIdentifier1(apiAddIdentifierRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AddIdentifierApi = AddIdentifierApi;
/**
 * AdminApi - axios parameter creator
 * @export
 */
exports.AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encodeBakktIdentifiers: (apiUnit21DataRetrieveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DataRetrieveRequest' is not null or undefined
            common_1.assertParamExists('encodeBakktIdentifiers', 'apiUnit21DataRetrieveRequest', apiUnit21DataRetrieveRequest);
            const localVarPath = `/aof/unit21/identifier/encode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DataRetrieveRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAchFile: (apiGenerateAchFileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiGenerateAchFileRequest' is not null or undefined
            common_1.assertParamExists('generateAchFile', 'apiGenerateAchFileRequest', apiGenerateAchFileRequest);
            const localVarPath = `/aof/admin/ach/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiGenerateAchFileRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAchFileByPartyId: (partyId, apiGenerateAchFileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('generateAchFileByPartyId', 'partyId', partyId);
            // verify required parameter 'apiGenerateAchFileRequest' is not null or undefined
            common_1.assertParamExists('generateAchFileByPartyId', 'apiGenerateAchFileRequest', apiGenerateAchFileRequest);
            const localVarPath = `/aof/admin/ach/party/{partyId}/generate`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiGenerateAchFileRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnit21Instruments: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/unit21/instruments/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadAchFileFromBlobStorage: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/admin/ach-returns/batch-load`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadAchFileFromFileSystem: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/admin/ach-returns/batch-load/file-system`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAchReturns: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/admin/ach-returns/batch-process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} achFileId
         * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateAchFile: (achFileId, apiGenerateAchFileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'achFileId' is not null or undefined
            common_1.assertParamExists('regenerateAchFile', 'achFileId', achFileId);
            // verify required parameter 'apiGenerateAchFileRequest' is not null or undefined
            common_1.assertParamExists('regenerateAchFile', 'apiGenerateAchFileRequest', apiGenerateAchFileRequest);
            const localVarPath = `/aof/admin/ach/regenerate/{achFileId}`
                .replace(`{${"achFileId"}}`, encodeURIComponent(String(achFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiGenerateAchFileRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} achFileDetailId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateAchFile1: (achFileDetailId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'achFileDetailId' is not null or undefined
            common_1.assertParamExists('regenerateAchFile1', 'achFileDetailId', achFileDetailId);
            const localVarPath = `/aof/admin/ach-return/{achFileDetailId}`
                .replace(`{${"achFileDetailId"}}`, encodeURIComponent(String(achFileDetailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccounts: (apiUnit21DataRetrieveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DataRetrieveRequest' is not null or undefined
            common_1.assertParamExists('retrieveAccounts', 'apiUnit21DataRetrieveRequest', apiUnit21DataRetrieveRequest);
            const localVarPath = `/aof/unit21/accounts/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DataRetrieveRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAchTransactions: (apiUnit21DataRetrieveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DataRetrieveRequest' is not null or undefined
            common_1.assertParamExists('retrieveAchTransactions', 'apiUnit21DataRetrieveRequest', apiUnit21DataRetrieveRequest);
            const localVarPath = `/aof/unit21/ach-transactions/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DataRetrieveRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBakktGiftCardTransactions: (apiUnit21DataRetrieveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DataRetrieveRequest' is not null or undefined
            common_1.assertParamExists('retrieveBakktGiftCardTransactions', 'apiUnit21DataRetrieveRequest', apiUnit21DataRetrieveRequest);
            const localVarPath = `/aof/unit21/bakkt-gift-card/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DataRetrieveRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCryptoCurrencyTransactions: (apiUnit21DataRetrieveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DataRetrieveRequest' is not null or undefined
            common_1.assertParamExists('retrieveCryptoCurrencyTransactions', 'apiUnit21DataRetrieveRequest', apiUnit21DataRetrieveRequest);
            const localVarPath = `/aof/unit21/btc-transactions/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DataRetrieveRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGiftCardTransactions: (apiUnit21DataRetrieveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DataRetrieveRequest' is not null or undefined
            common_1.assertParamExists('retrieveGiftCardTransactions', 'apiUnit21DataRetrieveRequest', apiUnit21DataRetrieveRequest);
            const localVarPath = `/aof/unit21/gift-card/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DataRetrieveRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveP2PTransactions: (apiUnit21DataRetrieveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DataRetrieveRequest' is not null or undefined
            common_1.assertParamExists('retrieveP2PTransactions', 'apiUnit21DataRetrieveRequest', apiUnit21DataRetrieveRequest);
            const localVarPath = `/aof/unit21/p2p-transactions/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DataRetrieveRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveParties: (apiUnit21DataRetrieveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DataRetrieveRequest' is not null or undefined
            common_1.assertParamExists('retrieveParties', 'apiUnit21DataRetrieveRequest', apiUnit21DataRetrieveRequest);
            const localVarPath = `/aof/unit21/parties/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DataRetrieveRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'ACCOUNT' | 'ACH_TRANSACTION' | 'BAKKT_CASH_REDEEM' | 'BTC_TRANSACTION' | 'GC_PURCHASE' | 'MERCHANT_TRANSACTION' | 'MERCHANT_PAYMENT_TRANSACTION' | 'MERCHANT_PAYMENT_CHILD_TRANSACTION' | 'P2P_BTC' | 'P2P_CASH' | 'P2P_GIFT_CARD' | 'PARTY' | 'PLAID_ACCOUNT' | 'BAKKT_CARD' | 'UNLINK_PLAID_ACCOUNT' | 'CARD_LINK' | 'DEBIT_CARD_LINK' | 'MERCHANT_PAYMENT_TOKEN_LINK' | 'PARTNER_PARTY_LINK' | 'DEBIT_CARD_TRANSACTION' | 'SEGMENT_IDENTITY_UPLOAD'} [dataSourceType]
         * @param {number} [limit]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21BatchActivity: (dataSourceType, limit, dateFrom, dateTo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/unit21/batch-activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dataSourceType !== undefined) {
                localVarQueryParameter['dataSourceType'] = dataSourceType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString() :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString() :
                    dateTo;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21Control: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/unit21/control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21DownloadControl: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/unit21/download-control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21MerchantTransactions: (apiUnit21DataRetrieveRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DataRetrieveRequest' is not null or undefined
            common_1.assertParamExists('retrieveUnit21MerchantTransactions', 'apiUnit21DataRetrieveRequest', apiUnit21DataRetrieveRequest);
            const localVarPath = `/aof/unit21/merchant-transactions/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DataRetrieveRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFile: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchAchFile', 'searchParameters', searchParameters);
            const localVarPath = `/aof/admin/ach-file/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileDetail: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchAchFileDetail', 'searchParameters', searchParameters);
            const localVarPath = `/aof/admin/ach-file-detail/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} fromDate
         * @param {string} toDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReturnTransactions: (fromDate, toDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fromDate' is not null or undefined
            common_1.assertParamExists('sendReturnTransactions', 'fromDate', fromDate);
            // verify required parameter 'toDate' is not null or undefined
            common_1.assertParamExists('sendReturnTransactions', 'toDate', toDate);
            const localVarPath = `/aof/admin/ach-return/transactions/batch-process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate instanceof Date) ?
                    fromDate.toISOString() :
                    fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate instanceof Date) ?
                    toDate.toISOString() :
                    toDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21Control} apiUnit21Control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnit21Control: (apiUnit21Control, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21Control' is not null or undefined
            common_1.assertParamExists('updateUnit21Control', 'apiUnit21Control', apiUnit21Control);
            const localVarPath = `/aof/unit21/control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21Control, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnit21DownloadControl} apiUnit21DownloadControl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnit21DownloadControl: (apiUnit21DownloadControl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnit21DownloadControl' is not null or undefined
            common_1.assertParamExists('updateUnit21DownloadControl', 'apiUnit21DownloadControl', apiUnit21DownloadControl);
            const localVarPath = `/aof/unit21/download-control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnit21DownloadControl, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUnit21Data: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/unit21/upload-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminApi - functional programming interface
 * @export
 */
exports.AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AdminApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encodeBakktIdentifiers(apiUnit21DataRetrieveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.encodeBakktIdentifiers(apiUnit21DataRetrieveRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAchFile(apiGenerateAchFileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateAchFile(apiGenerateAchFileRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAchFileByPartyId(partyId, apiGenerateAchFileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateAchFileByPartyId(partyId, apiGenerateAchFileRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnit21Instruments(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUnit21Instruments(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadAchFileFromBlobStorage(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loadAchFileFromBlobStorage(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadAchFileFromFileSystem(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loadAchFileFromFileSystem(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAchReturns(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.processAchReturns(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} achFileId
         * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateAchFile(achFileId, apiGenerateAchFileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.regenerateAchFile(achFileId, apiGenerateAchFileRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} achFileDetailId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateAchFile1(achFileDetailId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.regenerateAchFile1(achFileDetailId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccounts(apiUnit21DataRetrieveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveAccounts(apiUnit21DataRetrieveRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAchTransactions(apiUnit21DataRetrieveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveAchTransactions(apiUnit21DataRetrieveRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBakktGiftCardTransactions(apiUnit21DataRetrieveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveBakktGiftCardTransactions(apiUnit21DataRetrieveRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCryptoCurrencyTransactions(apiUnit21DataRetrieveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveCryptoCurrencyTransactions(apiUnit21DataRetrieveRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGiftCardTransactions(apiUnit21DataRetrieveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveGiftCardTransactions(apiUnit21DataRetrieveRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveP2PTransactions(apiUnit21DataRetrieveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveP2PTransactions(apiUnit21DataRetrieveRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveParties(apiUnit21DataRetrieveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveParties(apiUnit21DataRetrieveRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'ACCOUNT' | 'ACH_TRANSACTION' | 'BAKKT_CASH_REDEEM' | 'BTC_TRANSACTION' | 'GC_PURCHASE' | 'MERCHANT_TRANSACTION' | 'MERCHANT_PAYMENT_TRANSACTION' | 'MERCHANT_PAYMENT_CHILD_TRANSACTION' | 'P2P_BTC' | 'P2P_CASH' | 'P2P_GIFT_CARD' | 'PARTY' | 'PLAID_ACCOUNT' | 'BAKKT_CARD' | 'UNLINK_PLAID_ACCOUNT' | 'CARD_LINK' | 'DEBIT_CARD_LINK' | 'MERCHANT_PAYMENT_TOKEN_LINK' | 'PARTNER_PARTY_LINK' | 'DEBIT_CARD_TRANSACTION' | 'SEGMENT_IDENTITY_UPLOAD'} [dataSourceType]
         * @param {number} [limit]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21BatchActivity(dataSourceType, limit, dateFrom, dateTo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveUnit21BatchActivity(dataSourceType, limit, dateFrom, dateTo, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21Control(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveUnit21Control(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21DownloadControl(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveUnit21DownloadControl(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21MerchantTransactions(apiUnit21DataRetrieveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveUnit21MerchantTransactions(apiUnit21DataRetrieveRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFile(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAchFile(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileDetail(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAchFileDetail(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} fromDate
         * @param {string} toDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReturnTransactions(fromDate, toDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendReturnTransactions(fromDate, toDate, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21Control} apiUnit21Control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnit21Control(apiUnit21Control, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUnit21Control(apiUnit21Control, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnit21DownloadControl} apiUnit21DownloadControl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnit21DownloadControl(apiUnit21DownloadControl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUnit21DownloadControl(apiUnit21DownloadControl, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUnit21Data(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadUnit21Data(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminApi - factory interface
 * @export
 */
exports.AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AdminApiFp(configuration);
    return {
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        encodeBakktIdentifiers(apiUnit21DataRetrieveRequest, options) {
            return localVarFp.encodeBakktIdentifiers(apiUnit21DataRetrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAchFile(apiGenerateAchFileRequest, options) {
            return localVarFp.generateAchFile(apiGenerateAchFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAchFileByPartyId(partyId, apiGenerateAchFileRequest, options) {
            return localVarFp.generateAchFileByPartyId(partyId, apiGenerateAchFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnit21Instruments(options) {
            return localVarFp.listUnit21Instruments(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadAchFileFromBlobStorage(options) {
            return localVarFp.loadAchFileFromBlobStorage(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadAchFileFromFileSystem(options) {
            return localVarFp.loadAchFileFromFileSystem(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processAchReturns(options) {
            return localVarFp.processAchReturns(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} achFileId
         * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateAchFile(achFileId, apiGenerateAchFileRequest, options) {
            return localVarFp.regenerateAchFile(achFileId, apiGenerateAchFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} achFileDetailId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateAchFile1(achFileDetailId, options) {
            return localVarFp.regenerateAchFile1(achFileDetailId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAccounts(apiUnit21DataRetrieveRequest, options) {
            return localVarFp.retrieveAccounts(apiUnit21DataRetrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAchTransactions(apiUnit21DataRetrieveRequest, options) {
            return localVarFp.retrieveAchTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveBakktGiftCardTransactions(apiUnit21DataRetrieveRequest, options) {
            return localVarFp.retrieveBakktGiftCardTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCryptoCurrencyTransactions(apiUnit21DataRetrieveRequest, options) {
            return localVarFp.retrieveCryptoCurrencyTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveGiftCardTransactions(apiUnit21DataRetrieveRequest, options) {
            return localVarFp.retrieveGiftCardTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveP2PTransactions(apiUnit21DataRetrieveRequest, options) {
            return localVarFp.retrieveP2PTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveParties(apiUnit21DataRetrieveRequest, options) {
            return localVarFp.retrieveParties(apiUnit21DataRetrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'ACCOUNT' | 'ACH_TRANSACTION' | 'BAKKT_CASH_REDEEM' | 'BTC_TRANSACTION' | 'GC_PURCHASE' | 'MERCHANT_TRANSACTION' | 'MERCHANT_PAYMENT_TRANSACTION' | 'MERCHANT_PAYMENT_CHILD_TRANSACTION' | 'P2P_BTC' | 'P2P_CASH' | 'P2P_GIFT_CARD' | 'PARTY' | 'PLAID_ACCOUNT' | 'BAKKT_CARD' | 'UNLINK_PLAID_ACCOUNT' | 'CARD_LINK' | 'DEBIT_CARD_LINK' | 'MERCHANT_PAYMENT_TOKEN_LINK' | 'PARTNER_PARTY_LINK' | 'DEBIT_CARD_TRANSACTION' | 'SEGMENT_IDENTITY_UPLOAD'} [dataSourceType]
         * @param {number} [limit]
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21BatchActivity(dataSourceType, limit, dateFrom, dateTo, options) {
            return localVarFp.retrieveUnit21BatchActivity(dataSourceType, limit, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21Control(options) {
            return localVarFp.retrieveUnit21Control(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21DownloadControl(options) {
            return localVarFp.retrieveUnit21DownloadControl(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveUnit21MerchantTransactions(apiUnit21DataRetrieveRequest, options) {
            return localVarFp.retrieveUnit21MerchantTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFile(searchParameters, options) {
            return localVarFp.searchAchFile(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileDetail(searchParameters, options) {
            return localVarFp.searchAchFileDetail(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} fromDate
         * @param {string} toDate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReturnTransactions(fromDate, toDate, options) {
            return localVarFp.sendReturnTransactions(fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21Control} apiUnit21Control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnit21Control(apiUnit21Control, options) {
            return localVarFp.updateUnit21Control(apiUnit21Control, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnit21DownloadControl} apiUnit21DownloadControl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUnit21DownloadControl(apiUnit21DownloadControl, options) {
            return localVarFp.updateUnit21DownloadControl(apiUnit21DownloadControl, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUnit21Data(options) {
            return localVarFp.uploadUnit21Data(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
class AdminApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    encodeBakktIdentifiers(apiUnit21DataRetrieveRequest, options) {
        return exports.AdminApiFp(this.configuration).encodeBakktIdentifiers(apiUnit21DataRetrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    generateAchFile(apiGenerateAchFileRequest, options) {
        return exports.AdminApiFp(this.configuration).generateAchFile(apiGenerateAchFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    generateAchFileByPartyId(partyId, apiGenerateAchFileRequest, options) {
        return exports.AdminApiFp(this.configuration).generateAchFileByPartyId(partyId, apiGenerateAchFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    listUnit21Instruments(options) {
        return exports.AdminApiFp(this.configuration).listUnit21Instruments(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    loadAchFileFromBlobStorage(options) {
        return exports.AdminApiFp(this.configuration).loadAchFileFromBlobStorage(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    loadAchFileFromFileSystem(options) {
        return exports.AdminApiFp(this.configuration).loadAchFileFromFileSystem(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    processAchReturns(options) {
        return exports.AdminApiFp(this.configuration).processAchReturns(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} achFileId
     * @param {ApiGenerateAchFileRequest} apiGenerateAchFileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    regenerateAchFile(achFileId, apiGenerateAchFileRequest, options) {
        return exports.AdminApiFp(this.configuration).regenerateAchFile(achFileId, apiGenerateAchFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} achFileDetailId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    regenerateAchFile1(achFileDetailId, options) {
        return exports.AdminApiFp(this.configuration).regenerateAchFile1(achFileDetailId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveAccounts(apiUnit21DataRetrieveRequest, options) {
        return exports.AdminApiFp(this.configuration).retrieveAccounts(apiUnit21DataRetrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveAchTransactions(apiUnit21DataRetrieveRequest, options) {
        return exports.AdminApiFp(this.configuration).retrieveAchTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveBakktGiftCardTransactions(apiUnit21DataRetrieveRequest, options) {
        return exports.AdminApiFp(this.configuration).retrieveBakktGiftCardTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveCryptoCurrencyTransactions(apiUnit21DataRetrieveRequest, options) {
        return exports.AdminApiFp(this.configuration).retrieveCryptoCurrencyTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveGiftCardTransactions(apiUnit21DataRetrieveRequest, options) {
        return exports.AdminApiFp(this.configuration).retrieveGiftCardTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveP2PTransactions(apiUnit21DataRetrieveRequest, options) {
        return exports.AdminApiFp(this.configuration).retrieveP2PTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveParties(apiUnit21DataRetrieveRequest, options) {
        return exports.AdminApiFp(this.configuration).retrieveParties(apiUnit21DataRetrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {'ACCOUNT' | 'ACH_TRANSACTION' | 'BAKKT_CASH_REDEEM' | 'BTC_TRANSACTION' | 'GC_PURCHASE' | 'MERCHANT_TRANSACTION' | 'MERCHANT_PAYMENT_TRANSACTION' | 'MERCHANT_PAYMENT_CHILD_TRANSACTION' | 'P2P_BTC' | 'P2P_CASH' | 'P2P_GIFT_CARD' | 'PARTY' | 'PLAID_ACCOUNT' | 'BAKKT_CARD' | 'UNLINK_PLAID_ACCOUNT' | 'CARD_LINK' | 'DEBIT_CARD_LINK' | 'MERCHANT_PAYMENT_TOKEN_LINK' | 'PARTNER_PARTY_LINK' | 'DEBIT_CARD_TRANSACTION' | 'SEGMENT_IDENTITY_UPLOAD'} [dataSourceType]
     * @param {number} [limit]
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveUnit21BatchActivity(dataSourceType, limit, dateFrom, dateTo, options) {
        return exports.AdminApiFp(this.configuration).retrieveUnit21BatchActivity(dataSourceType, limit, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveUnit21Control(options) {
        return exports.AdminApiFp(this.configuration).retrieveUnit21Control(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveUnit21DownloadControl(options) {
        return exports.AdminApiFp(this.configuration).retrieveUnit21DownloadControl(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21DataRetrieveRequest} apiUnit21DataRetrieveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    retrieveUnit21MerchantTransactions(apiUnit21DataRetrieveRequest, options) {
        return exports.AdminApiFp(this.configuration).retrieveUnit21MerchantTransactions(apiUnit21DataRetrieveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    searchAchFile(searchParameters, options) {
        return exports.AdminApiFp(this.configuration).searchAchFile(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    searchAchFileDetail(searchParameters, options) {
        return exports.AdminApiFp(this.configuration).searchAchFileDetail(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} fromDate
     * @param {string} toDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    sendReturnTransactions(fromDate, toDate, options) {
        return exports.AdminApiFp(this.configuration).sendReturnTransactions(fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21Control} apiUnit21Control
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    updateUnit21Control(apiUnit21Control, options) {
        return exports.AdminApiFp(this.configuration).updateUnit21Control(apiUnit21Control, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnit21DownloadControl} apiUnit21DownloadControl
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    updateUnit21DownloadControl(apiUnit21DownloadControl, options) {
        return exports.AdminApiFp(this.configuration).updateUnit21DownloadControl(apiUnit21DownloadControl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    uploadUnit21Data(options) {
        return exports.AdminApiFp(this.configuration).uploadUnit21Data(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminApi = AdminApi;
/**
 * AllowListManagementApi - axios parameter creator
 * @export
 */
exports.AllowListManagementApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a new AllowListItem for a given Allow List type and sub-type
         * @summary Add to Allow List
         * @param {ApiAllowListItem} apiAllowListItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAllowListItem: (apiAllowListItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiAllowListItem' is not null or undefined
            common_1.assertParamExists('createAllowListItem', 'apiAllowListItem', apiAllowListItem);
            const localVarPath = `/aof/allow-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiAllowListItem, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Remove a given allowed list item
         * @summary Remove from Allow List
         * @param {string} id The unique identifier for the Allow List Item. Primary key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllowListItem: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('deleteAllowListItem', 'id', id);
            const localVarPath = `/aof/allow-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Lookup a single Allow List Item
         * @summary Fetch Allow List Item
         * @param {string} id The unique identifier for the Allow List Item. Primary key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllowListItem: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('fetchAllowListItem', 'id', id);
            const localVarPath = `/aof/allow-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List Allow List Items for a given type and sub-type
         * @summary Search Allow List
         * @param {'IDENTIFIER' | 'ADDRESS' | 'BATCH_P2P'} allowListItemType
         * @param {'EMAIL' | 'PHONE' | 'PARTY_ID' | 'REGION'} allowListItemSubtype
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllowListItems: (allowListItemType, allowListItemSubtype, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'allowListItemType' is not null or undefined
            common_1.assertParamExists('findAllowListItems', 'allowListItemType', allowListItemType);
            // verify required parameter 'allowListItemSubtype' is not null or undefined
            common_1.assertParamExists('findAllowListItems', 'allowListItemSubtype', allowListItemSubtype);
            const localVarPath = `/aof/allow-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (allowListItemType !== undefined) {
                localVarQueryParameter['allowListItemType'] = allowListItemType;
            }
            if (allowListItemSubtype !== undefined) {
                localVarQueryParameter['allowListItemSubtype'] = allowListItemSubtype;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Import a list of Allow List Items from a file input
         * @summary Import Allow List File
         * @param {InlineObject2} [inlineObject2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAllowListItemFile: (inlineObject2, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/allow-list/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inlineObject2, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllowListItems: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchAllowListItems', 'searchParameters', searchParameters);
            const localVarPath = `/aof/allow-list/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update the value of a given allow list item
         * @summary Update Allow List Item
         * @param {string} id The unique identifier for the Allow List Item. Primary key.
         * @param {ApiAllowListItem} apiAllowListItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllowListItem: (id, apiAllowListItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('updateAllowListItem', 'id', id);
            // verify required parameter 'apiAllowListItem' is not null or undefined
            common_1.assertParamExists('updateAllowListItem', 'apiAllowListItem', apiAllowListItem);
            const localVarPath = `/aof/allow-list/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiAllowListItem, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AllowListManagementApi - functional programming interface
 * @export
 */
exports.AllowListManagementApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AllowListManagementApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a new AllowListItem for a given Allow List type and sub-type
         * @summary Add to Allow List
         * @param {ApiAllowListItem} apiAllowListItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAllowListItem(apiAllowListItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAllowListItem(apiAllowListItem, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Remove a given allowed list item
         * @summary Remove from Allow List
         * @param {string} id The unique identifier for the Allow List Item. Primary key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllowListItem(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAllowListItem(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Lookup a single Allow List Item
         * @summary Fetch Allow List Item
         * @param {string} id The unique identifier for the Allow List Item. Primary key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllowListItem(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchAllowListItem(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * List Allow List Items for a given type and sub-type
         * @summary Search Allow List
         * @param {'IDENTIFIER' | 'ADDRESS' | 'BATCH_P2P'} allowListItemType
         * @param {'EMAIL' | 'PHONE' | 'PARTY_ID' | 'REGION'} allowListItemSubtype
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllowListItems(allowListItemType, allowListItemSubtype, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.findAllowListItems(allowListItemType, allowListItemSubtype, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Import a list of Allow List Items from a file input
         * @summary Import Allow List File
         * @param {InlineObject2} [inlineObject2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAllowListItemFile(inlineObject2, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importAllowListItemFile(inlineObject2, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllowListItems(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAllowListItems(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update the value of a given allow list item
         * @summary Update Allow List Item
         * @param {string} id The unique identifier for the Allow List Item. Primary key.
         * @param {ApiAllowListItem} apiAllowListItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllowListItem(id, apiAllowListItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAllowListItem(id, apiAllowListItem, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AllowListManagementApi - factory interface
 * @export
 */
exports.AllowListManagementApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AllowListManagementApiFp(configuration);
    return {
        /**
         * Create a new AllowListItem for a given Allow List type and sub-type
         * @summary Add to Allow List
         * @param {ApiAllowListItem} apiAllowListItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAllowListItem(apiAllowListItem, options) {
            return localVarFp.createAllowListItem(apiAllowListItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a given allowed list item
         * @summary Remove from Allow List
         * @param {string} id The unique identifier for the Allow List Item. Primary key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllowListItem(id, options) {
            return localVarFp.deleteAllowListItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lookup a single Allow List Item
         * @summary Fetch Allow List Item
         * @param {string} id The unique identifier for the Allow List Item. Primary key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllowListItem(id, options) {
            return localVarFp.fetchAllowListItem(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List Allow List Items for a given type and sub-type
         * @summary Search Allow List
         * @param {'IDENTIFIER' | 'ADDRESS' | 'BATCH_P2P'} allowListItemType
         * @param {'EMAIL' | 'PHONE' | 'PARTY_ID' | 'REGION'} allowListItemSubtype
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllowListItems(allowListItemType, allowListItemSubtype, options) {
            return localVarFp.findAllowListItems(allowListItemType, allowListItemSubtype, options).then((request) => request(axios, basePath));
        },
        /**
         * Import a list of Allow List Items from a file input
         * @summary Import Allow List File
         * @param {InlineObject2} [inlineObject2]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAllowListItemFile(inlineObject2, options) {
            return localVarFp.importAllowListItemFile(inlineObject2, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllowListItems(searchParameters, options) {
            return localVarFp.searchAllowListItems(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the value of a given allow list item
         * @summary Update Allow List Item
         * @param {string} id The unique identifier for the Allow List Item. Primary key.
         * @param {ApiAllowListItem} apiAllowListItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllowListItem(id, apiAllowListItem, options) {
            return localVarFp.updateAllowListItem(id, apiAllowListItem, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AllowListManagementApi - object-oriented interface
 * @export
 * @class AllowListManagementApi
 * @extends {BaseAPI}
 */
class AllowListManagementApi extends base_1.BaseAPI {
    /**
     * Create a new AllowListItem for a given Allow List type and sub-type
     * @summary Add to Allow List
     * @param {ApiAllowListItem} apiAllowListItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllowListManagementApi
     */
    createAllowListItem(apiAllowListItem, options) {
        return exports.AllowListManagementApiFp(this.configuration).createAllowListItem(apiAllowListItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove a given allowed list item
     * @summary Remove from Allow List
     * @param {string} id The unique identifier for the Allow List Item. Primary key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllowListManagementApi
     */
    deleteAllowListItem(id, options) {
        return exports.AllowListManagementApiFp(this.configuration).deleteAllowListItem(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Lookup a single Allow List Item
     * @summary Fetch Allow List Item
     * @param {string} id The unique identifier for the Allow List Item. Primary key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllowListManagementApi
     */
    fetchAllowListItem(id, options) {
        return exports.AllowListManagementApiFp(this.configuration).fetchAllowListItem(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List Allow List Items for a given type and sub-type
     * @summary Search Allow List
     * @param {'IDENTIFIER' | 'ADDRESS' | 'BATCH_P2P'} allowListItemType
     * @param {'EMAIL' | 'PHONE' | 'PARTY_ID' | 'REGION'} allowListItemSubtype
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllowListManagementApi
     */
    findAllowListItems(allowListItemType, allowListItemSubtype, options) {
        return exports.AllowListManagementApiFp(this.configuration).findAllowListItems(allowListItemType, allowListItemSubtype, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Import a list of Allow List Items from a file input
     * @summary Import Allow List File
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllowListManagementApi
     */
    importAllowListItemFile(inlineObject2, options) {
        return exports.AllowListManagementApiFp(this.configuration).importAllowListItemFile(inlineObject2, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllowListManagementApi
     */
    searchAllowListItems(searchParameters, options) {
        return exports.AllowListManagementApiFp(this.configuration).searchAllowListItems(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update the value of a given allow list item
     * @summary Update Allow List Item
     * @param {string} id The unique identifier for the Allow List Item. Primary key.
     * @param {ApiAllowListItem} apiAllowListItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllowListManagementApi
     */
    updateAllowListItem(id, apiAllowListItem, options) {
        return exports.AllowListManagementApiFp(this.configuration).updateAllowListItem(id, apiAllowListItem, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AllowListManagementApi = AllowListManagementApi;
/**
 * BackwardsCompatibilityApi - axios parameter creator
 * @export
 */
exports.BackwardsCompatibilityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwitterFeed: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/proxy/twitter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BackwardsCompatibilityApi - functional programming interface
 * @export
 */
exports.BackwardsCompatibilityApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BackwardsCompatibilityApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwitterFeed(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTwitterFeed(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BackwardsCompatibilityApi - factory interface
 * @export
 */
exports.BackwardsCompatibilityApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BackwardsCompatibilityApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwitterFeed(options) {
            return localVarFp.getTwitterFeed(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BackwardsCompatibilityApi - object-oriented interface
 * @export
 * @class BackwardsCompatibilityApi
 * @extends {BaseAPI}
 */
class BackwardsCompatibilityApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackwardsCompatibilityApi
     */
    getTwitterFeed(options) {
        return exports.BackwardsCompatibilityApiFp(this.configuration).getTwitterFeed(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BackwardsCompatibilityApi = BackwardsCompatibilityApi;
/**
 * BankAccountApi - axios parameter creator
 * @export
 */
exports.BankAccountApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Links a new bank account via Plaid. Calls Plaid to get the account details, creates the account in AoF and fetches the Plaid Institution for the account if we don\'t have it already or if it\'s out of date.
         * @summary Create Bank Account
         * @param {ApiCreateBankAccountRequest} apiCreateBankAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccount: (apiCreateBankAccountRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiCreateBankAccountRequest' is not null or undefined
            common_1.assertParamExists('createBankAccount', 'apiCreateBankAccountRequest', apiCreateBankAccountRequest);
            const localVarPath = `/aof/bank-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCreateBankAccountRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create Plaid Event
         * @param {ApiPlaidEvent} apiPlaidEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlaidEvent: (apiPlaidEvent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPlaidEvent' is not null or undefined
            common_1.assertParamExists('createPlaidEvent', 'apiPlaidEvent', apiPlaidEvent);
            const localVarPath = `/aof/bank-account/plaid-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPlaidEvent, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete Plaid Account
         * @param {string} plaidAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaidAccount: (plaidAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'plaidAccountId' is not null or undefined
            common_1.assertParamExists('deletePlaidAccount', 'plaidAccountId', plaidAccountId);
            const localVarPath = `/aof/bank-account/plaid-account/{plaidAccountId}`
                .replace(`{${"plaidAccountId"}}`, encodeURIComponent(String(plaidAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Expire the outstanding pending bank account if one exists for the selected party
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expirePendingBankAccount: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('expirePendingBankAccount', 'partyId', partyId);
            const localVarPath = `/aof/bank-account/verification/expiration/party/{partyId}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expirePendingBankAccount1: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/bank-account/pending-bank-account/expire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a list of accounts that have been linked in Plaid (i.e. account.plaid is non-null) for a given status, if any.  If status is not passed the active and all suspended Plaid accounts will be returned.
         * @summary Get Bank Accounts
         * @param {'ACTIVE' | 'PENDING' | 'SUSPENDED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccounts: (status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/bank-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * new type of token that is created by your app\'s server and passed to your app\'s client to initialize Link.
         * @summary Get Link Token
         * @param {ApiLinkTokenRequest} apiLinkTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkToken: (apiLinkTokenRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiLinkTokenRequest' is not null or undefined
            common_1.assertParamExists('getLinkToken', 'apiLinkTokenRequest', apiLinkTokenRequest);
            const localVarPath = `/aof/link-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiLinkTokenRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Token created by Plaid to initialize Link on client applications.
         * @summary Get Link Token
         * @param {boolean} [forUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkToken1: (forUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/link-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (forUpdate !== undefined) {
                localVarQueryParameter['forUpdate'] = forUpdate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get bank accounts pending verification.
         * @param {Set<'COMPLETE' | 'EXPIRED' | 'PENDING'>} [verificationStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingBankAccounts: (verificationStatus, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/bank-account/pending-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (verificationStatus) {
                localVarQueryParameter['verificationStatus'] = Array.from(verificationStatus);
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create Plaid link failure Event
         * @param {ApiLinkFailurePlaidEvent} apiLinkFailurePlaidEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkFailurePlaidEvent: (apiLinkFailurePlaidEvent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiLinkFailurePlaidEvent' is not null or undefined
            common_1.assertParamExists('linkFailurePlaidEvent', 'apiLinkFailurePlaidEvent', apiLinkFailurePlaidEvent);
            const localVarPath = `/aof/bank-account/plaid-event/link/failure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiLinkFailurePlaidEvent, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary This method to run bank kyc on existing bank account
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performBankKyc: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('performBankKyc', 'partyId', partyId);
            const localVarPath = `/aof/bank-account/party/{partyId}/bank-kyc`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Initialize migration of bank/institution to OAuth
         * @param {ApiBankAuthorizationNotification} apiBankAuthorizationNotification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueBankMigration: (apiBankAuthorizationNotification, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiBankAuthorizationNotification' is not null or undefined
            common_1.assertParamExists('queueBankMigration', 'apiBankAuthorizationNotification', apiBankAuthorizationNotification);
            const localVarPath = `/aof/bank-account/migration/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiBankAuthorizationNotification, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Remove Bank Account
         * @param {ApiRemoveAccountRequest} apiRemoveAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBankAccount: (apiRemoveAccountRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiRemoveAccountRequest' is not null or undefined
            common_1.assertParamExists('removeBankAccount', 'apiRemoveAccountRequest', apiRemoveAccountRequest);
            const localVarPath = `/aof/bank-account/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiRemoveAccountRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search Plaid Account
         * @param {SearchParameters} searchParameters
         * @param {boolean} [includeEncrypted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlaidAccount: (searchParameters, includeEncrypted, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchPlaidAccount', 'searchParameters', searchParameters);
            const localVarPath = `/aof/bank-account/plaid-account/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeEncrypted !== undefined) {
                localVarQueryParameter['includeEncrypted'] = includeEncrypted;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search Plaid Events
         * @param {SearchParameters} searchParameters
         * @param {boolean} [includeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlaidEvents: (searchParameters, includeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchPlaidEvents', 'searchParameters', searchParameters);
            const localVarPath = `/aof/bank-account/plaid-event/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeRequest !== undefined) {
                localVarQueryParameter['includeRequest'] = includeRequest;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Transact Bank Account
         * @param {ApiTransactBankAccountRequest} apiTransactBankAccountRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactBankAccount1: (apiTransactBankAccountRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiTransactBankAccountRequest' is not null or undefined
            common_1.assertParamExists('transactBankAccount1', 'apiTransactBankAccountRequest', apiTransactBankAccountRequest);
            const localVarPath = `/aof/bank-account/transact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiTransactBankAccountRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Unlink Bank Account for specified Party and Account
         * @param {string} partyId
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkBankAccountAsAdministrator: (partyId, accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('unlinkBankAccountAsAdministrator', 'partyId', partyId);
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('unlinkBankAccountAsAdministrator', 'accountId', accountId);
            const localVarPath = `/aof/bank-account/party/{partyId}/account/{accountId}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the LinkStatus between the bank account and plaid
         * @summary Update LinkStatus for the BankAccount
         * @param {ApiBankAccountLinkStatus} apiBankAccountLinkStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountLinkStatus: (apiBankAccountLinkStatus, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiBankAccountLinkStatus' is not null or undefined
            common_1.assertParamExists('updateAccountLinkStatus', 'apiBankAccountLinkStatus', apiBankAccountLinkStatus);
            const localVarPath = `/aof/bank-account/link-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiBankAccountLinkStatus, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Plaid Account
         * @param {ApiPlaidAccount} apiPlaidAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlaidAccount: (apiPlaidAccount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPlaidAccount' is not null or undefined
            common_1.assertParamExists('updatePlaidAccount', 'apiPlaidAccount', apiPlaidAccount);
            const localVarPath = `/aof/bank-account/plaid-account/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPlaidAccount, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify and Activate Pending Bank Account
         * @param {ApiBankAccountLinkStatusUpdateRequest} apiBankAccountLinkStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAndActivatePendingBankAccount: (apiBankAccountLinkStatusUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiBankAccountLinkStatusUpdateRequest' is not null or undefined
            common_1.assertParamExists('verifyAndActivatePendingBankAccount', 'apiBankAccountLinkStatusUpdateRequest', apiBankAccountLinkStatusUpdateRequest);
            const localVarPath = `/aof/bank-account/verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiBankAccountLinkStatusUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BankAccountApi - functional programming interface
 * @export
 */
exports.BankAccountApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BankAccountApiAxiosParamCreator(configuration);
    return {
        /**
         * Links a new bank account via Plaid. Calls Plaid to get the account details, creates the account in AoF and fetches the Plaid Institution for the account if we don\'t have it already or if it\'s out of date.
         * @summary Create Bank Account
         * @param {ApiCreateBankAccountRequest} apiCreateBankAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccount(apiCreateBankAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createBankAccount(apiCreateBankAccountRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create Plaid Event
         * @param {ApiPlaidEvent} apiPlaidEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlaidEvent(apiPlaidEvent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPlaidEvent(apiPlaidEvent, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete Plaid Account
         * @param {string} plaidAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaidAccount(plaidAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePlaidAccount(plaidAccountId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Expire the outstanding pending bank account if one exists for the selected party
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expirePendingBankAccount(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expirePendingBankAccount(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expirePendingBankAccount1(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.expirePendingBankAccount1(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns a list of accounts that have been linked in Plaid (i.e. account.plaid is non-null) for a given status, if any.  If status is not passed the active and all suspended Plaid accounts will be returned.
         * @summary Get Bank Accounts
         * @param {'ACTIVE' | 'PENDING' | 'SUSPENDED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccounts(status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBankAccounts(status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * new type of token that is created by your app\'s server and passed to your app\'s client to initialize Link.
         * @summary Get Link Token
         * @param {ApiLinkTokenRequest} apiLinkTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkToken(apiLinkTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLinkToken(apiLinkTokenRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Token created by Plaid to initialize Link on client applications.
         * @summary Get Link Token
         * @param {boolean} [forUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkToken1(forUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLinkToken1(forUpdate, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get bank accounts pending verification.
         * @param {Set<'COMPLETE' | 'EXPIRED' | 'PENDING'>} [verificationStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingBankAccounts(verificationStatus, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPendingBankAccounts(verificationStatus, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create Plaid link failure Event
         * @param {ApiLinkFailurePlaidEvent} apiLinkFailurePlaidEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkFailurePlaidEvent(apiLinkFailurePlaidEvent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.linkFailurePlaidEvent(apiLinkFailurePlaidEvent, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary This method to run bank kyc on existing bank account
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performBankKyc(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.performBankKyc(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Initialize migration of bank/institution to OAuth
         * @param {ApiBankAuthorizationNotification} apiBankAuthorizationNotification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueBankMigration(apiBankAuthorizationNotification, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queueBankMigration(apiBankAuthorizationNotification, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Remove Bank Account
         * @param {ApiRemoveAccountRequest} apiRemoveAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBankAccount(apiRemoveAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeBankAccount(apiRemoveAccountRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search Plaid Account
         * @param {SearchParameters} searchParameters
         * @param {boolean} [includeEncrypted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlaidAccount(searchParameters, includeEncrypted, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPlaidAccount(searchParameters, includeEncrypted, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search Plaid Events
         * @param {SearchParameters} searchParameters
         * @param {boolean} [includeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlaidEvents(searchParameters, includeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPlaidEvents(searchParameters, includeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Transact Bank Account
         * @param {ApiTransactBankAccountRequest} apiTransactBankAccountRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactBankAccount1(apiTransactBankAccountRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.transactBankAccount1(apiTransactBankAccountRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Unlink Bank Account for specified Party and Account
         * @param {string} partyId
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkBankAccountAsAdministrator(partyId, accountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unlinkBankAccountAsAdministrator(partyId, accountId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates the LinkStatus between the bank account and plaid
         * @summary Update LinkStatus for the BankAccount
         * @param {ApiBankAccountLinkStatus} apiBankAccountLinkStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountLinkStatus(apiBankAccountLinkStatus, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAccountLinkStatus(apiBankAccountLinkStatus, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Plaid Account
         * @param {ApiPlaidAccount} apiPlaidAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlaidAccount(apiPlaidAccount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePlaidAccount(apiPlaidAccount, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Verify and Activate Pending Bank Account
         * @param {ApiBankAccountLinkStatusUpdateRequest} apiBankAccountLinkStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAndActivatePendingBankAccount(apiBankAccountLinkStatusUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyAndActivatePendingBankAccount(apiBankAccountLinkStatusUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BankAccountApi - factory interface
 * @export
 */
exports.BankAccountApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BankAccountApiFp(configuration);
    return {
        /**
         * Links a new bank account via Plaid. Calls Plaid to get the account details, creates the account in AoF and fetches the Plaid Institution for the account if we don\'t have it already or if it\'s out of date.
         * @summary Create Bank Account
         * @param {ApiCreateBankAccountRequest} apiCreateBankAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankAccount(apiCreateBankAccountRequest, options) {
            return localVarFp.createBankAccount(apiCreateBankAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Plaid Event
         * @param {ApiPlaidEvent} apiPlaidEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlaidEvent(apiPlaidEvent, options) {
            return localVarFp.createPlaidEvent(apiPlaidEvent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Plaid Account
         * @param {string} plaidAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaidAccount(plaidAccountId, options) {
            return localVarFp.deletePlaidAccount(plaidAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Expire the outstanding pending bank account if one exists for the selected party
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expirePendingBankAccount(partyId, options) {
            return localVarFp.expirePendingBankAccount(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expirePendingBankAccount1(options) {
            return localVarFp.expirePendingBankAccount1(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of accounts that have been linked in Plaid (i.e. account.plaid is non-null) for a given status, if any.  If status is not passed the active and all suspended Plaid accounts will be returned.
         * @summary Get Bank Accounts
         * @param {'ACTIVE' | 'PENDING' | 'SUSPENDED'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccounts(status, options) {
            return localVarFp.getBankAccounts(status, options).then((request) => request(axios, basePath));
        },
        /**
         * new type of token that is created by your app\'s server and passed to your app\'s client to initialize Link.
         * @summary Get Link Token
         * @param {ApiLinkTokenRequest} apiLinkTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkToken(apiLinkTokenRequest, options) {
            return localVarFp.getLinkToken(apiLinkTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Token created by Plaid to initialize Link on client applications.
         * @summary Get Link Token
         * @param {boolean} [forUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkToken1(forUpdate, options) {
            return localVarFp.getLinkToken1(forUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get bank accounts pending verification.
         * @param {Set<'COMPLETE' | 'EXPIRED' | 'PENDING'>} [verificationStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingBankAccounts(verificationStatus, options) {
            return localVarFp.getPendingBankAccounts(verificationStatus, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Plaid link failure Event
         * @param {ApiLinkFailurePlaidEvent} apiLinkFailurePlaidEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkFailurePlaidEvent(apiLinkFailurePlaidEvent, options) {
            return localVarFp.linkFailurePlaidEvent(apiLinkFailurePlaidEvent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary This method to run bank kyc on existing bank account
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        performBankKyc(partyId, options) {
            return localVarFp.performBankKyc(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Initialize migration of bank/institution to OAuth
         * @param {ApiBankAuthorizationNotification} apiBankAuthorizationNotification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queueBankMigration(apiBankAuthorizationNotification, options) {
            return localVarFp.queueBankMigration(apiBankAuthorizationNotification, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove Bank Account
         * @param {ApiRemoveAccountRequest} apiRemoveAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBankAccount(apiRemoveAccountRequest, options) {
            return localVarFp.removeBankAccount(apiRemoveAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Plaid Account
         * @param {SearchParameters} searchParameters
         * @param {boolean} [includeEncrypted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlaidAccount(searchParameters, includeEncrypted, options) {
            return localVarFp.searchPlaidAccount(searchParameters, includeEncrypted, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Plaid Events
         * @param {SearchParameters} searchParameters
         * @param {boolean} [includeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlaidEvents(searchParameters, includeRequest, options) {
            return localVarFp.searchPlaidEvents(searchParameters, includeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Transact Bank Account
         * @param {ApiTransactBankAccountRequest} apiTransactBankAccountRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactBankAccount1(apiTransactBankAccountRequest, xTrackingId, options) {
            return localVarFp.transactBankAccount1(apiTransactBankAccountRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unlink Bank Account for specified Party and Account
         * @param {string} partyId
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkBankAccountAsAdministrator(partyId, accountId, options) {
            return localVarFp.unlinkBankAccountAsAdministrator(partyId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the LinkStatus between the bank account and plaid
         * @summary Update LinkStatus for the BankAccount
         * @param {ApiBankAccountLinkStatus} apiBankAccountLinkStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountLinkStatus(apiBankAccountLinkStatus, options) {
            return localVarFp.updateAccountLinkStatus(apiBankAccountLinkStatus, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Plaid Account
         * @param {ApiPlaidAccount} apiPlaidAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlaidAccount(apiPlaidAccount, options) {
            return localVarFp.updatePlaidAccount(apiPlaidAccount, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify and Activate Pending Bank Account
         * @param {ApiBankAccountLinkStatusUpdateRequest} apiBankAccountLinkStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAndActivatePendingBankAccount(apiBankAccountLinkStatusUpdateRequest, options) {
            return localVarFp.verifyAndActivatePendingBankAccount(apiBankAccountLinkStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BankAccountApi - object-oriented interface
 * @export
 * @class BankAccountApi
 * @extends {BaseAPI}
 */
class BankAccountApi extends base_1.BaseAPI {
    /**
     * Links a new bank account via Plaid. Calls Plaid to get the account details, creates the account in AoF and fetches the Plaid Institution for the account if we don\'t have it already or if it\'s out of date.
     * @summary Create Bank Account
     * @param {ApiCreateBankAccountRequest} apiCreateBankAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    createBankAccount(apiCreateBankAccountRequest, options) {
        return exports.BankAccountApiFp(this.configuration).createBankAccount(apiCreateBankAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Plaid Event
     * @param {ApiPlaidEvent} apiPlaidEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    createPlaidEvent(apiPlaidEvent, options) {
        return exports.BankAccountApiFp(this.configuration).createPlaidEvent(apiPlaidEvent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Plaid Account
     * @param {string} plaidAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    deletePlaidAccount(plaidAccountId, options) {
        return exports.BankAccountApiFp(this.configuration).deletePlaidAccount(plaidAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Expire the outstanding pending bank account if one exists for the selected party
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    expirePendingBankAccount(partyId, options) {
        return exports.BankAccountApiFp(this.configuration).expirePendingBankAccount(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    expirePendingBankAccount1(options) {
        return exports.BankAccountApiFp(this.configuration).expirePendingBankAccount1(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of accounts that have been linked in Plaid (i.e. account.plaid is non-null) for a given status, if any.  If status is not passed the active and all suspended Plaid accounts will be returned.
     * @summary Get Bank Accounts
     * @param {'ACTIVE' | 'PENDING' | 'SUSPENDED'} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    getBankAccounts(status, options) {
        return exports.BankAccountApiFp(this.configuration).getBankAccounts(status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * new type of token that is created by your app\'s server and passed to your app\'s client to initialize Link.
     * @summary Get Link Token
     * @param {ApiLinkTokenRequest} apiLinkTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    getLinkToken(apiLinkTokenRequest, options) {
        return exports.BankAccountApiFp(this.configuration).getLinkToken(apiLinkTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Token created by Plaid to initialize Link on client applications.
     * @summary Get Link Token
     * @param {boolean} [forUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    getLinkToken1(forUpdate, options) {
        return exports.BankAccountApiFp(this.configuration).getLinkToken1(forUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get bank accounts pending verification.
     * @param {Set<'COMPLETE' | 'EXPIRED' | 'PENDING'>} [verificationStatus]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    getPendingBankAccounts(verificationStatus, options) {
        return exports.BankAccountApiFp(this.configuration).getPendingBankAccounts(verificationStatus, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Plaid link failure Event
     * @param {ApiLinkFailurePlaidEvent} apiLinkFailurePlaidEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    linkFailurePlaidEvent(apiLinkFailurePlaidEvent, options) {
        return exports.BankAccountApiFp(this.configuration).linkFailurePlaidEvent(apiLinkFailurePlaidEvent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary This method to run bank kyc on existing bank account
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    performBankKyc(partyId, options) {
        return exports.BankAccountApiFp(this.configuration).performBankKyc(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Initialize migration of bank/institution to OAuth
     * @param {ApiBankAuthorizationNotification} apiBankAuthorizationNotification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    queueBankMigration(apiBankAuthorizationNotification, options) {
        return exports.BankAccountApiFp(this.configuration).queueBankMigration(apiBankAuthorizationNotification, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove Bank Account
     * @param {ApiRemoveAccountRequest} apiRemoveAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    removeBankAccount(apiRemoveAccountRequest, options) {
        return exports.BankAccountApiFp(this.configuration).removeBankAccount(apiRemoveAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search Plaid Account
     * @param {SearchParameters} searchParameters
     * @param {boolean} [includeEncrypted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    searchPlaidAccount(searchParameters, includeEncrypted, options) {
        return exports.BankAccountApiFp(this.configuration).searchPlaidAccount(searchParameters, includeEncrypted, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search Plaid Events
     * @param {SearchParameters} searchParameters
     * @param {boolean} [includeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    searchPlaidEvents(searchParameters, includeRequest, options) {
        return exports.BankAccountApiFp(this.configuration).searchPlaidEvents(searchParameters, includeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Transact Bank Account
     * @param {ApiTransactBankAccountRequest} apiTransactBankAccountRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    transactBankAccount1(apiTransactBankAccountRequest, xTrackingId, options) {
        return exports.BankAccountApiFp(this.configuration).transactBankAccount1(apiTransactBankAccountRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unlink Bank Account for specified Party and Account
     * @param {string} partyId
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    unlinkBankAccountAsAdministrator(partyId, accountId, options) {
        return exports.BankAccountApiFp(this.configuration).unlinkBankAccountAsAdministrator(partyId, accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the LinkStatus between the bank account and plaid
     * @summary Update LinkStatus for the BankAccount
     * @param {ApiBankAccountLinkStatus} apiBankAccountLinkStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    updateAccountLinkStatus(apiBankAccountLinkStatus, options) {
        return exports.BankAccountApiFp(this.configuration).updateAccountLinkStatus(apiBankAccountLinkStatus, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Plaid Account
     * @param {ApiPlaidAccount} apiPlaidAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    updatePlaidAccount(apiPlaidAccount, options) {
        return exports.BankAccountApiFp(this.configuration).updatePlaidAccount(apiPlaidAccount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify and Activate Pending Bank Account
     * @param {ApiBankAccountLinkStatusUpdateRequest} apiBankAccountLinkStatusUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountApi
     */
    verifyAndActivatePendingBankAccount(apiBankAccountLinkStatusUpdateRequest, options) {
        return exports.BankAccountApiFp(this.configuration).verifyAndActivatePendingBankAccount(apiBankAccountLinkStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BankAccountApi = BankAccountApi;
/**
 * BankAccountPatchesApi - axios parameter creator
 * @export
 */
exports.BankAccountPatchesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Patch Transact Bank Account
         * @param {string} partyId
         * @param {boolean} applyChanges
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactBankAccount: (partyId, applyChanges, fromDate, toDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('transactBankAccount', 'partyId', partyId);
            // verify required parameter 'applyChanges' is not null or undefined
            common_1.assertParamExists('transactBankAccount', 'applyChanges', applyChanges);
            const localVarPath = `/aof/patch/bank-account/transact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (partyId !== undefined) {
                localVarQueryParameter['partyId'] = partyId;
            }
            if (applyChanges !== undefined) {
                localVarQueryParameter['applyChanges'] = applyChanges;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate instanceof Date) ?
                    fromDate.toISOString() :
                    fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate instanceof Date) ?
                    toDate.toISOString() :
                    toDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BankAccountPatchesApi - functional programming interface
 * @export
 */
exports.BankAccountPatchesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BankAccountPatchesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Patch Transact Bank Account
         * @param {string} partyId
         * @param {boolean} applyChanges
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactBankAccount(partyId, applyChanges, fromDate, toDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.transactBankAccount(partyId, applyChanges, fromDate, toDate, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BankAccountPatchesApi - factory interface
 * @export
 */
exports.BankAccountPatchesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BankAccountPatchesApiFp(configuration);
    return {
        /**
         *
         * @summary Patch Transact Bank Account
         * @param {string} partyId
         * @param {boolean} applyChanges
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactBankAccount(partyId, applyChanges, fromDate, toDate, options) {
            return localVarFp.transactBankAccount(partyId, applyChanges, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BankAccountPatchesApi - object-oriented interface
 * @export
 * @class BankAccountPatchesApi
 * @extends {BaseAPI}
 */
class BankAccountPatchesApi extends base_1.BaseAPI {
    /**
     *
     * @summary Patch Transact Bank Account
     * @param {string} partyId
     * @param {boolean} applyChanges
     * @param {string} [fromDate]
     * @param {string} [toDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankAccountPatchesApi
     */
    transactBankAccount(partyId, applyChanges, fromDate, toDate, options) {
        return exports.BankAccountPatchesApiFp(this.configuration).transactBankAccount(partyId, applyChanges, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BankAccountPatchesApi = BankAccountPatchesApi;
/**
 * BusinessPortalAchControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalAchControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} achFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAchFileSummary: (achFileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'achFileId' is not null or undefined
            common_1.assertParamExists('fetchAchFileSummary', 'achFileId', achFileId);
            const localVarPath = `/business-portal/ach-file/summary/{achFileId}`
                .replace(`{${"achFileId"}}`, encodeURIComponent(String(achFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadAchFile: (reportType, filename, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'reportType' is not null or undefined
            common_1.assertParamExists('generateDownloadAchFile', 'reportType', reportType);
            // verify required parameter 'filename' is not null or undefined
            common_1.assertParamExists('generateDownloadAchFile', 'filename', filename);
            const localVarPath = `/business-portal/ach-file/download/{reportType}/{filename}`
                .replace(`{${"reportType"}}`, encodeURIComponent(String(reportType)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileDetail: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchAchFileDetail', 'searchParameters', searchParameters);
            const localVarPath = `/business-portal/ach-file/enriched-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} achFileId
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileDetail1: (achFileId, searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'achFileId' is not null or undefined
            common_1.assertParamExists('searchAchFileDetail1', 'achFileId', achFileId);
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchAchFileDetail1', 'searchParameters', searchParameters);
            const localVarPath = `/business-portal/ach-file/enriched-details/{achFileId}`
                .replace(`{${"achFileId"}}`, encodeURIComponent(String(achFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileSummaryView: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchAchFileSummaryView', 'searchParameters', searchParameters);
            const localVarPath = `/business-portal/ach-file/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalAchControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalAchControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalAchControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} achFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAchFileSummary(achFileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchAchFileSummary(achFileId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadAchFile(reportType, filename, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateDownloadAchFile(reportType, filename, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileDetail(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAchFileDetail(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} achFileId
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileDetail1(achFileId, searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAchFileDetail1(achFileId, searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileSummaryView(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAchFileSummaryView(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalAchControllerApi - factory interface
 * @export
 */
exports.BusinessPortalAchControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalAchControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} achFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAchFileSummary(achFileId, options) {
            return localVarFp.fetchAchFileSummary(achFileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadAchFile(reportType, filename, options) {
            return localVarFp.generateDownloadAchFile(reportType, filename, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileDetail(searchParameters, options) {
            return localVarFp.searchAchFileDetail(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} achFileId
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileDetail1(achFileId, searchParameters, options) {
            return localVarFp.searchAchFileDetail1(achFileId, searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAchFileSummaryView(searchParameters, options) {
            return localVarFp.searchAchFileSummaryView(searchParameters, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalAchControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalAchControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalAchControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} achFileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalAchControllerApi
     */
    fetchAchFileSummary(achFileId, options) {
        return exports.BusinessPortalAchControllerApiFp(this.configuration).fetchAchFileSummary(achFileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalAchControllerApi
     */
    generateDownloadAchFile(reportType, filename, options) {
        return exports.BusinessPortalAchControllerApiFp(this.configuration).generateDownloadAchFile(reportType, filename, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalAchControllerApi
     */
    searchAchFileDetail(searchParameters, options) {
        return exports.BusinessPortalAchControllerApiFp(this.configuration).searchAchFileDetail(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} achFileId
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalAchControllerApi
     */
    searchAchFileDetail1(achFileId, searchParameters, options) {
        return exports.BusinessPortalAchControllerApiFp(this.configuration).searchAchFileDetail1(achFileId, searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalAchControllerApi
     */
    searchAchFileSummaryView(searchParameters, options) {
        return exports.BusinessPortalAchControllerApiFp(this.configuration).searchAchFileSummaryView(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalAchControllerApi = BusinessPortalAchControllerApi;
/**
 * BusinessPortalBankAccountControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalBankAccountControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiTimeRange} apiTimeRange
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBlacklistedBankAccount: (apiTimeRange, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiTimeRange' is not null or undefined
            common_1.assertParamExists('fetchBlacklistedBankAccount', 'apiTimeRange', apiTimeRange);
            const localVarPath = `/business-portal/bankaccount/blacklist/consumers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiTimeRange, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBlacklistedConsumerReportSummary: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/bankaccount/blacklist/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiTimeRange} apiTimeRange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBlacklistedInstitutionAccount: (apiTimeRange, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiTimeRange' is not null or undefined
            common_1.assertParamExists('fetchBlacklistedInstitutionAccount', 'apiTimeRange', apiTimeRange);
            const localVarPath = `/business-portal/bankaccount/blacklist/institution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiTimeRange, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} institutionId
         * @param {ApiTimeRange} apiTimeRange
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartiesByBlacklistInstitution: (institutionId, apiTimeRange, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'institutionId' is not null or undefined
            common_1.assertParamExists('fetchPartiesByBlacklistInstitution', 'institutionId', institutionId);
            // verify required parameter 'apiTimeRange' is not null or undefined
            common_1.assertParamExists('fetchPartiesByBlacklistInstitution', 'apiTimeRange', apiTimeRange);
            const localVarPath = `/business-portal/bankaccount/blacklist/institution/{institutionId}/parties`
                .replace(`{${"institutionId"}}`, encodeURIComponent(String(institutionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiTimeRange, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} plaidAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskAccountNumber1: (plaidAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'plaidAccountId' is not null or undefined
            common_1.assertParamExists('unmaskAccountNumber1', 'plaidAccountId', plaidAccountId);
            const localVarPath = `/business-portal/bankaccount/{plaidAccountId}/accountNumber/unmask`
                .replace(`{${"plaidAccountId"}}`, encodeURIComponent(String(plaidAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} plaidAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskRoutingNumber: (plaidAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'plaidAccountId' is not null or undefined
            common_1.assertParamExists('unmaskRoutingNumber', 'plaidAccountId', plaidAccountId);
            const localVarPath = `/business-portal/bankaccount/{plaidAccountId}/routingNumber/unmask`
                .replace(`{${"plaidAccountId"}}`, encodeURIComponent(String(plaidAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalBankAccountControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalBankAccountControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalBankAccountControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiTimeRange} apiTimeRange
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBlacklistedBankAccount(apiTimeRange, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchBlacklistedBankAccount(apiTimeRange, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBlacklistedConsumerReportSummary(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchBlacklistedConsumerReportSummary(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiTimeRange} apiTimeRange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBlacklistedInstitutionAccount(apiTimeRange, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchBlacklistedInstitutionAccount(apiTimeRange, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} institutionId
         * @param {ApiTimeRange} apiTimeRange
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartiesByBlacklistInstitution(institutionId, apiTimeRange, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchPartiesByBlacklistInstitution(institutionId, apiTimeRange, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} plaidAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskAccountNumber1(plaidAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unmaskAccountNumber1(plaidAccountId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} plaidAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskRoutingNumber(plaidAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unmaskRoutingNumber(plaidAccountId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalBankAccountControllerApi - factory interface
 * @export
 */
exports.BusinessPortalBankAccountControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalBankAccountControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ApiTimeRange} apiTimeRange
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBlacklistedBankAccount(apiTimeRange, page, size, sort, options) {
            return localVarFp.fetchBlacklistedBankAccount(apiTimeRange, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBlacklistedConsumerReportSummary(options) {
            return localVarFp.fetchBlacklistedConsumerReportSummary(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiTimeRange} apiTimeRange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBlacklistedInstitutionAccount(apiTimeRange, options) {
            return localVarFp.fetchBlacklistedInstitutionAccount(apiTimeRange, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} institutionId
         * @param {ApiTimeRange} apiTimeRange
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartiesByBlacklistInstitution(institutionId, apiTimeRange, page, size, sort, options) {
            return localVarFp.fetchPartiesByBlacklistInstitution(institutionId, apiTimeRange, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} plaidAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskAccountNumber1(plaidAccountId, options) {
            return localVarFp.unmaskAccountNumber1(plaidAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} plaidAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskRoutingNumber(plaidAccountId, options) {
            return localVarFp.unmaskRoutingNumber(plaidAccountId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalBankAccountControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalBankAccountControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalBankAccountControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApiTimeRange} apiTimeRange
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalBankAccountControllerApi
     */
    fetchBlacklistedBankAccount(apiTimeRange, page, size, sort, options) {
        return exports.BusinessPortalBankAccountControllerApiFp(this.configuration).fetchBlacklistedBankAccount(apiTimeRange, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalBankAccountControllerApi
     */
    fetchBlacklistedConsumerReportSummary(options) {
        return exports.BusinessPortalBankAccountControllerApiFp(this.configuration).fetchBlacklistedConsumerReportSummary(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiTimeRange} apiTimeRange
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalBankAccountControllerApi
     */
    fetchBlacklistedInstitutionAccount(apiTimeRange, options) {
        return exports.BusinessPortalBankAccountControllerApiFp(this.configuration).fetchBlacklistedInstitutionAccount(apiTimeRange, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} institutionId
     * @param {ApiTimeRange} apiTimeRange
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalBankAccountControllerApi
     */
    fetchPartiesByBlacklistInstitution(institutionId, apiTimeRange, page, size, sort, options) {
        return exports.BusinessPortalBankAccountControllerApiFp(this.configuration).fetchPartiesByBlacklistInstitution(institutionId, apiTimeRange, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} plaidAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalBankAccountControllerApi
     */
    unmaskAccountNumber1(plaidAccountId, options) {
        return exports.BusinessPortalBankAccountControllerApiFp(this.configuration).unmaskAccountNumber1(plaidAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} plaidAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalBankAccountControllerApi
     */
    unmaskRoutingNumber(plaidAccountId, options) {
        return exports.BusinessPortalBankAccountControllerApiFp(this.configuration).unmaskRoutingNumber(plaidAccountId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalBankAccountControllerApi = BusinessPortalBankAccountControllerApi;
/**
 * BusinessPortalCardControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalCardControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiDigitalCardRequest} apiDigitalCardRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllDigitalCards: (apiDigitalCardRequest, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiDigitalCardRequest' is not null or undefined
            common_1.assertParamExists('fetchAllDigitalCards', 'apiDigitalCardRequest', apiDigitalCardRequest);
            const localVarPath = `/business-portal/card/devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDigitalCardRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllTerminatedCards: (body, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            common_1.assertParamExists('fetchAllTerminatedCards', 'body', body);
            const localVarPath = `/business-portal/card/terminated-cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCardDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('fetchCardDetails', 'partyId', partyId);
            const localVarPath = `/business-portal/card/details/{partyId}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} digitalCardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDigitalCardDetails: (digitalCardId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'digitalCardId' is not null or undefined
            common_1.assertParamExists('fetchDigitalCardDetails', 'digitalCardId', digitalCardId);
            const localVarPath = `/business-portal/card/digital-card/{digitalCardId}`
                .replace(`{${"digitalCardId"}}`, encodeURIComponent(String(digitalCardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchIssuerPartyDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('fetchIssuerPartyDetails', 'partyId', partyId);
            const localVarPath = `/business-portal/card/issuer-party/{partyId}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdatedIssuerPartyDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getUpdatedIssuerPartyDetails', 'partyId', partyId);
            const localVarPath = `/business-portal/card/issuer-party/status/{partyId}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardIssuerKYCStatus: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('updateCardIssuerKYCStatus', 'partyId', partyId);
            const localVarPath = `/business-portal/card/issuer-party/{partyId}/kyc`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiCardActionRequest} apiCardActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardStatus: (apiCardActionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiCardActionRequest' is not null or undefined
            common_1.assertParamExists('updateCardStatus', 'apiCardActionRequest', apiCardActionRequest);
            const localVarPath = `/business-portal/card/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCardActionRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiDigitalCardActionRequest} apiDigitalCardActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDigitalCardStatus: (apiDigitalCardActionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiDigitalCardActionRequest' is not null or undefined
            common_1.assertParamExists('updateDigitalCardStatus', 'apiDigitalCardActionRequest', apiDigitalCardActionRequest);
            const localVarPath = `/business-portal/card/digital-card/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDigitalCardActionRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalCardControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalCardControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalCardControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiDigitalCardRequest} apiDigitalCardRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllDigitalCards(apiDigitalCardRequest, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchAllDigitalCards(apiDigitalCardRequest, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} body
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllTerminatedCards(body, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchAllTerminatedCards(body, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCardDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchCardDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} digitalCardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDigitalCardDetails(digitalCardId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchDigitalCardDetails(digitalCardId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchIssuerPartyDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchIssuerPartyDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdatedIssuerPartyDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUpdatedIssuerPartyDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardIssuerKYCStatus(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCardIssuerKYCStatus(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiCardActionRequest} apiCardActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardStatus(apiCardActionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCardStatus(apiCardActionRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiDigitalCardActionRequest} apiDigitalCardActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDigitalCardStatus(apiDigitalCardActionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDigitalCardStatus(apiDigitalCardActionRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalCardControllerApi - factory interface
 * @export
 */
exports.BusinessPortalCardControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalCardControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ApiDigitalCardRequest} apiDigitalCardRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllDigitalCards(apiDigitalCardRequest, page, size, sort, options) {
            return localVarFp.fetchAllDigitalCards(apiDigitalCardRequest, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} body
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllTerminatedCards(body, page, size, sort, options) {
            return localVarFp.fetchAllTerminatedCards(body, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchCardDetails(partyId, options) {
            return localVarFp.fetchCardDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} digitalCardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDigitalCardDetails(digitalCardId, options) {
            return localVarFp.fetchDigitalCardDetails(digitalCardId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchIssuerPartyDetails(partyId, options) {
            return localVarFp.fetchIssuerPartyDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpdatedIssuerPartyDetails(partyId, options) {
            return localVarFp.getUpdatedIssuerPartyDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardIssuerKYCStatus(partyId, options) {
            return localVarFp.updateCardIssuerKYCStatus(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiCardActionRequest} apiCardActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardStatus(apiCardActionRequest, options) {
            return localVarFp.updateCardStatus(apiCardActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiDigitalCardActionRequest} apiDigitalCardActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDigitalCardStatus(apiDigitalCardActionRequest, options) {
            return localVarFp.updateDigitalCardStatus(apiDigitalCardActionRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalCardControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalCardControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalCardControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApiDigitalCardRequest} apiDigitalCardRequest
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalCardControllerApi
     */
    fetchAllDigitalCards(apiDigitalCardRequest, page, size, sort, options) {
        return exports.BusinessPortalCardControllerApiFp(this.configuration).fetchAllDigitalCards(apiDigitalCardRequest, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} body
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalCardControllerApi
     */
    fetchAllTerminatedCards(body, page, size, sort, options) {
        return exports.BusinessPortalCardControllerApiFp(this.configuration).fetchAllTerminatedCards(body, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalCardControllerApi
     */
    fetchCardDetails(partyId, options) {
        return exports.BusinessPortalCardControllerApiFp(this.configuration).fetchCardDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} digitalCardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalCardControllerApi
     */
    fetchDigitalCardDetails(digitalCardId, options) {
        return exports.BusinessPortalCardControllerApiFp(this.configuration).fetchDigitalCardDetails(digitalCardId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalCardControllerApi
     */
    fetchIssuerPartyDetails(partyId, options) {
        return exports.BusinessPortalCardControllerApiFp(this.configuration).fetchIssuerPartyDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalCardControllerApi
     */
    getUpdatedIssuerPartyDetails(partyId, options) {
        return exports.BusinessPortalCardControllerApiFp(this.configuration).getUpdatedIssuerPartyDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalCardControllerApi
     */
    updateCardIssuerKYCStatus(partyId, options) {
        return exports.BusinessPortalCardControllerApiFp(this.configuration).updateCardIssuerKYCStatus(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiCardActionRequest} apiCardActionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalCardControllerApi
     */
    updateCardStatus(apiCardActionRequest, options) {
        return exports.BusinessPortalCardControllerApiFp(this.configuration).updateCardStatus(apiCardActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiDigitalCardActionRequest} apiDigitalCardActionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalCardControllerApi
     */
    updateDigitalCardStatus(apiDigitalCardActionRequest, options) {
        return exports.BusinessPortalCardControllerApiFp(this.configuration).updateDigitalCardStatus(apiDigitalCardActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalCardControllerApi = BusinessPortalCardControllerApi;
/**
 * BusinessPortalDisputeControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalDisputeControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiDisputeRejectionReason} apiDisputeRejectionReason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDisputeRejectionReason: (apiDisputeRejectionReason, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiDisputeRejectionReason' is not null or undefined
            common_1.assertParamExists('addDisputeRejectionReason', 'apiDisputeRejectionReason', apiDisputeRejectionReason);
            const localVarPath = `/business-portal/dispute/reject/reason`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeRejectionReason, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveChargeBack: (disputeId, apiDisputeChargebackRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'disputeId' is not null or undefined
            common_1.assertParamExists('approveChargeBack', 'disputeId', disputeId);
            // verify required parameter 'apiDisputeChargebackRequest' is not null or undefined
            common_1.assertParamExists('approveChargeBack', 'apiDisputeChargebackRequest', apiDisputeChargebackRequest);
            const localVarPath = `/business-portal/dispute/merchant/{disputeId}/accept`
                .replace(`{${"disputeId"}}`, encodeURIComponent(String(disputeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeChargebackRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeAcceptRequest} apiDisputeAcceptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCredit: (disputeId, apiDisputeAcceptRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'disputeId' is not null or undefined
            common_1.assertParamExists('approveCredit', 'disputeId', disputeId);
            // verify required parameter 'apiDisputeAcceptRequest' is not null or undefined
            common_1.assertParamExists('approveCredit', 'apiDisputeAcceptRequest', apiDisputeAcceptRequest);
            const localVarPath = `/business-portal/dispute/{disputeId}/accept`
                .replace(`{${"disputeId"}}`, encodeURIComponent(String(disputeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeAcceptRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeCancelRequest} apiDisputeCancelRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDispute: (disputeId, apiDisputeCancelRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'disputeId' is not null or undefined
            common_1.assertParamExists('cancelDispute', 'disputeId', disputeId);
            // verify required parameter 'apiDisputeCancelRequest' is not null or undefined
            common_1.assertParamExists('cancelDispute', 'apiDisputeCancelRequest', apiDisputeCancelRequest);
            const localVarPath = `/business-portal/dispute/{disputeId}/cancel`
                .replace(`{${"disputeId"}}`, encodeURIComponent(String(disputeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeCancelRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiDisputeCreateRequest} apiDisputeCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispute: (apiDisputeCreateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiDisputeCreateRequest' is not null or undefined
            common_1.assertParamExists('createDispute', 'apiDisputeCreateRequest', apiDisputeCreateRequest);
            const localVarPath = `/business-portal/dispute/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeCreateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} reasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDisputeRejectionReasonById: (reasonId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'reasonId' is not null or undefined
            common_1.assertParamExists('deleteDisputeRejectionReasonById', 'reasonId', reasonId);
            const localVarPath = `/business-portal/dispute/reject/reason/{reasonId}`
                .replace(`{${"reasonId"}}`, encodeURIComponent(String(reasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeEscalateRequest} apiDisputeEscalateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateDispute: (disputeId, apiDisputeEscalateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'disputeId' is not null or undefined
            common_1.assertParamExists('escalateDispute', 'disputeId', disputeId);
            // verify required parameter 'apiDisputeEscalateRequest' is not null or undefined
            common_1.assertParamExists('escalateDispute', 'apiDisputeEscalateRequest', apiDisputeEscalateRequest);
            const localVarPath = `/business-portal/dispute/{disputeId}/escalate`
                .replace(`{${"disputeId"}}`, encodeURIComponent(String(disputeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeEscalateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeRejectRequest} apiDisputeRejectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCredit: (disputeId, apiDisputeRejectRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'disputeId' is not null or undefined
            common_1.assertParamExists('rejectCredit', 'disputeId', disputeId);
            // verify required parameter 'apiDisputeRejectRequest' is not null or undefined
            common_1.assertParamExists('rejectCredit', 'apiDisputeRejectRequest', apiDisputeRejectRequest);
            const localVarPath = `/business-portal/dispute/{disputeId}/reject`
                .replace(`{${"disputeId"}}`, encodeURIComponent(String(disputeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeRejectRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} reasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDisputeRejectionReasonById: (reasonId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'reasonId' is not null or undefined
            common_1.assertParamExists('retrieveDisputeRejectionReasonById', 'reasonId', reasonId);
            const localVarPath = `/business-portal/dispute/reject/reason/{reasonId}`
                .replace(`{${"reasonId"}}`, encodeURIComponent(String(reasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDisputeRejectionReasons: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/dispute/reject/reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeRegulationERequest} apiDisputeRegulationERequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegulationEFlag: (disputeId, apiDisputeRegulationERequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'disputeId' is not null or undefined
            common_1.assertParamExists('updateRegulationEFlag', 'disputeId', disputeId);
            // verify required parameter 'apiDisputeRegulationERequest' is not null or undefined
            common_1.assertParamExists('updateRegulationEFlag', 'apiDisputeRegulationERequest', apiDisputeRegulationERequest);
            const localVarPath = `/business-portal/dispute/{disputeId}/regulation-e-flag`
                .replace(`{${"disputeId"}}`, encodeURIComponent(String(disputeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeRegulationERequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalDisputeControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalDisputeControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalDisputeControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiDisputeRejectionReason} apiDisputeRejectionReason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDisputeRejectionReason(apiDisputeRejectionReason, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addDisputeRejectionReason(apiDisputeRejectionReason, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveChargeBack(disputeId, apiDisputeChargebackRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.approveChargeBack(disputeId, apiDisputeChargebackRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeAcceptRequest} apiDisputeAcceptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCredit(disputeId, apiDisputeAcceptRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.approveCredit(disputeId, apiDisputeAcceptRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeCancelRequest} apiDisputeCancelRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDispute(disputeId, apiDisputeCancelRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelDispute(disputeId, apiDisputeCancelRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiDisputeCreateRequest} apiDisputeCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispute(apiDisputeCreateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDispute(apiDisputeCreateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} reasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDisputeRejectionReasonById(reasonId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDisputeRejectionReasonById(reasonId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeEscalateRequest} apiDisputeEscalateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateDispute(disputeId, apiDisputeEscalateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.escalateDispute(disputeId, apiDisputeEscalateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeRejectRequest} apiDisputeRejectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCredit(disputeId, apiDisputeRejectRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rejectCredit(disputeId, apiDisputeRejectRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} reasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDisputeRejectionReasonById(reasonId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveDisputeRejectionReasonById(reasonId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDisputeRejectionReasons(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveDisputeRejectionReasons(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeRegulationERequest} apiDisputeRegulationERequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegulationEFlag(disputeId, apiDisputeRegulationERequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateRegulationEFlag(disputeId, apiDisputeRegulationERequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalDisputeControllerApi - factory interface
 * @export
 */
exports.BusinessPortalDisputeControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalDisputeControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ApiDisputeRejectionReason} apiDisputeRejectionReason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDisputeRejectionReason(apiDisputeRejectionReason, options) {
            return localVarFp.addDisputeRejectionReason(apiDisputeRejectionReason, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveChargeBack(disputeId, apiDisputeChargebackRequest, options) {
            return localVarFp.approveChargeBack(disputeId, apiDisputeChargebackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeAcceptRequest} apiDisputeAcceptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveCredit(disputeId, apiDisputeAcceptRequest, options) {
            return localVarFp.approveCredit(disputeId, apiDisputeAcceptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeCancelRequest} apiDisputeCancelRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDispute(disputeId, apiDisputeCancelRequest, options) {
            return localVarFp.cancelDispute(disputeId, apiDisputeCancelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiDisputeCreateRequest} apiDisputeCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDispute(apiDisputeCreateRequest, options) {
            return localVarFp.createDispute(apiDisputeCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} reasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDisputeRejectionReasonById(reasonId, options) {
            return localVarFp.deleteDisputeRejectionReasonById(reasonId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeEscalateRequest} apiDisputeEscalateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        escalateDispute(disputeId, apiDisputeEscalateRequest, options) {
            return localVarFp.escalateDispute(disputeId, apiDisputeEscalateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeRejectRequest} apiDisputeRejectRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectCredit(disputeId, apiDisputeRejectRequest, options) {
            return localVarFp.rejectCredit(disputeId, apiDisputeRejectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} reasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDisputeRejectionReasonById(reasonId, options) {
            return localVarFp.retrieveDisputeRejectionReasonById(reasonId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDisputeRejectionReasons(options) {
            return localVarFp.retrieveDisputeRejectionReasons(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeRegulationERequest} apiDisputeRegulationERequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRegulationEFlag(disputeId, apiDisputeRegulationERequest, options) {
            return localVarFp.updateRegulationEFlag(disputeId, apiDisputeRegulationERequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalDisputeControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalDisputeControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalDisputeControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApiDisputeRejectionReason} apiDisputeRejectionReason
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    addDisputeRejectionReason(apiDisputeRejectionReason, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).addDisputeRejectionReason(apiDisputeRejectionReason, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} disputeId
     * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    approveChargeBack(disputeId, apiDisputeChargebackRequest, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).approveChargeBack(disputeId, apiDisputeChargebackRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} disputeId
     * @param {ApiDisputeAcceptRequest} apiDisputeAcceptRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    approveCredit(disputeId, apiDisputeAcceptRequest, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).approveCredit(disputeId, apiDisputeAcceptRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} disputeId
     * @param {ApiDisputeCancelRequest} apiDisputeCancelRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    cancelDispute(disputeId, apiDisputeCancelRequest, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).cancelDispute(disputeId, apiDisputeCancelRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiDisputeCreateRequest} apiDisputeCreateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    createDispute(apiDisputeCreateRequest, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).createDispute(apiDisputeCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} reasonId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    deleteDisputeRejectionReasonById(reasonId, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).deleteDisputeRejectionReasonById(reasonId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} disputeId
     * @param {ApiDisputeEscalateRequest} apiDisputeEscalateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    escalateDispute(disputeId, apiDisputeEscalateRequest, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).escalateDispute(disputeId, apiDisputeEscalateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} disputeId
     * @param {ApiDisputeRejectRequest} apiDisputeRejectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    rejectCredit(disputeId, apiDisputeRejectRequest, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).rejectCredit(disputeId, apiDisputeRejectRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} reasonId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    retrieveDisputeRejectionReasonById(reasonId, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).retrieveDisputeRejectionReasonById(reasonId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    retrieveDisputeRejectionReasons(options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).retrieveDisputeRejectionReasons(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} disputeId
     * @param {ApiDisputeRegulationERequest} apiDisputeRegulationERequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalDisputeControllerApi
     */
    updateRegulationEFlag(disputeId, apiDisputeRegulationERequest, options) {
        return exports.BusinessPortalDisputeControllerApiFp(this.configuration).updateRegulationEFlag(disputeId, apiDisputeRegulationERequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalDisputeControllerApi = BusinessPortalDisputeControllerApi;
/**
 * BusinessPortalGiftCardControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalGiftCardControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllGiftCardBrands: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/giftcard/brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBrandDetailsByBrandId: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('fetchBrandDetailsByBrandId', 'id', id);
            const localVarPath = `/business-portal/giftcard/brand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFeaturedGiftCardBrands: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/giftcard/brand/featured`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} giftcardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardActivities: (giftcardId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'giftcardId' is not null or undefined
            common_1.assertParamExists('fetchGiftCardActivities', 'giftcardId', giftcardId);
            const localVarPath = `/business-portal/giftCards/activities/{giftcardId}`
                .replace(`{${"giftcardId"}}`, encodeURIComponent(String(giftcardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardBalance: (giftCardRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'giftCardRequest' is not null or undefined
            common_1.assertParamExists('fetchGiftCardBalance', 'giftCardRequest', giftCardRequest);
            const localVarPath = `/business-portal/giftCards/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(giftCardRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardBrandActivity: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('fetchGiftCardBrandActivity', 'id', id);
            const localVarPath = `/business-portal/giftcard/brand/activity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardBrandsAndProducts: (value, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'value' is not null or undefined
            common_1.assertParamExists('fetchGiftCardBrandsAndProducts', 'value', value);
            const localVarPath = `/business-portal/giftcard/brand/product/{value}`
                .replace(`{${"value"}}`, encodeURIComponent(String(value)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardById: (giftCardRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'giftCardRequest' is not null or undefined
            common_1.assertParamExists('fetchGiftCardById', 'giftCardRequest', giftCardRequest);
            const localVarPath = `/business-portal/giftcard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(giftCardRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardProductById: (productId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            common_1.assertParamExists('fetchGiftCardProductById', 'productId', productId);
            const localVarPath = `/business-portal/giftcard/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardProductsByBrand: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('fetchGiftCardProductsByBrand', 'id', id);
            const localVarPath = `/business-portal/giftcard/brand/{id}/product`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCards: (giftCardRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'giftCardRequest' is not null or undefined
            common_1.assertParamExists('fetchGiftCards', 'giftCardRequest', giftCardRequest);
            const localVarPath = `/business-portal/giftCards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(giftCardRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLastCatalogRefreshStatus: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/giftcard/catalog/refresh/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateGiftCard: (giftCardRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'giftCardRequest' is not null or undefined
            common_1.assertParamExists('reactivateGiftCard', 'giftCardRequest', giftCardRequest);
            const localVarPath = `/business-portal/giftCards/reactivate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(giftCardRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCatalog: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/giftcard/catalog/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUpdateGiftCardBrandFeaturedRank} apiUpdateGiftCardBrandFeaturedRank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeaturedMerchantRanks: (apiUpdateGiftCardBrandFeaturedRank, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUpdateGiftCardBrandFeaturedRank' is not null or undefined
            common_1.assertParamExists('setFeaturedMerchantRanks', 'apiUpdateGiftCardBrandFeaturedRank', apiUpdateGiftCardBrandFeaturedRank);
            const localVarPath = `/business-portal/giftcard/brand/featured`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateGiftCardBrandFeaturedRank, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} field
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskGiftcardField: (field, giftCardRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'field' is not null or undefined
            common_1.assertParamExists('unmaskGiftcardField', 'field', field);
            // verify required parameter 'giftCardRequest' is not null or undefined
            common_1.assertParamExists('unmaskGiftcardField', 'giftCardRequest', giftCardRequest);
            const localVarPath = `/business-portal/giftcard/{field}/unmask`
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(giftCardRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {ApiUpdateGiftCardBrand} apiUpdateGiftCardBrand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGiftCardBrand: (id, apiUpdateGiftCardBrand, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('updateGiftCardBrand', 'id', id);
            // verify required parameter 'apiUpdateGiftCardBrand' is not null or undefined
            common_1.assertParamExists('updateGiftCardBrand', 'apiUpdateGiftCardBrand', apiUpdateGiftCardBrand);
            const localVarPath = `/business-portal/giftcard/brand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateGiftCardBrand, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalGiftCardControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalGiftCardControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalGiftCardControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllGiftCardBrands(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchAllGiftCardBrands(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBrandDetailsByBrandId(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchBrandDetailsByBrandId(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFeaturedGiftCardBrands(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchFeaturedGiftCardBrands(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} giftcardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardActivities(giftcardId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchGiftCardActivities(giftcardId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardBalance(giftCardRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchGiftCardBalance(giftCardRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardBrandActivity(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchGiftCardBrandActivity(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardBrandsAndProducts(value, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchGiftCardBrandsAndProducts(value, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardById(giftCardRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchGiftCardById(giftCardRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardProductById(productId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchGiftCardProductById(productId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardProductsByBrand(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchGiftCardProductsByBrand(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCards(giftCardRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchGiftCards(giftCardRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLastCatalogRefreshStatus(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchLastCatalogRefreshStatus(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateGiftCard(giftCardRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reactivateGiftCard(giftCardRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCatalog(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshCatalog(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUpdateGiftCardBrandFeaturedRank} apiUpdateGiftCardBrandFeaturedRank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeaturedMerchantRanks(apiUpdateGiftCardBrandFeaturedRank, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setFeaturedMerchantRanks(apiUpdateGiftCardBrandFeaturedRank, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} field
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskGiftcardField(field, giftCardRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unmaskGiftcardField(field, giftCardRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {ApiUpdateGiftCardBrand} apiUpdateGiftCardBrand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGiftCardBrand(id, apiUpdateGiftCardBrand, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateGiftCardBrand(id, apiUpdateGiftCardBrand, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalGiftCardControllerApi - factory interface
 * @export
 */
exports.BusinessPortalGiftCardControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalGiftCardControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAllGiftCardBrands(options) {
            return localVarFp.fetchAllGiftCardBrands(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBrandDetailsByBrandId(id, options) {
            return localVarFp.fetchBrandDetailsByBrandId(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFeaturedGiftCardBrands(options) {
            return localVarFp.fetchFeaturedGiftCardBrands(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} giftcardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardActivities(giftcardId, options) {
            return localVarFp.fetchGiftCardActivities(giftcardId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardBalance(giftCardRequest, options) {
            return localVarFp.fetchGiftCardBalance(giftCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardBrandActivity(id, options) {
            return localVarFp.fetchGiftCardBrandActivity(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardBrandsAndProducts(value, options) {
            return localVarFp.fetchGiftCardBrandsAndProducts(value, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardById(giftCardRequest, options) {
            return localVarFp.fetchGiftCardById(giftCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardProductById(productId, options) {
            return localVarFp.fetchGiftCardProductById(productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCardProductsByBrand(id, options) {
            return localVarFp.fetchGiftCardProductsByBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchGiftCards(giftCardRequest, options) {
            return localVarFp.fetchGiftCards(giftCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLastCatalogRefreshStatus(options) {
            return localVarFp.fetchLastCatalogRefreshStatus(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateGiftCard(giftCardRequest, options) {
            return localVarFp.reactivateGiftCard(giftCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCatalog(options) {
            return localVarFp.refreshCatalog(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUpdateGiftCardBrandFeaturedRank} apiUpdateGiftCardBrandFeaturedRank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeaturedMerchantRanks(apiUpdateGiftCardBrandFeaturedRank, options) {
            return localVarFp.setFeaturedMerchantRanks(apiUpdateGiftCardBrandFeaturedRank, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} field
         * @param {GiftCardRequest} giftCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskGiftcardField(field, giftCardRequest, options) {
            return localVarFp.unmaskGiftcardField(field, giftCardRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {ApiUpdateGiftCardBrand} apiUpdateGiftCardBrand
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGiftCardBrand(id, apiUpdateGiftCardBrand, options) {
            return localVarFp.updateGiftCardBrand(id, apiUpdateGiftCardBrand, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalGiftCardControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalGiftCardControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalGiftCardControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchAllGiftCardBrands(options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchAllGiftCardBrands(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchBrandDetailsByBrandId(id, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchBrandDetailsByBrandId(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchFeaturedGiftCardBrands(options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchFeaturedGiftCardBrands(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} giftcardId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchGiftCardActivities(giftcardId, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchGiftCardActivities(giftcardId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GiftCardRequest} giftCardRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchGiftCardBalance(giftCardRequest, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchGiftCardBalance(giftCardRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchGiftCardBrandActivity(id, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchGiftCardBrandActivity(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchGiftCardBrandsAndProducts(value, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchGiftCardBrandsAndProducts(value, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GiftCardRequest} giftCardRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchGiftCardById(giftCardRequest, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchGiftCardById(giftCardRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} productId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchGiftCardProductById(productId, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchGiftCardProductById(productId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchGiftCardProductsByBrand(id, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchGiftCardProductsByBrand(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GiftCardRequest} giftCardRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchGiftCards(giftCardRequest, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchGiftCards(giftCardRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    fetchLastCatalogRefreshStatus(options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).fetchLastCatalogRefreshStatus(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {GiftCardRequest} giftCardRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    reactivateGiftCard(giftCardRequest, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).reactivateGiftCard(giftCardRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    refreshCatalog(options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).refreshCatalog(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUpdateGiftCardBrandFeaturedRank} apiUpdateGiftCardBrandFeaturedRank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    setFeaturedMerchantRanks(apiUpdateGiftCardBrandFeaturedRank, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).setFeaturedMerchantRanks(apiUpdateGiftCardBrandFeaturedRank, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} field
     * @param {GiftCardRequest} giftCardRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    unmaskGiftcardField(field, giftCardRequest, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).unmaskGiftcardField(field, giftCardRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {ApiUpdateGiftCardBrand} apiUpdateGiftCardBrand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalGiftCardControllerApi
     */
    updateGiftCardBrand(id, apiUpdateGiftCardBrand, options) {
        return exports.BusinessPortalGiftCardControllerApiFp(this.configuration).updateGiftCardBrand(id, apiUpdateGiftCardBrand, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalGiftCardControllerApi = BusinessPortalGiftCardControllerApi;
/**
 * BusinessPortalIncentiveControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalIncentiveControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchActiveIncentiveOfferSummaryList: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/incentive/offer/group/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchExpiredIncentiveOfferSummaryList: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/incentive/offer/group/expired`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIncentiveOffers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/incentive/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {boolean} isDraft
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncentiveOfferById: (id, isDraft, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getIncentiveOfferById', 'id', id);
            // verify required parameter 'isDraft' is not null or undefined
            common_1.assertParamExists('getIncentiveOfferById', 'isDraft', isDraft);
            const localVarPath = `/business-portal/incentive/offer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (isDraft !== undefined) {
                localVarQueryParameter['isDraft'] = isDraft;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncentiveOfferDrafts: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/incentive/offer/drafts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {'PARTICIPATING' | 'AVAILABLE' | 'EXPIRED'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncentiveParticipatingOfferDetails: (partyId, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getIncentiveParticipatingOfferDetails', 'partyId', partyId);
            // verify required parameter 'status' is not null or undefined
            common_1.assertParamExists('getIncentiveParticipatingOfferDetails', 'status', status);
            const localVarPath = `/business-portal/incentive/party/{partyId}/offer/{status}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} offerId
         * @param {string} comments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishIncentiveDraft: (offerId, comments, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'offerId' is not null or undefined
            common_1.assertParamExists('publishIncentiveDraft', 'offerId', offerId);
            // verify required parameter 'comments' is not null or undefined
            common_1.assertParamExists('publishIncentiveDraft', 'comments', comments);
            const localVarPath = `/business-portal/incentive/offer/publish/{offerId}`
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (comments !== undefined) {
                localVarQueryParameter['comments'] = comments;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiIncentiveOfferDetail} apiIncentiveOfferDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveIncentiveOfferDraft: (apiIncentiveOfferDetail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiIncentiveOfferDetail' is not null or undefined
            common_1.assertParamExists('saveIncentiveOfferDraft', 'apiIncentiveOfferDetail', apiIncentiveOfferDetail);
            const localVarPath = `/business-portal/incentive/offer/draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiIncentiveOfferDetail, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {ApiIncentiveOfferUpdateRequest} apiIncentiveOfferUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncentiveOffer: (id, apiIncentiveOfferUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('updateIncentiveOffer', 'id', id);
            // verify required parameter 'apiIncentiveOfferUpdateRequest' is not null or undefined
            common_1.assertParamExists('updateIncentiveOffer', 'apiIncentiveOfferUpdateRequest', apiIncentiveOfferUpdateRequest);
            const localVarPath = `/business-portal/incentive/offer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiIncentiveOfferUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {ApiIncentiveOfferDetail} apiIncentiveOfferDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncentiveOfferDraft: (id, apiIncentiveOfferDetail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('updateIncentiveOfferDraft', 'id', id);
            // verify required parameter 'apiIncentiveOfferDetail' is not null or undefined
            common_1.assertParamExists('updateIncentiveOfferDraft', 'apiIncentiveOfferDetail', apiIncentiveOfferDetail);
            const localVarPath = `/business-portal/incentive/offer/draft/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiIncentiveOfferDetail, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalIncentiveControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalIncentiveControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalIncentiveControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchActiveIncentiveOfferSummaryList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchActiveIncentiveOfferSummaryList(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchExpiredIncentiveOfferSummaryList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchExpiredIncentiveOfferSummaryList(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIncentiveOffers(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllIncentiveOffers(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {boolean} isDraft
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncentiveOfferById(id, isDraft, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIncentiveOfferById(id, isDraft, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncentiveOfferDrafts(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIncentiveOfferDrafts(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {'PARTICIPATING' | 'AVAILABLE' | 'EXPIRED'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncentiveParticipatingOfferDetails(partyId, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIncentiveParticipatingOfferDetails(partyId, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} offerId
         * @param {string} comments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishIncentiveDraft(offerId, comments, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publishIncentiveDraft(offerId, comments, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiIncentiveOfferDetail} apiIncentiveOfferDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveIncentiveOfferDraft(apiIncentiveOfferDetail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveIncentiveOfferDraft(apiIncentiveOfferDetail, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {ApiIncentiveOfferUpdateRequest} apiIncentiveOfferUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncentiveOffer(id, apiIncentiveOfferUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateIncentiveOffer(id, apiIncentiveOfferUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {ApiIncentiveOfferDetail} apiIncentiveOfferDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncentiveOfferDraft(id, apiIncentiveOfferDetail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateIncentiveOfferDraft(id, apiIncentiveOfferDetail, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalIncentiveControllerApi - factory interface
 * @export
 */
exports.BusinessPortalIncentiveControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalIncentiveControllerApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchActiveIncentiveOfferSummaryList(options) {
            return localVarFp.fetchActiveIncentiveOfferSummaryList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchExpiredIncentiveOfferSummaryList(options) {
            return localVarFp.fetchExpiredIncentiveOfferSummaryList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllIncentiveOffers(options) {
            return localVarFp.getAllIncentiveOffers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {boolean} isDraft
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncentiveOfferById(id, isDraft, options) {
            return localVarFp.getIncentiveOfferById(id, isDraft, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncentiveOfferDrafts(options) {
            return localVarFp.getIncentiveOfferDrafts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {'PARTICIPATING' | 'AVAILABLE' | 'EXPIRED'} status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncentiveParticipatingOfferDetails(partyId, status, options) {
            return localVarFp.getIncentiveParticipatingOfferDetails(partyId, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} offerId
         * @param {string} comments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishIncentiveDraft(offerId, comments, options) {
            return localVarFp.publishIncentiveDraft(offerId, comments, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiIncentiveOfferDetail} apiIncentiveOfferDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveIncentiveOfferDraft(apiIncentiveOfferDetail, options) {
            return localVarFp.saveIncentiveOfferDraft(apiIncentiveOfferDetail, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {ApiIncentiveOfferUpdateRequest} apiIncentiveOfferUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncentiveOffer(id, apiIncentiveOfferUpdateRequest, options) {
            return localVarFp.updateIncentiveOffer(id, apiIncentiveOfferUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {ApiIncentiveOfferDetail} apiIncentiveOfferDetail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIncentiveOfferDraft(id, apiIncentiveOfferDetail, options) {
            return localVarFp.updateIncentiveOfferDraft(id, apiIncentiveOfferDetail, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalIncentiveControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalIncentiveControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalIncentiveControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    fetchActiveIncentiveOfferSummaryList(options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).fetchActiveIncentiveOfferSummaryList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    fetchExpiredIncentiveOfferSummaryList(options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).fetchExpiredIncentiveOfferSummaryList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    getAllIncentiveOffers(options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).getAllIncentiveOffers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {boolean} isDraft
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    getIncentiveOfferById(id, isDraft, options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).getIncentiveOfferById(id, isDraft, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    getIncentiveOfferDrafts(options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).getIncentiveOfferDrafts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {'PARTICIPATING' | 'AVAILABLE' | 'EXPIRED'} status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    getIncentiveParticipatingOfferDetails(partyId, status, options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).getIncentiveParticipatingOfferDetails(partyId, status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} offerId
     * @param {string} comments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    publishIncentiveDraft(offerId, comments, options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).publishIncentiveDraft(offerId, comments, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiIncentiveOfferDetail} apiIncentiveOfferDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    saveIncentiveOfferDraft(apiIncentiveOfferDetail, options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).saveIncentiveOfferDraft(apiIncentiveOfferDetail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {ApiIncentiveOfferUpdateRequest} apiIncentiveOfferUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    updateIncentiveOffer(id, apiIncentiveOfferUpdateRequest, options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).updateIncentiveOffer(id, apiIncentiveOfferUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {ApiIncentiveOfferDetail} apiIncentiveOfferDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalIncentiveControllerApi
     */
    updateIncentiveOfferDraft(id, apiIncentiveOfferDetail, options) {
        return exports.BusinessPortalIncentiveControllerApiFp(this.configuration).updateIncentiveOfferDraft(id, apiIncentiveOfferDetail, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalIncentiveControllerApi = BusinessPortalIncentiveControllerApi;
/**
 * BusinessPortalLoyaltyControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalLoyaltyControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiCancelRedemptionRequest} apiCancelRedemptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRedemption: (apiCancelRedemptionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiCancelRedemptionRequest' is not null or undefined
            common_1.assertParamExists('cancelRedemption', 'apiCancelRedemptionRequest', apiCancelRedemptionRequest);
            const localVarPath = `/business-portal/loyalty/account/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCancelRedemptionRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyAccountsDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getLoyaltyAccountsDetails', 'partyId', partyId);
            const localVarPath = `/business-portal/loyalty/party/{partyId}/account`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {string} loyaltyAccountId
         * @param {string} comments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkLoyaltyAccount: (partyId, loyaltyAccountId, comments, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('unlinkLoyaltyAccount', 'partyId', partyId);
            // verify required parameter 'loyaltyAccountId' is not null or undefined
            common_1.assertParamExists('unlinkLoyaltyAccount', 'loyaltyAccountId', loyaltyAccountId);
            // verify required parameter 'comments' is not null or undefined
            common_1.assertParamExists('unlinkLoyaltyAccount', 'comments', comments);
            const localVarPath = `/business-portal/loyalty/party/{partyId}/account/{loyaltyAccountId}/unlink`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)))
                .replace(`{${"loyaltyAccountId"}}`, encodeURIComponent(String(loyaltyAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (comments !== undefined) {
                localVarQueryParameter['comments'] = comments;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {string} loyaltyAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskAccountNumber: (partyId, loyaltyAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('unmaskAccountNumber', 'partyId', partyId);
            // verify required parameter 'loyaltyAccountId' is not null or undefined
            common_1.assertParamExists('unmaskAccountNumber', 'loyaltyAccountId', loyaltyAccountId);
            const localVarPath = `/business-portal/loyalty/party/{partyId}/account/{loyaltyAccountId}/accountNumber/unmask`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)))
                .replace(`{${"loyaltyAccountId"}}`, encodeURIComponent(String(loyaltyAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalLoyaltyControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalLoyaltyControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalLoyaltyControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiCancelRedemptionRequest} apiCancelRedemptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRedemption(apiCancelRedemptionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelRedemption(apiCancelRedemptionRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyAccountsDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLoyaltyAccountsDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {string} loyaltyAccountId
         * @param {string} comments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkLoyaltyAccount(partyId, loyaltyAccountId, comments, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unlinkLoyaltyAccount(partyId, loyaltyAccountId, comments, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {string} loyaltyAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskAccountNumber(partyId, loyaltyAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unmaskAccountNumber(partyId, loyaltyAccountId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalLoyaltyControllerApi - factory interface
 * @export
 */
exports.BusinessPortalLoyaltyControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalLoyaltyControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ApiCancelRedemptionRequest} apiCancelRedemptionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRedemption(apiCancelRedemptionRequest, options) {
            return localVarFp.cancelRedemption(apiCancelRedemptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyAccountsDetails(partyId, options) {
            return localVarFp.getLoyaltyAccountsDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {string} loyaltyAccountId
         * @param {string} comments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkLoyaltyAccount(partyId, loyaltyAccountId, comments, options) {
            return localVarFp.unlinkLoyaltyAccount(partyId, loyaltyAccountId, comments, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {string} loyaltyAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskAccountNumber(partyId, loyaltyAccountId, options) {
            return localVarFp.unmaskAccountNumber(partyId, loyaltyAccountId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalLoyaltyControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalLoyaltyControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalLoyaltyControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApiCancelRedemptionRequest} apiCancelRedemptionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalLoyaltyControllerApi
     */
    cancelRedemption(apiCancelRedemptionRequest, options) {
        return exports.BusinessPortalLoyaltyControllerApiFp(this.configuration).cancelRedemption(apiCancelRedemptionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalLoyaltyControllerApi
     */
    getLoyaltyAccountsDetails(partyId, options) {
        return exports.BusinessPortalLoyaltyControllerApiFp(this.configuration).getLoyaltyAccountsDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {string} loyaltyAccountId
     * @param {string} comments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalLoyaltyControllerApi
     */
    unlinkLoyaltyAccount(partyId, loyaltyAccountId, comments, options) {
        return exports.BusinessPortalLoyaltyControllerApiFp(this.configuration).unlinkLoyaltyAccount(partyId, loyaltyAccountId, comments, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {string} loyaltyAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalLoyaltyControllerApi
     */
    unmaskAccountNumber(partyId, loyaltyAccountId, options) {
        return exports.BusinessPortalLoyaltyControllerApiFp(this.configuration).unmaskAccountNumber(partyId, loyaltyAccountId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalLoyaltyControllerApi = BusinessPortalLoyaltyControllerApi;
/**
 * BusinessPortalPartyControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalPartyControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiCreditActionRequest} apiCreditActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCredit: (apiCreditActionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiCreditActionRequest' is not null or undefined
            common_1.assertParamExists('addCredit', 'apiCreditActionRequest', apiCreditActionRequest);
            const localVarPath = `/business-portal/party/credit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCreditActionRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiBlacklistAccountRequest} apiBlacklistAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistBankAccount: (apiBlacklistAccountRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiBlacklistAccountRequest' is not null or undefined
            common_1.assertParamExists('blacklistBankAccount', 'apiBlacklistAccountRequest', apiBlacklistAccountRequest);
            const localVarPath = `/business-portal/party/bank-account/blacklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiBlacklistAccountRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Close Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeParty: (apiPartyStatusUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartyStatusUpdateRequest' is not null or undefined
            common_1.assertParamExists('closeParty', 'apiPartyStatusUpdateRequest', apiPartyStatusUpdateRequest);
            const localVarPath = `/business-portal/party/close`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartyStatusUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchThirdPartyVerificationLogs: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('fetchThirdPartyVerificationLogs', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/verification-logs`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountActivityReasonMapping: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/account-activity/reason`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConsumersAccount: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getAllConsumersAccount', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/bank-accounts`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} identityCheckId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditDetails: (identityCheckId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'identityCheckId' is not null or undefined
            common_1.assertParamExists('getAuditDetails', 'identityCheckId', identityCheckId);
            const localVarPath = `/business-portal/identity-check/audit/detail/{identityCheckId}`
                .replace(`{${"identityCheckId"}}`, encodeURIComponent(String(identityCheckId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebitCardsAndActivitiesByPartyId: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getDebitCardsAndActivitiesByPartyId', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/debit-cards`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {Array<'ARKOSE' | 'SARDINE' | 'SIFT'>} [sourceTypes]
         * @param {Array<'L1_IDENTITY_CHECK_FINALIZE' | 'L2A_IDENTITY_CHECK_FINALIZE' | 'L2A_IDENTITY_CHECK_ADMIN' | 'L2A_IDENTITY_CHECK_UPDATE_ADDRESS' | 'L2B_IDENTITY_CHECK' | 'L2B_IDENTITY_CHECK_ADMIN' | 'L2C_IDENTITY_CHECK' | 'PROFILE_UPDATE_ADDRESS' | 'PROFILE_UPDATE_IDENTIFIER' | 'BATCH_UPLOAD' | 'LOGIN' | 'LOGOUT' | 'REGISTRATION' | 'TRANSACTION' | 'BANK_VERIFICATION' | 'PARTNER_PARTY_ENROLLMENT' | 'ACH_DEPOSIT' | 'ACH_WITHDRAW' | 'BUY_CRYPTO' | 'SELL_CRYPTO' | 'SEND_CRYPTO' | 'CONVERT_REWARD' | 'SEND_CASH' | 'BUY_GIFT_CARD' | 'LINKING_BANK' | 'LINKING_DEBIT_CARD' | 'DEBIT_CARD_DEPOSIT_TO_WALLET' | 'DEBIT_CARD_WITHDRAWAL_FROM_WALLET' | 'PAYMENT' | 'DEBITCARD_VERIFICATION'>} [flowTypes]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceSessions: (partyId, sourceTypes, flowTypes, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getDeviceSessions', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/sessions`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sourceTypes) {
                localVarQueryParameter['sourceTypes'] = sourceTypes;
            }
            if (flowTypes) {
                localVarQueryParameter['flowTypes'] = flowTypes;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getPartnerDetails', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/partners`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaidAccounts: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getPlaidAccounts', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/plaid-accounts`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} plaidAccountId
         * @param {'AUTH_GET' | 'INSTITUTION_GET_BY_ID' | 'ITEM_PUBLIC_TOKEN_EXCHANGE' | 'LINK_TOKEN_CREATE' | 'LINK_TOKEN_REFRESH' | 'ACCOUNT_BALANCE_GET' | 'IDENTITY_GET' | 'TRANSACTIONS_GET'} eventType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaidEvent: (plaidAccountId, eventType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'plaidAccountId' is not null or undefined
            common_1.assertParamExists('getPlaidEvent', 'plaidAccountId', plaidAccountId);
            // verify required parameter 'eventType' is not null or undefined
            common_1.assertParamExists('getPlaidEvent', 'eventType', eventType);
            const localVarPath = `/business-portal/party/{plaidAccountId}/plaid-event/{eventType}`
                .replace(`{${"plaidAccountId"}}`, encodeURIComponent(String(plaidAccountId)))
                .replace(`{${"eventType"}}`, encodeURIComponent(String(eventType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskVerificationHistory: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getRiskVerificationHistory', 'partyId', partyId);
            const localVarPath = `/business-portal/identity-check/audit/party/{partyId}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getTaxDetails', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/tax-details`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsAndAccountLinkFailures: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getTransactionsAndAccountLinkFailures', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/failures`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSessionInfo: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/party/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiLinkUnlinkPartnerStatusRequest} apiLinkUnlinkPartnerStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkUnlinkPartner: (apiLinkUnlinkPartnerStatusRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiLinkUnlinkPartnerStatusRequest' is not null or undefined
            common_1.assertParamExists('linkUnlinkPartner', 'apiLinkUnlinkPartnerStatusRequest', apiLinkUnlinkPartnerStatusRequest);
            const localVarPath = `/business-portal/party/partner/link-unlink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiLinkUnlinkPartnerStatusRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Liquidate Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liquidateParty: (apiPartyStatusUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartyStatusUpdateRequest' is not null or undefined
            common_1.assertParamExists('liquidateParty', 'apiPartyStatusUpdateRequest', apiPartyStatusUpdateRequest);
            const localVarPath = `/business-portal/party/liquidate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartyStatusUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiBlacklistAccountRemovalRequest} apiBlacklistAccountRemovalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBlacklistFromBankAccount: (apiBlacklistAccountRemovalRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiBlacklistAccountRemovalRequest' is not null or undefined
            common_1.assertParamExists('removeBlacklistFromBankAccount', 'apiBlacklistAccountRemovalRequest', apiBlacklistAccountRemovalRequest);
            const localVarPath = `/business-portal/party/bank-account/blacklist/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiBlacklistAccountRemovalRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Liquidate Party
         * @param {string} partyId
         * @param {string} reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLiquidateParty: (partyId, reason, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('removeLiquidateParty', 'partyId', partyId);
            // verify required parameter 'reason' is not null or undefined
            common_1.assertParamExists('removeLiquidateParty', 'reason', reason);
            const localVarPath = `/business-portal/party/{partyId}/liquidate/{reason}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)))
                .replace(`{${"reason"}}`, encodeURIComponent(String(reason)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiWhitelistPartyRequest} apiWhitelistPartyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWhitelistFromParty: (apiWhitelistPartyRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiWhitelistPartyRequest' is not null or undefined
            common_1.assertParamExists('removeWhitelistFromParty', 'apiWhitelistPartyRequest', apiWhitelistPartyRequest);
            const localVarPath = `/business-portal/party/whitelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiWhitelistPartyRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartyDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('retrievePartyDetails', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/details`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartyRiskDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('retrievePartyRiskDetails', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/partyriskdetails`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePortfolio: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('retrievePortfolio', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/portfolio`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConsumers: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchConsumers', 'searchParameters', searchParameters);
            const localVarPath = `/business-portal/party/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiPartyDashboardSearch} apiPartyDashboardSearch
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConsumersUsingEmailOrPhoneOrNameOrPartyId: (apiPartyDashboardSearch, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartyDashboardSearch' is not null or undefined
            common_1.assertParamExists('searchConsumersUsingEmailOrPhoneOrNameOrPartyId', 'apiPartyDashboardSearch', apiPartyDashboardSearch);
            const localVarPath = `/business-portal/party/dashboard/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartyDashboardSearch, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Suspend Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendParty: (apiPartyStatusUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartyStatusUpdateRequest' is not null or undefined
            common_1.assertParamExists('suspendParty', 'apiPartyStatusUpdateRequest', apiPartyStatusUpdateRequest);
            const localVarPath = `/business-portal/party/suspend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartyStatusUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUnblockPrefundingRequest} apiUnblockPrefundingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPrefunding: (apiUnblockPrefundingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUnblockPrefundingRequest' is not null or undefined
            common_1.assertParamExists('unblockPrefunding', 'apiUnblockPrefundingRequest', apiUnblockPrefundingRequest);
            const localVarPath = `/business-portal/party/unblock-prefunding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUnblockPrefundingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskDateOfBirth: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('unmaskDateOfBirth', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/dob/unmask`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskTaxId: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('unmaskTaxId', 'partyId', partyId);
            const localVarPath = `/business-portal/party/{partyId}/tax-id/unmask`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} detailsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskVerificationDateOfBirth: (detailsId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'detailsId' is not null or undefined
            common_1.assertParamExists('unmaskVerificationDateOfBirth', 'detailsId', detailsId);
            const localVarPath = `/business-portal/party/tax-details/{detailsId}/dob/unmask`
                .replace(`{${"detailsId"}}`, encodeURIComponent(String(detailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} detailsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskVerificationTaxId: (detailsId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'detailsId' is not null or undefined
            common_1.assertParamExists('unmaskVerificationTaxId', 'detailsId', detailsId);
            const localVarPath = `/business-portal/party/tax-details/{detailsId}/tax-id/unmask`
                .replace(`{${"detailsId"}}`, encodeURIComponent(String(detailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Unsuspend Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsuspendParty: (apiPartyStatusUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartyStatusUpdateRequest' is not null or undefined
            common_1.assertParamExists('unsuspendParty', 'apiPartyStatusUpdateRequest', apiPartyStatusUpdateRequest);
            const localVarPath = `/business-portal/party/unsuspend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartyStatusUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Party Name
         * @param {string} partyId
         * @param {ApiUpdatePartyNameRequest} apiUpdatePartyNameRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartyName: (partyId, apiUpdatePartyNameRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('updatePartyName', 'partyId', partyId);
            // verify required parameter 'apiUpdatePartyNameRequest' is not null or undefined
            common_1.assertParamExists('updatePartyName', 'apiUpdatePartyNameRequest', apiUpdatePartyNameRequest);
            const localVarPath = `/business-portal/party/{partyId}/name`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdatePartyNameRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUpdateTransunionVerificationRequest} apiUpdateTransunionVerificationRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransunionVerification: (apiUpdateTransunionVerificationRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUpdateTransunionVerificationRequest' is not null or undefined
            common_1.assertParamExists('updateTransunionVerification', 'apiUpdateTransunionVerificationRequest', apiUpdateTransunionVerificationRequest);
            const localVarPath = `/business-portal/party/transunion-override`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateTransunionVerificationRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiWhitelistPartyRequest} apiWhitelistPartyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whitelistParty: (apiWhitelistPartyRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiWhitelistPartyRequest' is not null or undefined
            common_1.assertParamExists('whitelistParty', 'apiWhitelistPartyRequest', apiWhitelistPartyRequest);
            const localVarPath = `/business-portal/party/whitelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiWhitelistPartyRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalPartyControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalPartyControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalPartyControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiCreditActionRequest} apiCreditActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCredit(apiCreditActionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addCredit(apiCreditActionRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiBlacklistAccountRequest} apiBlacklistAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistBankAccount(apiBlacklistAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.blacklistBankAccount(apiBlacklistAccountRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Close Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeParty(apiPartyStatusUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.closeParty(apiPartyStatusUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchThirdPartyVerificationLogs(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchThirdPartyVerificationLogs(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountActivityReasonMapping(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountActivityReasonMapping(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConsumersAccount(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllConsumersAccount(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} identityCheckId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditDetails(identityCheckId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAuditDetails(identityCheckId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebitCardsAndActivitiesByPartyId(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDebitCardsAndActivitiesByPartyId(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {Array<'ARKOSE' | 'SARDINE' | 'SIFT'>} [sourceTypes]
         * @param {Array<'L1_IDENTITY_CHECK_FINALIZE' | 'L2A_IDENTITY_CHECK_FINALIZE' | 'L2A_IDENTITY_CHECK_ADMIN' | 'L2A_IDENTITY_CHECK_UPDATE_ADDRESS' | 'L2B_IDENTITY_CHECK' | 'L2B_IDENTITY_CHECK_ADMIN' | 'L2C_IDENTITY_CHECK' | 'PROFILE_UPDATE_ADDRESS' | 'PROFILE_UPDATE_IDENTIFIER' | 'BATCH_UPLOAD' | 'LOGIN' | 'LOGOUT' | 'REGISTRATION' | 'TRANSACTION' | 'BANK_VERIFICATION' | 'PARTNER_PARTY_ENROLLMENT' | 'ACH_DEPOSIT' | 'ACH_WITHDRAW' | 'BUY_CRYPTO' | 'SELL_CRYPTO' | 'SEND_CRYPTO' | 'CONVERT_REWARD' | 'SEND_CASH' | 'BUY_GIFT_CARD' | 'LINKING_BANK' | 'LINKING_DEBIT_CARD' | 'DEBIT_CARD_DEPOSIT_TO_WALLET' | 'DEBIT_CARD_WITHDRAWAL_FROM_WALLET' | 'PAYMENT' | 'DEBITCARD_VERIFICATION'>} [flowTypes]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceSessions(partyId, sourceTypes, flowTypes, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDeviceSessions(partyId, sourceTypes, flowTypes, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaidAccounts(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlaidAccounts(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} plaidAccountId
         * @param {'AUTH_GET' | 'INSTITUTION_GET_BY_ID' | 'ITEM_PUBLIC_TOKEN_EXCHANGE' | 'LINK_TOKEN_CREATE' | 'LINK_TOKEN_REFRESH' | 'ACCOUNT_BALANCE_GET' | 'IDENTITY_GET' | 'TRANSACTIONS_GET'} eventType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaidEvent(plaidAccountId, eventType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlaidEvent(plaidAccountId, eventType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskVerificationHistory(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRiskVerificationHistory(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTaxDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsAndAccountLinkFailures(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTransactionsAndAccountLinkFailures(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSessionInfo(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserSessionInfo(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiLinkUnlinkPartnerStatusRequest} apiLinkUnlinkPartnerStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkUnlinkPartner(apiLinkUnlinkPartnerStatusRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.linkUnlinkPartner(apiLinkUnlinkPartnerStatusRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Liquidate Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liquidateParty(apiPartyStatusUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.liquidateParty(apiPartyStatusUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiBlacklistAccountRemovalRequest} apiBlacklistAccountRemovalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBlacklistFromBankAccount(apiBlacklistAccountRemovalRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeBlacklistFromBankAccount(apiBlacklistAccountRemovalRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Liquidate Party
         * @param {string} partyId
         * @param {string} reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLiquidateParty(partyId, reason, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeLiquidateParty(partyId, reason, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiWhitelistPartyRequest} apiWhitelistPartyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWhitelistFromParty(apiWhitelistPartyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeWhitelistFromParty(apiWhitelistPartyRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartyDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrievePartyDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartyRiskDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrievePartyRiskDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePortfolio(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrievePortfolio(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConsumers(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchConsumers(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiPartyDashboardSearch} apiPartyDashboardSearch
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConsumersUsingEmailOrPhoneOrNameOrPartyId(apiPartyDashboardSearch, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchConsumersUsingEmailOrPhoneOrNameOrPartyId(apiPartyDashboardSearch, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Suspend Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendParty(apiPartyStatusUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suspendParty(apiPartyStatusUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUnblockPrefundingRequest} apiUnblockPrefundingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPrefunding(apiUnblockPrefundingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unblockPrefunding(apiUnblockPrefundingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskDateOfBirth(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unmaskDateOfBirth(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskTaxId(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unmaskTaxId(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} detailsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskVerificationDateOfBirth(detailsId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unmaskVerificationDateOfBirth(detailsId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} detailsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskVerificationTaxId(detailsId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unmaskVerificationTaxId(detailsId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Unsuspend Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsuspendParty(apiPartyStatusUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unsuspendParty(apiPartyStatusUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Party Name
         * @param {string} partyId
         * @param {ApiUpdatePartyNameRequest} apiUpdatePartyNameRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartyName(partyId, apiUpdatePartyNameRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePartyName(partyId, apiUpdatePartyNameRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUpdateTransunionVerificationRequest} apiUpdateTransunionVerificationRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransunionVerification(apiUpdateTransunionVerificationRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTransunionVerification(apiUpdateTransunionVerificationRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiWhitelistPartyRequest} apiWhitelistPartyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whitelistParty(apiWhitelistPartyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.whitelistParty(apiWhitelistPartyRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalPartyControllerApi - factory interface
 * @export
 */
exports.BusinessPortalPartyControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalPartyControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ApiCreditActionRequest} apiCreditActionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCredit(apiCreditActionRequest, options) {
            return localVarFp.addCredit(apiCreditActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiBlacklistAccountRequest} apiBlacklistAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blacklistBankAccount(apiBlacklistAccountRequest, options) {
            return localVarFp.blacklistBankAccount(apiBlacklistAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Close Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeParty(apiPartyStatusUpdateRequest, options) {
            return localVarFp.closeParty(apiPartyStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchThirdPartyVerificationLogs(partyId, options) {
            return localVarFp.fetchThirdPartyVerificationLogs(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountActivityReasonMapping(options) {
            return localVarFp.getAccountActivityReasonMapping(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllConsumersAccount(partyId, options) {
            return localVarFp.getAllConsumersAccount(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} identityCheckId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditDetails(identityCheckId, options) {
            return localVarFp.getAuditDetails(identityCheckId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDebitCardsAndActivitiesByPartyId(partyId, options) {
            return localVarFp.getDebitCardsAndActivitiesByPartyId(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {Array<'ARKOSE' | 'SARDINE' | 'SIFT'>} [sourceTypes]
         * @param {Array<'L1_IDENTITY_CHECK_FINALIZE' | 'L2A_IDENTITY_CHECK_FINALIZE' | 'L2A_IDENTITY_CHECK_ADMIN' | 'L2A_IDENTITY_CHECK_UPDATE_ADDRESS' | 'L2B_IDENTITY_CHECK' | 'L2B_IDENTITY_CHECK_ADMIN' | 'L2C_IDENTITY_CHECK' | 'PROFILE_UPDATE_ADDRESS' | 'PROFILE_UPDATE_IDENTIFIER' | 'BATCH_UPLOAD' | 'LOGIN' | 'LOGOUT' | 'REGISTRATION' | 'TRANSACTION' | 'BANK_VERIFICATION' | 'PARTNER_PARTY_ENROLLMENT' | 'ACH_DEPOSIT' | 'ACH_WITHDRAW' | 'BUY_CRYPTO' | 'SELL_CRYPTO' | 'SEND_CRYPTO' | 'CONVERT_REWARD' | 'SEND_CASH' | 'BUY_GIFT_CARD' | 'LINKING_BANK' | 'LINKING_DEBIT_CARD' | 'DEBIT_CARD_DEPOSIT_TO_WALLET' | 'DEBIT_CARD_WITHDRAWAL_FROM_WALLET' | 'PAYMENT' | 'DEBITCARD_VERIFICATION'>} [flowTypes]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceSessions(partyId, sourceTypes, flowTypes, page, size, sort, options) {
            return localVarFp.getDeviceSessions(partyId, sourceTypes, flowTypes, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDetails(partyId, options) {
            return localVarFp.getPartnerDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaidAccounts(partyId, options) {
            return localVarFp.getPlaidAccounts(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} plaidAccountId
         * @param {'AUTH_GET' | 'INSTITUTION_GET_BY_ID' | 'ITEM_PUBLIC_TOKEN_EXCHANGE' | 'LINK_TOKEN_CREATE' | 'LINK_TOKEN_REFRESH' | 'ACCOUNT_BALANCE_GET' | 'IDENTITY_GET' | 'TRANSACTIONS_GET'} eventType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaidEvent(plaidAccountId, eventType, options) {
            return localVarFp.getPlaidEvent(plaidAccountId, eventType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRiskVerificationHistory(partyId, options) {
            return localVarFp.getRiskVerificationHistory(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxDetails(partyId, options) {
            return localVarFp.getTaxDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsAndAccountLinkFailures(partyId, options) {
            return localVarFp.getTransactionsAndAccountLinkFailures(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSessionInfo(options) {
            return localVarFp.getUserSessionInfo(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiLinkUnlinkPartnerStatusRequest} apiLinkUnlinkPartnerStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkUnlinkPartner(apiLinkUnlinkPartnerStatusRequest, options) {
            return localVarFp.linkUnlinkPartner(apiLinkUnlinkPartnerStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Liquidate Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liquidateParty(apiPartyStatusUpdateRequest, options) {
            return localVarFp.liquidateParty(apiPartyStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiBlacklistAccountRemovalRequest} apiBlacklistAccountRemovalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBlacklistFromBankAccount(apiBlacklistAccountRemovalRequest, options) {
            return localVarFp.removeBlacklistFromBankAccount(apiBlacklistAccountRemovalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Liquidate Party
         * @param {string} partyId
         * @param {string} reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLiquidateParty(partyId, reason, options) {
            return localVarFp.removeLiquidateParty(partyId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiWhitelistPartyRequest} apiWhitelistPartyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWhitelistFromParty(apiWhitelistPartyRequest, options) {
            return localVarFp.removeWhitelistFromParty(apiWhitelistPartyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartyDetails(partyId, options) {
            return localVarFp.retrievePartyDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartyRiskDetails(partyId, options) {
            return localVarFp.retrievePartyRiskDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePortfolio(partyId, options) {
            return localVarFp.retrievePortfolio(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConsumers(searchParameters, options) {
            return localVarFp.searchConsumers(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiPartyDashboardSearch} apiPartyDashboardSearch
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConsumersUsingEmailOrPhoneOrNameOrPartyId(apiPartyDashboardSearch, page, size, sort, options) {
            return localVarFp.searchConsumersUsingEmailOrPhoneOrNameOrPartyId(apiPartyDashboardSearch, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Suspend Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suspendParty(apiPartyStatusUpdateRequest, options) {
            return localVarFp.suspendParty(apiPartyStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUnblockPrefundingRequest} apiUnblockPrefundingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockPrefunding(apiUnblockPrefundingRequest, options) {
            return localVarFp.unblockPrefunding(apiUnblockPrefundingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskDateOfBirth(partyId, options) {
            return localVarFp.unmaskDateOfBirth(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskTaxId(partyId, options) {
            return localVarFp.unmaskTaxId(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} detailsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskVerificationDateOfBirth(detailsId, options) {
            return localVarFp.unmaskVerificationDateOfBirth(detailsId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} detailsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskVerificationTaxId(detailsId, options) {
            return localVarFp.unmaskVerificationTaxId(detailsId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unsuspend Party
         * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsuspendParty(apiPartyStatusUpdateRequest, options) {
            return localVarFp.unsuspendParty(apiPartyStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Party Name
         * @param {string} partyId
         * @param {ApiUpdatePartyNameRequest} apiUpdatePartyNameRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartyName(partyId, apiUpdatePartyNameRequest, options) {
            return localVarFp.updatePartyName(partyId, apiUpdatePartyNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUpdateTransunionVerificationRequest} apiUpdateTransunionVerificationRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransunionVerification(apiUpdateTransunionVerificationRequest, xTrackingId, options) {
            return localVarFp.updateTransunionVerification(apiUpdateTransunionVerificationRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiWhitelistPartyRequest} apiWhitelistPartyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whitelistParty(apiWhitelistPartyRequest, options) {
            return localVarFp.whitelistParty(apiWhitelistPartyRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalPartyControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalPartyControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalPartyControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApiCreditActionRequest} apiCreditActionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    addCredit(apiCreditActionRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).addCredit(apiCreditActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiBlacklistAccountRequest} apiBlacklistAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    blacklistBankAccount(apiBlacklistAccountRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).blacklistBankAccount(apiBlacklistAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Close Party
     * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    closeParty(apiPartyStatusUpdateRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).closeParty(apiPartyStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    fetchThirdPartyVerificationLogs(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).fetchThirdPartyVerificationLogs(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getAccountActivityReasonMapping(options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getAccountActivityReasonMapping(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getAllConsumersAccount(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getAllConsumersAccount(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} identityCheckId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getAuditDetails(identityCheckId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getAuditDetails(identityCheckId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getDebitCardsAndActivitiesByPartyId(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getDebitCardsAndActivitiesByPartyId(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {Array<'ARKOSE' | 'SARDINE' | 'SIFT'>} [sourceTypes]
     * @param {Array<'L1_IDENTITY_CHECK_FINALIZE' | 'L2A_IDENTITY_CHECK_FINALIZE' | 'L2A_IDENTITY_CHECK_ADMIN' | 'L2A_IDENTITY_CHECK_UPDATE_ADDRESS' | 'L2B_IDENTITY_CHECK' | 'L2B_IDENTITY_CHECK_ADMIN' | 'L2C_IDENTITY_CHECK' | 'PROFILE_UPDATE_ADDRESS' | 'PROFILE_UPDATE_IDENTIFIER' | 'BATCH_UPLOAD' | 'LOGIN' | 'LOGOUT' | 'REGISTRATION' | 'TRANSACTION' | 'BANK_VERIFICATION' | 'PARTNER_PARTY_ENROLLMENT' | 'ACH_DEPOSIT' | 'ACH_WITHDRAW' | 'BUY_CRYPTO' | 'SELL_CRYPTO' | 'SEND_CRYPTO' | 'CONVERT_REWARD' | 'SEND_CASH' | 'BUY_GIFT_CARD' | 'LINKING_BANK' | 'LINKING_DEBIT_CARD' | 'DEBIT_CARD_DEPOSIT_TO_WALLET' | 'DEBIT_CARD_WITHDRAWAL_FROM_WALLET' | 'PAYMENT' | 'DEBITCARD_VERIFICATION'>} [flowTypes]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getDeviceSessions(partyId, sourceTypes, flowTypes, page, size, sort, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getDeviceSessions(partyId, sourceTypes, flowTypes, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getPartnerDetails(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getPartnerDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getPlaidAccounts(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getPlaidAccounts(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} plaidAccountId
     * @param {'AUTH_GET' | 'INSTITUTION_GET_BY_ID' | 'ITEM_PUBLIC_TOKEN_EXCHANGE' | 'LINK_TOKEN_CREATE' | 'LINK_TOKEN_REFRESH' | 'ACCOUNT_BALANCE_GET' | 'IDENTITY_GET' | 'TRANSACTIONS_GET'} eventType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getPlaidEvent(plaidAccountId, eventType, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getPlaidEvent(plaidAccountId, eventType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getRiskVerificationHistory(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getRiskVerificationHistory(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getTaxDetails(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getTaxDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getTransactionsAndAccountLinkFailures(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getTransactionsAndAccountLinkFailures(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    getUserSessionInfo(options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).getUserSessionInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiLinkUnlinkPartnerStatusRequest} apiLinkUnlinkPartnerStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    linkUnlinkPartner(apiLinkUnlinkPartnerStatusRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).linkUnlinkPartner(apiLinkUnlinkPartnerStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Liquidate Party
     * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    liquidateParty(apiPartyStatusUpdateRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).liquidateParty(apiPartyStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiBlacklistAccountRemovalRequest} apiBlacklistAccountRemovalRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    removeBlacklistFromBankAccount(apiBlacklistAccountRemovalRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).removeBlacklistFromBankAccount(apiBlacklistAccountRemovalRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Liquidate Party
     * @param {string} partyId
     * @param {string} reason
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    removeLiquidateParty(partyId, reason, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).removeLiquidateParty(partyId, reason, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiWhitelistPartyRequest} apiWhitelistPartyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    removeWhitelistFromParty(apiWhitelistPartyRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).removeWhitelistFromParty(apiWhitelistPartyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    retrievePartyDetails(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).retrievePartyDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    retrievePartyRiskDetails(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).retrievePartyRiskDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    retrievePortfolio(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).retrievePortfolio(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    searchConsumers(searchParameters, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).searchConsumers(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiPartyDashboardSearch} apiPartyDashboardSearch
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    searchConsumersUsingEmailOrPhoneOrNameOrPartyId(apiPartyDashboardSearch, page, size, sort, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).searchConsumersUsingEmailOrPhoneOrNameOrPartyId(apiPartyDashboardSearch, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Suspend Party
     * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    suspendParty(apiPartyStatusUpdateRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).suspendParty(apiPartyStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUnblockPrefundingRequest} apiUnblockPrefundingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    unblockPrefunding(apiUnblockPrefundingRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).unblockPrefunding(apiUnblockPrefundingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    unmaskDateOfBirth(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).unmaskDateOfBirth(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    unmaskTaxId(partyId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).unmaskTaxId(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} detailsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    unmaskVerificationDateOfBirth(detailsId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).unmaskVerificationDateOfBirth(detailsId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} detailsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    unmaskVerificationTaxId(detailsId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).unmaskVerificationTaxId(detailsId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unsuspend Party
     * @param {ApiPartyStatusUpdateRequest} apiPartyStatusUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    unsuspendParty(apiPartyStatusUpdateRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).unsuspendParty(apiPartyStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Party Name
     * @param {string} partyId
     * @param {ApiUpdatePartyNameRequest} apiUpdatePartyNameRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    updatePartyName(partyId, apiUpdatePartyNameRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).updatePartyName(partyId, apiUpdatePartyNameRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUpdateTransunionVerificationRequest} apiUpdateTransunionVerificationRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    updateTransunionVerification(apiUpdateTransunionVerificationRequest, xTrackingId, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).updateTransunionVerification(apiUpdateTransunionVerificationRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiWhitelistPartyRequest} apiWhitelistPartyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalPartyControllerApi
     */
    whitelistParty(apiWhitelistPartyRequest, options) {
        return exports.BusinessPortalPartyControllerApiFp(this.configuration).whitelistParty(apiWhitelistPartyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalPartyControllerApi = BusinessPortalPartyControllerApi;
/**
 * BusinessPortalReportControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalReportControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} reportName
         * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReport: (reportName, reportType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'reportName' is not null or undefined
            common_1.assertParamExists('downloadReport', 'reportName', reportName);
            // verify required parameter 'reportType' is not null or undefined
            common_1.assertParamExists('downloadReport', 'reportType', reportType);
            const localVarPath = `/business-portal/report/download/{reportType}/{reportName}`
                .replace(`{${"reportName"}}`, encodeURIComponent(String(reportName)))
                .replace(`{${"reportType"}}`, encodeURIComponent(String(reportType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} reportName
         * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadReport: (reportName, reportType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'reportName' is not null or undefined
            common_1.assertParamExists('generateDownloadReport', 'reportName', reportName);
            // verify required parameter 'reportType' is not null or undefined
            common_1.assertParamExists('generateDownloadReport', 'reportType', reportType);
            const localVarPath = `/business-portal/report/downloadlink/{reportType}/{reportName}`
                .replace(`{${"reportName"}}`, encodeURIComponent(String(reportName)))
                .replace(`{${"reportType"}}`, encodeURIComponent(String(reportType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiDateRangeReportRequest} apiDateRangeReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReport: (apiDateRangeReportRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiDateRangeReportRequest' is not null or undefined
            common_1.assertParamExists('generateReport', 'apiDateRangeReportRequest', apiDateRangeReportRequest);
            const localVarPath = `/business-portal/report/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDateRangeReportRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiReportListRequest} apiReportListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableReports: (apiReportListRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiReportListRequest' is not null or undefined
            common_1.assertParamExists('getAvailableReports', 'apiReportListRequest', apiReportListRequest);
            const localVarPath = `/business-portal/report/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiReportListRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalReportControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalReportControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalReportControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} reportName
         * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReport(reportName, reportType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadReport(reportName, reportType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} reportName
         * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadReport(reportName, reportType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateDownloadReport(reportName, reportType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiDateRangeReportRequest} apiDateRangeReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReport(apiDateRangeReportRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateReport(apiDateRangeReportRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiReportListRequest} apiReportListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableReports(apiReportListRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAvailableReports(apiReportListRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalReportControllerApi - factory interface
 * @export
 */
exports.BusinessPortalReportControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalReportControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} reportName
         * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadReport(reportName, reportType, options) {
            return localVarFp.downloadReport(reportName, reportType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} reportName
         * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadReport(reportName, reportType, options) {
            return localVarFp.generateDownloadReport(reportName, reportType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiDateRangeReportRequest} apiDateRangeReportRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReport(apiDateRangeReportRequest, options) {
            return localVarFp.generateReport(apiDateRangeReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiReportListRequest} apiReportListRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableReports(apiReportListRequest, options) {
            return localVarFp.getAvailableReports(apiReportListRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalReportControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalReportControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalReportControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} reportName
     * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalReportControllerApi
     */
    downloadReport(reportName, reportType, options) {
        return exports.BusinessPortalReportControllerApiFp(this.configuration).downloadReport(reportName, reportType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} reportName
     * @param {'ASSET_ACTIVTY' | 'CHARGEBACK' | 'PREFUNDING' | 'VIRTUAL_CURRENCY' | 'SIFT' | 'MERCHANT_RECONCILIATION_REPORT' | 'PARTNER_SETTLEMENT_REPORT' | 'DISPUTE_CREDIT' | 'ACCOUNT_BALANCE' | 'ACCOUNT_BALANCE_V2' | 'ACCOUNT_BALANCE_SUMMARY' | 'ALL_CURRENCY_MTL' | 'MTL' | 'BTC_TRANSACTION_REPORT' | 'CRYPTO_TRANSACTION_REPORT' | 'PARTNER_PARTY_CRYPTO_TRANSACTION_REPORT' | 'SUSPEND_ACCOUNT' | 'P2P_TRANSFER' | 'GIFT_CARD_RECON' | 'GIFT_CARD_REDEEM_RECON' | 'GIFT_CARD_RECON_MONTH' | 'GIFT_CARD_REDEEM_RECON_MONTH' | 'ACH_FILE_RETURNS' | 'ACH_FILE_OUTBOUND' | 'PARTNER_RECONCILIATION_REPORT' | 'CHOICE' | 'QUIZNOS' | 'FISERV_PAYMENT_STATUS'} reportType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalReportControllerApi
     */
    generateDownloadReport(reportName, reportType, options) {
        return exports.BusinessPortalReportControllerApiFp(this.configuration).generateDownloadReport(reportName, reportType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiDateRangeReportRequest} apiDateRangeReportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalReportControllerApi
     */
    generateReport(apiDateRangeReportRequest, options) {
        return exports.BusinessPortalReportControllerApiFp(this.configuration).generateReport(apiDateRangeReportRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiReportListRequest} apiReportListRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalReportControllerApi
     */
    getAvailableReports(apiReportListRequest, options) {
        return exports.BusinessPortalReportControllerApiFp(this.configuration).getAvailableReports(apiReportListRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalReportControllerApi = BusinessPortalReportControllerApi;
/**
 * BusinessPortalRiskControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalRiskControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelist: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('getWhitelist', 'searchParameters', searchParameters);
            const localVarPath = `/business-portal/whitelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalRiskControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalRiskControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalRiskControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelist(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWhitelist(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalRiskControllerApi - factory interface
 * @export
 */
exports.BusinessPortalRiskControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalRiskControllerApiFp(configuration);
    return {
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelist(searchParameters, options) {
            return localVarFp.getWhitelist(searchParameters, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalRiskControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalRiskControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalRiskControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalRiskControllerApi
     */
    getWhitelist(searchParameters, options) {
        return exports.BusinessPortalRiskControllerApiFp(this.configuration).getWhitelist(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalRiskControllerApi = BusinessPortalRiskControllerApi;
/**
 * BusinessPortalTicketControllerApi - axios parameter creator
 * @export
 */
exports.BusinessPortalTicketControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} ticketId
         * @param {ApiCommentRequest} apiCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment: (ticketId, apiCommentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ticketId' is not null or undefined
            common_1.assertParamExists('addComment', 'ticketId', ticketId);
            // verify required parameter 'apiCommentRequest' is not null or undefined
            common_1.assertParamExists('addComment', 'apiCommentRequest', apiCommentRequest);
            const localVarPath = `/business-portal/ticket/{ticketId}/comment`
                .replace(`{${"ticketId"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCommentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiTicketAssignRequest} apiTicketAssignRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTicket: (apiTicketAssignRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiTicketAssignRequest' is not null or undefined
            common_1.assertParamExists('assignTicket', 'apiTicketAssignRequest', apiTicketAssignRequest);
            const localVarPath = `/business-portal/ticket/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiTicketAssignRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComments: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('getComments', 'searchParameters', searchParameters);
            const localVarPath = `/business-portal/ticket/comment/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiAttachmentRequest} apiAttachmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAttachment: (apiAttachmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiAttachmentRequest' is not null or undefined
            common_1.assertParamExists('retrieveAttachment', 'apiAttachmentRequest', apiAttachmentRequest);
            const localVarPath = `/business-portal/ticket/retrieve-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiAttachmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTickets: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchTickets', 'searchParameters', searchParameters);
            const localVarPath = `/business-portal/ticket/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InlineObject3} [inlineObject3]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: (inlineObject3, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/ticket/upload-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inlineObject3, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessPortalTicketControllerApi - functional programming interface
 * @export
 */
exports.BusinessPortalTicketControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BusinessPortalTicketControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} ticketId
         * @param {ApiCommentRequest} apiCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment(ticketId, apiCommentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addComment(ticketId, apiCommentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiTicketAssignRequest} apiTicketAssignRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTicket(apiTicketAssignRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assignTicket(apiTicketAssignRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComments(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getComments(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiAttachmentRequest} apiAttachmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAttachment(apiAttachmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveAttachment(apiAttachmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTickets(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchTickets(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {InlineObject3} [inlineObject3]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(inlineObject3, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadAttachment(inlineObject3, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessPortalTicketControllerApi - factory interface
 * @export
 */
exports.BusinessPortalTicketControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BusinessPortalTicketControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} ticketId
         * @param {ApiCommentRequest} apiCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment(ticketId, apiCommentRequest, options) {
            return localVarFp.addComment(ticketId, apiCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiTicketAssignRequest} apiTicketAssignRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignTicket(apiTicketAssignRequest, options) {
            return localVarFp.assignTicket(apiTicketAssignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComments(searchParameters, options) {
            return localVarFp.getComments(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiAttachmentRequest} apiAttachmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAttachment(apiAttachmentRequest, options) {
            return localVarFp.retrieveAttachment(apiAttachmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTickets(searchParameters, options) {
            return localVarFp.searchTickets(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InlineObject3} [inlineObject3]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(inlineObject3, options) {
            return localVarFp.uploadAttachment(inlineObject3, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessPortalTicketControllerApi - object-oriented interface
 * @export
 * @class BusinessPortalTicketControllerApi
 * @extends {BaseAPI}
 */
class BusinessPortalTicketControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} ticketId
     * @param {ApiCommentRequest} apiCommentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalTicketControllerApi
     */
    addComment(ticketId, apiCommentRequest, options) {
        return exports.BusinessPortalTicketControllerApiFp(this.configuration).addComment(ticketId, apiCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiTicketAssignRequest} apiTicketAssignRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalTicketControllerApi
     */
    assignTicket(apiTicketAssignRequest, options) {
        return exports.BusinessPortalTicketControllerApiFp(this.configuration).assignTicket(apiTicketAssignRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalTicketControllerApi
     */
    getComments(searchParameters, options) {
        return exports.BusinessPortalTicketControllerApiFp(this.configuration).getComments(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiAttachmentRequest} apiAttachmentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalTicketControllerApi
     */
    retrieveAttachment(apiAttachmentRequest, options) {
        return exports.BusinessPortalTicketControllerApiFp(this.configuration).retrieveAttachment(apiAttachmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalTicketControllerApi
     */
    searchTickets(searchParameters, options) {
        return exports.BusinessPortalTicketControllerApiFp(this.configuration).searchTickets(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InlineObject3} [inlineObject3]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessPortalTicketControllerApi
     */
    uploadAttachment(inlineObject3, options) {
        return exports.BusinessPortalTicketControllerApiFp(this.configuration).uploadAttachment(inlineObject3, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BusinessPortalTicketControllerApi = BusinessPortalTicketControllerApi;
/**
 * ChecksStoresAliasApi - axios parameter creator
 * @export
 */
exports.ChecksStoresAliasApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Designed for users without account created yet.  It will store the chosen alias into newAlias.  Later in flow newAlias is stored into alias
         * @summary Add newAlias to customers Party
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aliasAvailable: (apiUpdateAliasRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUpdateAliasRequest' is not null or undefined
            common_1.assertParamExists('aliasAvailable', 'apiUpdateAliasRequest', apiUpdateAliasRequest);
            const localVarPath = `/aof/party/alias-available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateAliasRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ChecksStoresAliasApi - functional programming interface
 * @export
 */
exports.ChecksStoresAliasApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ChecksStoresAliasApiAxiosParamCreator(configuration);
    return {
        /**
         * Designed for users without account created yet.  It will store the chosen alias into newAlias.  Later in flow newAlias is stored into alias
         * @summary Add newAlias to customers Party
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aliasAvailable(apiUpdateAliasRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aliasAvailable(apiUpdateAliasRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ChecksStoresAliasApi - factory interface
 * @export
 */
exports.ChecksStoresAliasApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ChecksStoresAliasApiFp(configuration);
    return {
        /**
         * Designed for users without account created yet.  It will store the chosen alias into newAlias.  Later in flow newAlias is stored into alias
         * @summary Add newAlias to customers Party
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aliasAvailable(apiUpdateAliasRequest, options) {
            return localVarFp.aliasAvailable(apiUpdateAliasRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ChecksStoresAliasApi - object-oriented interface
 * @export
 * @class ChecksStoresAliasApi
 * @extends {BaseAPI}
 */
class ChecksStoresAliasApi extends base_1.BaseAPI {
    /**
     * Designed for users without account created yet.  It will store the chosen alias into newAlias.  Later in flow newAlias is stored into alias
     * @summary Add newAlias to customers Party
     * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecksStoresAliasApi
     */
    aliasAvailable(apiUpdateAliasRequest, options) {
        return exports.ChecksStoresAliasApiFp(this.configuration).aliasAvailable(apiUpdateAliasRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ChecksStoresAliasApi = ChecksStoresAliasApi;
/**
 * EmbeddedPartnerAPIApi - axios parameter creator
 * @export
 */
exports.EmbeddedPartnerAPIApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Api removes a user profile from redis cache when user exits the onboarding flow
         * @summary Delete profile from cache
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile: (profileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'profileId' is not null or undefined
            common_1.assertParamExists('deleteProfile', 'profileId', profileId);
            const localVarPath = `/partner/embedded/profile/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch profile for party enroll
         * @summary Fetch profile for party enroll
         * @param {ApiEmbeddedPartnerPartyEnrollRequest} apiEmbeddedPartnerPartyEnrollRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollPartnerParty: (apiEmbeddedPartnerPartyEnrollRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiEmbeddedPartnerPartyEnrollRequest' is not null or undefined
            common_1.assertParamExists('enrollPartnerParty', 'apiEmbeddedPartnerPartyEnrollRequest', apiEmbeddedPartnerPartyEnrollRequest);
            const localVarPath = `/partner/embedded/enroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiEmbeddedPartnerPartyEnrollRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch accounts
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccount: (accountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('fetchAccount', 'accountId', accountId);
            const localVarPath = `/partner/embedded/account/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccounts: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/embedded/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch accounts
         * @param {'USD'} fiatCurrency The funding currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFundingAccounts: (fiatCurrency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fiatCurrency' is not null or undefined
            common_1.assertParamExists('fetchFundingAccounts', 'fiatCurrency', fiatCurrency);
            const localVarPath = `/partner/embedded/funding/account/{fiatCurrency}`
                .replace(`{${"fiatCurrency"}}`, encodeURIComponent(String(fiatCurrency)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch profile for party enroll
         * @summary Fetch profile for party enroll
         * @param {boolean} [additionalAttributes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnerPartyProfile: (additionalAttributes, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/embedded/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (additionalAttributes !== undefined) {
                localVarQueryParameter['additionalAttributes'] = additionalAttributes;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves the pricing between a fiat currency and all supported cryptocurrencies. Both buy and sell prices are returned.
         * @summary Retrieve Cryptocurrency Pricing
         * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} cryptoCurrency The cryptocurrency we want the price in
         * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} fiatCurrency The price we want the cryptocurrency in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCryptoCurrencyPrices: (cryptoCurrency, fiatCurrency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'cryptoCurrency' is not null or undefined
            common_1.assertParamExists('getCryptoCurrencyPrices', 'cryptoCurrency', cryptoCurrency);
            // verify required parameter 'fiatCurrency' is not null or undefined
            common_1.assertParamExists('getCryptoCurrencyPrices', 'fiatCurrency', fiatCurrency);
            const localVarPath = `/partner/embedded/cryptocurrency/price/{cryptoCurrency}/{fiatCurrency}`
                .replace(`{${"cryptoCurrency"}}`, encodeURIComponent(String(cryptoCurrency)))
                .replace(`{${"fiatCurrency"}}`, encodeURIComponent(String(fiatCurrency)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves value of currency converted from source to target.
         * @summary Retieve Execute Price
         * @param {ApiEmbeddedCryptoExecutePriceRequest} apiEmbeddedCryptoExecutePriceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutePrice: (apiEmbeddedCryptoExecutePriceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiEmbeddedCryptoExecutePriceRequest' is not null or undefined
            common_1.assertParamExists('getExecutePrice', 'apiEmbeddedCryptoExecutePriceRequest', apiEmbeddedCryptoExecutePriceRequest);
            const localVarPath = `/partner/embedded/cryptocurrency/execute-price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiEmbeddedCryptoExecutePriceRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves the historical prices of a given cryptocurrency for a given period.
         * @summary Retrieve Historical Cryptocurrency Price
         * @param {'YEAR' | 'MONTH' | 'WEEK' | 'DAY' | 'HOUR'} historicalPeriod Period for which to retrieve price data
         * @param {'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC'} cryptoCurrency The cryptocurrency we\&#39;re looking for
         * @param {'USD'} fiatCurrency The price we want the cryptocurrency in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricalCryptoCurrencyPrice: (historicalPeriod, cryptoCurrency, fiatCurrency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'historicalPeriod' is not null or undefined
            common_1.assertParamExists('getHistoricalCryptoCurrencyPrice', 'historicalPeriod', historicalPeriod);
            // verify required parameter 'cryptoCurrency' is not null or undefined
            common_1.assertParamExists('getHistoricalCryptoCurrencyPrice', 'cryptoCurrency', cryptoCurrency);
            // verify required parameter 'fiatCurrency' is not null or undefined
            common_1.assertParamExists('getHistoricalCryptoCurrencyPrice', 'fiatCurrency', fiatCurrency);
            const localVarPath = `/partner/embedded/cryptocurrency/price/{historicalPeriod}/{cryptoCurrency}/{fiatCurrency}`
                .replace(`{${"historicalPeriod"}}`, encodeURIComponent(String(historicalPeriod)))
                .replace(`{${"cryptoCurrency"}}`, encodeURIComponent(String(cryptoCurrency)))
                .replace(`{${"fiatCurrency"}}`, encodeURIComponent(String(fiatCurrency)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Api provides details to embedded web ui to make initial decision based on partner, party and link information
         * @summary Get Partner Party Link Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPartyLinkInfo: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/embedded/link/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves a single Cryptocurrency Transaction
         * @summary Retrieve Single Cryptocurrency Transaction
         * @param {string} partnerTransactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetails: (partnerTransactionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerTransactionId' is not null or undefined
            common_1.assertParamExists('getTransactionDetails', 'partnerTransactionId', partnerTransactionId);
            const localVarPath = `/partner/embedded/transaction/{partnerTransactionId}`
                .replace(`{${"partnerTransactionId"}}`, encodeURIComponent(String(partnerTransactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieves Customers crypto currency transactions for a given period.
         * @summary Retrieves Customers crypto currency transactions
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionSummary: (fromDate, toDate, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/embedded/transaction/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate instanceof Date) ?
                    fromDate.toISOString() :
                    fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate instanceof Date) ?
                    toDate.toISOString() :
                    toDate;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Buy or sell cryptocurrency for a given Party.
         * @summary Buy or Sell Cryptocurrency
         * @param {ApiEmbeddedCryptoTransactionRequest} apiEmbeddedCryptoTransactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactCryptoCurrency: (apiEmbeddedCryptoTransactionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiEmbeddedCryptoTransactionRequest' is not null or undefined
            common_1.assertParamExists('transactCryptoCurrency', 'apiEmbeddedCryptoTransactionRequest', apiEmbeddedCryptoTransactionRequest);
            const localVarPath = `/partner/embedded/transaction/cryptocurrency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiEmbeddedCryptoTransactionRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EmbeddedPartnerAPIApi - functional programming interface
 * @export
 */
exports.EmbeddedPartnerAPIApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.EmbeddedPartnerAPIApiAxiosParamCreator(configuration);
    return {
        /**
         * Api removes a user profile from redis cache when user exits the onboarding flow
         * @summary Delete profile from cache
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile(profileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProfile(profileId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch profile for party enroll
         * @summary Fetch profile for party enroll
         * @param {ApiEmbeddedPartnerPartyEnrollRequest} apiEmbeddedPartnerPartyEnrollRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollPartnerParty(apiEmbeddedPartnerPartyEnrollRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.enrollPartnerParty(apiEmbeddedPartnerPartyEnrollRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch accounts
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccount(accountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchAccount(accountId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccounts(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchAccounts(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch accounts
         * @param {'USD'} fiatCurrency The funding currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFundingAccounts(fiatCurrency, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchFundingAccounts(fiatCurrency, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch profile for party enroll
         * @summary Fetch profile for party enroll
         * @param {boolean} [additionalAttributes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnerPartyProfile(additionalAttributes, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchPartnerPartyProfile(additionalAttributes, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieves the pricing between a fiat currency and all supported cryptocurrencies. Both buy and sell prices are returned.
         * @summary Retrieve Cryptocurrency Pricing
         * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} cryptoCurrency The cryptocurrency we want the price in
         * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} fiatCurrency The price we want the cryptocurrency in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCryptoCurrencyPrices(cryptoCurrency, fiatCurrency, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCryptoCurrencyPrices(cryptoCurrency, fiatCurrency, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieves value of currency converted from source to target.
         * @summary Retieve Execute Price
         * @param {ApiEmbeddedCryptoExecutePriceRequest} apiEmbeddedCryptoExecutePriceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutePrice(apiEmbeddedCryptoExecutePriceRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExecutePrice(apiEmbeddedCryptoExecutePriceRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieves the historical prices of a given cryptocurrency for a given period.
         * @summary Retrieve Historical Cryptocurrency Price
         * @param {'YEAR' | 'MONTH' | 'WEEK' | 'DAY' | 'HOUR'} historicalPeriod Period for which to retrieve price data
         * @param {'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC'} cryptoCurrency The cryptocurrency we\&#39;re looking for
         * @param {'USD'} fiatCurrency The price we want the cryptocurrency in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricalCryptoCurrencyPrice(historicalPeriod, cryptoCurrency, fiatCurrency, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHistoricalCryptoCurrencyPrice(historicalPeriod, cryptoCurrency, fiatCurrency, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Api provides details to embedded web ui to make initial decision based on partner, party and link information
         * @summary Get Partner Party Link Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPartyLinkInfo(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerPartyLinkInfo(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieves a single Cryptocurrency Transaction
         * @summary Retrieve Single Cryptocurrency Transaction
         * @param {string} partnerTransactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetails(partnerTransactionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTransactionDetails(partnerTransactionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieves Customers crypto currency transactions for a given period.
         * @summary Retrieves Customers crypto currency transactions
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionSummary(fromDate, toDate, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTransactionSummary(fromDate, toDate, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Buy or sell cryptocurrency for a given Party.
         * @summary Buy or Sell Cryptocurrency
         * @param {ApiEmbeddedCryptoTransactionRequest} apiEmbeddedCryptoTransactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactCryptoCurrency(apiEmbeddedCryptoTransactionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.transactCryptoCurrency(apiEmbeddedCryptoTransactionRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EmbeddedPartnerAPIApi - factory interface
 * @export
 */
exports.EmbeddedPartnerAPIApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.EmbeddedPartnerAPIApiFp(configuration);
    return {
        /**
         * Api removes a user profile from redis cache when user exits the onboarding flow
         * @summary Delete profile from cache
         * @param {string} profileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfile(profileId, options) {
            return localVarFp.deleteProfile(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch profile for party enroll
         * @summary Fetch profile for party enroll
         * @param {ApiEmbeddedPartnerPartyEnrollRequest} apiEmbeddedPartnerPartyEnrollRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollPartnerParty(apiEmbeddedPartnerPartyEnrollRequest, xTrackingId, options) {
            return localVarFp.enrollPartnerParty(apiEmbeddedPartnerPartyEnrollRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch accounts
         * @param {string} accountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccount(accountId, options) {
            return localVarFp.fetchAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch accounts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAccounts(options) {
            return localVarFp.fetchAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch accounts
         * @param {'USD'} fiatCurrency The funding currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFundingAccounts(fiatCurrency, options) {
            return localVarFp.fetchFundingAccounts(fiatCurrency, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch profile for party enroll
         * @summary Fetch profile for party enroll
         * @param {boolean} [additionalAttributes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPartnerPartyProfile(additionalAttributes, options) {
            return localVarFp.fetchPartnerPartyProfile(additionalAttributes, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the pricing between a fiat currency and all supported cryptocurrencies. Both buy and sell prices are returned.
         * @summary Retrieve Cryptocurrency Pricing
         * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} cryptoCurrency The cryptocurrency we want the price in
         * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} fiatCurrency The price we want the cryptocurrency in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCryptoCurrencyPrices(cryptoCurrency, fiatCurrency, options) {
            return localVarFp.getCryptoCurrencyPrices(cryptoCurrency, fiatCurrency, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves value of currency converted from source to target.
         * @summary Retieve Execute Price
         * @param {ApiEmbeddedCryptoExecutePriceRequest} apiEmbeddedCryptoExecutePriceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutePrice(apiEmbeddedCryptoExecutePriceRequest, options) {
            return localVarFp.getExecutePrice(apiEmbeddedCryptoExecutePriceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the historical prices of a given cryptocurrency for a given period.
         * @summary Retrieve Historical Cryptocurrency Price
         * @param {'YEAR' | 'MONTH' | 'WEEK' | 'DAY' | 'HOUR'} historicalPeriod Period for which to retrieve price data
         * @param {'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC'} cryptoCurrency The cryptocurrency we\&#39;re looking for
         * @param {'USD'} fiatCurrency The price we want the cryptocurrency in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricalCryptoCurrencyPrice(historicalPeriod, cryptoCurrency, fiatCurrency, options) {
            return localVarFp.getHistoricalCryptoCurrencyPrice(historicalPeriod, cryptoCurrency, fiatCurrency, options).then((request) => request(axios, basePath));
        },
        /**
         * Api provides details to embedded web ui to make initial decision based on partner, party and link information
         * @summary Get Partner Party Link Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPartyLinkInfo(options) {
            return localVarFp.getPartnerPartyLinkInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a single Cryptocurrency Transaction
         * @summary Retrieve Single Cryptocurrency Transaction
         * @param {string} partnerTransactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetails(partnerTransactionId, options) {
            return localVarFp.getTransactionDetails(partnerTransactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves Customers crypto currency transactions for a given period.
         * @summary Retrieves Customers crypto currency transactions
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionSummary(fromDate, toDate, page, size, sort, options) {
            return localVarFp.getTransactionSummary(fromDate, toDate, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Buy or sell cryptocurrency for a given Party.
         * @summary Buy or Sell Cryptocurrency
         * @param {ApiEmbeddedCryptoTransactionRequest} apiEmbeddedCryptoTransactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transactCryptoCurrency(apiEmbeddedCryptoTransactionRequest, options) {
            return localVarFp.transactCryptoCurrency(apiEmbeddedCryptoTransactionRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmbeddedPartnerAPIApi - object-oriented interface
 * @export
 * @class EmbeddedPartnerAPIApi
 * @extends {BaseAPI}
 */
class EmbeddedPartnerAPIApi extends base_1.BaseAPI {
    /**
     * Api removes a user profile from redis cache when user exits the onboarding flow
     * @summary Delete profile from cache
     * @param {string} profileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    deleteProfile(profileId, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).deleteProfile(profileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch profile for party enroll
     * @summary Fetch profile for party enroll
     * @param {ApiEmbeddedPartnerPartyEnrollRequest} apiEmbeddedPartnerPartyEnrollRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    enrollPartnerParty(apiEmbeddedPartnerPartyEnrollRequest, xTrackingId, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).enrollPartnerParty(apiEmbeddedPartnerPartyEnrollRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch accounts
     * @param {string} accountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    fetchAccount(accountId, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).fetchAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    fetchAccounts(options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).fetchAccounts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch accounts
     * @param {'USD'} fiatCurrency The funding currency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    fetchFundingAccounts(fiatCurrency, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).fetchFundingAccounts(fiatCurrency, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch profile for party enroll
     * @summary Fetch profile for party enroll
     * @param {boolean} [additionalAttributes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    fetchPartnerPartyProfile(additionalAttributes, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).fetchPartnerPartyProfile(additionalAttributes, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the pricing between a fiat currency and all supported cryptocurrencies. Both buy and sell prices are returned.
     * @summary Retrieve Cryptocurrency Pricing
     * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} cryptoCurrency The cryptocurrency we want the price in
     * @param {'USD' | 'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BCH' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC' | 'LXX' | 'LCP' | 'LWR' | 'LMO' | 'LKO' | 'LED'} fiatCurrency The price we want the cryptocurrency in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    getCryptoCurrencyPrices(cryptoCurrency, fiatCurrency, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).getCryptoCurrencyPrices(cryptoCurrency, fiatCurrency, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves value of currency converted from source to target.
     * @summary Retieve Execute Price
     * @param {ApiEmbeddedCryptoExecutePriceRequest} apiEmbeddedCryptoExecutePriceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    getExecutePrice(apiEmbeddedCryptoExecutePriceRequest, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).getExecutePrice(apiEmbeddedCryptoExecutePriceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves the historical prices of a given cryptocurrency for a given period.
     * @summary Retrieve Historical Cryptocurrency Price
     * @param {'YEAR' | 'MONTH' | 'WEEK' | 'DAY' | 'HOUR'} historicalPeriod Period for which to retrieve price data
     * @param {'AAVE' | 'AVAX' | 'AXS' | 'BAT' | 'BTC' | 'DOGE' | 'ETH' | 'LINK' | 'LTC' | 'MANA' | 'MATIC' | 'SOL' | 'UNI' | 'USDC'} cryptoCurrency The cryptocurrency we\&#39;re looking for
     * @param {'USD'} fiatCurrency The price we want the cryptocurrency in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    getHistoricalCryptoCurrencyPrice(historicalPeriod, cryptoCurrency, fiatCurrency, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).getHistoricalCryptoCurrencyPrice(historicalPeriod, cryptoCurrency, fiatCurrency, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Api provides details to embedded web ui to make initial decision based on partner, party and link information
     * @summary Get Partner Party Link Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    getPartnerPartyLinkInfo(options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).getPartnerPartyLinkInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves a single Cryptocurrency Transaction
     * @summary Retrieve Single Cryptocurrency Transaction
     * @param {string} partnerTransactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    getTransactionDetails(partnerTransactionId, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).getTransactionDetails(partnerTransactionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieves Customers crypto currency transactions for a given period.
     * @summary Retrieves Customers crypto currency transactions
     * @param {string} [fromDate]
     * @param {string} [toDate]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    getTransactionSummary(fromDate, toDate, page, size, sort, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).getTransactionSummary(fromDate, toDate, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Buy or sell cryptocurrency for a given Party.
     * @summary Buy or Sell Cryptocurrency
     * @param {ApiEmbeddedCryptoTransactionRequest} apiEmbeddedCryptoTransactionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmbeddedPartnerAPIApi
     */
    transactCryptoCurrency(apiEmbeddedCryptoTransactionRequest, options) {
        return exports.EmbeddedPartnerAPIApiFp(this.configuration).transactCryptoCurrency(apiEmbeddedCryptoTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmbeddedPartnerAPIApi = EmbeddedPartnerAPIApi;
/**
 * EvilAchTransactionControllerApi - axios parameter creator
 * @export
 */
exports.EvilAchTransactionControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} accountId
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchTransactions: (accountId, fromDate, toDate, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'accountId' is not null or undefined
            common_1.assertParamExists('getAchTransactions', 'accountId', accountId);
            const localVarPath = `/aof/evil/ach-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate instanceof Date) ?
                    fromDate.toISOString() :
                    fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate instanceof Date) ?
                    toDate.toISOString() :
                    toDate;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} achTransactionId
         * @param {ApiUpdateAchTransactionRequest} apiUpdateAchTransactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAchTransaction: (achTransactionId, apiUpdateAchTransactionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'achTransactionId' is not null or undefined
            common_1.assertParamExists('updateAchTransaction', 'achTransactionId', achTransactionId);
            // verify required parameter 'apiUpdateAchTransactionRequest' is not null or undefined
            common_1.assertParamExists('updateAchTransaction', 'apiUpdateAchTransactionRequest', apiUpdateAchTransactionRequest);
            const localVarPath = `/aof/evil/ach-transactions/{achTransactionId}`
                .replace(`{${"achTransactionId"}}`, encodeURIComponent(String(achTransactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateAchTransactionRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EvilAchTransactionControllerApi - functional programming interface
 * @export
 */
exports.EvilAchTransactionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.EvilAchTransactionControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} accountId
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchTransactions(accountId, fromDate, toDate, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAchTransactions(accountId, fromDate, toDate, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} achTransactionId
         * @param {ApiUpdateAchTransactionRequest} apiUpdateAchTransactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAchTransaction(achTransactionId, apiUpdateAchTransactionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAchTransaction(achTransactionId, apiUpdateAchTransactionRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EvilAchTransactionControllerApi - factory interface
 * @export
 */
exports.EvilAchTransactionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.EvilAchTransactionControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} accountId
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAchTransactions(accountId, fromDate, toDate, page, size, sort, options) {
            return localVarFp.getAchTransactions(accountId, fromDate, toDate, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} achTransactionId
         * @param {ApiUpdateAchTransactionRequest} apiUpdateAchTransactionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAchTransaction(achTransactionId, apiUpdateAchTransactionRequest, options) {
            return localVarFp.updateAchTransaction(achTransactionId, apiUpdateAchTransactionRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EvilAchTransactionControllerApi - object-oriented interface
 * @export
 * @class EvilAchTransactionControllerApi
 * @extends {BaseAPI}
 */
class EvilAchTransactionControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} accountId
     * @param {string} [fromDate]
     * @param {string} [toDate]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvilAchTransactionControllerApi
     */
    getAchTransactions(accountId, fromDate, toDate, page, size, sort, options) {
        return exports.EvilAchTransactionControllerApiFp(this.configuration).getAchTransactions(accountId, fromDate, toDate, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} achTransactionId
     * @param {ApiUpdateAchTransactionRequest} apiUpdateAchTransactionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvilAchTransactionControllerApi
     */
    updateAchTransaction(achTransactionId, apiUpdateAchTransactionRequest, options) {
        return exports.EvilAchTransactionControllerApiFp(this.configuration).updateAchTransaction(achTransactionId, apiUpdateAchTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EvilAchTransactionControllerApi = EvilAchTransactionControllerApi;
/**
 * MonitorApi - axios parameter creator
 * @export
 */
exports.MonitorApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBlackhawkUp: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/checkBlackhawkUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MonitorApi - functional programming interface
 * @export
 */
exports.MonitorApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MonitorApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBlackhawkUp(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkBlackhawkUp(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MonitorApi - factory interface
 * @export
 */
exports.MonitorApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MonitorApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBlackhawkUp(options) {
            return localVarFp.checkBlackhawkUp(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MonitorApi - object-oriented interface
 * @export
 * @class MonitorApi
 * @extends {BaseAPI}
 */
class MonitorApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MonitorApi
     */
    checkBlackhawkUp(options) {
        return exports.MonitorApiFp(this.configuration).checkBlackhawkUp(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MonitorApi = MonitorApi;
/**
 * NewPartySignUpFlowApi - axios parameter creator
 * @export
 */
exports.NewPartySignUpFlowApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Last step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP.  This is needed because the OTP resets need be secure.)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeParty: (apiFinalizeRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiFinalizeRequest' is not null or undefined
            common_1.assertParamExists('finalizeParty', 'apiFinalizeRequest', apiFinalizeRequest);
            const localVarPath = `/aof/party/finalize-party`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiFinalizeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NewPartySignUpFlowApi - functional programming interface
 * @export
 */
exports.NewPartySignUpFlowApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.NewPartySignUpFlowApiAxiosParamCreator(configuration);
    return {
        /**
         * Last step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP.  This is needed because the OTP resets need be secure.)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeParty(apiFinalizeRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.finalizeParty(apiFinalizeRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NewPartySignUpFlowApi - factory interface
 * @export
 */
exports.NewPartySignUpFlowApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.NewPartySignUpFlowApiFp(configuration);
    return {
        /**
         * Last step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP.  This is needed because the OTP resets need be secure.)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeParty(apiFinalizeRequest, xTrackingId, options) {
            return localVarFp.finalizeParty(apiFinalizeRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NewPartySignUpFlowApi - object-oriented interface
 * @export
 * @class NewPartySignUpFlowApi
 * @extends {BaseAPI}
 */
class NewPartySignUpFlowApi extends base_1.BaseAPI {
    /**
     * Last step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP.  This is needed because the OTP resets need be secure.)
     * @summary Finalize Party Sign Up
     * @param {ApiFinalizeRequest} apiFinalizeRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewPartySignUpFlowApi
     */
    finalizeParty(apiFinalizeRequest, xTrackingId, options) {
        return exports.NewPartySignUpFlowApiFp(this.configuration).finalizeParty(apiFinalizeRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.NewPartySignUpFlowApi = NewPartySignUpFlowApi;
/**
 * OfficeOfForeignAssetsControlOFACApi - axios parameter creator
 * @export
 */
exports.OfficeOfForeignAssetsControlOFACApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiCreateOfacRuleRequest} apiCreateOfacRuleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfacRule: (apiCreateOfacRuleRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiCreateOfacRuleRequest' is not null or undefined
            common_1.assertParamExists('createOfacRule', 'apiCreateOfacRuleRequest', apiCreateOfacRuleRequest);
            const localVarPath = `/aof/ofac/rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCreateOfacRuleRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfacRule: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('deleteOfacRule', 'id', id);
            const localVarPath = `/aof/ofac/rule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfacRules: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/ofac/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMatchedParties: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/ofac/matches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMatchedPartyAudits: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('listMatchedPartyAudits', 'partyId', partyId);
            const localVarPath = `/aof/ofac/matches/{partyId}/audits`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiOfacRequest} apiOfacRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markActedByCompliance: (apiOfacRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiOfacRequest' is not null or undefined
            common_1.assertParamExists('markActedByCompliance', 'apiOfacRequest', apiOfacRequest);
            const localVarPath = `/aof/ofac/match/acted-upon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiOfacRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSdnRecords: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchSdnRecords', 'searchParameters', searchParameters);
            const localVarPath = `/aof/ofac/sdn/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OfficeOfForeignAssetsControlOFACApi - functional programming interface
 * @export
 */
exports.OfficeOfForeignAssetsControlOFACApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OfficeOfForeignAssetsControlOFACApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiCreateOfacRuleRequest} apiCreateOfacRuleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfacRule(apiCreateOfacRuleRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createOfacRule(apiCreateOfacRuleRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfacRule(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOfacRule(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfacRules(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOfacRules(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMatchedParties(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMatchedParties(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMatchedPartyAudits(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMatchedPartyAudits(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiOfacRequest} apiOfacRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markActedByCompliance(apiOfacRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markActedByCompliance(apiOfacRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSdnRecords(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchSdnRecords(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OfficeOfForeignAssetsControlOFACApi - factory interface
 * @export
 */
exports.OfficeOfForeignAssetsControlOFACApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OfficeOfForeignAssetsControlOFACApiFp(configuration);
    return {
        /**
         *
         * @param {ApiCreateOfacRuleRequest} apiCreateOfacRuleRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOfacRule(apiCreateOfacRuleRequest, options) {
            return localVarFp.createOfacRule(apiCreateOfacRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOfacRule(id, options) {
            return localVarFp.deleteOfacRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfacRules(options) {
            return localVarFp.getOfacRules(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMatchedParties(options) {
            return localVarFp.listMatchedParties(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMatchedPartyAudits(partyId, options) {
            return localVarFp.listMatchedPartyAudits(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiOfacRequest} apiOfacRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markActedByCompliance(apiOfacRequest, options) {
            return localVarFp.markActedByCompliance(apiOfacRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSdnRecords(searchParameters, options) {
            return localVarFp.searchSdnRecords(searchParameters, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OfficeOfForeignAssetsControlOFACApi - object-oriented interface
 * @export
 * @class OfficeOfForeignAssetsControlOFACApi
 * @extends {BaseAPI}
 */
class OfficeOfForeignAssetsControlOFACApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApiCreateOfacRuleRequest} apiCreateOfacRuleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeOfForeignAssetsControlOFACApi
     */
    createOfacRule(apiCreateOfacRuleRequest, options) {
        return exports.OfficeOfForeignAssetsControlOFACApiFp(this.configuration).createOfacRule(apiCreateOfacRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeOfForeignAssetsControlOFACApi
     */
    deleteOfacRule(id, options) {
        return exports.OfficeOfForeignAssetsControlOFACApiFp(this.configuration).deleteOfacRule(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeOfForeignAssetsControlOFACApi
     */
    getOfacRules(options) {
        return exports.OfficeOfForeignAssetsControlOFACApiFp(this.configuration).getOfacRules(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeOfForeignAssetsControlOFACApi
     */
    listMatchedParties(options) {
        return exports.OfficeOfForeignAssetsControlOFACApiFp(this.configuration).listMatchedParties(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeOfForeignAssetsControlOFACApi
     */
    listMatchedPartyAudits(partyId, options) {
        return exports.OfficeOfForeignAssetsControlOFACApiFp(this.configuration).listMatchedPartyAudits(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiOfacRequest} apiOfacRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeOfForeignAssetsControlOFACApi
     */
    markActedByCompliance(apiOfacRequest, options) {
        return exports.OfficeOfForeignAssetsControlOFACApiFp(this.configuration).markActedByCompliance(apiOfacRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfficeOfForeignAssetsControlOFACApi
     */
    searchSdnRecords(searchParameters, options) {
        return exports.OfficeOfForeignAssetsControlOFACApiFp(this.configuration).searchSdnRecords(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OfficeOfForeignAssetsControlOFACApi = OfficeOfForeignAssetsControlOFACApi;
/**
 * OldMerchantPortalReportControllerApi - axios parameter creator
 * @export
 */
exports.OldMerchantPortalReportControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiOldMerchantSettlementSummaryRequest} apiOldMerchantSettlementSummaryRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlementSummaryList: (apiOldMerchantSettlementSummaryRequest, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiOldMerchantSettlementSummaryRequest' is not null or undefined
            common_1.assertParamExists('getSettlementSummaryList', 'apiOldMerchantSettlementSummaryRequest', apiOldMerchantSettlementSummaryRequest);
            const localVarPath = `/business-portal/merchant/settlement-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiOldMerchantSettlementSummaryRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OldMerchantPortalReportControllerApi - functional programming interface
 * @export
 */
exports.OldMerchantPortalReportControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OldMerchantPortalReportControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiOldMerchantSettlementSummaryRequest} apiOldMerchantSettlementSummaryRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlementSummaryList(apiOldMerchantSettlementSummaryRequest, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSettlementSummaryList(apiOldMerchantSettlementSummaryRequest, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OldMerchantPortalReportControllerApi - factory interface
 * @export
 */
exports.OldMerchantPortalReportControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OldMerchantPortalReportControllerApiFp(configuration);
    return {
        /**
         *
         * @param {ApiOldMerchantSettlementSummaryRequest} apiOldMerchantSettlementSummaryRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlementSummaryList(apiOldMerchantSettlementSummaryRequest, page, size, sort, options) {
            return localVarFp.getSettlementSummaryList(apiOldMerchantSettlementSummaryRequest, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OldMerchantPortalReportControllerApi - object-oriented interface
 * @export
 * @class OldMerchantPortalReportControllerApi
 * @extends {BaseAPI}
 */
class OldMerchantPortalReportControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApiOldMerchantSettlementSummaryRequest} apiOldMerchantSettlementSummaryRequest
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OldMerchantPortalReportControllerApi
     */
    getSettlementSummaryList(apiOldMerchantSettlementSummaryRequest, page, size, sort, options) {
        return exports.OldMerchantPortalReportControllerApiFp(this.configuration).getSettlementSummaryList(apiOldMerchantSettlementSummaryRequest, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OldMerchantPortalReportControllerApi = OldMerchantPortalReportControllerApi;
/**
 * PartnerAPIAdminApi - axios parameter creator
 * @export
 */
exports.PartnerAPIAdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Generate Settlement file for a given date
         * @param {string} partnerId
         * @param {ApiPartnerBatchCompleteRequest} apiPartnerBatchCompleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchCompletion: (partnerId, apiPartnerBatchCompleteRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('batchCompletion', 'partnerId', partnerId);
            // verify required parameter 'apiPartnerBatchCompleteRequest' is not null or undefined
            common_1.assertParamExists('batchCompletion', 'apiPartnerBatchCompleteRequest', apiPartnerBatchCompleteRequest);
            const localVarPath = `/partner/report/{partnerId}/batchComplete`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartnerBatchCompleteRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Clear Partner Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearCache: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Clear Partner config & hierarchy Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearRiskConfigAndHierarchyCache: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/clear/risk-config/cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create Partner
         * @param {ApiCreatePartnerRequest} apiCreatePartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner: (apiCreatePartnerRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiCreatePartnerRequest' is not null or undefined
            common_1.assertParamExists('createPartner', 'apiCreatePartnerRequest', apiCreatePartnerRequest);
            const localVarPath = `/partner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCreatePartnerRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Generate Reconciliation file for a given date
         * @param {ApiPartnerReconciliationFileRequest} apiPartnerReconciliationFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReconciliationFile: (apiPartnerReconciliationFileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartnerReconciliationFileRequest' is not null or undefined
            common_1.assertParamExists('generateReconciliationFile', 'apiPartnerReconciliationFileRequest', apiPartnerReconciliationFileRequest);
            const localVarPath = `/partner/report/reconciliation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartnerReconciliationFileRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Generate Settlement file for a given date
         * @param {ApiPartnerSettlementFileRequest} apiPartnerSettlementFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSettlementFile: (apiPartnerSettlementFileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartnerSettlementFileRequest' is not null or undefined
            common_1.assertParamExists('generateSettlementFile', 'apiPartnerSettlementFileRequest', apiPartnerSettlementFileRequest);
            const localVarPath = `/partner/report/settlement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartnerSettlementFileRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Cryptocurrency transactions for a given a Partner Id
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCryptoCurrencyTransactions: (partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('getCryptoCurrencyTransactions', 'partnerId', partnerId);
            const localVarPath = `/partner/test-support/partner/{partnerId}/cryptocurrency/transactions`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a list of Enrollment logs for a given party id. If the id is unknown an empty list will be returned.
         * @summary Get Enrollment Logs
         * @param {string} partyId Target Party id. An unknown id will return an empty list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrollmentLogs: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getEnrollmentLogs', 'partyId', partyId);
            const localVarPath = `/partner/test-support/partner/{partyId}/enrollmentlog`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Cryptocurrency ledger postings
         * @param {string} partnerId
         * @param {Pageable} pageable
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerLedgerPostings: (partnerId, pageable, from, to, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('getPartnerLedgerPostings', 'partnerId', partnerId);
            // verify required parameter 'pageable' is not null or undefined
            common_1.assertParamExists('getPartnerLedgerPostings', 'pageable', pageable);
            const localVarPath = `/partner/test-support/partner/{partnerId}/ledger`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (pageable !== undefined) {
                localVarQueryParameter['pageable'] = pageable;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Partner-Party details for a given Party Id
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPartyDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('getPartnerPartyDetails', 'partyId', partyId);
            const localVarPath = `/partner/test-support/partner/party/{partyId}/details`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get Cryptocurrency transaction details for a given transaction id
         * @param {string} transactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerTransactionDetails: (transactionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'transactionId' is not null or undefined
            common_1.assertParamExists('getPartnerTransactionDetails', 'transactionId', transactionId);
            const localVarPath = `/partner/test-support/partner/transaction/{transactionId}/details`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Generate Partner Report has completed processing
         * @param {string} id The id of the results of the target batch process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportCompletion: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getReportCompletion', 'id', id);
            const localVarPath = `/partner/report/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Migrate Partner config & parent hierarchy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateRiskPartnerAndHierarchyConfig: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/migrate/risk-partner-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Refresh IMM partner config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshConfig: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/config-refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve Descendant Partners for a given partner id
         * @summary Retrieve Descendant Partners for a given partner id
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDescendantPartners: (partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('retrieveDescendantPartners', 'partnerId', partnerId);
            const localVarPath = `/partner/{partnerId}/descendants`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieve Partner
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartner: (partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('retrievePartner', 'partnerId', partnerId);
            const localVarPath = `/partner/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search Partner(s)
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPartner: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchPartner', 'searchParameters', searchParameters);
            const localVarPath = `/partner/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Partner
         * @param {string} partnerId
         * @param {ApiUpdatePartnerRequest} apiUpdatePartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartner: (partnerId, apiUpdatePartnerRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('updatePartner', 'partnerId', partnerId);
            // verify required parameter 'apiUpdatePartnerRequest' is not null or undefined
            common_1.assertParamExists('updatePartner', 'apiUpdatePartnerRequest', apiUpdatePartnerRequest);
            const localVarPath = `/partner/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdatePartnerRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update the partner party link status
         * @param {string} partnerId
         * @param {string} partyId
         * @param {TestAdminPartnerPartyLinkStatusRequest} testAdminPartnerPartyLinkStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerPartyLinkStatus: (partnerId, partyId, testAdminPartnerPartyLinkStatusRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('updatePartnerPartyLinkStatus', 'partnerId', partnerId);
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('updatePartnerPartyLinkStatus', 'partyId', partyId);
            // verify required parameter 'testAdminPartnerPartyLinkStatusRequest' is not null or undefined
            common_1.assertParamExists('updatePartnerPartyLinkStatus', 'testAdminPartnerPartyLinkStatusRequest', testAdminPartnerPartyLinkStatusRequest);
            const localVarPath = `/partner/test-support/partner/{partnerId}/party/{partyId}/link`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(testAdminPartnerPartyLinkStatusRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Calling this endpoint will create the configuration and approve it instantly.A Partner can be configured through this endpoint only when it has no approved configuration.
         * @summary Create Partner spread and commission configuration in IMM.
         * @param {string} partnerId Target Partner id. If unknown the call will fail.
         * @param {ApiPartnerImmConfigUpdateRequest} apiPartnerImmConfigUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerSpreadAndCommissionIMMConfig: (partnerId, apiPartnerImmConfigUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('updatePartnerSpreadAndCommissionIMMConfig', 'partnerId', partnerId);
            // verify required parameter 'apiPartnerImmConfigUpdateRequest' is not null or undefined
            common_1.assertParamExists('updatePartnerSpreadAndCommissionIMMConfig', 'apiPartnerImmConfigUpdateRequest', apiPartnerImmConfigUpdateRequest);
            const localVarPath = `/partner/test-support/partner/{partnerId}/config/spread-and-commission`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartnerImmConfigUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PartnerAPIAdminApi - functional programming interface
 * @export
 */
exports.PartnerAPIAdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PartnerAPIAdminApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Generate Settlement file for a given date
         * @param {string} partnerId
         * @param {ApiPartnerBatchCompleteRequest} apiPartnerBatchCompleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchCompletion(partnerId, apiPartnerBatchCompleteRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchCompletion(partnerId, apiPartnerBatchCompleteRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Clear Partner Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearCache(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clearCache(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Clear Partner config & hierarchy Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearRiskConfigAndHierarchyCache(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clearRiskConfigAndHierarchyCache(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create Partner
         * @param {ApiCreatePartnerRequest} apiCreatePartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner(apiCreatePartnerRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPartner(apiCreatePartnerRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Generate Reconciliation file for a given date
         * @param {ApiPartnerReconciliationFileRequest} apiPartnerReconciliationFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReconciliationFile(apiPartnerReconciliationFileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateReconciliationFile(apiPartnerReconciliationFileRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Generate Settlement file for a given date
         * @param {ApiPartnerSettlementFileRequest} apiPartnerSettlementFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSettlementFile(apiPartnerSettlementFileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateSettlementFile(apiPartnerSettlementFileRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Cryptocurrency transactions for a given a Partner Id
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCryptoCurrencyTransactions(partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCryptoCurrencyTransactions(partnerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get a list of Enrollment logs for a given party id. If the id is unknown an empty list will be returned.
         * @summary Get Enrollment Logs
         * @param {string} partyId Target Party id. An unknown id will return an empty list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrollmentLogs(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEnrollmentLogs(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Cryptocurrency ledger postings
         * @param {string} partnerId
         * @param {Pageable} pageable
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerLedgerPostings(partnerId, pageable, from, to, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerLedgerPostings(partnerId, pageable, from, to, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Partner-Party details for a given Party Id
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPartyDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerPartyDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get Cryptocurrency transaction details for a given transaction id
         * @param {string} transactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerTransactionDetails(transactionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerTransactionDetails(transactionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Generate Partner Report has completed processing
         * @param {string} id The id of the results of the target batch process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportCompletion(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getReportCompletion(id, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Migrate Partner config & parent hierarchy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateRiskPartnerAndHierarchyConfig(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrateRiskPartnerAndHierarchyConfig(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Refresh IMM partner config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshConfig(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshConfig(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve Descendant Partners for a given partner id
         * @summary Retrieve Descendant Partners for a given partner id
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDescendantPartners(partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveDescendantPartners(partnerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retrieve Partner
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartner(partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrievePartner(partnerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search Partner(s)
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPartner(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPartner(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Partner
         * @param {string} partnerId
         * @param {ApiUpdatePartnerRequest} apiUpdatePartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartner(partnerId, apiUpdatePartnerRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePartner(partnerId, apiUpdatePartnerRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update the partner party link status
         * @param {string} partnerId
         * @param {string} partyId
         * @param {TestAdminPartnerPartyLinkStatusRequest} testAdminPartnerPartyLinkStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerPartyLinkStatus(partnerId, partyId, testAdminPartnerPartyLinkStatusRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePartnerPartyLinkStatus(partnerId, partyId, testAdminPartnerPartyLinkStatusRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Calling this endpoint will create the configuration and approve it instantly.A Partner can be configured through this endpoint only when it has no approved configuration.
         * @summary Create Partner spread and commission configuration in IMM.
         * @param {string} partnerId Target Partner id. If unknown the call will fail.
         * @param {ApiPartnerImmConfigUpdateRequest} apiPartnerImmConfigUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerSpreadAndCommissionIMMConfig(partnerId, apiPartnerImmConfigUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePartnerSpreadAndCommissionIMMConfig(partnerId, apiPartnerImmConfigUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PartnerAPIAdminApi - factory interface
 * @export
 */
exports.PartnerAPIAdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PartnerAPIAdminApiFp(configuration);
    return {
        /**
         *
         * @summary Generate Settlement file for a given date
         * @param {string} partnerId
         * @param {ApiPartnerBatchCompleteRequest} apiPartnerBatchCompleteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchCompletion(partnerId, apiPartnerBatchCompleteRequest, options) {
            return localVarFp.batchCompletion(partnerId, apiPartnerBatchCompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Clear Partner Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearCache(options) {
            return localVarFp.clearCache(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Clear Partner config & hierarchy Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearRiskConfigAndHierarchyCache(options) {
            return localVarFp.clearRiskConfigAndHierarchyCache(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Partner
         * @param {ApiCreatePartnerRequest} apiCreatePartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner(apiCreatePartnerRequest, options) {
            return localVarFp.createPartner(apiCreatePartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate Reconciliation file for a given date
         * @param {ApiPartnerReconciliationFileRequest} apiPartnerReconciliationFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReconciliationFile(apiPartnerReconciliationFileRequest, options) {
            return localVarFp.generateReconciliationFile(apiPartnerReconciliationFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate Settlement file for a given date
         * @param {ApiPartnerSettlementFileRequest} apiPartnerSettlementFileRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSettlementFile(apiPartnerSettlementFileRequest, options) {
            return localVarFp.generateSettlementFile(apiPartnerSettlementFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Cryptocurrency transactions for a given a Partner Id
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCryptoCurrencyTransactions(partnerId, options) {
            return localVarFp.getCryptoCurrencyTransactions(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of Enrollment logs for a given party id. If the id is unknown an empty list will be returned.
         * @summary Get Enrollment Logs
         * @param {string} partyId Target Party id. An unknown id will return an empty list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnrollmentLogs(partyId, options) {
            return localVarFp.getEnrollmentLogs(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Cryptocurrency ledger postings
         * @param {string} partnerId
         * @param {Pageable} pageable
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerLedgerPostings(partnerId, pageable, from, to, options) {
            return localVarFp.getPartnerLedgerPostings(partnerId, pageable, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Partner-Party details for a given Party Id
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerPartyDetails(partyId, options) {
            return localVarFp.getPartnerPartyDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get Cryptocurrency transaction details for a given transaction id
         * @param {string} transactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerTransactionDetails(transactionId, options) {
            return localVarFp.getPartnerTransactionDetails(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Generate Partner Report has completed processing
         * @param {string} id The id of the results of the target batch process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportCompletion(id, options) {
            return localVarFp.getReportCompletion(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Migrate Partner config & parent hierarchy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateRiskPartnerAndHierarchyConfig(options) {
            return localVarFp.migrateRiskPartnerAndHierarchyConfig(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Refresh IMM partner config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshConfig(options) {
            return localVarFp.refreshConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve Descendant Partners for a given partner id
         * @summary Retrieve Descendant Partners for a given partner id
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDescendantPartners(partnerId, options) {
            return localVarFp.retrieveDescendantPartners(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve Partner
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartner(partnerId, options) {
            return localVarFp.retrievePartner(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search Partner(s)
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPartner(searchParameters, options) {
            return localVarFp.searchPartner(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Partner
         * @param {string} partnerId
         * @param {ApiUpdatePartnerRequest} apiUpdatePartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartner(partnerId, apiUpdatePartnerRequest, options) {
            return localVarFp.updatePartner(partnerId, apiUpdatePartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update the partner party link status
         * @param {string} partnerId
         * @param {string} partyId
         * @param {TestAdminPartnerPartyLinkStatusRequest} testAdminPartnerPartyLinkStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerPartyLinkStatus(partnerId, partyId, testAdminPartnerPartyLinkStatusRequest, options) {
            return localVarFp.updatePartnerPartyLinkStatus(partnerId, partyId, testAdminPartnerPartyLinkStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Calling this endpoint will create the configuration and approve it instantly.A Partner can be configured through this endpoint only when it has no approved configuration.
         * @summary Create Partner spread and commission configuration in IMM.
         * @param {string} partnerId Target Partner id. If unknown the call will fail.
         * @param {ApiPartnerImmConfigUpdateRequest} apiPartnerImmConfigUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerSpreadAndCommissionIMMConfig(partnerId, apiPartnerImmConfigUpdateRequest, options) {
            return localVarFp.updatePartnerSpreadAndCommissionIMMConfig(partnerId, apiPartnerImmConfigUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartnerAPIAdminApi - object-oriented interface
 * @export
 * @class PartnerAPIAdminApi
 * @extends {BaseAPI}
 */
class PartnerAPIAdminApi extends base_1.BaseAPI {
    /**
     *
     * @summary Generate Settlement file for a given date
     * @param {string} partnerId
     * @param {ApiPartnerBatchCompleteRequest} apiPartnerBatchCompleteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    batchCompletion(partnerId, apiPartnerBatchCompleteRequest, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).batchCompletion(partnerId, apiPartnerBatchCompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Clear Partner Cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    clearCache(options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).clearCache(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Clear Partner config & hierarchy Cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    clearRiskConfigAndHierarchyCache(options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).clearRiskConfigAndHierarchyCache(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Partner
     * @param {ApiCreatePartnerRequest} apiCreatePartnerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    createPartner(apiCreatePartnerRequest, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).createPartner(apiCreatePartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Generate Reconciliation file for a given date
     * @param {ApiPartnerReconciliationFileRequest} apiPartnerReconciliationFileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    generateReconciliationFile(apiPartnerReconciliationFileRequest, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).generateReconciliationFile(apiPartnerReconciliationFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Generate Settlement file for a given date
     * @param {ApiPartnerSettlementFileRequest} apiPartnerSettlementFileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    generateSettlementFile(apiPartnerSettlementFileRequest, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).generateSettlementFile(apiPartnerSettlementFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Cryptocurrency transactions for a given a Partner Id
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    getCryptoCurrencyTransactions(partnerId, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).getCryptoCurrencyTransactions(partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a list of Enrollment logs for a given party id. If the id is unknown an empty list will be returned.
     * @summary Get Enrollment Logs
     * @param {string} partyId Target Party id. An unknown id will return an empty list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    getEnrollmentLogs(partyId, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).getEnrollmentLogs(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Cryptocurrency ledger postings
     * @param {string} partnerId
     * @param {Pageable} pageable
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    getPartnerLedgerPostings(partnerId, pageable, from, to, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).getPartnerLedgerPostings(partnerId, pageable, from, to, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Partner-Party details for a given Party Id
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    getPartnerPartyDetails(partyId, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).getPartnerPartyDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get Cryptocurrency transaction details for a given transaction id
     * @param {string} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    getPartnerTransactionDetails(transactionId, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).getPartnerTransactionDetails(transactionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Generate Partner Report has completed processing
     * @param {string} id The id of the results of the target batch process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    getReportCompletion(id, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).getReportCompletion(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Migrate Partner config & parent hierarchy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    migrateRiskPartnerAndHierarchyConfig(options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).migrateRiskPartnerAndHierarchyConfig(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Refresh IMM partner config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    refreshConfig(options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).refreshConfig(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve Descendant Partners for a given partner id
     * @summary Retrieve Descendant Partners for a given partner id
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    retrieveDescendantPartners(partnerId, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).retrieveDescendantPartners(partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve Partner
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    retrievePartner(partnerId, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).retrievePartner(partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search Partner(s)
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    searchPartner(searchParameters, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).searchPartner(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Partner
     * @param {string} partnerId
     * @param {ApiUpdatePartnerRequest} apiUpdatePartnerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    updatePartner(partnerId, apiUpdatePartnerRequest, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).updatePartner(partnerId, apiUpdatePartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update the partner party link status
     * @param {string} partnerId
     * @param {string} partyId
     * @param {TestAdminPartnerPartyLinkStatusRequest} testAdminPartnerPartyLinkStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    updatePartnerPartyLinkStatus(partnerId, partyId, testAdminPartnerPartyLinkStatusRequest, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).updatePartnerPartyLinkStatus(partnerId, partyId, testAdminPartnerPartyLinkStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Calling this endpoint will create the configuration and approve it instantly.A Partner can be configured through this endpoint only when it has no approved configuration.
     * @summary Create Partner spread and commission configuration in IMM.
     * @param {string} partnerId Target Partner id. If unknown the call will fail.
     * @param {ApiPartnerImmConfigUpdateRequest} apiPartnerImmConfigUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAPIAdminApi
     */
    updatePartnerSpreadAndCommissionIMMConfig(partnerId, apiPartnerImmConfigUpdateRequest, options) {
        return exports.PartnerAPIAdminApiFp(this.configuration).updatePartnerSpreadAndCommissionIMMConfig(partnerId, apiPartnerImmConfigUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PartnerAPIAdminApi = PartnerAPIAdminApi;
/**
 * PartnerPortalApisApi - axios parameter creator
 * @export
 */
exports.PartnerPortalApisApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} disputeId
         * @param {ApiCommentRequest} apiCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment: (disputeId, apiCommentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'disputeId' is not null or undefined
            common_1.assertParamExists('addComment', 'disputeId', disputeId);
            // verify required parameter 'apiCommentRequest' is not null or undefined
            common_1.assertParamExists('addComment', 'apiCommentRequest', apiCommentRequest);
            const localVarPath = `/partner/ticket/{disputeId}/comment`
                .replace(`{${"disputeId"}}`, encodeURIComponent(String(disputeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCommentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveChargeBack: (disputeId, apiDisputeChargebackRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'disputeId' is not null or undefined
            common_1.assertParamExists('approveChargeBack', 'disputeId', disputeId);
            // verify required parameter 'apiDisputeChargebackRequest' is not null or undefined
            common_1.assertParamExists('approveChargeBack', 'apiDisputeChargebackRequest', apiDisputeChargebackRequest);
            const localVarPath = `/partner/dispute/{disputeId}/accept`
                .replace(`{${"disputeId"}}`, encodeURIComponent(String(disputeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeChargebackRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} bakktTransactionRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDisputeDetails: (bakktTransactionRef, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'bakktTransactionRef' is not null or undefined
            common_1.assertParamExists('fetchDisputeDetails', 'bakktTransactionRef', bakktTransactionRef);
            const localVarPath = `/partner/dispute/{bakktTransactionRef}`
                .replace(`{${"bakktTransactionRef"}}`, encodeURIComponent(String(bakktTransactionRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectChargeBack: (disputeId, apiDisputeChargebackRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'disputeId' is not null or undefined
            common_1.assertParamExists('rejectChargeBack', 'disputeId', disputeId);
            // verify required parameter 'apiDisputeChargebackRequest' is not null or undefined
            common_1.assertParamExists('rejectChargeBack', 'apiDisputeChargebackRequest', apiDisputeChargebackRequest);
            const localVarPath = `/partner/dispute/{disputeId}/reject`
                .replace(`{${"disputeId"}}`, encodeURIComponent(String(disputeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiDisputeChargebackRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiAttachmentRequest} apiAttachmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAttachment: (apiAttachmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiAttachmentRequest' is not null or undefined
            common_1.assertParamExists('retrieveAttachment', 'apiAttachmentRequest', apiAttachmentRequest);
            const localVarPath = `/partner/ticket/retrieve-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiAttachmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieve Partner
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartnerDetails: (partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('retrievePartnerDetails', 'partnerId', partnerId);
            const localVarPath = `/partner/{partnerId}/details`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch the portfolio details for a party and list of partnerIds
         * @summary partner portal portfolio api
         * @param {string} partnerId
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePortfolioAccounts: (partnerId, partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('retrievePortfolioAccounts', 'partnerId', partnerId);
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('retrievePortfolioAccounts', 'partyId', partyId);
            const localVarPath = `/partner/{partnerId}/party/{partyId}/portfolio`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: (inlineObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/partner/ticket/upload-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} filename
         * @param {string} contentType
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment1: (filename, contentType, inlineObject1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'filename' is not null or undefined
            common_1.assertParamExists('uploadAttachment1', 'filename', filename);
            // verify required parameter 'contentType' is not null or undefined
            common_1.assertParamExists('uploadAttachment1', 'contentType', contentType);
            // verify required parameter 'inlineObject1' is not null or undefined
            common_1.assertParamExists('uploadAttachment1', 'inlineObject1', inlineObject1);
            const localVarPath = `/partner/ticket/upload-attachment/{filename}`
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (contentType !== undefined) {
                localVarQueryParameter['contentType'] = contentType;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PartnerPortalApisApi - functional programming interface
 * @export
 */
exports.PartnerPortalApisApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PartnerPortalApisApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} disputeId
         * @param {ApiCommentRequest} apiCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment(disputeId, apiCommentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addComment(disputeId, apiCommentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveChargeBack(disputeId, apiDisputeChargebackRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.approveChargeBack(disputeId, apiDisputeChargebackRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} bakktTransactionRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDisputeDetails(bakktTransactionRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fetchDisputeDetails(bakktTransactionRef, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectChargeBack(disputeId, apiDisputeChargebackRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rejectChargeBack(disputeId, apiDisputeChargebackRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiAttachmentRequest} apiAttachmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAttachment(apiAttachmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveAttachment(apiAttachmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retrieve Partner
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartnerDetails(partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrievePartnerDetails(partnerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch the portfolio details for a party and list of partnerIds
         * @summary partner portal portfolio api
         * @param {string} partnerId
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePortfolioAccounts(partnerId, partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrievePortfolioAccounts(partnerId, partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(inlineObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadAttachment(inlineObject, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} filename
         * @param {string} contentType
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment1(filename, contentType, inlineObject1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadAttachment1(filename, contentType, inlineObject1, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PartnerPortalApisApi - factory interface
 * @export
 */
exports.PartnerPortalApisApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PartnerPortalApisApiFp(configuration);
    return {
        /**
         *
         * @param {string} disputeId
         * @param {ApiCommentRequest} apiCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment(disputeId, apiCommentRequest, options) {
            return localVarFp.addComment(disputeId, apiCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveChargeBack(disputeId, apiDisputeChargebackRequest, options) {
            return localVarFp.approveChargeBack(disputeId, apiDisputeChargebackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} bakktTransactionRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDisputeDetails(bakktTransactionRef, options) {
            return localVarFp.fetchDisputeDetails(bakktTransactionRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} disputeId
         * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectChargeBack(disputeId, apiDisputeChargebackRequest, options) {
            return localVarFp.rejectChargeBack(disputeId, apiDisputeChargebackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiAttachmentRequest} apiAttachmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAttachment(apiAttachmentRequest, options) {
            return localVarFp.retrieveAttachment(apiAttachmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve Partner
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePartnerDetails(partnerId, options) {
            return localVarFp.retrievePartnerDetails(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the portfolio details for a party and list of partnerIds
         * @summary partner portal portfolio api
         * @param {string} partnerId
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrievePortfolioAccounts(partnerId, partyId, options) {
            return localVarFp.retrievePortfolioAccounts(partnerId, partyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(inlineObject, options) {
            return localVarFp.uploadAttachment(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} filename
         * @param {string} contentType
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment1(filename, contentType, inlineObject1, options) {
            return localVarFp.uploadAttachment1(filename, contentType, inlineObject1, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartnerPortalApisApi - object-oriented interface
 * @export
 * @class PartnerPortalApisApi
 * @extends {BaseAPI}
 */
class PartnerPortalApisApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} disputeId
     * @param {ApiCommentRequest} apiCommentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerPortalApisApi
     */
    addComment(disputeId, apiCommentRequest, options) {
        return exports.PartnerPortalApisApiFp(this.configuration).addComment(disputeId, apiCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} disputeId
     * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerPortalApisApi
     */
    approveChargeBack(disputeId, apiDisputeChargebackRequest, options) {
        return exports.PartnerPortalApisApiFp(this.configuration).approveChargeBack(disputeId, apiDisputeChargebackRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} bakktTransactionRef
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerPortalApisApi
     */
    fetchDisputeDetails(bakktTransactionRef, options) {
        return exports.PartnerPortalApisApiFp(this.configuration).fetchDisputeDetails(bakktTransactionRef, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} disputeId
     * @param {ApiDisputeChargebackRequest} apiDisputeChargebackRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerPortalApisApi
     */
    rejectChargeBack(disputeId, apiDisputeChargebackRequest, options) {
        return exports.PartnerPortalApisApiFp(this.configuration).rejectChargeBack(disputeId, apiDisputeChargebackRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiAttachmentRequest} apiAttachmentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerPortalApisApi
     */
    retrieveAttachment(apiAttachmentRequest, options) {
        return exports.PartnerPortalApisApiFp(this.configuration).retrieveAttachment(apiAttachmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve Partner
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerPortalApisApi
     */
    retrievePartnerDetails(partnerId, options) {
        return exports.PartnerPortalApisApiFp(this.configuration).retrievePartnerDetails(partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch the portfolio details for a party and list of partnerIds
     * @summary partner portal portfolio api
     * @param {string} partnerId
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerPortalApisApi
     */
    retrievePortfolioAccounts(partnerId, partyId, options) {
        return exports.PartnerPortalApisApiFp(this.configuration).retrievePortfolioAccounts(partnerId, partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerPortalApisApi
     */
    uploadAttachment(inlineObject, options) {
        return exports.PartnerPortalApisApiFp(this.configuration).uploadAttachment(inlineObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} filename
     * @param {string} contentType
     * @param {InlineObject1} inlineObject1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerPortalApisApi
     */
    uploadAttachment1(filename, contentType, inlineObject1, options) {
        return exports.PartnerPortalApisApiFp(this.configuration).uploadAttachment1(filename, contentType, inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PartnerPortalApisApi = PartnerPortalApisApi;
/**
 * PartyApi - axios parameter creator
 * @export
 */
exports.PartyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add Identifier
         * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifier: (apiAddIdentifierRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiAddIdentifierRequest' is not null or undefined
            common_1.assertParamExists('addIdentifier', 'apiAddIdentifierRequest', apiAddIdentifierRequest);
            const localVarPath = `/aof/party/identifier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiAddIdentifierRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Designed for users without account created yet.
         * @summary Add Identifier to non-Account
         * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifier1: (apiAddIdentifierRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiAddIdentifierRequest' is not null or undefined
            common_1.assertParamExists('addIdentifier1', 'apiAddIdentifierRequest', apiAddIdentifierRequest);
            const localVarPath = `/aof/party/add-identifier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiAddIdentifierRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch a list of Parties that match all the given search criteria. All specified search criteria are combined.
         * @summary Party Search for Party Operations
         * @param {ApiPartySearchRequest} apiPartySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchParties: (apiPartySearchRequest, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartySearchRequest' is not null or undefined
            common_1.assertParamExists('adminSearchParties', 'apiPartySearchRequest', apiPartySearchRequest);
            const localVarPath = `/aof/party/search/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartySearchRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Designed for users without account created yet.  It will store the chosen alias into newAlias.  Later in flow newAlias is stored into alias
         * @summary Add newAlias to customers Party
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aliasAvailable: (apiUpdateAliasRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUpdateAliasRequest' is not null or undefined
            common_1.assertParamExists('aliasAvailable', 'apiUpdateAliasRequest', apiUpdateAliasRequest);
            const localVarPath = `/aof/party/alias-available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateAliasRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * First step in consumer sign-up. Verifies that the identifier in request is available for use
         * @summary Check Party identifier availability
         * @param {ApiAvailabilityRequest} apiAvailabilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        available: (apiAvailabilityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiAvailabilityRequest' is not null or undefined
            common_1.assertParamExists('available', 'apiAvailabilityRequest', apiAvailabilityRequest);
            const localVarPath = `/aof/party/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiAvailabilityRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Check Bakkt ID / alias availabilitity
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableAlias: (apiUpdateAliasRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUpdateAliasRequest' is not null or undefined
            common_1.assertParamExists('availableAlias', 'apiUpdateAliasRequest', apiUpdateAliasRequest);
            const localVarPath = `/aof/party/alias/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateAliasRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Change the password of the logged in user
         * @summary Change Password
         * @param {ApiChangePasswordRequest} apiChangePasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: (apiChangePasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiChangePasswordRequest' is not null or undefined
            common_1.assertParamExists('changePassword', 'apiChangePasswordRequest', apiChangePasswordRequest);
            const localVarPath = `/aof/party/password/change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiChangePasswordRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch a list of Parties that match all the given search criteria. All specified search criteria are combined.
         * @summary Party Search for Consumers
         * @param {ApiPartySearchRequest} apiPartySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumerSearchParties: (apiPartySearchRequest, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartySearchRequest' is not null or undefined
            common_1.assertParamExists('consumerSearchParties', 'apiPartySearchRequest', apiPartySearchRequest);
            const localVarPath = `/aof/party/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartySearchRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fourth and final step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalize: (apiFinalizeRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiFinalizeRequest' is not null or undefined
            common_1.assertParamExists('finalize', 'apiFinalizeRequest', apiFinalizeRequest);
            const localVarPath = `/aof/party/finalize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiFinalizeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Last step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP.  This is needed because the OTP resets need be secure.)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeParty: (apiFinalizeRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiFinalizeRequest' is not null or undefined
            common_1.assertParamExists('finalizeParty', 'apiFinalizeRequest', apiFinalizeRequest);
            const localVarPath = `/aof/party/finalize-party`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiFinalizeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieve Funding Preference by type
         * @param {'BUY_GIFTCARD' | 'BUY_CRYPTO' | 'BAKKT_CARD'} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInAppPaymentFundingSource: (type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            common_1.assertParamExists('getInAppPaymentFundingSource', 'type', type);
            const localVarPath = `/aof/party/funding-sources/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/party/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Third step in consumer sign-up. This call is the validation step proving (theoretical) ownership of the identifier
         * @summary Validate One Time Password (OTP)
         * @param {ApiValidateOTPRequest} apiValidateOTPRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otp: (apiValidateOTPRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiValidateOTPRequest' is not null or undefined
            common_1.assertParamExists('otp', 'apiValidateOTPRequest', apiValidateOTPRequest);
            const localVarPath = `/aof/party/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiValidateOTPRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Suspend and possibly liquidate a party
         * @summary Suspend party
         * @param {ApiPartyLiquidateRequest} apiPartyLiquidateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyLiquidate: (apiPartyLiquidateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartyLiquidateRequest' is not null or undefined
            common_1.assertParamExists('partyLiquidate', 'apiPartyLiquidateRequest', apiPartyLiquidateRequest);
            const localVarPath = `/aof/party/liquidate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartyLiquidateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Persist EW9 Acceptance Time and Signature in Party
         * @summary Persist EW9 Acceptance Time and Signature
         * @param {ApiSignatureEw9Request} apiSignatureEw9Request
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistEW9AcceptanceDate: (apiSignatureEw9Request, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiSignatureEw9Request' is not null or undefined
            common_1.assertParamExists('persistEW9AcceptanceDate', 'apiSignatureEw9Request', apiSignatureEw9Request);
            const localVarPath = `/aof/party/updateEw9`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiSignatureEw9Request, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Resend an OTP for the identifier given. This function will reuse the party created during validate. This call will invalidate any other OTPs that have been sent for this particular identifier. If the client passes the encryptedIdentifier from POST /party/available the system will NOT send the otp and the system will return the same encryptedIdentifier to the client without an error.
         * @summary Resend One Time Password (OTP)
         * @param {ApiResendValidateIdentifierRequest} apiResendValidateIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resend: (apiResendValidateIdentifierRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiResendValidateIdentifierRequest' is not null or undefined
            common_1.assertParamExists('resend', 'apiResendValidateIdentifierRequest', apiResendValidateIdentifierRequest);
            const localVarPath = `/aof/party/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiResendValidateIdentifierRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * First step in reset password process. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Start Reset Password
         * @param {ApiResetPasswordRequest} apiResetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: (apiResetPasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiResetPasswordRequest' is not null or undefined
            common_1.assertParamExists('resetPassword', 'apiResetPasswordRequest', apiResetPasswordRequest);
            const localVarPath = `/aof/party/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiResetPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Second and final step when resetting a password.
         * @summary Finalize Reset Password
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordFinalize: (apiFinalizeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiFinalizeRequest' is not null or undefined
            common_1.assertParamExists('resetPasswordFinalize', 'apiFinalizeRequest', apiFinalizeRequest);
            const localVarPath = `/aof/party/password/reset/finalize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiFinalizeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a list of entitlements that are needed to upgrade to the next leveland validate user input.
         * @summary Retrieve Next-RoleEntitlementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCurrentAndNextRoleData: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/party/next-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Full details of a Party with the given Party ID
         * @summary Party Details
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFullPartyDetails: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('retrieveFullPartyDetails', 'partyId', partyId);
            const localVarPath = `/aof/party/{partyId}/full-details`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a list of entitlements that are needed to upgrade to the next leveland validate user input.
         * @summary Retrieve Next-RoleEntitlementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveNextRoleData: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/party/next-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieve Party for Consumers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveParty: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/party`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieve Party for Admins
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveParty1: (partyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('retrieveParty1', 'partyId', partyId);
            const localVarPath = `/aof/party/{partyId}`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a list of static data to be used by the clients to help render user interfaces and validate user input.
         * @summary Retrieve Static Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStaticData: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/aof/static-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Bakkt ID / alias
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAlias: (apiUpdateAliasRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUpdateAliasRequest' is not null or undefined
            common_1.assertParamExists('setAlias', 'apiUpdateAliasRequest', apiUpdateAliasRequest);
            const localVarPath = `/aof/party/alias`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateAliasRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set the party\'s attribution
         * @param {ApiPartyAttributionData} apiPartyAttributionData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAttribution: (apiPartyAttributionData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartyAttributionData' is not null or undefined
            common_1.assertParamExists('setAttribution', 'apiPartyAttributionData', apiPartyAttributionData);
            const localVarPath = `/aof/party/attribution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartyAttributionData, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update Bakkt ID / alias
         * @param {string} partyId
         * @param {ApiUpdateElevatedAliasRequest} apiUpdateElevatedAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlias: (partyId, apiUpdateElevatedAliasRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partyId' is not null or undefined
            common_1.assertParamExists('updateAlias', 'partyId', partyId);
            // verify required parameter 'apiUpdateElevatedAliasRequest' is not null or undefined
            common_1.assertParamExists('updateAlias', 'apiUpdateElevatedAliasRequest', apiUpdateElevatedAliasRequest);
            const localVarPath = `/aof/party/{partyId}/alias`
                .replace(`{${"partyId"}}`, encodeURIComponent(String(partyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateElevatedAliasRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the Cardholder Agreement publishing date and sets the acceptance date on the party
         * @summary Update Cardholder Agreement Acceptance Time
         * @param {ApiCardholderAgreementAcceptanceRequest} apiCardholderAgreementAcceptanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardHolderAgreementAcceptanceTime: (apiCardholderAgreementAcceptanceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiCardholderAgreementAcceptanceRequest' is not null or undefined
            common_1.assertParamExists('updateCardHolderAgreementAcceptanceTime', 'apiCardholderAgreementAcceptanceRequest', apiCardholderAgreementAcceptanceRequest);
            const localVarPath = `/aof/party/policy-update/cardholder-agreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCardholderAgreementAcceptanceRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update the first and last name along with address on a given party.
         * @summary Update Name and Address
         * @param {ApiUpdateNameAndAddressRequest} apiUpdateNameAndAddressRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNameAndAddress: (apiUpdateNameAndAddressRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUpdateNameAndAddressRequest' is not null or undefined
            common_1.assertParamExists('updateNameAndAddress', 'apiUpdateNameAndAddressRequest', apiUpdateNameAndAddressRequest);
            const localVarPath = `/aof/party/name-and-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateNameAndAddressRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update the first and last name along with address on a given party with only an identifierToken
         * @summary Update Party details
         * @param {ApiPartyRegistrationRequest} apiPartyRegistrationRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartyNameAndAddress: (apiPartyRegistrationRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPartyRegistrationRequest' is not null or undefined
            common_1.assertParamExists('updatePartyNameAndAddress', 'apiPartyRegistrationRequest', apiPartyRegistrationRequest);
            const localVarPath = `/aof/party/name-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPartyRegistrationRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the privacy policy publishing date and sets the acceptance date on the party
         * @summary Update Privacy Policy Acceptance Time
         * @param {ApiPrivacyPolicyAcceptanceRequest} apiPrivacyPolicyAcceptanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrivacyPolicyAcceptanceTime: (apiPrivacyPolicyAcceptanceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPrivacyPolicyAcceptanceRequest' is not null or undefined
            common_1.assertParamExists('updatePrivacyPolicyAcceptanceTime', 'apiPrivacyPolicyAcceptanceRequest', apiPrivacyPolicyAcceptanceRequest);
            const localVarPath = `/aof/party/policy-update/privacy-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPrivacyPolicyAcceptanceRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the terms and conditions publishing date and sets the acceptance date on the party
         * @summary Update Terms and Conditions Acceptance Time
         * @param {ApiTermsAndConditionsAcceptanceRequest} apiTermsAndConditionsAcceptanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTermsAndConditionsAcceptanceTime: (apiTermsAndConditionsAcceptanceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiTermsAndConditionsAcceptanceRequest' is not null or undefined
            common_1.assertParamExists('updateTermsAndConditionsAcceptanceTime', 'apiTermsAndConditionsAcceptanceRequest', apiTermsAndConditionsAcceptanceRequest);
            const localVarPath = `/aof/party/policy-update/terms-and-conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiTermsAndConditionsAcceptanceRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Second step in consumer sign-up. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Send One Time Password (OTP)
         * @param {ApiValidateIdentifierRequest} apiValidateIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: (apiValidateIdentifierRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiValidateIdentifierRequest' is not null or undefined
            common_1.assertParamExists('validate', 'apiValidateIdentifierRequest', apiValidateIdentifierRequest);
            const localVarPath = `/aof/party/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiValidateIdentifierRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Validate the password of the logged in user
         * @summary Validate Password
         * @param {ApiValidatePasswordRequest} apiValidatePasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword: (apiValidatePasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiValidatePasswordRequest' is not null or undefined
            common_1.assertParamExists('validatePassword', 'apiValidatePasswordRequest', apiValidatePasswordRequest);
            const localVarPath = `/aof/party/password/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiValidatePasswordRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PartyApi - functional programming interface
 * @export
 */
exports.PartyApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PartyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add Identifier
         * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifier(apiAddIdentifierRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addIdentifier(apiAddIdentifierRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Designed for users without account created yet.
         * @summary Add Identifier to non-Account
         * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifier1(apiAddIdentifierRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addIdentifier1(apiAddIdentifierRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch a list of Parties that match all the given search criteria. All specified search criteria are combined.
         * @summary Party Search for Party Operations
         * @param {ApiPartySearchRequest} apiPartySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchParties(apiPartySearchRequest, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminSearchParties(apiPartySearchRequest, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Designed for users without account created yet.  It will store the chosen alias into newAlias.  Later in flow newAlias is stored into alias
         * @summary Add newAlias to customers Party
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aliasAvailable(apiUpdateAliasRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aliasAvailable(apiUpdateAliasRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * First step in consumer sign-up. Verifies that the identifier in request is available for use
         * @summary Check Party identifier availability
         * @param {ApiAvailabilityRequest} apiAvailabilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        available(apiAvailabilityRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.available(apiAvailabilityRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Check Bakkt ID / alias availabilitity
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableAlias(apiUpdateAliasRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.availableAlias(apiUpdateAliasRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Change the password of the logged in user
         * @summary Change Password
         * @param {ApiChangePasswordRequest} apiChangePasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(apiChangePasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changePassword(apiChangePasswordRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch a list of Parties that match all the given search criteria. All specified search criteria are combined.
         * @summary Party Search for Consumers
         * @param {ApiPartySearchRequest} apiPartySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumerSearchParties(apiPartySearchRequest, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.consumerSearchParties(apiPartySearchRequest, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fourth and final step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalize(apiFinalizeRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.finalize(apiFinalizeRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Last step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP.  This is needed because the OTP resets need be secure.)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeParty(apiFinalizeRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.finalizeParty(apiFinalizeRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retrieve Funding Preference by type
         * @param {'BUY_GIFTCARD' | 'BUY_CRYPTO' | 'BAKKT_CARD'} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInAppPaymentFundingSource(type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInAppPaymentFundingSource(type, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.logout(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Third step in consumer sign-up. This call is the validation step proving (theoretical) ownership of the identifier
         * @summary Validate One Time Password (OTP)
         * @param {ApiValidateOTPRequest} apiValidateOTPRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otp(apiValidateOTPRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.otp(apiValidateOTPRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Suspend and possibly liquidate a party
         * @summary Suspend party
         * @param {ApiPartyLiquidateRequest} apiPartyLiquidateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyLiquidate(apiPartyLiquidateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.partyLiquidate(apiPartyLiquidateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Persist EW9 Acceptance Time and Signature in Party
         * @summary Persist EW9 Acceptance Time and Signature
         * @param {ApiSignatureEw9Request} apiSignatureEw9Request
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistEW9AcceptanceDate(apiSignatureEw9Request, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.persistEW9AcceptanceDate(apiSignatureEw9Request, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Resend an OTP for the identifier given. This function will reuse the party created during validate. This call will invalidate any other OTPs that have been sent for this particular identifier. If the client passes the encryptedIdentifier from POST /party/available the system will NOT send the otp and the system will return the same encryptedIdentifier to the client without an error.
         * @summary Resend One Time Password (OTP)
         * @param {ApiResendValidateIdentifierRequest} apiResendValidateIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resend(apiResendValidateIdentifierRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resend(apiResendValidateIdentifierRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * First step in reset password process. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Start Reset Password
         * @param {ApiResetPasswordRequest} apiResetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(apiResetPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPassword(apiResetPasswordRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Second and final step when resetting a password.
         * @summary Finalize Reset Password
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordFinalize(apiFinalizeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPasswordFinalize(apiFinalizeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns a list of entitlements that are needed to upgrade to the next leveland validate user input.
         * @summary Retrieve Next-RoleEntitlementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCurrentAndNextRoleData(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveCurrentAndNextRoleData(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Full details of a Party with the given Party ID
         * @summary Party Details
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFullPartyDetails(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveFullPartyDetails(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns a list of entitlements that are needed to upgrade to the next leveland validate user input.
         * @summary Retrieve Next-RoleEntitlementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveNextRoleData(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveNextRoleData(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retrieve Party for Consumers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveParty(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveParty(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retrieve Party for Admins
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveParty1(partyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveParty1(partyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns a list of static data to be used by the clients to help render user interfaces and validate user input.
         * @summary Retrieve Static Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStaticData(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveStaticData(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Bakkt ID / alias
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAlias(apiUpdateAliasRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setAlias(apiUpdateAliasRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Set the party\'s attribution
         * @param {ApiPartyAttributionData} apiPartyAttributionData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAttribution(apiPartyAttributionData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setAttribution(apiPartyAttributionData, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update Bakkt ID / alias
         * @param {string} partyId
         * @param {ApiUpdateElevatedAliasRequest} apiUpdateElevatedAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlias(partyId, apiUpdateElevatedAliasRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAlias(partyId, apiUpdateElevatedAliasRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates the Cardholder Agreement publishing date and sets the acceptance date on the party
         * @summary Update Cardholder Agreement Acceptance Time
         * @param {ApiCardholderAgreementAcceptanceRequest} apiCardholderAgreementAcceptanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardHolderAgreementAcceptanceTime(apiCardholderAgreementAcceptanceRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCardHolderAgreementAcceptanceTime(apiCardholderAgreementAcceptanceRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update the first and last name along with address on a given party.
         * @summary Update Name and Address
         * @param {ApiUpdateNameAndAddressRequest} apiUpdateNameAndAddressRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNameAndAddress(apiUpdateNameAndAddressRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateNameAndAddress(apiUpdateNameAndAddressRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update the first and last name along with address on a given party with only an identifierToken
         * @summary Update Party details
         * @param {ApiPartyRegistrationRequest} apiPartyRegistrationRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartyNameAndAddress(apiPartyRegistrationRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePartyNameAndAddress(apiPartyRegistrationRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates the privacy policy publishing date and sets the acceptance date on the party
         * @summary Update Privacy Policy Acceptance Time
         * @param {ApiPrivacyPolicyAcceptanceRequest} apiPrivacyPolicyAcceptanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrivacyPolicyAcceptanceTime(apiPrivacyPolicyAcceptanceRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePrivacyPolicyAcceptanceTime(apiPrivacyPolicyAcceptanceRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates the terms and conditions publishing date and sets the acceptance date on the party
         * @summary Update Terms and Conditions Acceptance Time
         * @param {ApiTermsAndConditionsAcceptanceRequest} apiTermsAndConditionsAcceptanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTermsAndConditionsAcceptanceTime(apiTermsAndConditionsAcceptanceRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTermsAndConditionsAcceptanceTime(apiTermsAndConditionsAcceptanceRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Second step in consumer sign-up. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Send One Time Password (OTP)
         * @param {ApiValidateIdentifierRequest} apiValidateIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(apiValidateIdentifierRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validate(apiValidateIdentifierRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Validate the password of the logged in user
         * @summary Validate Password
         * @param {ApiValidatePasswordRequest} apiValidatePasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword(apiValidatePasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validatePassword(apiValidatePasswordRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PartyApi - factory interface
 * @export
 */
exports.PartyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PartyApiFp(configuration);
    return {
        /**
         *
         * @summary Add Identifier
         * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifier(apiAddIdentifierRequest, options) {
            return localVarFp.addIdentifier(apiAddIdentifierRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Designed for users without account created yet.
         * @summary Add Identifier to non-Account
         * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addIdentifier1(apiAddIdentifierRequest, options) {
            return localVarFp.addIdentifier1(apiAddIdentifierRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a list of Parties that match all the given search criteria. All specified search criteria are combined.
         * @summary Party Search for Party Operations
         * @param {ApiPartySearchRequest} apiPartySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchParties(apiPartySearchRequest, page, size, sort, options) {
            return localVarFp.adminSearchParties(apiPartySearchRequest, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Designed for users without account created yet.  It will store the chosen alias into newAlias.  Later in flow newAlias is stored into alias
         * @summary Add newAlias to customers Party
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aliasAvailable(apiUpdateAliasRequest, options) {
            return localVarFp.aliasAvailable(apiUpdateAliasRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * First step in consumer sign-up. Verifies that the identifier in request is available for use
         * @summary Check Party identifier availability
         * @param {ApiAvailabilityRequest} apiAvailabilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        available(apiAvailabilityRequest, options) {
            return localVarFp.available(apiAvailabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Check Bakkt ID / alias availabilitity
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableAlias(apiUpdateAliasRequest, options) {
            return localVarFp.availableAlias(apiUpdateAliasRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Change the password of the logged in user
         * @summary Change Password
         * @param {ApiChangePasswordRequest} apiChangePasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(apiChangePasswordRequest, options) {
            return localVarFp.changePassword(apiChangePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a list of Parties that match all the given search criteria. All specified search criteria are combined.
         * @summary Party Search for Consumers
         * @param {ApiPartySearchRequest} apiPartySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumerSearchParties(apiPartySearchRequest, page, size, sort, options) {
            return localVarFp.consumerSearchParties(apiPartySearchRequest, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Fourth and final step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalize(apiFinalizeRequest, xTrackingId, options) {
            return localVarFp.finalize(apiFinalizeRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Last step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP.  This is needed because the OTP resets need be secure.)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeParty(apiFinalizeRequest, xTrackingId, options) {
            return localVarFp.finalizeParty(apiFinalizeRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve Funding Preference by type
         * @param {'BUY_GIFTCARD' | 'BUY_CRYPTO' | 'BAKKT_CARD'} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInAppPaymentFundingSource(type, options) {
            return localVarFp.getInAppPaymentFundingSource(type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * Third step in consumer sign-up. This call is the validation step proving (theoretical) ownership of the identifier
         * @summary Validate One Time Password (OTP)
         * @param {ApiValidateOTPRequest} apiValidateOTPRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otp(apiValidateOTPRequest, xTrackingId, options) {
            return localVarFp.otp(apiValidateOTPRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Suspend and possibly liquidate a party
         * @summary Suspend party
         * @param {ApiPartyLiquidateRequest} apiPartyLiquidateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyLiquidate(apiPartyLiquidateRequest, options) {
            return localVarFp.partyLiquidate(apiPartyLiquidateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Persist EW9 Acceptance Time and Signature in Party
         * @summary Persist EW9 Acceptance Time and Signature
         * @param {ApiSignatureEw9Request} apiSignatureEw9Request
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        persistEW9AcceptanceDate(apiSignatureEw9Request, xTrackingId, options) {
            return localVarFp.persistEW9AcceptanceDate(apiSignatureEw9Request, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend an OTP for the identifier given. This function will reuse the party created during validate. This call will invalidate any other OTPs that have been sent for this particular identifier. If the client passes the encryptedIdentifier from POST /party/available the system will NOT send the otp and the system will return the same encryptedIdentifier to the client without an error.
         * @summary Resend One Time Password (OTP)
         * @param {ApiResendValidateIdentifierRequest} apiResendValidateIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resend(apiResendValidateIdentifierRequest, options) {
            return localVarFp.resend(apiResendValidateIdentifierRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * First step in reset password process. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Start Reset Password
         * @param {ApiResetPasswordRequest} apiResetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(apiResetPasswordRequest, options) {
            return localVarFp.resetPassword(apiResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Second and final step when resetting a password.
         * @summary Finalize Reset Password
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordFinalize(apiFinalizeRequest, options) {
            return localVarFp.resetPasswordFinalize(apiFinalizeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of entitlements that are needed to upgrade to the next leveland validate user input.
         * @summary Retrieve Next-RoleEntitlementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveCurrentAndNextRoleData(options) {
            return localVarFp.retrieveCurrentAndNextRoleData(options).then((request) => request(axios, basePath));
        },
        /**
         * Full details of a Party with the given Party ID
         * @summary Party Details
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveFullPartyDetails(partyId, options) {
            return localVarFp.retrieveFullPartyDetails(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of entitlements that are needed to upgrade to the next leveland validate user input.
         * @summary Retrieve Next-RoleEntitlementData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveNextRoleData(options) {
            return localVarFp.retrieveNextRoleData(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve Party for Consumers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveParty(options) {
            return localVarFp.retrieveParty(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve Party for Admins
         * @param {string} partyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveParty1(partyId, options) {
            return localVarFp.retrieveParty1(partyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of static data to be used by the clients to help render user interfaces and validate user input.
         * @summary Retrieve Static Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveStaticData(options) {
            return localVarFp.retrieveStaticData(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Bakkt ID / alias
         * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAlias(apiUpdateAliasRequest, options) {
            return localVarFp.setAlias(apiUpdateAliasRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set the party\'s attribution
         * @param {ApiPartyAttributionData} apiPartyAttributionData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAttribution(apiPartyAttributionData, options) {
            return localVarFp.setAttribution(apiPartyAttributionData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update Bakkt ID / alias
         * @param {string} partyId
         * @param {ApiUpdateElevatedAliasRequest} apiUpdateElevatedAliasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlias(partyId, apiUpdateElevatedAliasRequest, options) {
            return localVarFp.updateAlias(partyId, apiUpdateElevatedAliasRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the Cardholder Agreement publishing date and sets the acceptance date on the party
         * @summary Update Cardholder Agreement Acceptance Time
         * @param {ApiCardholderAgreementAcceptanceRequest} apiCardholderAgreementAcceptanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardHolderAgreementAcceptanceTime(apiCardholderAgreementAcceptanceRequest, options) {
            return localVarFp.updateCardHolderAgreementAcceptanceTime(apiCardholderAgreementAcceptanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the first and last name along with address on a given party.
         * @summary Update Name and Address
         * @param {ApiUpdateNameAndAddressRequest} apiUpdateNameAndAddressRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNameAndAddress(apiUpdateNameAndAddressRequest, xTrackingId, options) {
            return localVarFp.updateNameAndAddress(apiUpdateNameAndAddressRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the first and last name along with address on a given party with only an identifierToken
         * @summary Update Party details
         * @param {ApiPartyRegistrationRequest} apiPartyRegistrationRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartyNameAndAddress(apiPartyRegistrationRequest, xTrackingId, options) {
            return localVarFp.updatePartyNameAndAddress(apiPartyRegistrationRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the privacy policy publishing date and sets the acceptance date on the party
         * @summary Update Privacy Policy Acceptance Time
         * @param {ApiPrivacyPolicyAcceptanceRequest} apiPrivacyPolicyAcceptanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrivacyPolicyAcceptanceTime(apiPrivacyPolicyAcceptanceRequest, options) {
            return localVarFp.updatePrivacyPolicyAcceptanceTime(apiPrivacyPolicyAcceptanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the terms and conditions publishing date and sets the acceptance date on the party
         * @summary Update Terms and Conditions Acceptance Time
         * @param {ApiTermsAndConditionsAcceptanceRequest} apiTermsAndConditionsAcceptanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTermsAndConditionsAcceptanceTime(apiTermsAndConditionsAcceptanceRequest, options) {
            return localVarFp.updateTermsAndConditionsAcceptanceTime(apiTermsAndConditionsAcceptanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Second step in consumer sign-up. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Send One Time Password (OTP)
         * @param {ApiValidateIdentifierRequest} apiValidateIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(apiValidateIdentifierRequest, options) {
            return localVarFp.validate(apiValidateIdentifierRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate the password of the logged in user
         * @summary Validate Password
         * @param {ApiValidatePasswordRequest} apiValidatePasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePassword(apiValidatePasswordRequest, options) {
            return localVarFp.validatePassword(apiValidatePasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartyApi - object-oriented interface
 * @export
 * @class PartyApi
 * @extends {BaseAPI}
 */
class PartyApi extends base_1.BaseAPI {
    /**
     *
     * @summary Add Identifier
     * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    addIdentifier(apiAddIdentifierRequest, options) {
        return exports.PartyApiFp(this.configuration).addIdentifier(apiAddIdentifierRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Designed for users without account created yet.
     * @summary Add Identifier to non-Account
     * @param {ApiAddIdentifierRequest} apiAddIdentifierRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    addIdentifier1(apiAddIdentifierRequest, options) {
        return exports.PartyApiFp(this.configuration).addIdentifier1(apiAddIdentifierRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch a list of Parties that match all the given search criteria. All specified search criteria are combined.
     * @summary Party Search for Party Operations
     * @param {ApiPartySearchRequest} apiPartySearchRequest
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    adminSearchParties(apiPartySearchRequest, page, size, sort, options) {
        return exports.PartyApiFp(this.configuration).adminSearchParties(apiPartySearchRequest, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Designed for users without account created yet.  It will store the chosen alias into newAlias.  Later in flow newAlias is stored into alias
     * @summary Add newAlias to customers Party
     * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    aliasAvailable(apiUpdateAliasRequest, options) {
        return exports.PartyApiFp(this.configuration).aliasAvailable(apiUpdateAliasRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * First step in consumer sign-up. Verifies that the identifier in request is available for use
     * @summary Check Party identifier availability
     * @param {ApiAvailabilityRequest} apiAvailabilityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    available(apiAvailabilityRequest, options) {
        return exports.PartyApiFp(this.configuration).available(apiAvailabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Check Bakkt ID / alias availabilitity
     * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    availableAlias(apiUpdateAliasRequest, options) {
        return exports.PartyApiFp(this.configuration).availableAlias(apiUpdateAliasRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Change the password of the logged in user
     * @summary Change Password
     * @param {ApiChangePasswordRequest} apiChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    changePassword(apiChangePasswordRequest, options) {
        return exports.PartyApiFp(this.configuration).changePassword(apiChangePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch a list of Parties that match all the given search criteria. All specified search criteria are combined.
     * @summary Party Search for Consumers
     * @param {ApiPartySearchRequest} apiPartySearchRequest
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    consumerSearchParties(apiPartySearchRequest, page, size, sort, options) {
        return exports.PartyApiFp(this.configuration).consumerSearchParties(apiPartySearchRequest, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fourth and final step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP)
     * @summary Finalize Party Sign Up
     * @param {ApiFinalizeRequest} apiFinalizeRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    finalize(apiFinalizeRequest, xTrackingId, options) {
        return exports.PartyApiFp(this.configuration).finalize(apiFinalizeRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Last step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP.  This is needed because the OTP resets need be secure.)
     * @summary Finalize Party Sign Up
     * @param {ApiFinalizeRequest} apiFinalizeRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    finalizeParty(apiFinalizeRequest, xTrackingId, options) {
        return exports.PartyApiFp(this.configuration).finalizeParty(apiFinalizeRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve Funding Preference by type
     * @param {'BUY_GIFTCARD' | 'BUY_CRYPTO' | 'BAKKT_CARD'} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    getInAppPaymentFundingSource(type, options) {
        return exports.PartyApiFp(this.configuration).getInAppPaymentFundingSource(type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    logout(options) {
        return exports.PartyApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Third step in consumer sign-up. This call is the validation step proving (theoretical) ownership of the identifier
     * @summary Validate One Time Password (OTP)
     * @param {ApiValidateOTPRequest} apiValidateOTPRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    otp(apiValidateOTPRequest, xTrackingId, options) {
        return exports.PartyApiFp(this.configuration).otp(apiValidateOTPRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Suspend and possibly liquidate a party
     * @summary Suspend party
     * @param {ApiPartyLiquidateRequest} apiPartyLiquidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    partyLiquidate(apiPartyLiquidateRequest, options) {
        return exports.PartyApiFp(this.configuration).partyLiquidate(apiPartyLiquidateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Persist EW9 Acceptance Time and Signature in Party
     * @summary Persist EW9 Acceptance Time and Signature
     * @param {ApiSignatureEw9Request} apiSignatureEw9Request
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    persistEW9AcceptanceDate(apiSignatureEw9Request, xTrackingId, options) {
        return exports.PartyApiFp(this.configuration).persistEW9AcceptanceDate(apiSignatureEw9Request, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Resend an OTP for the identifier given. This function will reuse the party created during validate. This call will invalidate any other OTPs that have been sent for this particular identifier. If the client passes the encryptedIdentifier from POST /party/available the system will NOT send the otp and the system will return the same encryptedIdentifier to the client without an error.
     * @summary Resend One Time Password (OTP)
     * @param {ApiResendValidateIdentifierRequest} apiResendValidateIdentifierRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    resend(apiResendValidateIdentifierRequest, options) {
        return exports.PartyApiFp(this.configuration).resend(apiResendValidateIdentifierRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * First step in reset password process. This call results in an OTP sent to the identifier in the request (mobile phone or email)
     * @summary Start Reset Password
     * @param {ApiResetPasswordRequest} apiResetPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    resetPassword(apiResetPasswordRequest, options) {
        return exports.PartyApiFp(this.configuration).resetPassword(apiResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Second and final step when resetting a password.
     * @summary Finalize Reset Password
     * @param {ApiFinalizeRequest} apiFinalizeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    resetPasswordFinalize(apiFinalizeRequest, options) {
        return exports.PartyApiFp(this.configuration).resetPasswordFinalize(apiFinalizeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of entitlements that are needed to upgrade to the next leveland validate user input.
     * @summary Retrieve Next-RoleEntitlementData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    retrieveCurrentAndNextRoleData(options) {
        return exports.PartyApiFp(this.configuration).retrieveCurrentAndNextRoleData(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Full details of a Party with the given Party ID
     * @summary Party Details
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    retrieveFullPartyDetails(partyId, options) {
        return exports.PartyApiFp(this.configuration).retrieveFullPartyDetails(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of entitlements that are needed to upgrade to the next leveland validate user input.
     * @summary Retrieve Next-RoleEntitlementData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    retrieveNextRoleData(options) {
        return exports.PartyApiFp(this.configuration).retrieveNextRoleData(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve Party for Consumers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    retrieveParty(options) {
        return exports.PartyApiFp(this.configuration).retrieveParty(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve Party for Admins
     * @param {string} partyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    retrieveParty1(partyId, options) {
        return exports.PartyApiFp(this.configuration).retrieveParty1(partyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a list of static data to be used by the clients to help render user interfaces and validate user input.
     * @summary Retrieve Static Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    retrieveStaticData(options) {
        return exports.PartyApiFp(this.configuration).retrieveStaticData(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Bakkt ID / alias
     * @param {ApiUpdateAliasRequest} apiUpdateAliasRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    setAlias(apiUpdateAliasRequest, options) {
        return exports.PartyApiFp(this.configuration).setAlias(apiUpdateAliasRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set the party\'s attribution
     * @param {ApiPartyAttributionData} apiPartyAttributionData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    setAttribution(apiPartyAttributionData, options) {
        return exports.PartyApiFp(this.configuration).setAttribution(apiPartyAttributionData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update Bakkt ID / alias
     * @param {string} partyId
     * @param {ApiUpdateElevatedAliasRequest} apiUpdateElevatedAliasRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    updateAlias(partyId, apiUpdateElevatedAliasRequest, options) {
        return exports.PartyApiFp(this.configuration).updateAlias(partyId, apiUpdateElevatedAliasRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the Cardholder Agreement publishing date and sets the acceptance date on the party
     * @summary Update Cardholder Agreement Acceptance Time
     * @param {ApiCardholderAgreementAcceptanceRequest} apiCardholderAgreementAcceptanceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    updateCardHolderAgreementAcceptanceTime(apiCardholderAgreementAcceptanceRequest, options) {
        return exports.PartyApiFp(this.configuration).updateCardHolderAgreementAcceptanceTime(apiCardholderAgreementAcceptanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update the first and last name along with address on a given party.
     * @summary Update Name and Address
     * @param {ApiUpdateNameAndAddressRequest} apiUpdateNameAndAddressRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    updateNameAndAddress(apiUpdateNameAndAddressRequest, xTrackingId, options) {
        return exports.PartyApiFp(this.configuration).updateNameAndAddress(apiUpdateNameAndAddressRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update the first and last name along with address on a given party with only an identifierToken
     * @summary Update Party details
     * @param {ApiPartyRegistrationRequest} apiPartyRegistrationRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    updatePartyNameAndAddress(apiPartyRegistrationRequest, xTrackingId, options) {
        return exports.PartyApiFp(this.configuration).updatePartyNameAndAddress(apiPartyRegistrationRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the privacy policy publishing date and sets the acceptance date on the party
     * @summary Update Privacy Policy Acceptance Time
     * @param {ApiPrivacyPolicyAcceptanceRequest} apiPrivacyPolicyAcceptanceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    updatePrivacyPolicyAcceptanceTime(apiPrivacyPolicyAcceptanceRequest, options) {
        return exports.PartyApiFp(this.configuration).updatePrivacyPolicyAcceptanceTime(apiPrivacyPolicyAcceptanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the terms and conditions publishing date and sets the acceptance date on the party
     * @summary Update Terms and Conditions Acceptance Time
     * @param {ApiTermsAndConditionsAcceptanceRequest} apiTermsAndConditionsAcceptanceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    updateTermsAndConditionsAcceptanceTime(apiTermsAndConditionsAcceptanceRequest, options) {
        return exports.PartyApiFp(this.configuration).updateTermsAndConditionsAcceptanceTime(apiTermsAndConditionsAcceptanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Second step in consumer sign-up. This call results in an OTP sent to the identifier in the request (mobile phone or email)
     * @summary Send One Time Password (OTP)
     * @param {ApiValidateIdentifierRequest} apiValidateIdentifierRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    validate(apiValidateIdentifierRequest, options) {
        return exports.PartyApiFp(this.configuration).validate(apiValidateIdentifierRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Validate the password of the logged in user
     * @summary Validate Password
     * @param {ApiValidatePasswordRequest} apiValidatePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    validatePassword(apiValidatePasswordRequest, options) {
        return exports.PartyApiFp(this.configuration).validatePassword(apiValidatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PartyApi = PartyApi;
/**
 * PartyResetPasswordApi - axios parameter creator
 * @export
 */
exports.PartyResetPasswordApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * First step in reset password process. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Start Reset Password
         * @param {ApiResetPasswordRequest} apiResetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: (apiResetPasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiResetPasswordRequest' is not null or undefined
            common_1.assertParamExists('resetPassword', 'apiResetPasswordRequest', apiResetPasswordRequest);
            const localVarPath = `/aof/party/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiResetPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Second and final step when resetting a password.
         * @summary Finalize Reset Password
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordFinalize: (apiFinalizeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiFinalizeRequest' is not null or undefined
            common_1.assertParamExists('resetPasswordFinalize', 'apiFinalizeRequest', apiFinalizeRequest);
            const localVarPath = `/aof/party/password/reset/finalize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiFinalizeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PartyResetPasswordApi - functional programming interface
 * @export
 */
exports.PartyResetPasswordApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PartyResetPasswordApiAxiosParamCreator(configuration);
    return {
        /**
         * First step in reset password process. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Start Reset Password
         * @param {ApiResetPasswordRequest} apiResetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(apiResetPasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPassword(apiResetPasswordRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Second and final step when resetting a password.
         * @summary Finalize Reset Password
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordFinalize(apiFinalizeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPasswordFinalize(apiFinalizeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PartyResetPasswordApi - factory interface
 * @export
 */
exports.PartyResetPasswordApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PartyResetPasswordApiFp(configuration);
    return {
        /**
         * First step in reset password process. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Start Reset Password
         * @param {ApiResetPasswordRequest} apiResetPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(apiResetPasswordRequest, options) {
            return localVarFp.resetPassword(apiResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Second and final step when resetting a password.
         * @summary Finalize Reset Password
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordFinalize(apiFinalizeRequest, options) {
            return localVarFp.resetPasswordFinalize(apiFinalizeRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartyResetPasswordApi - object-oriented interface
 * @export
 * @class PartyResetPasswordApi
 * @extends {BaseAPI}
 */
class PartyResetPasswordApi extends base_1.BaseAPI {
    /**
     * First step in reset password process. This call results in an OTP sent to the identifier in the request (mobile phone or email)
     * @summary Start Reset Password
     * @param {ApiResetPasswordRequest} apiResetPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyResetPasswordApi
     */
    resetPassword(apiResetPasswordRequest, options) {
        return exports.PartyResetPasswordApiFp(this.configuration).resetPassword(apiResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Second and final step when resetting a password.
     * @summary Finalize Reset Password
     * @param {ApiFinalizeRequest} apiFinalizeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyResetPasswordApi
     */
    resetPasswordFinalize(apiFinalizeRequest, options) {
        return exports.PartyResetPasswordApiFp(this.configuration).resetPasswordFinalize(apiFinalizeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PartyResetPasswordApi = PartyResetPasswordApi;
/**
 * PartySignUpApi - axios parameter creator
 * @export
 */
exports.PartySignUpApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * First step in consumer sign-up. Verifies that the identifier in request is available for use
         * @summary Check Party identifier availability
         * @param {ApiAvailabilityRequest} apiAvailabilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        available: (apiAvailabilityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiAvailabilityRequest' is not null or undefined
            common_1.assertParamExists('available', 'apiAvailabilityRequest', apiAvailabilityRequest);
            const localVarPath = `/aof/party/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiAvailabilityRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fourth and final step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalize: (apiFinalizeRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiFinalizeRequest' is not null or undefined
            common_1.assertParamExists('finalize', 'apiFinalizeRequest', apiFinalizeRequest);
            const localVarPath = `/aof/party/finalize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiFinalizeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Third step in consumer sign-up. This call is the validation step proving (theoretical) ownership of the identifier
         * @summary Validate One Time Password (OTP)
         * @param {ApiValidateOTPRequest} apiValidateOTPRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otp: (apiValidateOTPRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiValidateOTPRequest' is not null or undefined
            common_1.assertParamExists('otp', 'apiValidateOTPRequest', apiValidateOTPRequest);
            const localVarPath = `/aof/party/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiValidateOTPRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Second step in consumer sign-up. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Send One Time Password (OTP)
         * @param {ApiValidateIdentifierRequest} apiValidateIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: (apiValidateIdentifierRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiValidateIdentifierRequest' is not null or undefined
            common_1.assertParamExists('validate', 'apiValidateIdentifierRequest', apiValidateIdentifierRequest);
            const localVarPath = `/aof/party/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiValidateIdentifierRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PartySignUpApi - functional programming interface
 * @export
 */
exports.PartySignUpApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PartySignUpApiAxiosParamCreator(configuration);
    return {
        /**
         * First step in consumer sign-up. Verifies that the identifier in request is available for use
         * @summary Check Party identifier availability
         * @param {ApiAvailabilityRequest} apiAvailabilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        available(apiAvailabilityRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.available(apiAvailabilityRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fourth and final step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalize(apiFinalizeRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.finalize(apiFinalizeRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Third step in consumer sign-up. This call is the validation step proving (theoretical) ownership of the identifier
         * @summary Validate One Time Password (OTP)
         * @param {ApiValidateOTPRequest} apiValidateOTPRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otp(apiValidateOTPRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.otp(apiValidateOTPRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Second step in consumer sign-up. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Send One Time Password (OTP)
         * @param {ApiValidateIdentifierRequest} apiValidateIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(apiValidateIdentifierRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validate(apiValidateIdentifierRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PartySignUpApi - factory interface
 * @export
 */
exports.PartySignUpApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PartySignUpApiFp(configuration);
    return {
        /**
         * First step in consumer sign-up. Verifies that the identifier in request is available for use
         * @summary Check Party identifier availability
         * @param {ApiAvailabilityRequest} apiAvailabilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        available(apiAvailabilityRequest, options) {
            return localVarFp.available(apiAvailabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fourth and final step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP)
         * @summary Finalize Party Sign Up
         * @param {ApiFinalizeRequest} apiFinalizeRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalize(apiFinalizeRequest, xTrackingId, options) {
            return localVarFp.finalize(apiFinalizeRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Third step in consumer sign-up. This call is the validation step proving (theoretical) ownership of the identifier
         * @summary Validate One Time Password (OTP)
         * @param {ApiValidateOTPRequest} apiValidateOTPRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        otp(apiValidateOTPRequest, xTrackingId, options) {
            return localVarFp.otp(apiValidateOTPRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Second step in consumer sign-up. This call results in an OTP sent to the identifier in the request (mobile phone or email)
         * @summary Send One Time Password (OTP)
         * @param {ApiValidateIdentifierRequest} apiValidateIdentifierRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(apiValidateIdentifierRequest, options) {
            return localVarFp.validate(apiValidateIdentifierRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartySignUpApi - object-oriented interface
 * @export
 * @class PartySignUpApi
 * @extends {BaseAPI}
 */
class PartySignUpApi extends base_1.BaseAPI {
    /**
     * First step in consumer sign-up. Verifies that the identifier in request is available for use
     * @summary Check Party identifier availability
     * @param {ApiAvailabilityRequest} apiAvailabilityRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartySignUpApi
     */
    available(apiAvailabilityRequest, options) {
        return exports.PartySignUpApiFp(this.configuration).available(apiAvailabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fourth and final step in consumer sign-up. This step completes the creation of the party by linking the AoF party to the user created in the IDP (currently FusionAuth) Linkage is via subjectRef (sub of the jwt or objectId in IDP)
     * @summary Finalize Party Sign Up
     * @param {ApiFinalizeRequest} apiFinalizeRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartySignUpApi
     */
    finalize(apiFinalizeRequest, xTrackingId, options) {
        return exports.PartySignUpApiFp(this.configuration).finalize(apiFinalizeRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Third step in consumer sign-up. This call is the validation step proving (theoretical) ownership of the identifier
     * @summary Validate One Time Password (OTP)
     * @param {ApiValidateOTPRequest} apiValidateOTPRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartySignUpApi
     */
    otp(apiValidateOTPRequest, xTrackingId, options) {
        return exports.PartySignUpApiFp(this.configuration).otp(apiValidateOTPRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Second step in consumer sign-up. This call results in an OTP sent to the identifier in the request (mobile phone or email)
     * @summary Send One Time Password (OTP)
     * @param {ApiValidateIdentifierRequest} apiValidateIdentifierRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartySignUpApi
     */
    validate(apiValidateIdentifierRequest, options) {
        return exports.PartySignUpApiFp(this.configuration).validate(apiValidateIdentifierRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PartySignUpApi = PartySignUpApi;
/**
 * PhotoIdVerificationApi - axios parameter creator
 * @export
 */
exports.PhotoIdVerificationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiPhotoIdVerificationRequest} apiPhotoIdVerificationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhotoId: (apiPhotoIdVerificationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiPhotoIdVerificationRequest' is not null or undefined
            common_1.assertParamExists('verifyPhotoId', 'apiPhotoIdVerificationRequest', apiPhotoIdVerificationRequest);
            const localVarPath = `/aof/photo-id/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiPhotoIdVerificationRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PhotoIdVerificationApi - functional programming interface
 * @export
 */
exports.PhotoIdVerificationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PhotoIdVerificationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ApiPhotoIdVerificationRequest} apiPhotoIdVerificationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhotoId(apiPhotoIdVerificationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyPhotoId(apiPhotoIdVerificationRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PhotoIdVerificationApi - factory interface
 * @export
 */
exports.PhotoIdVerificationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PhotoIdVerificationApiFp(configuration);
    return {
        /**
         *
         * @param {ApiPhotoIdVerificationRequest} apiPhotoIdVerificationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhotoId(apiPhotoIdVerificationRequest, options) {
            return localVarFp.verifyPhotoId(apiPhotoIdVerificationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PhotoIdVerificationApi - object-oriented interface
 * @export
 * @class PhotoIdVerificationApi
 * @extends {BaseAPI}
 */
class PhotoIdVerificationApi extends base_1.BaseAPI {
    /**
     *
     * @param {ApiPhotoIdVerificationRequest} apiPhotoIdVerificationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotoIdVerificationApi
     */
    verifyPhotoId(apiPhotoIdVerificationRequest, options) {
        return exports.PhotoIdVerificationApiFp(this.configuration).verifyPhotoId(apiPhotoIdVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PhotoIdVerificationApi = PhotoIdVerificationApi;
/**
 * SettlementApi - axios parameter creator
 * @export
 */
exports.SettlementApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} date
         * @param {'WITHDRAWAL' | 'DEPOSIT'} achType
         * @param {Pageable} pageable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConsumerSettlementTransactions: (date, achType, pageable, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'date' is not null or undefined
            common_1.assertParamExists('listConsumerSettlementTransactions', 'date', date);
            // verify required parameter 'achType' is not null or undefined
            common_1.assertParamExists('listConsumerSettlementTransactions', 'achType', achType);
            // verify required parameter 'pageable' is not null or undefined
            common_1.assertParamExists('listConsumerSettlementTransactions', 'pageable', pageable);
            const localVarPath = `/aof/settlement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString().substr(0, 10) :
                    date;
            }
            if (achType !== undefined) {
                localVarQueryParameter['achType'] = achType;
            }
            if (pageable !== undefined) {
                localVarQueryParameter['pageable'] = pageable;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SettlementApi - functional programming interface
 * @export
 */
exports.SettlementApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SettlementApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} date
         * @param {'WITHDRAWAL' | 'DEPOSIT'} achType
         * @param {Pageable} pageable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConsumerSettlementTransactions(date, achType, pageable, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listConsumerSettlementTransactions(date, achType, pageable, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SettlementApi - factory interface
 * @export
 */
exports.SettlementApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SettlementApiFp(configuration);
    return {
        /**
         *
         * @param {string} date
         * @param {'WITHDRAWAL' | 'DEPOSIT'} achType
         * @param {Pageable} pageable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConsumerSettlementTransactions(date, achType, pageable, options) {
            return localVarFp.listConsumerSettlementTransactions(date, achType, pageable, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SettlementApi - object-oriented interface
 * @export
 * @class SettlementApi
 * @extends {BaseAPI}
 */
class SettlementApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} date
     * @param {'WITHDRAWAL' | 'DEPOSIT'} achType
     * @param {Pageable} pageable
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementApi
     */
    listConsumerSettlementTransactions(date, achType, pageable, options) {
        return exports.SettlementApiFp(this.configuration).listConsumerSettlementTransactions(date, achType, pageable, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SettlementApi = SettlementApi;
/**
 * TaxIdVerificationApi - axios parameter creator
 * @export
 */
exports.TaxIdVerificationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} serviceProviderName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkServiceAvailability: (serviceProviderName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'serviceProviderName' is not null or undefined
            common_1.assertParamExists('checkServiceAvailability', 'serviceProviderName', serviceProviderName);
            const localVarPath = `/aof/tax-id/check-service-availability`
                .replace(`{${"serviceProviderName"}}`, encodeURIComponent(String(serviceProviderName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} serviceProviderName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkServiceAvailability1: (serviceProviderName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'serviceProviderName' is not null or undefined
            common_1.assertParamExists('checkServiceAvailability1', 'serviceProviderName', serviceProviderName);
            const localVarPath = `/aof/tax-id/check-service-availability/{serviceProviderName}`
                .replace(`{${"serviceProviderName"}}`, encodeURIComponent(String(serviceProviderName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiVerifyTaxIdRequest} apiVerifyTaxIdRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTaxId: (apiVerifyTaxIdRequest, xTrackingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiVerifyTaxIdRequest' is not null or undefined
            common_1.assertParamExists('verifyTaxId', 'apiVerifyTaxIdRequest', apiVerifyTaxIdRequest);
            const localVarPath = `/aof/tax-id/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xTrackingId !== undefined && xTrackingId !== null) {
                localVarHeaderParameter['x-tracking-id'] = String(JSON.stringify(xTrackingId));
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiVerifyTaxIdRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TaxIdVerificationApi - functional programming interface
 * @export
 */
exports.TaxIdVerificationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TaxIdVerificationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} serviceProviderName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkServiceAvailability(serviceProviderName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkServiceAvailability(serviceProviderName, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} serviceProviderName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkServiceAvailability1(serviceProviderName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkServiceAvailability1(serviceProviderName, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiVerifyTaxIdRequest} apiVerifyTaxIdRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTaxId(apiVerifyTaxIdRequest, xTrackingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyTaxId(apiVerifyTaxIdRequest, xTrackingId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TaxIdVerificationApi - factory interface
 * @export
 */
exports.TaxIdVerificationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TaxIdVerificationApiFp(configuration);
    return {
        /**
         *
         * @param {string} serviceProviderName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkServiceAvailability(serviceProviderName, options) {
            return localVarFp.checkServiceAvailability(serviceProviderName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} serviceProviderName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkServiceAvailability1(serviceProviderName, options) {
            return localVarFp.checkServiceAvailability1(serviceProviderName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiVerifyTaxIdRequest} apiVerifyTaxIdRequest
         * @param {string} [xTrackingId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTaxId(apiVerifyTaxIdRequest, xTrackingId, options) {
            return localVarFp.verifyTaxId(apiVerifyTaxIdRequest, xTrackingId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TaxIdVerificationApi - object-oriented interface
 * @export
 * @class TaxIdVerificationApi
 * @extends {BaseAPI}
 */
class TaxIdVerificationApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} serviceProviderName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxIdVerificationApi
     */
    checkServiceAvailability(serviceProviderName, options) {
        return exports.TaxIdVerificationApiFp(this.configuration).checkServiceAvailability(serviceProviderName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} serviceProviderName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxIdVerificationApi
     */
    checkServiceAvailability1(serviceProviderName, options) {
        return exports.TaxIdVerificationApiFp(this.configuration).checkServiceAvailability1(serviceProviderName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiVerifyTaxIdRequest} apiVerifyTaxIdRequest
     * @param {string} [xTrackingId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxIdVerificationApi
     */
    verifyTaxId(apiVerifyTaxIdRequest, xTrackingId, options) {
        return exports.TaxIdVerificationApiFp(this.configuration).verifyTaxId(apiVerifyTaxIdRequest, xTrackingId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TaxIdVerificationApi = TaxIdVerificationApi;
/**
 * TransactionControllerApi - axios parameter creator
 * @export
 */
exports.TransactionControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AssetActivitySearchRequest} assetActivitySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetActivities: (assetActivitySearchRequest, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assetActivitySearchRequest' is not null or undefined
            common_1.assertParamExists('getAssetActivities', 'assetActivitySearchRequest', assetActivitySearchRequest);
            const localVarPath = `/business-portal/transactions/asset/activity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(assetActivitySearchRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiTransactionDetailsRequest} apiTransactionDetailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTransaction: (apiTransactionDetailsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiTransactionDetailsRequest' is not null or undefined
            common_1.assertParamExists('getCustomerTransaction', 'apiTransactionDetailsRequest', apiTransactionDetailsRequest);
            const localVarPath = `/business-portal/transaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiTransactionDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AssetActivitySummarySearchRequest} assetActivitySummarySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAssetActivitySummaryList: (assetActivitySummarySearchRequest, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assetActivitySummarySearchRequest' is not null or undefined
            common_1.assertParamExists('searchAssetActivitySummaryList', 'assetActivitySummarySearchRequest', assetActivitySummarySearchRequest);
            const localVarPath = `/business-portal/asset-activity/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(assetActivitySummarySearchRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AssetActivitySummarySearchRequest} assetActivitySummarySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactionSummary: (assetActivitySummarySearchRequest, page, size, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assetActivitySummarySearchRequest' is not null or undefined
            common_1.assertParamExists('searchTransactionSummary', 'assetActivitySummarySearchRequest', assetActivitySummarySearchRequest);
            const localVarPath = `/business-portal/transaction/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(assetActivitySummarySearchRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactions: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('searchTransactions', 'searchParameters', searchParameters);
            const localVarPath = `/business-portal/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} debitCardTransactionId
         * @param {string} field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskDebitCardFields: (debitCardTransactionId, field, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'debitCardTransactionId' is not null or undefined
            common_1.assertParamExists('unmaskDebitCardFields', 'debitCardTransactionId', debitCardTransactionId);
            // verify required parameter 'field' is not null or undefined
            common_1.assertParamExists('unmaskDebitCardFields', 'field', field);
            const localVarPath = `/business-portal/transaction/{debitCardTransactionId}/debit-card/{field}/unmask`
                .replace(`{${"debitCardTransactionId"}}`, encodeURIComponent(String(debitCardTransactionId)))
                .replace(`{${"field"}}`, encodeURIComponent(String(field)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TransactionControllerApi - functional programming interface
 * @export
 */
exports.TransactionControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TransactionControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AssetActivitySearchRequest} assetActivitySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetActivities(assetActivitySearchRequest, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssetActivities(assetActivitySearchRequest, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiTransactionDetailsRequest} apiTransactionDetailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTransaction(apiTransactionDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomerTransaction(apiTransactionDetailsRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {AssetActivitySummarySearchRequest} assetActivitySummarySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAssetActivitySummaryList(assetActivitySummarySearchRequest, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAssetActivitySummaryList(assetActivitySummarySearchRequest, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {AssetActivitySummarySearchRequest} assetActivitySummarySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactionSummary(assetActivitySummarySearchRequest, page, size, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchTransactionSummary(assetActivitySummarySearchRequest, page, size, sort, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactions(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchTransactions(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} debitCardTransactionId
         * @param {string} field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskDebitCardFields(debitCardTransactionId, field, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unmaskDebitCardFields(debitCardTransactionId, field, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TransactionControllerApi - factory interface
 * @export
 */
exports.TransactionControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TransactionControllerApiFp(configuration);
    return {
        /**
         *
         * @param {AssetActivitySearchRequest} assetActivitySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetActivities(assetActivitySearchRequest, page, size, sort, options) {
            return localVarFp.getAssetActivities(assetActivitySearchRequest, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiTransactionDetailsRequest} apiTransactionDetailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerTransaction(apiTransactionDetailsRequest, options) {
            return localVarFp.getCustomerTransaction(apiTransactionDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AssetActivitySummarySearchRequest} assetActivitySummarySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAssetActivitySummaryList(assetActivitySummarySearchRequest, page, size, sort, options) {
            return localVarFp.searchAssetActivitySummaryList(assetActivitySummarySearchRequest, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AssetActivitySummarySearchRequest} assetActivitySummarySearchRequest
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactionSummary(assetActivitySummarySearchRequest, page, size, sort, options) {
            return localVarFp.searchTransactionSummary(assetActivitySummarySearchRequest, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactions(searchParameters, options) {
            return localVarFp.searchTransactions(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} debitCardTransactionId
         * @param {string} field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmaskDebitCardFields(debitCardTransactionId, field, options) {
            return localVarFp.unmaskDebitCardFields(debitCardTransactionId, field, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TransactionControllerApi - object-oriented interface
 * @export
 * @class TransactionControllerApi
 * @extends {BaseAPI}
 */
class TransactionControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {AssetActivitySearchRequest} assetActivitySearchRequest
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionControllerApi
     */
    getAssetActivities(assetActivitySearchRequest, page, size, sort, options) {
        return exports.TransactionControllerApiFp(this.configuration).getAssetActivities(assetActivitySearchRequest, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiTransactionDetailsRequest} apiTransactionDetailsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionControllerApi
     */
    getCustomerTransaction(apiTransactionDetailsRequest, options) {
        return exports.TransactionControllerApiFp(this.configuration).getCustomerTransaction(apiTransactionDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AssetActivitySummarySearchRequest} assetActivitySummarySearchRequest
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionControllerApi
     */
    searchAssetActivitySummaryList(assetActivitySummarySearchRequest, page, size, sort, options) {
        return exports.TransactionControllerApiFp(this.configuration).searchAssetActivitySummaryList(assetActivitySummarySearchRequest, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AssetActivitySummarySearchRequest} assetActivitySummarySearchRequest
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionControllerApi
     */
    searchTransactionSummary(assetActivitySummarySearchRequest, page, size, sort, options) {
        return exports.TransactionControllerApiFp(this.configuration).searchTransactionSummary(assetActivitySummarySearchRequest, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionControllerApi
     */
    searchTransactions(searchParameters, options) {
        return exports.TransactionControllerApiFp(this.configuration).searchTransactions(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} debitCardTransactionId
     * @param {string} field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionControllerApi
     */
    unmaskDebitCardFields(debitCardTransactionId, field, options) {
        return exports.TransactionControllerApiFp(this.configuration).unmaskDebitCardFields(debitCardTransactionId, field, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TransactionControllerApi = TransactionControllerApi;
/**
 * UserRoleManagementControllerApi - axios parameter creator
 * @export
 */
exports.UserRoleManagementControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateUserRequest} createUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateUser: (createUserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createUserRequest' is not null or undefined
            common_1.assertParamExists('addOrUpdateUser', 'createUserRequest', createUserRequest);
            const localVarPath = `/business-portal/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiCreateRole} apiCreateRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleWithPermissions: (apiCreateRole, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiCreateRole' is not null or undefined
            common_1.assertParamExists('createRoleWithPermissions', 'apiCreateRole', apiCreateRole);
            const localVarPath = `/business-portal/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiCreateRole, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} fusionAuthRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalUserDetail: (fusionAuthRef, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fusionAuthRef' is not null or undefined
            common_1.assertParamExists('getPortalUserDetail', 'fusionAuthRef', fusionAuthRef);
            const localVarPath = `/business-portal/users/{fusionAuthRef}`
                .replace(`{${"fusionAuthRef"}}`, encodeURIComponent(String(fusionAuthRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalUsers: (searchParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchParameters' is not null or undefined
            common_1.assertParamExists('getPortalUsers', 'searchParameters', searchParameters);
            const localVarPath = `/business-portal/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchParameters, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleList: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateUserRequest} createUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteTangoPortalUser: (createUserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createUserRequest' is not null or undefined
            common_1.assertParamExists('inviteTangoPortalUser', 'createUserRequest', createUserRequest);
            const localVarPath = `/business-portal/users/tango-portal/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} role
         * @param {RoleUpdateRequest} roleUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyRoleUsers: (role, roleUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'role' is not null or undefined
            common_1.assertParamExists('modifyRoleUsers', 'role', role);
            // verify required parameter 'roleUpdateRequest' is not null or undefined
            common_1.assertParamExists('modifyRoleUsers', 'roleUpdateRequest', roleUpdateRequest);
            const localVarPath = `/business-portal/roles/{role}`
                .replace(`{${"role"}}`, encodeURIComponent(String(role)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(roleUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} fusionAuthRef
         * @param {UpdateUserRequest} updateUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserRoles: (fusionAuthRef, updateUserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fusionAuthRef' is not null or undefined
            common_1.assertParamExists('modifyUserRoles', 'fusionAuthRef', fusionAuthRef);
            // verify required parameter 'updateUserRequest' is not null or undefined
            common_1.assertParamExists('modifyUserRoles', 'updateUserRequest', updateUserRequest);
            const localVarPath = `/business-portal/users/{fusionAuthRef}`
                .replace(`{${"fusionAuthRef"}}`, encodeURIComponent(String(fusionAuthRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} fusionAuthRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateUser: (fusionAuthRef, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fusionAuthRef' is not null or undefined
            common_1.assertParamExists('reactivateUser', 'fusionAuthRef', fusionAuthRef);
            const localVarPath = `/business-portal/users/{fusionAuthRef}/reactivate`
                .replace(`{${"fusionAuthRef"}}`, encodeURIComponent(String(fusionAuthRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InvitePortalUserRequest} invitePortalUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvite: (invitePortalUserRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'invitePortalUserRequest' is not null or undefined
            common_1.assertParamExists('sendInvite', 'invitePortalUserRequest', invitePortalUserRequest);
            const localVarPath = `/business-portal/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(invitePortalUserRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncZendeskWithFusionAuth: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-portal/batch/users/zendesk/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ApiUpdateRole} apiUpdateRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleWithPermissions: (apiUpdateRole, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'apiUpdateRole' is not null or undefined
            common_1.assertParamExists('updateRoleWithPermissions', 'apiUpdateRole', apiUpdateRole);
            const localVarPath = `/business-portal/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(apiUpdateRole, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserRoleManagementControllerApi - functional programming interface
 * @export
 */
exports.UserRoleManagementControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.UserRoleManagementControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateUserRequest} createUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateUser(createUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addOrUpdateUser(createUserRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiCreateRole} apiCreateRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleWithPermissions(apiCreateRole, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createRoleWithPermissions(apiCreateRole, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} fusionAuthRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalUserDetail(fusionAuthRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPortalUserDetail(fusionAuthRef, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalUsers(searchParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPortalUsers(searchParameters, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRoleList(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateUserRequest} createUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteTangoPortalUser(createUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.inviteTangoPortalUser(createUserRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} role
         * @param {RoleUpdateRequest} roleUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyRoleUsers(role, roleUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.modifyRoleUsers(role, roleUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} fusionAuthRef
         * @param {UpdateUserRequest} updateUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserRoles(fusionAuthRef, updateUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.modifyUserRoles(fusionAuthRef, updateUserRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} fusionAuthRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateUser(fusionAuthRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reactivateUser(fusionAuthRef, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {InvitePortalUserRequest} invitePortalUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvite(invitePortalUserRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendInvite(invitePortalUserRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncZendeskWithFusionAuth(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncZendeskWithFusionAuth(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ApiUpdateRole} apiUpdateRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleWithPermissions(apiUpdateRole, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateRoleWithPermissions(apiUpdateRole, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UserRoleManagementControllerApi - factory interface
 * @export
 */
exports.UserRoleManagementControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.UserRoleManagementControllerApiFp(configuration);
    return {
        /**
         *
         * @param {CreateUserRequest} createUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateUser(createUserRequest, options) {
            return localVarFp.addOrUpdateUser(createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiCreateRole} apiCreateRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleWithPermissions(apiCreateRole, options) {
            return localVarFp.createRoleWithPermissions(apiCreateRole, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} fusionAuthRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalUserDetail(fusionAuthRef, options) {
            return localVarFp.getPortalUserDetail(fusionAuthRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchParameters} searchParameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortalUsers(searchParameters, options) {
            return localVarFp.getPortalUsers(searchParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleList(options) {
            return localVarFp.getRoleList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateUserRequest} createUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteTangoPortalUser(createUserRequest, options) {
            return localVarFp.inviteTangoPortalUser(createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} role
         * @param {RoleUpdateRequest} roleUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyRoleUsers(role, roleUpdateRequest, options) {
            return localVarFp.modifyRoleUsers(role, roleUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} fusionAuthRef
         * @param {UpdateUserRequest} updateUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyUserRoles(fusionAuthRef, updateUserRequest, options) {
            return localVarFp.modifyUserRoles(fusionAuthRef, updateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} fusionAuthRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateUser(fusionAuthRef, options) {
            return localVarFp.reactivateUser(fusionAuthRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InvitePortalUserRequest} invitePortalUserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvite(invitePortalUserRequest, options) {
            return localVarFp.sendInvite(invitePortalUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncZendeskWithFusionAuth(options) {
            return localVarFp.syncZendeskWithFusionAuth(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ApiUpdateRole} apiUpdateRole
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleWithPermissions(apiUpdateRole, options) {
            return localVarFp.updateRoleWithPermissions(apiUpdateRole, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserRoleManagementControllerApi - object-oriented interface
 * @export
 * @class UserRoleManagementControllerApi
 * @extends {BaseAPI}
 */
class UserRoleManagementControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {CreateUserRequest} createUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    addOrUpdateUser(createUserRequest, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).addOrUpdateUser(createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiCreateRole} apiCreateRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    createRoleWithPermissions(apiCreateRole, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).createRoleWithPermissions(apiCreateRole, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} fusionAuthRef
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    getPortalUserDetail(fusionAuthRef, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).getPortalUserDetail(fusionAuthRef, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SearchParameters} searchParameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    getPortalUsers(searchParameters, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).getPortalUsers(searchParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    getRoleList(options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).getRoleList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CreateUserRequest} createUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    inviteTangoPortalUser(createUserRequest, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).inviteTangoPortalUser(createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} role
     * @param {RoleUpdateRequest} roleUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    modifyRoleUsers(role, roleUpdateRequest, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).modifyRoleUsers(role, roleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} fusionAuthRef
     * @param {UpdateUserRequest} updateUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    modifyUserRoles(fusionAuthRef, updateUserRequest, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).modifyUserRoles(fusionAuthRef, updateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} fusionAuthRef
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    reactivateUser(fusionAuthRef, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).reactivateUser(fusionAuthRef, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InvitePortalUserRequest} invitePortalUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    sendInvite(invitePortalUserRequest, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).sendInvite(invitePortalUserRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    syncZendeskWithFusionAuth(options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).syncZendeskWithFusionAuth(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ApiUpdateRole} apiUpdateRole
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRoleManagementControllerApi
     */
    updateRoleWithPermissions(apiUpdateRole, options) {
        return exports.UserRoleManagementControllerApiFp(this.configuration).updateRoleWithPermissions(apiUpdateRole, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserRoleManagementControllerApi = UserRoleManagementControllerApi;
